(function() {
  angular.module('fsa', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'ui.bootstrap', 'ui.bootstrap.tooltip', 'ui.bootstrap.modal', 'toastr', 'pouchdb', 'ui.grid', 'ui.grid.selection', 'ui.grid.resizeColumns', 'ui.grid.saveState', 'ui.grid.cellNav', 'ui.grid.edit', 'ui.grid.moveColumns', 'ui.grid.pagination', 'ui.grid.autoResize', 'mgo-angular-wizard', 'ngDropzone', 'angular-md5', 'ngStorage', 'barcodeListener', 'cfp.hotkeys', 'angularMoment', 'base64', 'ui.select', 'angular-storage', 'ngImgCrop', 'flow', 'angular-loading-bar', 'ui.mask', 'angular-js-xlsx', 'xeditable', 'ngWYSIWYG']);

}).call(this);



(function() {
  angular.module('fsa').controller('SectionsofpublicationController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportCategoryController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ProductController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('PeriodController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('InsurancetypesController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('InsuranceobjectsController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('InsuranceformsController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('IndustryController', function($scope, RequestService) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('EnumController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DirReportCategoriesController', function($scope, RequestService, toastr) {
    var vm;
    vm = this;
    vm.dirReportCategories = [];
    RequestService.post('reporta.category_listing', {}).then(function(response) {
      vm.dirReportCategories = response.docs;
    });
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DepartmentdocumentController', function($scope, toastr) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('CurrencyController', function($scope) {
    'ngInject';
    var vm;
    vm = this;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('FileLoadController', function($scope, $rootScope, RequestService, flowFactory, $base64, Session, toastr) {
    'ngInject';
    var getFileSize, initFlow, vm;
    vm = this;
    vm.api = $rootScope.api;
    initFlow = function() {
      var auth_token;
      auth_token = 'Basic ' + $base64.encode('web' + ':' + Session.getToken());
      vm.flow = flowFactory.create({
        target: $rootScope.api + 'upload/docs/file/' + $scope.type,
        singleFile: true,
        headers: {
          Authorization: auth_token
        },
        withCredentials: true,
        testChunks: false
      });
      vm.flow.on('fileAdded', function(file, event) {
        var ext;
        ext = file.name.substring(file.name.lastIndexOf('.'));
        if (ext !== '.pdf' && ext !== '.doc' && ext !== '.docx' && ext !== '.zip' && ext !== '.jpg' && ext !== '.jpeg' && ext !== '.png' && ext !== '.gif') {
          toastr.warning('Выберите файл PDF или Word или Zip');
          event.preventDefault();
          return false;
        }
        if (file.size > 15 * 1024 * 1024) {
          toastr.warning('Файл слишком большой');
          event.preventDefault();
          return false;
        }
      });
      vm.flow.on('filesSubmitted', function(array, event) {
        if (array.length > 0) {
          vm.flow.upload();
        }
      });
      vm.flow.on('complete', function() {
        vm.flow.files.clear();
      });
      vm.flow.on('fileSuccess', function(file, message, chunk) {
        $scope.fileSrc = message;
      });
      return vm.flow.on('error', function(message, file, chunk) {
        console.log(message, file, chunk);
      });
    };
    initFlow();
    getFileSize = function() {
      RequestService.post('education.file_size', {
        bobject: $scope.fileSrc
      }).then(function(result) {
        if (vm.file) {
          return vm.file.size = result.bobject;
        }
      });
    };
    $scope.$watch('fileSrc', function(newVal) {
      if (newVal && newVal.lastIndexOf('/') > -1) {
        vm.file = {
          name: newVal.substring(1 + newVal.lastIndexOf('/')),
          size: 0
        };
        getFileSize();
      } else {
        delete vm.file;
      }
    });
  }).directive('fileLoad', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        fileSrc: '=',
        type: '@'
      },
      controller: 'FileLoadController',
      controllerAs: 'file',
      templateUrl: 'app/components/fileLoad/file-load.html'
    };
  }).directive('fileLink', function($rootScope) {
    return {
      restrict: 'A',
      scope: {
        fileLink: '@'
      },
      link: function(scope, elem, attr) {
        attr.$observe('fileLink', function(val) {
          if (val) {
            scope.file_link = $rootScope.api + val;
            return scope.file_name = val && val.length > 0 ? val.substring(val.lastIndexOf('/') + 1) : '';
          }
        });
      },
      templateUrl: 'app/components/fileLoad/file-link.html'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').constant('stockContractorModalOptions', {
    title: 'Выбрать контрагента',
    can_create: false,
    filter: {}
  }).controller('ContractorSelectController', function($scope, RequestService, $uibModalInstance, modalOptions, stockContractorModalOptions, $uibModal) {
    'ngInject';
    var cancel, createContractor, industryParentGroup, searchContractors, selectContractor, vm;
    vm = this;
    vm.modalOptions = angular.merge({}, stockContractorModalOptions, angular.copy(modalOptions || {}));
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      appScopeProvider: {
        onDoubleClick: function(row) {
          return selectContractor(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>',
      columnDefs: [
        {
          name: 'name',
          displayName: 'Наименование'
        }, {
          name: 'data.email',
          displayName: 'E-mail'
        }, {
          name: 'data.industry.name',
          displayName: 'Индустрия'
        }, {
          name: 'contractor_type_value.data.name',
          displayName: 'Тип'
        }, {
          name: 'contractor_company.name',
          displayName: 'Компания агента',
          visible: false
        }
      ],
      events: {
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          searchContractors(true);
        },
        onRowSelect: function(row) {
          vm.selected_contractor = angular.copy(row.entity);
        }
      }
    };
    searchContractors = function(paging) {
      var filter;
      if (!paging || angular.isUndefined(paging)) {
        vm.offset = 0;
      }
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        search: vm.search_name,
        filter: {
          contractor_type: vm.modalOptions.filter.contractor_type || vm.contractor_type,
          data: {
            industry_id: vm.industry_id
          }
        }
      };
      RequestService.post('contractor.list', filter).then(function(result) {
        delete vm.selected_contractor;
        vm.gridOptions.data = result.docs;
        vm.gridOptions.totalItems = result.count;
      });
    };
    industryParentGroup = function(item) {
      if (!item.parent) {
        return '';
      }
      return item.parent.name;
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    selectContractor = function(selected_contractor) {
      if (selected_contractor) {
        $uibModalInstance.close(selected_contractor);
      } else if (angular.isDefined(vm.selected_contractor)) {
        $uibModalInstance.close(vm.selected_contractor);
      }
    };
    createContractor = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/contractor/edit.html',
        controller: 'ContractorEditController',
        controllerAs: 'contractor',
        size: 'lg',
        scope: $scope,
        resolve: {
          contractor: void 0
        }
      });
      editModal.result.then(function() {
        return searchContractors();
      });
    };
    searchContractors();
    vm.searchContractors = searchContractors;
    vm.industryParentGroup = industryParentGroup;
    vm.cancel = cancel;
    vm.selectContractor = selectContractor;
    vm.createContractor = createContractor;
  });

}).call(this);



(function() {
  angular.module('fsa').directive('contractorSelect', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        contractorId: '=',
        item: '=',
        ngDisabled: '=?',
        ngRequired: '=?',
        modalOptions: '=?'
      },
      controller: function($scope, $attrs, RequestService, $uibModal, $uibModalStack) {
        'ngInject';
        var vm;
        vm = this;
        vm.openSelectContractor = function() {
          var editModal;
          editModal = $uibModal.open({
            templateUrl: 'app/components/contractorSelect/select.html',
            controller: 'ContractorSelectController',
            controllerAs: 'contractor',
            size: 'lg',
            scope: $scope.$parent,
            resolve: {
              modalOptions: $scope.modalOptions || {}
            }
          });
          editModal.result.then(function(result) {
            vm.selected = result;
          });
        };
        vm.searchContractor = function(search_name) {
          var filter;
          filter = {
            limit: 10,
            search: search_name,
            filter: $scope.modalOptions ? $scope.modalOptions.filter : void 0
          };
          return RequestService.post('contractor.list', filter).then(function(result) {
            return result.docs;
          });
        };
        $scope.$watch('contractorId', function() {
          if ((angular.isDefined($scope.contractorId)) && vm.watch_prevent !== true) {
            RequestService.post('contractor.list', {
              filter: {
                _id: $scope.contractorId
              }
            }).then(function(result) {
              if (result.docs.length === 1) {
                vm.watch_prevent = true;
                vm.selected = result.docs[0];
              }
            });
          }
        });
        $scope.$watch('contractor.selected', function() {
          if ((angular.isDefined(vm.selected)) && vm.watch_prevent !== true) {
            vm.watch_prevent = true;
            $scope.contractorId = vm.selected._id;
            if ($attrs.item) {
              $scope.item = vm.selected;
            }
          }
          vm.watch_prevent = false;
        });
      },
      controllerAs: 'contractor',
      link: function(scope, element, attr) {},
      templateUrl: 'app/components/contractorSelect/contractor-select.html'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('UsersController', function(RequestService, product_types, $scope, $uibModal) {
    'ngInject';
    var editUser, getUsers, newUser, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.usersGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'username',
          displayName: 'Имя'
        }, {
          name: 'email',
          displayName: 'Емайл'
        }, {
          name: 'role',
          displayName: 'Важность'
        }, {
          name: 'rec_date',
          displayName: 'Дата регистрации'
        }
      ]
    };
    getUsers = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "login") {
          filter.filter.login = v;
        }
        if (k === "email") {
          filter.filter.email = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      RequestService.post('user.listing', filter).then(function(result) {
        vm.users = result.users;
        vm.usersGridOptions.data = vm.users;
        vm.usersGridOptions.totalItems = result.count;
      });
    };
    editUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/users/edit.html',
        controller: 'UsersEditController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    newUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/users/create.html',
        controller: 'UsersEditController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getUsers();
    });
    vm.editUser = editUser;
    vm.newUser = newUser;
    vm.getUsers = getUsers;
    getUsers();
  }).controller('UsersEditController', function(RequestService, product_types, user, $scope, $uibModalInstance) {
    'ngInject';
    var cancel, createUser, updateUser, vm;
    vm = this;
    if (user === null || user === void 0) {
      vm.user = {};
    } else {
      vm.user = user;
    }
    createUser = function() {
      RequestService.post('user.register', vm.user).then(function(result) {
        console.log("createUser ->result.token = " + result.token);
        $uibModalInstance.close(result);
      });
    };
    updateUser = function() {
      RequestService.post('user.put', vm.user).then(function(result) {
        console.log("updateUser ->result.user = ");
        console.log(result.user);
        $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateUser = updateUser;
    vm.createUser = createUser;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('RoleController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal) {
    'ngInject';
    var editRole, getRoles, newRole, vm;
    vm = this;
    vm.rolesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Наименование'
        }, {
          name: 'data.approval_name',
          displayName: 'Наим. для одобрения'
        }, {
          name: 'data.read',
          displayName: 'Чтение'
        }, {
          name: 'data.write',
          displayName: 'Редактирование'
        }, {
          name: 'data.delete',
          displayName: 'Удаление'
        }
      ]
    };
    getRoles = function() {
      var filter;
      filter = {};
      RequestService.post('role.listing', filter).then(function(result) {
        delete vm.selected_role;
        vm.roles = result.docs;
        vm.rolesGridOptions.data = vm.roles;
      });
    };
    editRole = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/role/edit.html',
        controller: 'RoleEditController',
        controllerAs: 'role',
        size: 'lg',
        resolve: {
          role: angular.copy(vm.selected_role)
        }
      });
      editModal.result.then(function() {
        return getRoles();
      });
      return false;
    };
    newRole = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/role/edit.html',
        controller: 'RoleEditController',
        controllerAs: 'role',
        size: 'lg',
        resolve: {
          role: void 0
        }
      });
      editModal.result.then(function() {
        return getRoles();
      });
    };
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить роль',
      callback: newRole
    }).add({
      combo: 'r',
      description: 'Обновить список ролей',
      callback: getRoles
    });
    $scope.$on('data-selected', function(event, row) {
      vm.selected_role = row.entity;
    });
    vm.getRoles = getRoles;
    vm.editRole = editRole;
    vm.newRole = newRole;
    getRoles();
  });

  angular.module('fsa').controller('RoleEditController', function($scope, RequestService, AppStorage, toastr, role, $uibModalInstance) {
    'ngInject';
    var menuParentGroup, saveRole, vm;
    vm = this;
    vm.role = role || {
      type: 'Roles',
      data: {
        read: true
      }
    };
    vm.menus = AppStorage.getObject('menus') || [];
    saveRole = function() {
      vm.role.type = 'Roles';
      RequestService.post('role.save', vm.role).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    menuParentGroup = function(menu) {
      if (menu && menu.parent && menu.parent.name) {
        return menu.parent.name;
      }
    };
    vm.saveRole = saveRole;
    vm.menuParentGroup = menuParentGroup;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportperiodController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var date, downloadExcelRPAP, downloadExcelRPC, downloadExcelRPCR, downloadPDFRPA, downloadPDFRPAR, downloadPDFRPC, downloadPDFRPCR, downloadPDFRPF, downloadPDFRPFR, getAgents, getBranches, getPolicies, m, removeAgents, removeBranches, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.offset = 0;
    vm.limit = 10;
    vm.branch_id = null;
    vm.user_id = null;
    vm.agents = [];
    vm.branches = [];
    vm.policies = null;
    vm.policy_filtered = [];
    vm.company = Session.getCompany();
    vm.user = Session.getUser();
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20, 50],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    downloadPDFRPC = function() {
      ReportService.printReport('RPC', {
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadExcelRPC = function() {
      ReportService.saveReportExcel('RPC', {
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPCR = function() {
      ReportService.printReport('RPCR', {
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadExcelRPCR = function() {
      ReportService.saveReportExcel('RPCR', {
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPFR = function() {
      ReportService.printReport('RPFR', {
        'branch_id': vm.branch_id + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPF = function() {
      ReportService.printReport('RPF', {
        'branch_id': vm.branch_id + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        'end_date': moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPAR = function() {
      ReportService.printReport('RPAR', {
        'user_id': String(vm.user_id) + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        end_date: moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadPDFRPA = function() {
      ReportService.printReport('RPA', {
        'user_id': String(vm.user_id) + '',
        'start_date': moment(vm.date_start).format('MM.DD.YYYY') + '',
        end_date: moment(vm.date_end).format('MM.DD.YYYY') + ''
      });
    };
    downloadExcelRPAP = function() {
      ReportService.saveReportExcel('RPAP', {
        'agent_id': vm.filter.filter.agent_id + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    getPolicies = function() {
      if (vm.company.company_type === 'insurance_company' && vm.branch_id === null && vm.user_id === null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            date_start: vm.date_start,
            date_end: vm.date_end,
            report_period: ['Оформлен', 'Истек']
          }
        };
      } else if (vm.company.company_type === 'branch_company') {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            company_id: vm.company._id,
            date_end: vm.date_end,
            edit_user_id: vm.user.id,
            report_period: ['Оформлен', 'Истек']
          }
        };
      } else if (vm.company.company_type === 'insurance_company' && vm.branch_id !== null && vm.user_id === null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            branch_id: vm.branch_id,
            date_start: vm.date_start,
            date_end: vm.date_end,
            report_period: ['Оформлен', 'Истек']
          }
        };
      } else if (vm.company.company_type === 'insurance_company' && vm.user_id !== null) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            user_id: String(vm.user_id),
            date_start: vm.date_start,
            date_end: vm.date_end,
            report_period: ['Оформлен', 'Истек']
          }
        };
      }
      RequestService.post('policies.listing', vm.filter).then(function(data) {
        delete vm.selected_policy;
        vm.policiesGridOptions.data = angular.copy(data.docs);
        return vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getBranches = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'branch_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        return vm.branches = data.docs;
      });
    };
    getAgents = function() {
      var filter;
      if (vm.branch_id) {
        filter = {
          offset: vm.offset,
          limit: vm.limit,
          with_related: true,
          id: vm.branch_id
        };
        RequestService.post('agentemployee.listing', filter).then(function(data) {
          return vm.agents = data.users;
        });
      } else {
        vm.agents = [];
      }
    };
    removeAgents = function() {
      vm.user_id = null;
    };
    removeBranches = function() {
      vm.branch_id = null;
      vm.user_id = null;
      $scope.$watch('reportperiod.user_id', function() {
        vm.agents = [];
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadExcelRPC = downloadExcelRPC;
    vm.downloadPDFRPFR = downloadPDFRPFR;
    vm.downloadPDFRPF = downloadPDFRPF;
    vm.downloadExcelRPAP = downloadExcelRPAP;
    vm.downloadPDFRPA = downloadPDFRPA;
    vm.downloadPDFRPAR = downloadPDFRPAR;
    vm.downloadPDFRPC = downloadPDFRPC;
    vm.downloadPDFRPCR = downloadPDFRPCR;
    vm.getPolicies = getPolicies;
    vm.getBranches = getBranches;
    vm.getAgents = getAgents;
    vm.removeAgents = removeAgents;
    vm.removeBranches = removeBranches;
    vm.downloadExcelRPCR = downloadExcelRPCR;
    getBranches();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('Report_templateEditController', function($scope, RequestService, $uibModalInstance, report_template, toastr) {
    var save, vm;
    vm = this;
    vm.template = report_template || {
      "ReportVersion": "2016.2.5",
      "ReportGuid": "fa01abce0ca5d18ec4ad5a91c86cf9ed",
      "ReportName": "Report",
      "ReportAlias": "Report",
      "ReportCreated": "/Date(1480997975000+0600)/",
      "ReportChanged": "/Date(1480997975000+0600)/",
      "EngineVersion": "EngineV2",
      "CalculationMode": "Interpretation",
      "Pages": {
        "0": {
          "Ident": "StiPage",
          "Name": "Page1",
          "Guid": "4c037a5bc82cc89b8aaeaca0d31be61e",
          "Interaction": {
            "Ident": "StiInteraction"
          },
          "Border": ";;2;;;;;solid:Black",
          "Brush": "solid:Transparent",
          "PageWidth": 21.01,
          "PageHeight": 29.69,
          "Watermark": {
            "TextBrush": "solid:50,0,0,0"
          },
          "Margins": {
            "Left": 1,
            "Right": 1,
            "Top": 1,
            "Bottom": 1
          }
        }
      }
    };
    save = function() {
      if (vm.saving) {
        return;
      }
      vm.saving = true;
      if (!vm.template.code) {
        toastr.warning('Укажите код');
        vm.saving = false;
        return;
      }
      if (!vm.template.name) {
        toastr.warning('Укажите наименование');
        vm.saving = false;
        return;
      }
      if (!vm.template.report_category_id) {
        toastr.warning('Укажите категорию');
        vm.saving = false;
        return;
      }
      if (!vm.template.template) {
        toastr.warning('Заполните шаблон');
        vm.saving = false;
        return;
      }
      return RequestService.post('report.put', vm.template).then(function(data) {
        vm.saving = false;
        return $uibModalInstance.close(data);
      }, function() {
        return vm.saving = false;
      });
    };
    vm.save = save;
    vm.cancel = function() {
      return $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('Report_templateController', function($scope, RequestService, $uibModal) {
    var editQuery, editTemplate, getQueries, getTemplates, newQuery, newTemplate, vm;
    vm = this;
    vm.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          field: 'code',
          displayName: 'Код'
        }, {
          field: 'name',
          displayName: 'Наименование'
        }, {
          field: 'report_category.name',
          displayName: 'Категория'
        }
      ]
    };
    vm.queriesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          field: 'code',
          displayName: 'Код'
        }, {
          field: 'name',
          displayName: 'Наименование'
        }, {
          field: 'result_key',
          displayName: 'Ключ возврата'
        }
      ]
    };
    getTemplates = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('report.listing', filter).then(function(data) {
        delete vm.selected_template;
        vm.gridOptions.data = data.report_list;
        return vm.gridOptions.totalItems = data.count;
      });
    };
    newTemplate = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/template_edit.html',
        controller: 'Report_templateEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_template: null
        }
      });
      return editModal.result.then(function() {
        return getTemplates();
      });
    };
    editTemplate = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/template_edit.html',
        controller: 'Report_templateEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_template: vm.selected_template
        }
      });
      return editModal.result.then(function() {
        delete vm.selected_template;
        return getTemplates();
      });
    };
    getQueries = function() {
      var filter;
      filter = {};
      return RequestService.post('report.query_listing', filter).then(function(data) {
        delete vm.selected_query;
        vm.queriesGridOptions.data = data.docs;
        return vm.queriesGridOptions.totalItems = data.count;
      });
    };
    newQuery = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/query_edit.html',
        controller: 'ReportQueryEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_query: null
        }
      });
      return editModal.result.then(function() {
        return getQueries();
      });
    };
    editQuery = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/report_template/query_edit.html',
        controller: 'ReportQueryEditController',
        controllerAs: 'edit',
        size: 'lg',
        scope: $scope,
        resolve: {
          report_query: vm.selected_query
        }
      });
      return editModal.result.then(function() {
        delete vm.selected_query;
        return getQueries();
      });
    };
    $scope.$on('data-selected', function(event, data) {
      if (data.grid.id === vm.gridOptions.gridApi.grid.id) {
        vm.selected_template = data.entity;
      } else if (data.grid.id === vm.queriesGridOptions.gridApi.grid.id) {
        vm.selected_query = data.entity;
      }
    });
    getTemplates();
    getQueries();
    vm.getTemplates = getTemplates;
    vm.newTemplate = newTemplate;
    vm.editTemplate = editTemplate;
    vm.getQueries = getQueries;
    vm.newQuery = newQuery;
    vm.editQuery = editQuery;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportQueryEditController', function($scope, RequestService, $uibModalInstance, report_query, toastr) {
    var save, vm;
    vm = this;
    vm.query = report_query || {};
    save = function() {
      if (vm.saving) {
        return;
      }
      vm.saving = true;
      if (!vm.query.code) {
        toastr.warning('Укажите код');
        vm.saving = false;
        return;
      }
      if (!vm.query.name) {
        toastr.warning('Укажите наименование');
        vm.saving = false;
        return;
      }
      if (!vm.query.result_key) {
        toastr.warning('Укажите ключ возврата');
        vm.saving = false;
        return;
      }
      if (!vm.query.query) {
        toastr.warning('Заполните запрос');
        vm.saving = false;
        return;
      }
      return RequestService.post('report.query_put', vm.query).then(function(data) {
        vm.saving = false;
        return $uibModalInstance.close(data);
      }, function() {
        return vm.saving = false;
      });
    };
    vm.save = save;
    vm.cancel = function() {
      return $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportaController', function($scope, RequestService, $timeout, $document, $stateParams) {
    var createDesigner, createViewer, designer, designerFullWindowToggle, getCategoryList, getReportList, reportObj, reportTemp, search, setReport, setSelected, viewer, vm;
    vm = this;
    viewer = null;
    designer = null;
    reportTemp = {
      "ReportVersion": "2016.2.5",
      "ReportGuid": "fa01abce0ca5d18ec4ad5a91c86cf9ed",
      "ReportName": "Report",
      "ReportAlias": "Report",
      "ReportCreated": "/Date(1480997975000+0600)/",
      "ReportChanged": "/Date(1480997975000+0600)/",
      "EngineVersion": "EngineV2",
      "CalculationMode": "Interpretation",
      "Pages": {
        "0": {
          "Ident": "StiPage",
          "Name": "Page1",
          "Guid": "4c037a5bc82cc89b8aaeaca0d31be61e",
          "Interaction": {
            "Ident": "StiInteraction"
          },
          "Border": ";;2;;;;;solid:Black",
          "Brush": "solid:Transparent",
          "PageWidth": 21.01,
          "PageHeight": 29.69,
          "Watermark": {
            "TextBrush": "solid:50,0,0,0"
          },
          "Margins": {
            "Left": 1,
            "Right": 1,
            "Top": 1,
            "Bottom": 1
          }
        }
      }
    };
    reportObj = {};
    search = {};
    Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile("stimulsoft/ru.xml");
    createViewer = function() {
      var options;
      options = new Stimulsoft.Viewer.StiViewerOptions();
      options.height = "100%";
      options.appearance.scrollbarsMode = true;
      options.toolbar.showDesignButton = false;
      options.toolbar.showFullScreenButton = false;
      options.toolbar.showAboutButton = false;
      options.exports.showExportToPdf = true;
      options.exports.showExportToExcel2007 = true;
      options.exports.ShowExportToWord2007 = false;
      options.exports.showExportToHtml = false;
      options.exports.showExportToDocument = false;
      viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
      viewer.renderHtml("viewerContent");
      viewer.jsObject.postInteractionOld = viewer.jsObject.postInteraction;
      viewer.jsObject.postInteraction = function(params) {
        var report;
        if (params.action === 'Variables' && reportObj.code) {
          report = viewer.report;
          RequestService.post('report/get_query_result', {
            code: reportObj.code,
            parameters: params.variables
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(reportObj.code, reportObj.code, response.data);
          });
        }
        viewer.jsObject.postInteractionOld(params);
      };
      setReport(reportTemp);
      document.getElementById("StiViewerReportPanel").style.cssText = "text-align: center;bottom: 0px;position: static;top: 35px;overflow: auto;margin-top: 0px;";
    };
    designerFullWindowToggle = function() {
      var body, reportDesigner;
      body = $document.find('body');
      reportDesigner = $document.find('#designerContent');
      if (body.hasClass('report-designer-fullscreen')) {
        body.removeClass('report-designer-fullscreen');
        reportDesigner.removeClass('fullscreen');
      } else {
        body.addClass('report-designer-fullscreen');
        reportDesigner.addClass('fullscreen');
      }
    };
    createDesigner = function() {
      var options, resizeBtn;
      options = new Stimulsoft.Designer.StiDesignerOptions();
      options.appearance.fullScreenMode = false;
      options.appearance.htmlRenderMode = Stimulsoft.Report.Export.StiHtmlExportMode.Table;
      options.appearance.showSaveDialog = false;
      options.toolbar.showFileMenuExit = false;
      options.toolbar.showFileMenu = false;
      options.toolbar.showPreviewButton = true;
      options.toolbar.showAboutButton = false;
      designer = new Stimulsoft.Designer.StiDesigner(options, "StiDesigner", false);
      designer.onSaveReport = function(event) {
        var _params;
        if (!reportObj.code) {
          return;
        }
        reportObj.template = event.report.saveToJsonString();
        RequestService.post('report.put', reportObj).then(function(response) {});
        _params = {};
        angular.forEach(event.report.dictionary.variables.list, function(variable) {
          _params[variable.name] = variable.value;
        });
        RequestService.post('report.get_query_result', {
          code: reportObj.code,
          parameters: _params
        }).then(function(response) {
          event.report.dictionary.databases.clear();
          event.report.regData(reportObj.code, reportObj.code, response.data);
        });
      };
      designer.renderHtml("designerContent");
      viewer = designer.jsObject.options.viewerContainer.firstChild;
      viewer.jsObject.postInteractionOld = viewer.jsObject.postInteraction;
      viewer.jsObject.postInteraction = function(params) {
        var report;
        if (params.action === 'Variables' && reportObj.code) {
          report = viewer.jsObject.viewer.report;
          RequestService.post('report.get_query_result', {
            code: reportObj.code,
            parameters: params.variables
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(reportObj.code, reportObj.code, response.data);
          });
        }
        viewer.jsObject.postInteractionOld(params);
      };
      resizeBtn = $document.find('#StiDesignerresizeDesigner');
      resizeBtn[0].action = designerFullWindowToggle;
      setReport(reportTemp);
    };
    getCategoryList = function() {
      RequestService.post('report.category_listing', {}).then(function(response) {
        vm.report_categories = response.docs;
      });
    };
    getReportList = function() {
      var filter;
      filter = {
        filter: {
          report_category_id: vm.search.report_category_id
        }
      };
      RequestService.post('report.listing', filter).then(function(data) {
        vm.reports = data.report_list;
      });
    };
    setReport = function(reportObject) {
      $timeout(function() {
        var report;
        report = new Stimulsoft.Report.StiReport();
        report.load(reportObject);
        if (viewer) {
          viewer.report = report;
        }
        if (designer) {
          designer.report = report;
        }
      });
    };
    setSelected = function(selectedReport) {
      if (selectedReport === void 0) {
        return;
      }
      reportObj = selectedReport;
      setReport(JSON.parse(reportObj.template));
    };
    vm.getReportList = getReportList;
    vm.getCategoryList = getCategoryList;
    vm.setSelected = setSelected;
    getCategoryList();
    if ($stateParams.reportMode && $stateParams.reportMode === 'designer') {
      createDesigner();
    } else {
      createViewer();
    }
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ReportController', function($scope, RequestService) {
    var createViewer, getReportList, setReport, showReport, viewer, vm;
    vm = this;
    viewer = null;
    Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile("assets/stimulsoft/ru.xml");
    Stimulsoft.Base.Localization.StiLocalization.setCulture("ru");
    createViewer = function() {
      var options;
      options = new Stimulsoft.Viewer.StiViewerOptions();
      options.height = "100%";
      options.appearance.scrollbarsMode = true;
      options.toolbar.showDesignButton = false;
      options.toolbar.showFullScreenButton = false;
      options.exports.showExportToPdf = true;
      options.exports.showExportToExcel2007 = true;
      options.exports.ShowExportToWord2007 = false;
      options.exports.showExportToHtml = false;
      options.exports.showExportToDocument = false;
      viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
      viewer.renderHtml("reportViewer");
    };
    setReport = function(reportObject) {
      viewer.showProcessIndicator();
      setTimeout(function() {
        var report;
        report = new Stimulsoft.Report.StiReport();
        report.load(reportObject);
        viewer.report = report;
      }, 50);
    };
    getReportList = function() {
      var filter;
      filter = {
        filter: {
          report_category_id: vm.report_category_id
        }
      };
      RequestService.post('report.listing', filter).then(function(data) {
        vm.reports = data.report_list;
      });
    };
    showReport = function(report) {
      var reportObject;
      reportObject = JSON.parse(report.template) || {};
      return setReport(reportObject);
    };
    $scope.$watch('report.report_category_id', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        return getReportList();
      }
    });
    $scope.$watch('report.selected_report', function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        return showReport(newVal);
      }
    });
    vm.getReportList = getReportList;
    vm.showReport = showReport;
    createViewer();
    setReport({});
    document.getElementById("StiViewerReportPanel").style.cssText = "text-align: center;bottom: 0px;position: static;top: 35px;overflow: auto;margin-top: 0px;";
  });

}).call(this);



(function() {
  angular.module('fsa').controller('RegulationsController', function($timeout, toastr, $rootScope, $http, $state) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('RegulationsListController', function($rootScope, $scope, $state, RequestService, $http, $uibModal) {
    'ngInject';
    var confirmAction, getRegulations, openCreateForm, openEditForm, removeRegulations, vm;
    vm = this;
    vm.searchValues = {};
    vm.searchValuesLang = {};
    vm.dateOptions = {
      startingDay: 1,
      opened1: false,
      opened2: false
    };
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [100, 200, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          displayName: 'Наименование',
          name: 'name'
        }
      ],
      events: {
        onRowSelect: function(row) {
          vm.selected_regulations = angular.copy(row.entity);
        },
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          getRegulations();
        }
      }
    };
    getRegulations = function() {
      var filters, lang;
      lang = vm.searchValuesLang;
      filters = vm.searchValues;
      RequestService.post('regulations/listing', filters, lang).then(function(response) {
        vm.gridOptions.data = response.list;
      }, function(response) {});
    };
    openCreateForm = function() {
      $state.go('app.regulations.form');
    };
    openEditForm = function() {
      return $state.go('app.regulations.form', {
        regulations: vm.selected_regulations
      });
    };
    removeRegulations = function() {
      if (!vm.selected_regulations) {
        return;
      }
      vm.selected_regulations.crud = 'Regulations';
      RequestService.post('regulations/remove', vm.selected_regulations).then(function(result) {
        getRegulations();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_regulations = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getRegulations();
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот документ"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeRegulations();
        }
      });
    };
    vm.removeRegulations = removeRegulations;
    vm.getRegulations = getRegulations;
    vm.openCreateForm = openCreateForm;
    vm.openEditForm = openEditForm;
    vm.confirmAction = confirmAction;
    getRegulations();
  }).controller('RegulationsFormController', function($rootScope, $scope, $state, $stateParams, RequestService, $http, $base64, Session, toastr) {
    'ngInject';
    var goBack, saveRegulations, vm;
    vm = this;
    vm.regulationsItem = $stateParams.regulations;
    saveRegulations = function() {
      RequestService.post('regulations/put', vm.regulationsItem).then(function(response) {
        goBack();
      }, function(response) {});
    };
    goBack = function() {
      $state.go('app.regulations.list');
    };
    vm.saveRegulations = saveRegulations;
    vm.goBack = goBack;
  });

}).call(this);



(function() {


}).call(this);



(function() {
  angular.module('fsa').controller('ProfileController', function(hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('ProfileEditController', function(Session, hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $log) {
    'ngInject';
    var putData, vm;
    vm = this;
    vm.profile = angular.copy($scope.app.ua);
    vm.profile.data.phones = vm.profile.data.phones || [];
    vm.tempPhone = '';
    vm.addPhone = function() {
      if (vm.tempPhone === '' || vm.tempPhone === void 0) {
        console.log("Пароль пустой или неопределен");
      } else {
        vm.profile.data.phones.push(vm.tempPhone);
        return vm.tempPhone = '';
      }
    };
    vm.deletePhone = function(index) {
      return vm.profile.data.phones.splice(index, 1);
    };
    putData = function() {
      console.log(vm.profile);
      RequestService.post('user.put', vm.profile).then(function(result) {
        vm.profile = result.user;
        Session.setUser(vm.profile);
        $scope.app.ua = Session.getUser();
        return $state.go('app.profile.view');
      });
    };
    vm.putData = putData;
  }).controller('ProfileViewController', function(Session, hotkeys, $scope, $state, RequestService, toastr, uiGridConstants, $uibModal, $log) {
    'ngInject';
    var open, vm;
    vm = this;
    open = function(templ) {
      var modalInstance;
      modalInstance = $uibModal.open({
        templateUrl: templ,
        controller: 'ModalInstanceCtrl',
        controllerAs: '$ctrl',
        size: '',
        resolve: {
          cUser: function() {
            return $scope.app.ua;
          }
        }
      });
      return modalInstance.result;
    };
    vm.profile = angular.copy($scope.app.ua);
    vm.Show = function() {
      console.log($scope.app.ua);
    };
    vm.changePassword = function() {
      var result;
      result = open('changePassword.html');
      result.then((function(res) {
        vm.profile = res;
        Session.setUser(vm.profile);
        $scope.app.ua = Session.getUser();
        return alert('Ok');
      }), (function(reasn) {
        return console.log("da of " + reasn);
      }));
    };
    vm.changeUsername = function() {
      var result;
      result = open('changeUsername.html');
      result.then((function(res) {
        console.log(res);
        vm.profile = res;
        Session.setUser(vm.profile);
        $scope.app.ua = Session.getUser();
        return alert('Ok');
      }), (function(reson) {
        return console.log("da of " + reson);
      }));
    };
    vm.changeEmail = function() {
      var result;
      result = open('changeEmail.html');
      result.then((function(res) {
        vm.profile = res;
        Session.setUser(vm.profile);
        $scope.app.ua = Session.getUser();
        return alert('Ok');
      }), (function(reson) {
        return console.log("da of " + reson);
      }));
    };
  }).controller('ModalInstanceCtrl', function($uibModalInstance, cUser, $log, RequestService) {
    'ngInject';
    var $ctrl;
    $ctrl = this;
    $ctrl.cUser = cUser;
    $ctrl.password = {
      currentPswd: '',
      newPswd: '',
      confirmPswd: ''
    };
    $ctrl.email = $ctrl.cUser.email;
    $ctrl.username = $ctrl.cUser.username;
    $ctrl.passwordSave = function() {
      var data;
      if ($ctrl.password.newPswd !== $ctrl.password.confirmPswd) {
        alert("Пароль не подтвержден");
        return;
      }
      data = {
        password: $ctrl.password.currentPswd,
        newpswd: $ctrl.password.newPswd
      };
      return RequestService.post('user.putPassword', data).then(function(result) {
        $uibModalInstance.close(result.user);
      });
    };
    $ctrl.usernameSave = function() {
      var data;
      data = {
        password: $ctrl.password.currentPswd,
        username: $ctrl.username
      };
      return RequestService.post('user.putUsername', data).then(function(result) {
        $uibModalInstance.close(result.user);
      });
    };
    $ctrl.emailSave = function() {
      var data;
      data = {
        password: $ctrl.password.currentPswd,
        email: $ctrl.email
      };
      return RequestService.post('user.putEmail', data).then(function(result) {
        $uibModalInstance.close(result.user);
      });
    };
    $ctrl.cancel = function() {
      return $uibModalInstance.dismiss("Canceled");
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ProductController', function($scope, Session, $state, RequestService, toastr, hotkeys, $uibModal) {
    'ngInject';
    var confirmAction, deleteProduct, getProducts, gotoedit, gotoview, vm;
    vm = this;
    $scope.g;
    vm.offset = 0;
    vm.limit = 10;
    vm.productsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'description',
          displayName: 'описание'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'date_update',
          displayName: 'Дата обновления',
          visible: false
        }, {
          name: 'date_close',
          displayName: 'Закрытие',
          visible: false
        }, {
          name: 'user_update',
          displayName: 'Пользователь',
          visible: false
        }, {
          name: 'user_entry',
          displayName: 'Залогинившийся',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    deleteProduct = function() {
      RequestService.post('productsbasefactor.deleteall', {
        items: vm.selected_product.basefactors
      }).then(function(result) {});
      RequestService.post('productfactor.deleteall', {
        items: vm.selected_product.factors
      }).then(function(result) {});
      RequestService.post('product.delete', vm.selected_product).then(function(result) {
        getProducts();
      });
    };
    getProducts = function() {
      var company, filter, filter1;
      company = Session.getCompany();
      filter1 = {};
      if (company !== null && company !== void 0) {
        filter1.company_id = company._id;
      }
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        filter: filter1
      };
      RequestService.post('product.listing', filter).then(function(result) {
        var item, j, len, ref;
        delete vm.selected_product;
        vm.products = result.docs;
        ref = vm.products;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          item.date_start = new Date(item.date_start);
          item.date_end = new Date(item.date_end);
        }
        console.log(vm.products);
        vm.productsGridOptions.data = vm.products;
        vm.productsGridOptions.totalItems = result.count;
      });
    };
    gotoedit = function(item) {
      return $state.go('app.product_new', {
        product: item
      });
    };
    gotoview = function(item) {
      return $state.go('app.product_view', {
        product: item
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_product = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getProducts();
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот продукт"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteProduct();
        }
      });
    };
    vm.confirmAction = confirmAction;
    vm.deleteProduct = deleteProduct;
    vm.gotoview = gotoview;
    vm.gotoedit = gotoedit;
    vm.getProducts = getProducts;
    getProducts();
  }).controller('ProductNewController', function($scope, Session, RequestService, $stateParams, $filter, $state, toastr, $uibModal) {
    'ngInject';
    var addBF, basefactorDelete, basefactorEdit, basefactorRowEdit, clearFactorValues, confirmActionBF, confirmActionBFdelete, confirmActionF, confirmActionFDeleteAll, confirmActionFdelete, confirmActionFinish, countryFilter, deleteBF, deleteBFandDB, factorValueFilter, getInsAmount, getProductsBaseFactor, getProductsFactor, initFunc, removeAllFactors, removeFactor, resetForm, saveProduct, saveProductsBaseFactor, saveProductsFactor, sortFactorValues, vm;
    vm = this;
    vm.today = new Date();
    vm.new_product = $stateParams.product | {
      services_id: []
    };
    vm.selected_country = '';
    vm.current_BF = {
      countries_id: [],
      values: []
    };
    vm.current_F = {};
    vm.BFitem = {};
    resetForm = function() {
      vm.current_BF = {
        countries_id: [],
        values: []
      };
    };
    addBF = function() {
      var i, item, j, k, len, len1, ref, ref1, temp_bf;
      temp_bf = null;
      if (vm.BFitem.from_day > vm.BFitem.to_day) {
        console.log("product.controller.coffee/ProductNewController/addBF: Такой промежуток НЕВОЗМОЖЕН");
        return;
      }
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if ((item.to_day < vm.BFitem.from_day) || (item.from_day > vm.BFitem.to_day)) {
          null;
        } else {
          if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
            if (item._id === vm.BFitem._id) {
              continue;
            }
          }
          console.log("product.controller.coffee/ProductNewController/addBF: Конфлик интервалов");
          return;
        }
      }
      if (vm.BFitem._id !== void 0 && vm.BFitem._id !== null) {
        ref1 = vm.current_BF.values;
        for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
          item = ref1[i];
          if (item._id === vm.BFitem._id) {
            vm.current_BF.values.splice(i, 1);
          }
        }
      }
      vm.current_BF.values.push(vm.BFitem);
      return vm.BFitem = {};
    };
    removeFactor = function(index, item, top) {
      vm.factorListTS.splice(index, 1);
      RequestService.post('productfactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {
        getProductsFactor();
      });
    };
    removeAllFactors = function(bf) {
      RequestService.post('productfactor.deleteall', {
        items: bf.data
      }).then(function(result) {
        getProductsFactor();
      });
    };
    deleteBF = function(index) {
      return vm.current_BF.values.splice(index, 1);
    };
    deleteBFandDB = function(index, item) {
      vm.current_BF.values.splice(index, 1);
      RequestService.post('productsbasefactor.delete', {
        _id: item._id,
        _rev: item._rev
      }).then(function(result) {});
    };
    initFunc = function() {
      if ($stateParams.product === null || $stateParams.product === void 0) {
        vm.new_product = {};
      } else {
        vm.new_product = $stateParams.product;
        vm.current_BF.product_id = vm.new_product._id | null;
        return vm.current_F.product_id = vm.new_product._id | null;
      }
    };
    saveProduct = function() {
      var company, company_id, product_code;
      company = Session.getCompany();
      company_id = null;
      product_code = null;
      if (company !== null && company !== void 0) {
        company_id = company._id;
        if (vm.new_product.insurance_type !== null && vm.new_product.insurance_type !== void 0) {
          product_code = company.code + vm.new_product.insurance_type + '00';
          vm.new_product.code = product_code;
        } else {
          console.log("vm.insurance_type_code isnt null and vm.insurance_type_code isnt undefined");
          return;
        }
      }
      if (vm.new_product.company_id === null || vm.new_product.company_id === void 0) {
        vm.new_product.company_id = company_id;
      }
      if (vm.new_product.basefactors) {
        delete vm.new_product.basefactors;
      }
      if (vm.new_product.factors) {
        delete vm.new_product.factors;
      }
      if (vm.new_product.services) {
        delete vm.new_product.services;
      }
      RequestService.post('product.save', vm.new_product).then(function(result) {
        vm.current_BF.product_id = result.id;
        vm.current_F.product_id = result.id;
        vm.new_product._id = result.id;
        return toastr.success('Продукт Сохранен успешно');
      });
      return false;
    };
    basefactorRowEdit = function(bf) {
      vm.BFitem = angular.copy(bf);
    };
    basefactorDelete = function(index, bf) {
      RequestService.post('productsbasefactor.deleteall', {
        items: bf.data
      }).then(function(result) {
        getProductsBaseFactor();
      });
    };
    basefactorEdit = function(bf) {
      var item, item1, j, k, len, len1, ref, ref1;
      vm.current_BF.countries_id = [];
      ref = bf.countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        vm.current_BF.countries_id.push(item._id);
      }
      vm.current_BF.insurance_amount = bf.data[0].insurance_amount;
      vm.current_BF.values = [];
      vm.current_BF.values = bf.data;
      ref1 = vm.current_BF.values;
      for (k = 0, len1 = ref1.length; k < len1; k++) {
        item1 = ref1[k];
        item1.from_day = item1.interval.from_day;
        item1.to_day = item1.interval.to_day;
      }
    };
    saveProductsBaseFactor = function() {
      var arraytopass, item, j, len, ref, x;
      arraytopass = [];
      ref = vm.current_BF.values;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        x = {
          _id: item._id,
          product_id: vm.current_BF.product_id,
          insurance_amount: vm.insurance_amount,
          countries_id: vm.current_BF.countries_id,
          base_price: item.base_price,
          is_per_day: item.is_per_day,
          interval: {
            from_day: item.from_day,
            to_day: item.to_day
          }
        };
        arraytopass.push(x);
      }
      RequestService.post('productsbasefactor.save', {
        items: arraytopass
      }).then(function(result) {
        var id;
        id = vm.current_BF.product_id;
        vm.current_BF.product_id = id;
        vm.current_BF.values = [];
        return getProductsBaseFactor();
      });
      return false;
    };
    vm.basefactorList = [];
    getProductsBaseFactor = function() {
      var filter, tmp_product_id;
      filter = {};
      if (vm.new_product._id === null || vm.new_product._id === void 0) {
        tmp_product_id = "1";
      } else {
        tmp_product_id = vm.new_product._id;
      }
      filter = {
        with_related: true,
        filter: {
          product_id: tmp_product_id
        }
      };
      RequestService.post('productsbasefactor.listing', filter).then(function(result) {
        var atom, atom1, is_included, item, item2, j, k, len, len1, ref, ref1, tempAtom;
        vm.basefactorList = result.docs;
        vm.basefactorListTS = [];
        is_included = false;
        ref = vm.basefactorList;
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          ref1 = vm.basefactorListTS;
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            item2 = ref1[k];
            item.countries = $filter('orderBy')(item.countries, 'name');
            item2.countries = $filter('orderBy')(item2.countries, 'name');
            if (angular.equals(item.countries, item2.countries)) {
              is_included = true;
              atom1 = {
                _id: item._id,
                _rev: item._rev,
                interval: item.interval,
                base_price: item.base_price,
                insurance_amount: item.insurance_amount,
                is_per_day: item.is_per_day
              };
              item2.data.push(atom1);
            }
          }
          if (is_included === false) {
            tempAtom = {
              countries: item.countries,
              data: []
            };
            atom = {
              _id: item._id,
              _rev: item._rev,
              interval: item.interval,
              base_price: item.base_price,
              insurance_amount: item.insurance_amount,
              is_per_day: item.is_per_day
            };
            tempAtom.data.push(atom);
            vm.basefactorListTS.push(tempAtom);
          }
          is_included = false;
        }
        console.log("vm.basefactorListTS");
        return console.log(vm.basefactorListTS);
      });
      return false;
    };
    saveProductsFactor = function() {
      vm.current_F.factor_id = vm.current_F.factor._id;
      RequestService.post('productfactor.save', vm.current_F).then(function(result) {
        var id;
        id = vm.current_F.product_id;
        vm.current_F = {
          product_id: id
        };
        return getProductsFactor();
      });
      return false;
    };
    vm.factorList = [];
    getProductsFactor = function() {
      var filter, tmp_product_id;
      filter = {};
      if (vm.new_product._id === null || vm.new_product._id === void 0) {
        tmp_product_id = "1";
      } else {
        tmp_product_id = vm.new_product._id;
      }
      filter = {
        with_related: true,
        filter: {
          product_id: tmp_product_id
        }
      };
      RequestService.post('productfactor.listing', filter).then(function(result) {
        var atom, atom1, index1, is_included, item, item2, item3, itemvalue, j, k, l, len, len1, len2, len3, m, ref, ref1, ref2, ref3, results, tempAtom;
        vm.factorList = result.docs;
        vm.factorListTS = [];
        is_included = false;
        ref = vm.factorList;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          item = ref[j];
          ref1 = vm.factorListTS;
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            item2 = ref1[k];
            if (item2.factor_name === item.factor.name) {
              is_included = true;
              atom1 = {
                _id: item._id,
                _rev: item._rev,
                values: item.values,
                coefficient: item.coefficient,
                coefficient_type: item.coefficient_type,
                is_default: item.is_default
              };
              ref2 = item2.data;
              for (l = 0, len2 = ref2.length; l < len2; l++) {
                item3 = ref2[l];
                ref3 = item3.values;
                for (m = 0, len3 = ref3.length; m < len3; m++) {
                  itemvalue = ref3[m];
                  index1 = atom1.values.indexOf(itemvalue);
                  if (index1 === !-1) {
                    atom1.values.splice(index1, 1);
                    console.log(item3 + " Уже содержится в списке значений факторов");
                  }
                }
              }
              item2.data.push(atom1);
            }
          }
          if (is_included === false) {
            tempAtom = {
              factor_name: item.factor.name,
              data: []
            };
            atom = {
              _id: item._id,
              _rev: item._rev,
              values: item.values,
              coefficient: item.coefficient,
              coefficient_type: item.coefficient_type,
              is_default: item.is_default
            };
            tempAtom.data.push(atom);
            vm.factorListTS.push(tempAtom);
          }
          results.push(is_included = false);
        }
        return results;
      });
      return false;
    };
    getInsAmount = function() {
      var item, j, len, ref;
      vm.current_BF.insurance_amount = 0;
      ref = vm.tmp_countries;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if (vm.current_BF.countries_id.indexOf(item._id) > -1 && item.min_insurance > vm.current_BF.insurance_amount) {
          vm.current_BF.insurance_amount = item.min_insurance;
        }
      }
    };
    factorValueFilter = function(f_value) {
      var f_item, j, len, ref;
      ref = vm.factorList;
      for (j = 0, len = ref.length; j < len; j++) {
        f_item = ref[j];
        if (f_item.factor_id === vm.current_F.factor._id) {
          if (-1 !== f_item.values.indexOf(f_value)) {
            return false;
          }
        }
      }
      return true;
    };
    countryFilter = function(f_value) {
      var f_item, item2, j, k, len, len1, ref, ref1;
      if (vm.basefactorListTS === null || vm.basefactorListTS === void 0) {
        return true;
      }
      ref = vm.basefactorListTS;
      for (j = 0, len = ref.length; j < len; j++) {
        f_item = ref[j];
        ref1 = f_item.countries;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          item2 = ref1[k];
          if (f_value._id === item2._id && vm.current_BF.countries_id.indexOf(f_value._id) < 0) {
            return false;
          }
        }
      }
      return true;
    };
    clearFactorValues = function() {
      vm.current_F.values = [];
    };
    sortFactorValues = function(value) {
      if (isNaN(value)) {
        return value;
      } else {
        return parseInt(value, 10);
      }
    };
    confirmActionBF = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProductsBaseFactor();
        }
      });
    };
    confirmActionF = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          saveProductsFactor();
        }
      });
    };
    confirmActionBFdelete = function(index, bf) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          basefactorDelete(index, bf);
        }
      });
    };
    confirmActionFDeleteAll = function(bf) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeAllFactors(bf);
        }
      });
    };
    confirmActionFdelete = function(index, item, top) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот фактор"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeFactor(index, item, top);
        }
      });
    };
    confirmActionFinish = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите закончить создание продукта"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          $state.go("app.product");
        }
      });
    };
    vm.confirmActionFinish = confirmActionFinish;
    vm.confirmActionBFdelete = confirmActionBFdelete;
    vm.confirmActionFdelete = confirmActionFdelete;
    vm.confirmActionFDeleteAll = confirmActionFDeleteAll;
    vm.confirmActionF = confirmActionF;
    vm.confirmActionBF = confirmActionBF;
    vm.sortFactorValues = sortFactorValues;
    vm.clearFactorValues = clearFactorValues;
    vm.removeAllFactors = removeAllFactors;
    vm.removeFactor = removeFactor;
    vm.basefactorDelete = basefactorDelete;
    vm.resetForm = resetForm;
    vm.deleteBFandDB = deleteBFandDB;
    vm.saveProductsFactor = saveProductsFactor;
    vm.getProductsBaseFactor = getProductsBaseFactor;
    vm.saveProduct = saveProduct;
    vm.saveProductsBaseFactor = saveProductsBaseFactor;
    vm.factorValueFilter = factorValueFilter;
    vm.getInsAmount = getInsAmount;
    vm.addBF = addBF;
    vm.deleteBF = deleteBF;
    vm.basefactorEdit = basefactorEdit;
    vm.basefactorRowEdit = basefactorRowEdit;
    vm.countryFilter = countryFilter;
    initFunc();
    getProductsBaseFactor();
    getProductsFactor();
  }).controller('ProductViewController', function($scope, Session, RequestService, $stateParams, $filter, $state) {
    'ngInject';
    var toDate, vm;
    vm = this;
    vm.product = $stateParams.product;
    if (vm.product) {
      console.log(vm.product);
    } else {
      console.log("Данные не получены");
    }
    toDate = function(arg) {
      return new Date(arg);
    };
    vm.toDate = toDate;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('PolicyController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, savePDF, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/show.html',
        controller: 'PolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.policy_select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.policy_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/edit.html',
        controller: 'PolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getPolicies();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      } else if (vm.company.company_type === 'branch_company') {
        filter.with_related = true;
        filter.filter = {
          branch_id: vm.company._id
        };
      }
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.date_start = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    savePDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        ReportService.saveReportPdf('TS', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'LN') {
        ReportService.saveReportPdf('LN', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'NED') {
        ReportService.saveReportPdf('NED', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.savePDF = savePDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    getPolicies();
  }).controller('PolicyEditController', function($scope, hotkeys, $state, RequestService, Session, $uibModalInstance, branch, toastr) {
    'ngInject';
    var putBranch, vm;
    vm = this;
    vm.branch = branch || {
      type: 'Branches'
    };
    putBranch = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.branch.name === void 0 || vm.branch.name.trim().length === 0) {
        toastr.warning('Укажите имя филиала');
        vm.saving = false;
        return false;
      }
      if (angular.isUndefined(vm.branch.branch_type)) {
        toastr.warning('Выберите тип');
        vm.saving = false;
        return false;
      }
      RequestService.post('branch.save', vm.branch).then(function(result) {
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
      return false;
    };
    vm.putBranch = putBranch;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('PolicyNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var getDiffDays, goToSelect, vm;
    vm = this;
    vm.diffDays = 0;
    vm.today = new Date();
    goToSelect = function(item) {
      $state.go('app.policy_select', {
        product: item
      });
    };
    getDiffDays = function() {
      var end, start;
      if (vm.pruduct.date_end && vm.pruduct.date_start) {
        start = new Date(vm.pruduct.date_start);
        end = new Date(vm.pruduct.date_end);
        vm.diffDays = Math.round(Math.abs((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000))) + 1;
      }
    };
    vm.goToSelect = goToSelect;
    vm.getDiffDays = getDiffDays;
  }).controller('PolicySelectController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr, AppStorage) {
    'ngInject';
    var addCollateralTs, calculatePremiumTs, confirmAction, deleteCollateralTs, getInsuranceTsObjects, getInvoiceNumber, getTotalDays, getYearLabel, onFullYearsChange, onPeriodTypeChange, onVehicleTypeChange, recalculateOnEventAll, savePolicy, setDefaultCurrency, setDefaultProduct, updateEndDateForOverYear, validateVehicleAge, vm;
    vm = this;
    vm.parseInt = parseInt;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(364, 'day').toDate();
    vm.diffDays = 0;
    vm.insurance_period_type = 'year';
    vm.full_years = 1.5;
    vm.period_disabled = false;
    vm.currentYear = new Date().getFullYear();
    vm.minYear = vm.currentYear - 15;
    vm.vehicleAgeError = false;
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.collateralsts = {
      ts: []
    };
    vm.policy = {
      objects: [],
      insurance_amount: 0,
      insurance_amountts: 0,
      insurance_premiumts: 0,
      date_start: moment().toDate()
    };
    vm.payment_data = {
      who: '',
      inn: '',
      product_name: '',
      amount: 0
    };
    vm.insuranceformts = {
      adres: 'Кыргызская Республика',
      driver: 'Лица, имеющие право на управление застрахованным транспортным средством.',
      objectts: null
    };
    vm.inputCheck = true;
    vm.currenciesToday = AppStorage.getObject('currenciesToday') || [];
    vm.company = Session.getCompany();
    getInvoiceNumber = function() {
      if (vm.policy && vm.policy.policy_no && vm.policy.policy_no.length > 3) {
        return vm.policy.policy_no.substring(3);
      }
      return '';
    };
    validateVehicleAge = function() {
      var age, currentYear, yearIssue;
      if (vm.insuranceformts.year_issue) {
        yearIssue = parseInt(vm.insuranceformts.year_issue);
        currentYear = new Date().getFullYear();
        age = currentYear - yearIssue;
        if (age > 15 || yearIssue < vm.minYear) {
          vm.vehicleAgeError = true;
          toastr.warning("Принимаются ТС не старше 15 лет (не младше " + vm.minYear + " года выпуска)");
        } else {
          vm.vehicleAgeError = false;
        }
      }
    };
    onPeriodTypeChange = function() {
      if (vm.insurance_period_type === 'year') {
        vm.policy.date_end = moment(vm.policy.date_start).add(364, 'day').toDate();
        vm.diffDays = 365;
        vm.period_disabled = true;
      } else if (vm.insurance_period_type === 'over_year') {
        if (!vm.full_years || vm.full_years < 1) {
          vm.full_years = 1.5;
        }
        updateEndDateForOverYear();
        vm.period_disabled = false;
      } else {
        vm.period_disabled = false;
        vm.policy.date_end = null;
      }
      recalculateOnEventAll();
    };
    onFullYearsChange = function() {
      if (vm.insurance_period_type === 'over_year' && vm.full_years) {
        if (vm.full_years < 1) {
          vm.full_years = 1;
        }
        updateEndDateForOverYear();
        recalculateOnEventAll();
      }
    };
    updateEndDateForOverYear = function() {
      var fractionalYears, fullYears, monthsInFractional, totalDays;
      if (vm.policy.date_start && vm.full_years) {
        fullYears = Math.floor(vm.full_years);
        fractionalYears = vm.full_years - fullYears;
        monthsInFractional = Math.round(fractionalYears * 10);
        totalDays = (fullYears * 365) + (monthsInFractional * 30) - 1;
        vm.policy.date_end = moment(vm.policy.date_start).add(totalDays, 'day').toDate();
      }
    };
    getYearLabel = function() {
      var years;
      years = parseFloat(vm.full_years);
      if (years % 1 !== 0) {
        return "года";
      }
      if (years === 1) {
        return "год";
      } else if (years >= 2 && years <= 4) {
        return "года";
      } else {
        return "лет";
      }
    };
    getTotalDays = function() {
      var fractionalYears, fullYears, monthsInFractional;
      if (vm.full_years) {
        fullYears = Math.floor(vm.full_years);
        fractionalYears = vm.full_years - fullYears;
        monthsInFractional = Math.round(fractionalYears * 10);
        return (fullYears * 365) + (monthsInFractional * 30);
      }
      return 0;
    };
    getInsuranceTsObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsts = angular.copy(data.docs);
      });
    };
    onVehicleTypeChange = function() {};
    addCollateralTs = function(insuranceform) {
      if (vm.vehicleAgeError) {
        toastr.error('Невозможно добавить ТС старше 15 лет');
        return;
      }
      if (!insuranceform.objectts) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (insuranceform.insurance_premium) {
        vm.ts = {
          object: insuranceform.objectts.name,
          objectts: insuranceform.objectts,
          adres: insuranceform.adres,
          model: insuranceform.model,
          gosnumber: insuranceform.gosnumber,
          number: insuranceform.number,
          year_issue: insuranceform.year_issue,
          insurance_summ: insuranceform.insurance_summ,
          coll_price: insuranceform.coll_price,
          insurance_premium: insuranceform.insurance_premium,
          driver: insuranceform.driver
        };
        vm.collateralsts.ts.push(vm.ts);
        vm.ts = {};
        vm.insuranceformts = {
          objectts: null,
          adres: 'Кыргызская Республика',
          model: null,
          gosnumber: null,
          number: null,
          year_issue: null,
          insurance_summ: null,
          coll_price: null,
          insurance_premium: null,
          driver: 'Лица, имеющие право на управление застрахованным транспортным средством.'
        };
        vm.policy.insurance_premiumts = vm.policy.insurance_premiumts + insuranceform.insurance_premium;
        vm.policy.insurance_amountts = vm.policy.insurance_amountts + insuranceform.insurance_summ;
        vm.payment_data.amount = vm.policy.insurance_premiumts;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralTs = function(collateral, index) {
      vm.collateralsts.ts.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumts = vm.policy.insurance_premiumts - collateral.insurance_premium;
      vm.policy.insurance_amountts = vm.policy.insurance_amountts - collateral.insurance_summ;
      vm.payment_data.amount = vm.policy.insurance_premiumts;
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, fullYearsCount, monthsCount, remainingDays, timeDiff;
      if (vm.insurance_period_type === 'year') {
        vm.diffDays = 365;
      } else if (vm.insurance_period_type === 'over_year') {
        if (vm.policy.date_start && vm.policy.date_end) {
          date1 = vm.policy.date_start;
          date2 = vm.policy.date_end;
          timeDiff = Math.abs(date2.getTime() - date1.getTime());
          diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
          fullYearsCount = Math.floor(diffDays / 365);
          remainingDays = diffDays - (fullYearsCount * 365);
          monthsCount = Math.round(remainingDays / 30);
          vm.full_years = parseFloat((fullYearsCount + monthsCount / 10).toFixed(1));
          if (vm.full_years < 1) {
            vm.full_years = 1;
          }
          vm.diffDays = diffDays;
        } else {
          vm.diffDays = getTotalDays();
        }
      } else {
        date1 = vm.policy.date_start;
        date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
    };
    savePolicy = function() {
      var agent_id, branch_id, end_date, fractionalYears, fullYears, monthsInFractional, policy, policyList, policy_no, theUser, totalDays;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
        branch_id = vm.company.company_id;
      } else if (vm.company.company_type === "branch_company") {
        branch_id = vm.company._id;
      }
      theUser = Session.getUser();
      policyList = {
        items: []
      };
      if (vm.collateralsts.ts.length > 0) {
        policy_no = 'DVI';
        policy_no = policy_no.slice(0, 3);
        end_date = null;
        if (vm.insurance_period_type === 'year') {
          end_date = moment(vm.policy.date_start).add(364, 'day').toDate();
        } else if (vm.insurance_period_type === 'over_year') {
          fullYears = Math.floor(vm.full_years);
          fractionalYears = vm.full_years - fullYears;
          monthsInFractional = Math.round(fractionalYears * 10);
          totalDays = (fullYears * 365) + (monthsInFractional * 30) - 1;
          end_date = moment(vm.policy.date_start).add(totalDays, 'day').toDate();
        } else {
          end_date = vm.policy.date_end;
        }
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountts,
          insurance_premium: vm.policy.insurance_premiumts,
          insurance_data: {
            ts: vm.collateralsts.ts,
            date_start: vm.policy.date_start,
            date_end: end_date,
            diffDays: vm.diffDays,
            period_type: vm.insurance_period_type,
            full_years: vm.full_years
          },
          objects: 'TS',
          payment_data: {
            invoice_no: policy_no,
            invoice_created_date: new Date(),
            who: vm.policy.client,
            inn: vm.payment_data.inn,
            product_name: policy_no,
            amount: vm.policy.insurance_premiumts
          },
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0,
            payment_data: {
              invoice_no: policy_no,
              invoice_created_date: new Date(),
              who: vm.policy.client,
              inn: vm.payment_data.inn,
              product_name: policy_no,
              amount: vm.policy.insurance_premiumts
            }
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        return $state.go("app.policy");
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var i, item, len, ref, temp, to_save;
        if (result) {
          to_save = [];
          ref = vm.insurants;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    calculatePremiumTs = function() {
      var annualPremium, baseRate, coefficient, days, daysInFractional, fractionalYears, fullYears, monthsInFractional, premiumForFractional, premiumForFullYears, years;
      if (!vm.insuranceformts.objectts) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformts.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      if (!vm.insuranceformts.year_issue) {
        toastr.warning('Введите год выпуска');
        return;
      }
      if (vm.vehicleAgeError) {
        toastr.error('ТС старше 15 лет не принимается');
        return;
      }
      baseRate = vm.insuranceformts.objectts.rate / 100;
      annualPremium = vm.insuranceformts.insurance_summ * baseRate;
      if (vm.insurance_period_type === 'year') {
        vm.insuranceformts.insurance_premium = Math.round(annualPremium);
      } else if (vm.insurance_period_type === 'over_year') {
        years = parseFloat(vm.full_years) || 1.5;
        fullYears = Math.floor(years);
        fractionalYears = years - fullYears;
        premiumForFullYears = annualPremium * fullYears;
        premiumForFractional = 0;
        if (fractionalYears > 0) {
          monthsInFractional = Math.round(fractionalYears * 10);
          daysInFractional = monthsInFractional * 30;
          coefficient = 1.0;
          if (daysInFractional <= 60) {
            coefficient = 0.20;
          } else if (daysInFractional <= 90) {
            coefficient = 0.30;
          } else if (daysInFractional <= 120) {
            coefficient = 0.40;
          } else if (daysInFractional <= 150) {
            coefficient = 0.50;
          } else if (daysInFractional <= 180) {
            coefficient = 0.60;
          } else if (daysInFractional <= 210) {
            coefficient = 0.70;
          } else if (daysInFractional <= 240) {
            coefficient = 0.75;
          } else if (daysInFractional <= 270) {
            coefficient = 0.80;
          } else if (daysInFractional <= 300) {
            coefficient = 0.85;
          } else if (daysInFractional <= 330) {
            coefficient = 0.90;
          } else if (daysInFractional <= 360) {
            coefficient = 0.95;
          } else {
            coefficient = 1.00;
          }
          premiumForFractional = annualPremium * coefficient;
        }
        vm.insuranceformts.insurance_premium = Math.round(premiumForFullYears + premiumForFractional);
      } else if (vm.insurance_period_type === 'up_to_year') {
        days = vm.diffDays;
        coefficient = 1.0;
        if (days <= 30) {
          coefficient = 0.20;
        } else if (days <= 60) {
          coefficient = 0.30;
        } else if (days <= 90) {
          coefficient = 0.40;
        } else if (days <= 120) {
          coefficient = 0.50;
        } else if (days <= 150) {
          coefficient = 0.60;
        } else if (days <= 180) {
          coefficient = 0.70;
        } else if (days <= 210) {
          coefficient = 0.75;
        } else if (days <= 240) {
          coefficient = 0.80;
        } else if (days <= 270) {
          coefficient = 0.85;
        } else if (days <= 300) {
          coefficient = 0.90;
        } else if (days <= 330) {
          coefficient = 0.95;
        } else {
          coefficient = 1.00;
        }
        vm.insuranceformts.insurance_premium = Math.round(annualPremium * coefficient);
      }
      toastr.success("Премия рассчитана: " + vm.insuranceformts.insurance_premium);
    };
    vm.addCollateralTs = addCollateralTs;
    vm.deleteCollateralTs = deleteCollateralTs;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.confirmAction = confirmAction;
    vm.savePolicy = savePolicy;
    vm.calculatePremiumTs = calculatePremiumTs;
    vm.validateVehicleAge = validateVehicleAge;
    vm.onPeriodTypeChange = onPeriodTypeChange;
    vm.onFullYearsChange = onFullYearsChange;
    vm.getYearLabel = getYearLabel;
    vm.getTotalDays = getTotalDays;
    vm.getInvoiceNumber = getInvoiceNumber;
    vm.getInsuranceTsObjects = getInsuranceTsObjects;
    vm.onVehicleTypeChange = onVehicleTypeChange;
    setDefaultCurrency = function() {
      var somCurrency;
      if (vm.currencies && vm.currencies.length > 0) {
        somCurrency = vm.currencies.find(function(c) {
          var ref;
          return ((ref = c.data) != null ? ref.code : void 0) === '417';
        });
        if (somCurrency) {
          vm.currency = somCurrency;
          console.log('Установлена валюта по умолчанию:', vm.currency.name);
        }
      }
    };
    setDefaultProduct = function() {
      if (vm.products && vm.products.length > 0) {
        vm.policy.product_id = vm.products[0]._id;
        console.log('Установлена программа кредитования по умолчанию:', vm.products[0].name);
      }
    };
    $scope.$watch('select.currencies', function(newVal) {
      if (newVal && newVal.length > 0) {
        setDefaultCurrency();
      }
    }, true);
    $scope.$watch('select.products', function(newVal) {
      if (newVal && newVal.length > 0) {
        setDefaultProduct();
      }
    }, true);
    recalculateOnEventAll();
    onPeriodTypeChange();
    RequestService.post('insurancetypes.listing').then(function(data) {
      var i, len, ref, type;
      ref = data.docs;
      for (i = 0, len = ref.length; i < len; i++) {
        type = ref[i];
        if (type.code === 'TC') {
          getInsuranceTsObjects(type._id);
          break;
        }
      }
    });
  }).controller('PolicyIssueController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var addInsurant, changeIcon, computePrice, confirmAction, deleteInsurant, email, getCountries, i, j, len, len1, pdrobneeIconCnange, phone, reCompute, ref, ref1, savePolicy, vm;
    vm = this;
    vm.today = new Date();
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.product = $stateParams.product;
    vm.currency_name = '';
    vm.currencyRate = 0;
    vm.iconsList = [];
    vm.pdrobneeIcon = 'fa fa-chevron-down';
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.company = Session.getCompany();
    vm.buyer = {};
    if (vm.company.company_type = 'agent') {
      vm.buyer.surname = null;
      vm.buyer.name = null;
      if (vm.company.data.emails) {
        ref = vm.company.data.emails;
        for (i = 0, len = ref.length; i < len; i++) {
          email = ref[i];
          vm.buyer.email = email;
          break;
        }
      } else {
        vm.buyer.email = null;
      }
      if (vm.company.data.phones) {
        ref1 = vm.company.data.phones;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          phone = ref1[j];
          vm.buyer.phone = phone;
          break;
        }
      } else {
        vm.buyer.phone = null;
      }
    }
    getCountries = function() {
      var filter;
      filter = {
        with_related: true
      };
      RequestService.post('select.issue_listing', filter).then(function(result) {
        var country, currency, item, itemx, l, len2, len3, len4, m, n, ref2, ref3, ref4, results;
        vm.countries = result.countries;
        vm.min_insurance = 0;
        ref2 = result.countries;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          item = ref2[l];
          ref3 = vm.product.tmp_product.country_id;
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            itemx = ref3[m];
            if (itemx === item._id) {
              vm.countriesView.push(item);
              if (item.min_insurance > vm.min_insurance) {
                vm.min_insurance = item.min_insurance;
                vm.currentCountryId = itemx;
              }
            }
          }
        }
        vm.currencies = result.currencies;
        ref4 = vm.countries;
        results = [];
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          country = ref4[n];
          if (country._id === vm.currentCountryId) {
            results.push((function() {
              var len5, o, ref5, results1;
              ref5 = vm.currencies;
              results1 = [];
              for (o = 0, len5 = ref5.length; o < len5; o++) {
                currency = ref5[o];
                if (country.currency_id === currency._id) {
                  vm.currency_name = currency.data.name;
                  results1.push(RequestService.post('currencynbkr.get_nbkr_rate', {
                    iso: vm.currency_name
                  }).then(function(result) {
                    return vm.currencyRate = result.results;
                  }));
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          } else {
            results.push(void 0);
          }
        }
        return results;
      });
    };
    if (vm.product) {
      getCountries();
      vm.insurants = [
        {
          surname: '',
          name: '',
          passport_no: '',
          date_of_birth: '',
          factorListing: angular.copy(vm.product.factorListing),
          factors: angular.copy(vm.product.tmp_product.factors),
          theprice: angular.copy(vm.product.theprice)
        }
      ];
      vm.iconsList.push('fa fa-plus-square');
    } else {
      $state.go("app.policy_select");
    }
    addInsurant = function() {
      vm.insurants.push({
        surname: '',
        name: '',
        passport_no: '',
        date_of_birth: '',
        factorListing: angular.copy(vm.product.factorListing),
        factors: angular.copy(vm.product.tmp_product.factors),
        theprice: angular.copy(vm.product.theprice)
      });
      vm.iconsList.push('fa fa-plus-square');
    };
    deleteInsurant = function(index) {
      vm.insurants.splice(index, 1);
      vm.iconsList.splice(index, 1);
    };
    changeIcon = function(index) {
      if (vm.iconsList[index] === 'fa fa-plus-square') {
        return vm.iconsList[index] = 'fa fa-minus-square';
      } else {
        return vm.iconsList[index] = 'fa fa-plus-square';
      }
    };
    reCompute = function(insurant) {
      if (insurant.date_of_birth) {
        insurant.factors['Возраст'] = moment().diff(insurant.date_of_birth, 'years');
        insurant.theprice = $filter('number')(computePrice(insurant), 2);
        console.log(insurant);
        console.log(vm.insurants);
      }
    };
    computePrice = function(insurant) {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, item_fact, l, len2, len3, len4, len5, m, n, o, obj_x, prod, ref2, ref3, ref4, ref5, theprice, timeDiff;
      prod = angular.copy(vm.product);
      prod.tmp_product.factors = insurant.factors;
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = "2016-11-03T18:00:00.000Z";
        date1 = new Date(prod.tmp_product.date_start);
      } else {
        date1 = new Date(prod.tmp_product.date_start);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = "2016-11-04T18:00:00.000Z";
        date2 = new Date(prod.tmp_product.date_end);
      } else {
        date2 = new Date(prod.tmp_product.date_end);
      }
      timeDiff = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref2 = vm.countries;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          country_x = ref2[l];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
      } else {
        country_id = country_id[0];
      }
      ref3 = prod.basefactors;
      for (m = 0, len3 = ref3.length; m < len3; m++) {
        basefactor = ref3[m];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.product.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref4 = prod.factors;
      for (n = 0, len4 = ref4.length; n < len4; n++) {
        factor = ref4[n];
        ref5 = factor.factor;
        for (o = 0, len5 = ref5.length; o < len5; o++) {
          item_fact = ref5[o];
          if (prod.tmp_product.factors[item_fact.name] !== null && prod.tmp_product.factors[item_fact.name] !== void 0 && factor.values.indexOf(prod.tmp_product.factors[item_fact.name].toString()) > -1) {
            if (factor.coefficient_type === "Множитель") {
              theprice = theprice * factor.coefficient;
            }
            if (factor.coefficient_type === "Слагаемое") {
              fixedamounts = fixedamounts + factor.coefficient;
            }
          }
        }
      }
      theprice = theprice + fixedamounts;
      theprice = theprice + ((theprice / 100) * 2);
      return theprice;
    };
    savePolicy = function() {
      var agent_id, branch_id, insurance_data, item, key, l, len2, len3, m, policy, policyList, policy_no, ref2, ref3, ref4, theUser, user, value;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
      }
      theUser = Session.getUser();
      if (vm.company) {
        ref2 = vm.company.staff;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          user = ref2[l];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      vm.product.data;
      insurance_data = angular.copy(vm.product.tmp_product);
      policyList = {
        items: []
      };
      ref3 = vm.insurants;
      for (m = 0, len3 = ref3.length; m < len3; m++) {
        item = ref3[m];
        insurance_data.factors = item.factors;
        insurance_data.factors_list = [];
        ref4 = item.factors;
        for (key in ref4) {
          value = ref4[key];
          value = value + "";
          insurance_data.factors_list.push({
            key: key,
            value: value
          });
        }
        policy_no = vm.product.code;
        if (vm.company.company_type === "agent") {
          agent_id = vm.company._id;
          policy_no = policy_no.slice(0, 3) + vm.company.code + "00000";
        } else {
          policy_no = policy_no + "00000";
        }
        policy = {
          policy_no: policy_no,
          issue_date: new Date(),
          product_id: vm.product._id,
          company_id: vm.product.company_id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: {
            surname: item.surname.toUpperCase(),
            name: item.name.toUpperCase(),
            passport_no: item.passport_no,
            date_of_birth: item.date_of_birth
          },
          insurance_amount: vm.product.insurance_amount,
          insurance_premium: item.theprice,
          insurance_data: angular.copy(insurance_data),
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency_name,
            insurance_premium_kgs: (item.theprice * vm.currencyRate).toFixed(2)
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        if (policyList.items.length === 1) {
          policy = angular.copy(policyList.items[0]);
          policy._id = result.resultList[0].id;
          policy._rev = result.resultList[0].rev;
          policy.policy_no = result.resultList[0].policy_no;
          return $state.go('app.policy_view', {
            product: policy
          });
        } else {
          return $state.go("app.policy");
        }
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var item, l, len2, ref2, temp, to_save;
        if (result) {
          to_save = [];
          ref2 = vm.insurants;
          for (l = 0, len2 = ref2.length; l < len2; l++) {
            item = ref2[l];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.changeIcon = changeIcon;
    vm.confirmAction = confirmAction;
    vm.addInsurant = addInsurant;
    vm.deleteInsurant = deleteInsurant;
    vm.reCompute = reCompute;
    vm.savePolicy = savePolicy;
  }).controller('PolicyViewController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal) {
    'ngInject';
    var FormPolicy, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    findCurrencyName = function() {
      var country, currency, i, j, len, len1, ref, ref1;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        country = ref[i];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            currency = ref1[j];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.policy.policy_no === '00000' && vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var i, item, itemx, j, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        ref1 = vm.policy.insurance_data.country_id;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          itemx = ref1[j];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = $stateParams.product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
    }
    sendMail = function() {
      var countries, country, country_id, i, j, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (i = 0, len = ref.length; i < len; i++) {
        country_id = ref[i];
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country = ref1[j];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, i, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code + "00000";
      } else {
        policy_no = policy_no + "00000";
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        policyNumber: vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
  }).controller('PolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.policy");
    }
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.policy');
    };
    goToForm = function() {
      $state.go('app.policy_form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var date1, diffDays, timeDiff;
        if (result) {
          date1 = new Date(vm.policy.issue_date);
          timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
          diffDays = Math.ceil((timeDiff / (1000 * 3600 * 24)) - 1);
          if (diffDays < 1) {
            spoilPolicy();
          } else {
            toastr.warning('Данная операция невозможна!');
          }
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  }).controller('PolicyFormController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var SavePolicy, confirmActionSave, getPeriods, recalculateOnEventAll, vm;
    vm = this;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(364, 'day').toDate();
    vm.diffDays = 0;
    vm.min_insurance = 0;
    vm.currency_name = '';
    vm.currencyRate = 1;
    vm.policy = $stateParams.policy;
    vm.policy.date_start = moment().toDate();
    vm.policy.date_end = null;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, i, j, l, len, len1, len2, len3, len4, len5, ln, m, n, ned, o, period, ref, ref1, ref2, ref3, ref4, ref5, timeDiff, ts;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      vm.policy.insurance_premium = 0;
      vm.policy.insurance_amount = 0;
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
      if (vm.policy.insurance_data.ned) {
        ref = vm.policy.insurance_data.ned;
        for (i = 0, len = ref.length; i < len; i++) {
          ned = ref[i];
          ref1 = vm.periods;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            period = ref1[j];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ned.insurance_premium = Math.round(ned.insurance_summ * (ned.objectned.rate / 100) * vm.period_rate);
          }
          vm.policy.insurance_premium += ned.insurance_premium;
          vm.policy.insurance_amount += ned.insurance_summ;
        }
      } else if (vm.policy.insurance_data.ts) {
        ref2 = vm.policy.insurance_data.ts;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          ts = ref2[l];
          ref3 = vm.periods;
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            period = ref3[m];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ts.insurance_premium = Math.round(ts.insurance_summ * (ts.objectts.rate / 100) * vm.period_rate);
          }
          vm.policy.insurance_premium += ts.insurance_premium;
          vm.policy.insurance_amount += ts.insurance_summ;
        }
      } else if (vm.policy.insurance_data.ln) {
        ref4 = vm.policy.insurance_data.ln;
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          ln = ref4[n];
          ref5 = vm.periods;
          for (o = 0, len5 = ref5.length; o < len5; o++) {
            period = ref5[o];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ln.insurance_premium = Math.round(ln.insurance_summ * 0.004 * vm.period_rate);
          }
          vm.policy.insurance_premium += ln.insurance_premium;
          vm.policy.insurance_amount += ln.insurance_summ;
        }
      }
    };
    SavePolicy = function() {
      var old_policy_no, policyList, policy_no;
      policyList = {
        items: []
      };
      old_policy_no = vm.policy.policy_no;
      delete vm.policy._id;
      delete vm.policy._created;
      delete vm.policy._deleted;
      delete vm.policy._rev;
      if (vm.policy.insurance_data.ned) {
        policy_no = 'HPI';
        policy_no = policy_no.slice(0, 3);
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      } else if (vm.policy.insurance_data.ts) {
        policy_no = 'DVI';
        policy_no = policy_no.slice(0, 3);
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      } else if (vm.policy.insurance_data.ln) {
        policy_no = 'HAI';
        policy_no = policy_no.slice(0, 3);
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      }
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис сохранен успешно');
        return $state.go('app.policy');
      });
      return false;
    };
    confirmActionSave = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          SavePolicy();
        }
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    vm.getPeriods = getPeriods;
    vm.confirmActionSave = confirmActionSave;
    vm.SavePolicy = SavePolicy;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    getPeriods();
  }).controller('PolicyDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    ok = function() {
      $uibModalInstance.close(true);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).controller('TerminateDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    vm.moneyBack = 0;
    ok = function() {
      $uibModalInstance.close(vm.moneyBack);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).filter('filterCountries', function() {
    return function(input, search) {
      var i, item, len, res;
      res = [];
      if (input) {
        for (i = 0, len = input.length; i < len; i++) {
          item = input[i];
          if (item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.data.name_eng.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
            res.push(item);
          }
        }
      } else {
        return [];
      }
      return res;
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('PaymentController', function($scope, $state, RequestService, hotkeys, $uibModal) {
    'ngInject';
    var editPayment, getPayments, newPayment, viewPayment, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'branch.name',
          displayName: 'Филиал'
        }, {
          name: 'amount',
          displayName: 'Наименование'
        }, {
          name: 'currency.name',
          displayName: 'Валюта'
        }, {
          name: 'payment_direction_value.data.name',
          displayName: 'Направление платежа'
        }, {
          name: 'payment_type_value.data.name',
          displayName: 'Тип платежа'
        }, {
          name: 'payment_date',
          displayName: 'Дата редактирования',
          cellTemplate: '<div class="ui-grid-cell-contents" am-time-ago="grid.getCellValue(row,col)"></div>'
        }
      ],
      appScopeProvider: {
        onDoubleClick: function(row) {
          viewPayment(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>'
    };
    getPayments = function() {
      var filter;
      filter = {
        limit: vm.limit,
        offset: vm.offset,
        with_related: true
      };
      RequestService.post('payment.listing', filter).then(function(result) {
        delete vm.selected_payment;
        vm.gridOptions.data = result.payments;
        vm.gridOptions.totalItems = result.count;
      });
    };
    newPayment = function() {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentEditController',
        controllerAs: 'edit',
        templateUrl: 'app/payment/edit.html',
        size: 'lg',
        resolve: {
          payment: void 0
        }
      });
      paymentModal.result.then(function(result) {
        getPayments();
      });
    };
    editPayment = function() {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentEditController',
        controllerAs: 'edit',
        templateUrl: 'app/payment/edit.html',
        size: 'lg',
        resolve: {
          payment: angular.copy(vm.selected_payment)
        }
      });
      paymentModal.result.then(function(result) {
        getPayments();
      });
    };
    viewPayment = function(payment) {
      var paymentModal;
      paymentModal = $uibModal.open({
        controller: 'PaymentViewController',
        controllerAs: 'view',
        templateUrl: 'app/payment/view.html',
        size: 'lg',
        resolve: {
          payment: payment
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_payment = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPayments();
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить платеж',
      callback: newPayment
    }).add({
      combo: 'r',
      description: 'Обновить список платежей',
      callback: getPayments
    });
    vm.getPayments = getPayments;
    vm.newPayment = newPayment;
    vm.editPayment = editPayment;
    getPayments();
  }).controller('PaymentEditController', function($scope, $state, RequestService, payment, $uibModalInstance, toastr) {
    'ngInject';
    var savePayment, vm;
    vm = this;
    vm.payment = payment;
    savePayment = function() {
      if (vm.saving === true) {
        return;
      }
      if ((angular.isDefined(vm.payment.data.contractor_id)) && (angular.isDefined(vm.payment.data.employee_id)) && (angular.isDefined(vm.payment.data.branch_id))) {
        vm.contractor_error = angular.isDefined(vm.payment.data.contractor_id);
        vm.employee_error = angular.isDefined(vm.payment.data.employee_id);
        vm.brach_error = angular.isDefined(vm.payment.data.branch_id);
        toastr.warning('Укажите только одного');
        vm.saving = false;
        return;
      }
      if ((angular.isUndefined(vm.payment.data.contractor_id)) && (angular.isUndefined(vm.payment.data.employee_id)) && (angular.isUndefined(vm.payment.data.branch_id))) {
        vm.contractor_error = true;
        vm.employee_error = true;
        vm.brach_error = true;
        toastr.warning('Заполните одно из полей');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.branch_id)) {
        toastr.warning('Укажите филиал');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.currency_id)) {
        toastr.warning('Укажите валюту');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.payment_direction)) {
        toastr.warning('Укажите направление платежа');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.payment_type)) {
        toastr.warning('Укажите тип платежа');
        vm.saving = false;
        return;
      }
      if (angular.isUndefined(vm.payment.amount)) {
        toastr.warning('Укажите сумму');
        vm.saving = false;
        return;
      }
      vm.saving = true;
      RequestService.post('payment.put', vm.payment).then(function(result) {
        vm.saving = false;
        return $uibModalInstance.close(result);
      }, function(result) {
        vm.saving = false;
      });
    };
    vm.savePayment = savePayment;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('PaymentViewController', function($scope, $state, RequestService, payment, $uibModalInstance) {
    'ngInject';
    var vm;
    vm = this;
    vm.payment = payment;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('OperationController', function($scope, $state, RequestService, hotkeys, $uibModal) {
    'ngInject';
    var getOperations, viewOperation, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'branch.name',
          displayName: 'Филиал'
        }, {
          name: 'product.name',
          displayName: 'Продукт'
        }, {
          name: 'quantity',
          displayName: 'Наименование'
        }, {
          name: 'currency.name',
          displayName: 'Валюта'
        }, {
          name: 'quote_unit_price',
          displayName: 'Цена'
        }, {
          name: 'total_cost',
          displayName: 'Сумма'
        }, {
          name: 'additional_cost',
          displayName: 'Доп. стоимость'
        }
      ],
      appScopeProvider: {
        onDoubleClick: function(row) {
          viewOperation(row.entity);
        }
      },
      rowTemplate: '<div ng-dblclick="grid.appScope.onDoubleClick(row)" ng-repeat="col in colContainer.renderedColumns" class="ui-grid-cell" ui-grid-cell></div>'
    };
    getOperations = function() {
      var filter;
      filter = {
        limit: vm.limit,
        offset: vm.offset,
        with_related: true
      };
      RequestService.post('operation.listing', filter).then(function(result) {
        delete vm.selected_operation;
        vm.gridOptions.data = result.operations;
        vm.gridOptions.totalItems = result.count;
      });
    };
    viewOperation = function(operation) {
      var operationModal;
      operationModal = $uibModal.open({
        controller: 'OperationViewController',
        controllerAs: 'view',
        templateUrl: 'app/operation/view.html',
        size: 'lg',
        resolve: {
          operation: operation
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_operation = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getOperations();
    });
    hotkeys.bindTo($scope).add({
      combo: 'r',
      description: 'Обновить список операций',
      callback: getOperations
    });
    vm.getOperations = getOperations;
    getOperations();
  }).controller('OperationViewController', function($scope, $state, RequestService, operation, $uibModalInstance) {
    'ngInject';
    var vm;
    vm = this;
    vm.operation = operation;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('NewsController', function(RequestService, $timeout, toastr, $rootScope, $http, $state) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('NewsListController', function($rootScope, $scope, $state, RequestService, $http) {
    'ngInject';
    var getNews, openCreateForm, openEditForm, removeNews, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 20;
    vm.searchValues = {};
    vm.searchValuesLang = {};
    vm.dateOptions = {
      startingDay: 1,
      opened1: false,
      opened2: false
    };
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [100, 200, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          displayName: 'Название',
          name: 'name'
        }, {
          displayName: 'Актив',
          name: 'is_active'
        }
      ],
      events: {
        onRowSelect: function(row) {
          vm.selected_news = angular.copy(row.entity);
        },
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          getNews();
        }
      }
    };
    getNews = function() {
      var filter;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      RequestService.post('news.listing', filter).then(function(response) {
        vm.gridOptions.data = response.docs;
      }, function(response) {});
    };
    openCreateForm = function() {
      $state.go('app.news.form');
    };
    openEditForm = function() {
      return $state.go('app.news.form', {
        news: vm.selected_news
      });
    };
    removeNews = function() {
      if (!vm.selected_news) {
        return;
      }
      vm.selected_news.crud = 'News';
      RequestService.post('news/delete', vm.selected_news).then(function(result) {
        getNews();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_news = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getRegulations();
    });
    vm.removeNews = removeNews;
    vm.getNews = getNews;
    vm.openCreateForm = openCreateForm;
    vm.openEditForm = openEditForm;
    getNews();
  }).controller('NewsFormController', function($rootScope, $scope, $state, $stateParams, RequestService, $http, hotkeys, toastr, $base64, $uibModal) {
    'ngInject';
    var goBack, saveNews, vm;
    vm = this;
    vm.newsItem = $stateParams.news;
    if (angular.isUndefined(vm.newsItem || vm.newsItem === null)) {
      goBack();
    }
    saveNews = function() {
      RequestService.post('news.put', vm.newsItem).then(function(response) {
        $state.go('app.news.list');
        return toastr.success('Вы успешно добавили новость');
      });
    };
    goBack = function() {
      $state.go('app.news.list');
    };
    vm.saveNews = saveNews;
    vm.goBack = goBack;
  }).controller('NewsViewController', function($rootScope, $scope, $state, $stateParams, RequestService, $http, hotkeys, toastr, $base64, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
    vm.document = $stateParams.news;
    if (angular.isUndefined(vm.document || vm.document === null)) {
      goBack();
    }
  });

}).call(this);



(function() {
  angular.module('fsa').controller('SearchProdController', function($scope, $uibModalInstance, uiGridConstants, $timeout) {
    $scope.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'data.name',
          pinnedLeft: true,
          displayName: 'Наименование'
        }, {
          name: 'data.price',
          pinnedLeft: true,
          displayName: 'Цена'
        }
      ]
    };
    $scope.ok = function() {
      return $uibModalInstance.close($scope.entity);
    };
    $scope.cancel = function() {
      return $uibModalInstance.dismiss();
    };
    $scope.pressed = function(e) {
      if (e.keyCode === 13 && $scope.entity) {
        $scope.ok();
      }
    };
    $scope.$on('data-selected', function(e, row) {
      return $scope.entity = row.entity;
    });
  });

}).call(this);



(function() {
  angular.module('fsa').controller('MenuController', function($scope, RequestService, Session, $state, AppStorage, hotkeys) {
    'ngInject';
    var filterOnlyParents, getMenus, vm;
    vm = this;
    if ($scope.app.ua.role < 10) {
      $state.go('app.company');
      return;
    }
    getMenus = function() {
      RequestService.post('menu.listing').then(function(result) {
        vm.menus = result.docs;
      });
    };
    filterOnlyParents = function(menu) {
      if ((angular.isUndefined(menu)) || (angular.isUndefined(menu.parent_id)) || menu.parent_id === null) {
        return true;
      }
      return false;
    };
    $scope.$on('refresh-menus', function() {
      return getMenus();
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Новое меню',
      callback: function() {
        return $state.go('app.menu.item', {
          id: 'new'
        });
      }
    }).add({
      combo: 'r',
      description: 'Обновить сисок меню',
      callback: getMenus
    });
    vm.getMenus = getMenus;
    vm.filterOnlyParents = filterOnlyParents;
    getMenus();
  }).controller('MenuItemController', function($scope, RequestService, $stateParams, AppStorage, $state, $rootScope) {
    'ngInject';
    var initMenu, putMenu, refreshMenus, vm;
    vm = this;
    refreshMenus = function() {
      return $rootScope.$broadcast('refresh-menus');
    };
    putMenu = function() {
      var data;
      data = {
        _id: vm.menu._id,
        _rev: vm.menu._rev,
        name: vm.menu.name,
        parent_id: vm.menu.parent_id,
        data: {
          position: vm.menu.data.position,
          icon: vm.menu.data.icon,
          route: vm.menu.data.route
        }
      };
      RequestService.post('menu.save', data).then(function(result) {
        vm.menu._id = result.id;
        if ($stateParams.id === 'new') {
          $state.go('app.menu.item', {
            id: vm.menu._id
          });
        }
        refreshMenus();
        return;
      });
      return false;
    };
    initMenu = function() {
      vm.menu = {};
      if ($stateParams.id !== 'new') {
        return RequestService.post('menu.listing', {
          filter: {
            _id: $stateParams.id
          }
        }).then(function(result) {
          if (result.docs.length === 1) {
            return vm.menu = result.docs[0];
          }
        });
      }
    };
    $rootScope.$on('menus-updated', function() {
      return initMenu();
    });
    vm.putMenu = putMenu;
    initMenu();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('MainController', function($scope, AppStorage, $rootScope, RequestService, $state, Session, EVENTS, $window, toastr, $location) {
    'ngInject';
    var closeCompany, getCurrency, getMenus, goBack, logOut, parentGroup, vm;
    vm = this;
    $rootScope.$on(EVENTS.notAuthenticated, function() {
      Session.destroy();
      delete vm.ua;
      $state.go('login');
      return AppStorage.clear();
    });
    $rootScope.$on(EVENTS.businessError, function(e, message) {
      return toastr.warning(message);
    });
    $rootScope.$on(EVENTS.applicationError, function(e, message) {
      return toastr.error(message);
    });
    $rootScope.$on(EVENTS.connectionError, function() {
      return toastr.error('Проверьте соединение с сервером');
    });
    $rootScope.$on(EVENTS.successMessage, function(e, message) {
      return toastr.success(message);
    });
    $rootScope.$on(EVENTS.loginSuccess, function() {
      AppStorage.clear();
      $state.go('app.dashboard');
    });
    vm.signOut = function() {
      return vm.$emit(EVENTS.notAuthenticated);
    };
    $rootScope.company = {
      name: "APEX GROUP",
      id: 1
    };
    $rootScope.branch = {
      name: "Main Office",
      id: 5
    };
    $rootScope.user = {
      name: "User",
      id: 1
    };
    if (Session.getToken() === void 0) {
      $state.go('login');
      return;
    }
    vm.api = $rootScope.api;
    vm.ua = Session.getUser();
    vm.uc = Session.getCompany();
    vm.navigation = AppStorage.getObject('navigation') || [];
    logOut = function() {
      return $rootScope.$broadcast(EVENTS.notAuthenticated);
    };
    if (vm.ua === void 0) {
      logOut();
      return;
    }
    if (vm.ua.role >= 10) {
      vm.admin_menu = [
        {
          name: 'Админ',
          data: {
            icon: 'fa fa-cogs',
            position: 1
          },
          children: [
            {
              name: 'Компании',
              data: {
                route: 'app.company',
                position: 0
              }
            }, {
              name: 'Агенты',
              data: {
                route: 'app.agent',
                position: 1
              }
            }, {
              name: 'Меню',
              data: {
                route: 'app.menu',
                position: 2
              }
            }, {
              name: 'Роли',
              data: {
                route: 'app.role',
                position: 3
              }
            }, {
              name: 'Справочники',
              data: {
                route: 'app.dictionary',
                position: 4
              }
            }, {
              name: 'Пользователи',
              data: {
                route: 'app.users',
                position: 5
              }
            }, {
              name: 'Просмотр отчетов',
              data: {
                route: 'app.report_viewer',
                position: 6
              }
            }, {
              name: 'Дизайнер отчетов',
              data: {
                route: 'app.report_designer',
                position: 7
              }
            }, {
              name: 'Шаблоны отчетов',
              data: {
                route: 'app.report_template',
                position: 8
              }
            }, {
              name: 'Курсы валют',
              data: {
                route: 'app.currency',
                position: 10
              }
            }
          ]
        }
      ];
    }
    getMenus = function() {
      var filter;
      filter = {
        with_related: true
      };
      return RequestService.post('menu.listing', filter).then(function(result) {
        var child, children, i, j, k, len, len1, len2, menu, parents, ref;
        parents = [];
        children = [];
        ref = result.docs;
        for (i = 0, len = ref.length; i < len; i++) {
          menu = ref[i];
          if (menu.parent_id === null || angular.isUndefined(menu.parent_id)) {
            parents.push(menu);
          } else {
            children.push(menu);
          }
        }
        for (j = 0, len1 = parents.length; j < len1; j++) {
          menu = parents[j];
          menu.children = [];
          for (k = 0, len2 = children.length; k < len2; k++) {
            child = children[k];
            if (menu._id === child.parent_id) {
              menu.children.push(child);
            }
          }
        }
        vm.navigation = parents;
        AppStorage.setObject('navigation', vm.navigation);
        AppStorage.setObject('menus', result.docs);
        return $rootScope.$broadcast('menus-updated');
      });
    };
    closeCompany = function() {
      RequestService.post('user.set_company', {
        company_id: null
      }).then(function(result) {
        $rootScope.$broadcast('close-active-company');
        $state.go('app.company');
        return getMenus();
      });
    };
    parentGroup = function(item) {
      if (!item.parent) {
        return '';
      }
      return item.parent.name;
    };
    $rootScope.$on('refresh-menus', function() {
      getMenus();
    });
    goBack = function() {
      if ($window.history.length === 1) {
        if ($state.current.name.startsWith('app.docs')) {
          $state.go("app.docs.listing");
        } else {
          $state.go("app.company");
        }
        return;
      }
      $window.history.back();
    };
    vm.app = {
      name: 'Halyk',
      merchant: $location.host().indexOf('.') < 0 ? 'Халык Банк' : $location.host().split('.')[0],
      version: '2.0.0',
      color: {
        primary: '#7266ba',
        info: '#23b7e5',
        success: '#27c24c',
        warning: '#fad733',
        danger: '#f05050',
        light: '#e8eff0',
        dark: '#3a3f51',
        black: '#1c2b36'
      },
      settings: {
        themeID: 1,
        navbarHeaderColor: 'bg-black',
        navbarCollapseColor: 'bg-white-only',
        asideColor: 'bg-black',
        headerFixed: true,
        asideFixed: true,
        asideFolded: true,
        asideDock: false,
        container: false
      }
    };
    getCurrency = function() {
      return RequestService.post('currencynbkr.get_nbkr_rate', {
        date: moment().format("YYYY-MM-DD 00:00:00")
      }).then(function(response) {
        return AppStorage.setObject('currenciesToday', response.results);
      });
    };
    vm.getCurrency = getCurrency;
    vm.parentGroup = parentGroup;
    vm.closeCompany = closeCompany;
    vm.logOut = logOut;
    $scope.goBack = goBack;
    getCurrency();
    getMenus();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('HpolicyController', function() {
    'ngInject';
    var vm;
    vm = this;
  }).controller('HpolicyListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getBranches, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, savePDF, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/hpolicy/show.html',
        controller: 'HpolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.policy_select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.policy_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/edit.html',
        controller: 'PolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.date_start = v;
        }
        if (k === "agent_id") {
          filter.filter.edit_user_id = v;
        }
        if (k === "branch_id") {
          filter.filter.branch_id = v;
        }
        if (k === "client") {
          filter.filter.client = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getBranches = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'branch_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.branches = data.docs;
      });
    };
    getAgents = function(company_id) {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        id: company_id
      };
      RequestService.post('agentemployee.listing', filter).then(function(data) {
        vm.agents = data.users;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    savePDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        ReportService.saveReportPdf('TS', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'LN') {
        ReportService.saveReportPdf('LN', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'NED') {
        ReportService.saveReportPdf('NED', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.savePDF = savePDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.getAgents = getAgents;
    getBranches();
    getPolicies();
  }).controller('HpolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, date1, diffDays, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, timeDiff, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.policy");
    } else {
      date1 = new Date(vm.policy.issue_date);
      timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays >= 1) {
        vm.flag_status_policy = false;
      }
    }
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.policy');
    };
    goToForm = function() {
      $state.go('app.policy_form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('FpolicyController', function() {
    'ngInject';
    var vm;
    vm = this;
  }).controller('FpolicyListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, savePDF, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/fpolicy/show.html',
        controller: 'FpolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.policy_select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.policy_issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/policy/edit.html',
        controller: 'PolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.date_start = v;
        }
        if (k === "agent_id") {
          filter.filter.edit_user_id = v;
        }
        if (k === "branch_id") {
          filter.filter.branch_id = v;
        }
        if (k === "client") {
          filter.filter.client = v;
        }
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        id: vm.company._id
      };
      RequestService.post('agentemployee.listing', filter).then(function(data) {
        vm.agents = data.users;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    savePDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        ReportService.saveReportPdf('TS', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'LN') {
        ReportService.saveReportPdf('LN', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else if (vm.selected_policy.objects === 'NED') {
        ReportService.saveReportPdf('NED', {
          'policyNumber': vm.selected_policy.policy_no
        });
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.savePDF = savePDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    vm.getAgents = getAgents;
    getAgents();
    getPolicies();
  }).controller('FpolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, date1, diffDays, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, timeDiff, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.policy");
    } else {
      date1 = new Date(vm.policy.issue_date);
      timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays >= 1) {
        vm.flag_status_policy = false;
      }
    }
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.policy");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.policy');
    };
    goToForm = function() {
      $state.go('app.policy_form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('EmployeeController', function(RequestService, product_types, $scope, $uibModal, toastr, Session) {
    'ngInject';
    var deleteEmployee, editEmployee, getEmployees, newEmployee, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.employeeGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'ФИО'
        }, {
          name: 'birthday',
          displayName: 'Дата рождения',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }
      ]
    };
    getEmployees = function() {
      RequestService.post('employee.listing', {
        company_id: vm.company._id
      }).then(function(data) {
        vm.employees = data.docs;
        vm.employeeGridOptions.data = vm.employees;
        vm.employeeGridOptions.totalItems = vm.employees.length;
      });
    };
    editEmployee = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/employee/edit.html',
        controller: 'EmployeeCreateController',
        controllerAs: 'employee',
        size: 'lg',
        resolve: {
          employee: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getEmployees();
      });
    };
    deleteEmployee = function(user) {
      RequestService.post('employee.delete', {
        _id: user._id,
        _rev: user._rev
      }).then(function(data) {
        toastr.success('Сотрудник удален');
        return getEmployees();
      });
    };
    newEmployee = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/employee/create.html',
        controller: 'EmployeeCreateController',
        controllerAs: 'employee',
        size: 'lg',
        resolve: {
          employee: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getEmployees();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    vm.newEmployee = newEmployee;
    vm.editEmployee = editEmployee;
    vm.getEmployees = getEmployees;
    vm.deleteEmployee = deleteEmployee;
    getEmployees();
  }).controller('EmployeeCreateController', function(RequestService, employee, $scope, $uibModalInstance) {
    'ngInject';
    var cancel, createEmployee, updateEmployee, vm;
    vm = this;
    if (employee === null || employee === void 0) {
      vm.employee = {};
    } else {
      vm.employee = employee;
    }
    createEmployee = function() {
      RequestService.post('employee.put', vm.employee).then(function(result) {
        return $uibModalInstance.close(result);
      });
    };
    updateEmployee = function() {
      RequestService.post('employee.put', vm.employee).then(function(result) {
        return $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateEmployee = updateEmployee;
    vm.createEmployee = createEmployee;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DoctemplatesController', function() {
    'ngInject';
    var vm;
    vm = this;
  }).controller('DoctemplatesAddController', function($rootScope, $scope, RequestService, $state, $http, Session) {
    'ngInject';
    var goBack, saveDocTemp, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.flowConfig = {
      target: $rootScope.api + 'upload/' + vm.company.name + '/' + vm.company._id,
      singleFile: true
    };
    vm.docTemp = {};
    goBack = function() {
      $state.go('app.doctemplates.list');
    };
    saveDocTemp = function() {
      console.log(vm.docTemp);
      RequestService.post('doc_templates/put', vm.docTemp).then(function(response) {
        goBack();
      }, function(response) {
        console.log(response);
      });
    };
    vm.goBack = goBack;
    vm.saveDocTemp = saveDocTemp;
  }).controller('DoctemplatesListController', function($rootScope, $scope, AppStorage, RequestService, $http, $state, Session, $base64) {
    'ngInject';
    var deleteDoc, getDocTeplates, openAddForm, vm;
    vm = this;
    vm.docTemps = [];
    vm.api = $rootScope.api;
    getDocTeplates = function() {
      RequestService.post('doc_templates.listing', {}).then(function(response) {
        vm.docTemps = response.docs;
      }, function(response) {
        console.log(response);
      });
    };
    deleteDoc = function(docTemp) {
      if (!confirm('Вы действительно хотите удалить шаблон ?')) {
        return;
      }
      RequestService.post('doc_templates.delete', docTemp).then(function(response) {
        console.log(response);
        getDocTeplates();
      }, function(response) {
        console.log(response);
      });
    };
    openAddForm = function() {
      $state.go('app.doctemplates.add');
    };
    vm.getDocTeplates = getDocTeplates;
    vm.deleteDoc = deleteDoc;
    vm.openAddForm = openAddForm;
    getDocTeplates();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DictionaryController', function($scope, RequestService, $state, $stateParams, toastr, $uibModal) {
    'ngInject';
    var editDictionary, getDictionaries, listTables, newDictionary, removeConfirmAction, removeDictionary, roleFilter, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.gridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: []
    };
    listTables = function() {
      RequestService.post('dictionary.tables_list').then(function(result) {
        vm.tables = result.tables;
        if ((angular.isUndefined(vm.active_table)) && vm.tables.length > 0) {
          vm.active_table = vm.tables[0];
        }
      });
    };
    getDictionaries = function() {
      var filter;
      if (angular.isUndefined(vm.active_table)) {
        listDictionaries();
        return;
      }
      filter = {
        type: vm.active_table.table,
        offset: vm.offset,
        limit: vm.limit,
        with_related: true
      };
      RequestService.post('dictionary.listing', filter).then(function(result) {
        delete vm.selected_dictionary;
        vm.gridOptions.data = result.docs;
        vm.gridOptions.totalItems = result.count;
      });
    };
    newDictionary = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/dictionary/modal.html',
        controller: 'DictionaryEditController',
        controllerAs: 'edit',
        size: 'lg',
        resolve: {
          table: vm.active_table,
          dictionary: void 0
        }
      });
      editModal.result.then(function() {
        return getDictionaries();
      });
    };
    editDictionary = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/dictionary/modal.html',
        controller: 'DictionaryEditController',
        controllerAs: 'edit',
        size: 'lg',
        resolve: {
          table: vm.active_table,
          dictionary: angular.copy(vm.selected_dictionary)
        }
      });
      editModal.result.then(function() {
        return getDictionaries();
      });
    };
    roleFilter = function(table) {
      if (table.role_requires <= $scope.app.ua.role) {
        return true;
      }
      return false;
    };
    removeDictionary = function() {
      vm.selected_dictionary.type = vm.active_table.table;
      return RequestService.post('dictionary.remove', vm.selected_dictionary).then(function(data) {
        getDictionaries();
      });
    };
    removeConfirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить справочник"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeDictionary();
        }
      });
    };
    $scope.$watch('dictionary.active_table', function() {
      var column;
      if (angular.isDefined(vm.active_table)) {
        vm.gridOptions.columnDefs = (function() {
          var i, len, ref, results;
          ref = vm.active_table.columns;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            column = ref[i];
            results.push({
              name: column.name,
              displayName: column.displayName
            });
          }
          return results;
        })();
        vm.grid = '<paged-table options="dictionary.gridOptions" disable-search="true"></paged-table>';
        getDictionaries();
      }
    });
    $scope.$on('data-selected', function(event, row) {
      vm.selected_dictionary = row.entity;
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getDictionaries();
    });
    vm.roleFilter = roleFilter;
    vm.getDictionaries = getDictionaries;
    vm.newDictionary = newDictionary;
    vm.editDictionary = editDictionary;
    vm.removeDictionary = removeDictionary;
    vm.removeConfirmAction = removeConfirmAction;
    vm.grid = '';
    listTables();
  }).controller('DictionaryEditController', function($scope, RequestService, table, dictionary, $uibModalInstance) {
    'ngInject';
    var saveDictionary, vm;
    vm = this;
    if (angular.isUndefined(table)) {
      $uibModalInstance.dismiss('cancel');
      return;
    }
    vm.template = 'app/dictionary/' + (table.table.toLowerCase()) + '/edit.html';
    if (angular.isUndefined(dictionary)) {
      dictionary = {
        type: table.table
      };
    }
    vm.table = table;
    vm.dictionary = dictionary;
    saveDictionary = function() {
      if (vm.preSave() === false) {
        return;
      }
      vm.dictionary.type = vm.table.table;
      RequestService.post('dictionary.save', vm.dictionary).then(function(result) {
        $uibModalInstance.close(result);
      });
    };
    vm.preSave = function() {};
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.saveDictionary = saveDictionary;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DefaultsController', function($scope, $state, $stateParams, toastr, hotkeys, RequestService, $uibModal) {
    'ngInject';
    var editDefault, getDefaults, vm;
    vm = this;
    vm.gridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Тип'
        }, {
          name: 'data.approval.required',
          displayName: 'Обьязательное одобрение'
        }, {
          name: 'data.data.executor.username',
          displayName: 'Исполнитель'
        }
      ]
    };
    getDefaults = function() {
      vm.doc_types = [];
      RequestService.post('doc/all').then(function(result) {
        var doc_type, filter;
        delete vm.selected_default;
        vm.doc_types = result.doc_types;
        vm.gridOptions.data = (function() {
          var i, len, ref, results;
          ref = vm.doc_types;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            doc_type = ref[i];
            results.push({
              document_type: doc_type.id,
              name: doc_type.name
            });
          }
          return results;
        })();
        filter = {
          with_related: true
        };
        return RequestService.post('defaults.listing', filter).then(function(result) {
          var doc_default, i, item, len, position, ref, ref1;
          ref = result.docs;
          for (i = 0, len = ref.length; i < len; i++) {
            doc_type = ref[i];
            position = -1;
            ref1 = vm.gridOptions.data;
            for (item in ref1) {
              doc_default = ref1[item];
              if (doc_default.document_type === doc_type.document_type) {
                doc_type.name = doc_default.name;
                position = item;
                break;
              }
            }
            if (position > -1) {
              vm.gridOptions.data.splice(position, 1, doc_type);
            }
          }
        });
      });
    };
    editDefault = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/defaults/edit.html',
        controller: 'DefaultsEditController',
        controllerAs: 'defaults',
        size: 'lg',
        resolve: {
          doc_types: function() {
            return angular.copy(vm.doc_types);
          },
          doc_default: angular.copy(vm.selected_default)
        }
      });
      editModal.result.then(function() {
        return getDefaults();
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_default = row.entity;
    });
    hotkeys.bindTo($scope).add({
      combo: 'r',
      description: 'Обновить',
      callback: function() {
        return getDefaults();
      }
    });
    vm.getDefaults = getDefaults;
    vm.editDefault = editDefault;
    getDefaults();
  }).controller('DefaultsEditController', function($scope, $state, $stateParams, toastr, RequestService, doc_types, doc_default, $uibModalInstance) {
    'ngInject';
    var addApprovalRole, delApprovalRole, putDefault, vm;
    vm = this;
    vm.doc_types = doc_types;
    vm.doc_default = doc_default;
    putDefault = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.doc_default.data.approval && vm.doc_default.data.approval.required === true) {
        if (vm.doc_default.data.approval.approval_type === void 0) {
          toastr.warning('Выберите тип одобрения!');
          vm.saving = false;
          return;
        }
        if (angular.isUndefined(vm.doc_default.data.approval.approval_roles) || vm.doc_default.data.approval.approval_roles.length === 0) {
          toastr.warning('Укажите роли!');
          vm.saving = false;
          return;
        }
      } else {
        delete vm.doc_default.data.approval;
      }
      RequestService.post('defaults.save', vm.doc_default).then(function(result) {
        vm.saving = false;
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
    };
    addApprovalRole = function() {
      if (angular.isUndefined(vm.approval_role_id)) {
        toastr.warning('Роль не выбрана!');
        return;
      }
      if ((vm.doc_default.data.approval.roles_id ? vm.doc_default.data.approval.roles_id : vm.doc_default.data.approval.roles_id = []).indexOf(vm.approval_role_id) > -1) {
        toastr.warning('Роль уже указана');
        return;
      }
      vm.doc_default.data.approval.roles_id.push(vm.approval_role_id);
      delete vm.approval_role_id;
    };
    delApprovalRole = function(role_id) {
      var index;
      index = vm.doc_default.data.approval.roles_id.indexOf(role_id);
      if (index > -1) {
        vm.doc_default.data.approval.roles_id.splice(index, 1);
      }
    };
    vm.putDefault = putDefault;
    vm.addApprovalRole = addApprovalRole;
    vm.delApprovalRole = delApprovalRole;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('DashboardController', function($rootScope, $scope, $state, RequestService, $http, IntermediateDataService, AppStorage) {
    'ngInject';
    var getNews, getPolicies, getRegulations, goToNewsPage, onDblClick, vm;
    vm = this;
    vm.today = new Date();
    vm.api = $rootScope.api;
    vm.offset = 0;
    vm.limit = 20;
    vm.currencies = AppStorage.getObject('currenciesToday') || [];
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'day',
          displayName: 'Истекает через N дней'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    getNews = function() {
      var filter;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.with_related = true;
      filter.order_by = ["create_date DESC"];
      RequestService.post('news.listing', filter).then(function(response) {
        vm.news = response.docs;
      }, function(response) {});
    };
    getPolicies = function() {
      var filter;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.report_period = ['Оформлен'];
      RequestService.post('policies.list_period', filter).then(function(response) {
        vm.policiesGridOptions.data = angular.copy(response.docs);
        vm.policiesGridOptions.totalItems = response.count;
      }, function(response) {});
    };
    goToNewsPage = function(item) {
      $state.go('app.news.view', {
        news: item
      });
    };
    getRegulations = function() {
      RequestService.post('regulations.listing').then(function(result) {
        return vm.regulations = result.list;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.getNews = getNews;
    vm.goToNewsPage = goToNewsPage;
    vm.getRegulations = getRegulations;
    vm.getPolicies = getPolicies;
    getNews();
    getRegulations();
    getPolicies();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('CurrencyController', function(RequestService, ReportService, $scope, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deleteCurrency, getCurrency, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 10;
    vm.currencyGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'currency_date',
          displayName: 'День',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'currency',
          displayName: 'Валюта'
        }, {
          name: 'rate',
          displayName: 'Ставка'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      }
    };
    getCurrency = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["currency_date DESC"];
      RequestService.post('currencyrate.listing', filter).then(function(result) {
        vm.currencyGridOptions.data = result.docs;
        vm.currencyGridOptions.totalItems = result.count;
      });
    };
    deleteCurrency = function() {
      RequestService.post('currencyrate.delete', vm.selected_currency).then(function(data) {
        toastr.success('Операция выполнена успешно');
        getCurrency();
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот курс валют"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deleteCurrency();
        }
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_currency = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getCurrency();
    });
    vm.getCurrency = getCurrency;
    vm.deleteCurrency = deleteCurrency;
    vm.confirmAction = confirmAction;
    getCurrency();
  });

}).call(this);



(function() {
  angular.module('fsa').directive('pagedTable', function($location, $rootScope, store) {
    var link;
    link = function(scope, el, attr) {
      var localStore;
      if (angular.isUndefined(scope.options)) {
        scope.options = {};
      }
      localStore = store.getNamespacedStore($location.path());
      scope.options.enableRowSelection = scope.options.enableRowSelection || true;
      scope.options.enableRowHeaderSelection = scope.options.enableRowHeaderSelection || false;
      scope.options.multiSelect = scope.options.multiSelect || false;
      scope.options.saveWidths = scope.options.saveWidths || true;
      scope.options.enableGridMenu = scope.options.enableGridMenu || true;
      scope.options.gridMenuCustomItems = scope.options.gridMenuCustomItems || [];
      scope.options.gridMenuCustomItems.push({
        title: 'Сохранить',
        action: function() {
          return localStore.set('state', scope.options.gridApi.saveState.save());
        },
        order: 210
      });
      scope.options.onRegisterApi = function(gridApi) {
        scope.options.gridApi = gridApi;
        gridApi.selection.on.rowSelectionChanged(scope, function(row) {
          return $rootScope.$broadcast('data-selected', row);
        });
        gridApi.cellNav.on.navigate(scope, function(newRowCol, oldRowCol) {
          return gridApi.selection.selectRow(newRowCol.row.entity);
        });
        if (gridApi.pagination) {
          gridApi.pagination.on.paginationChanged(scope, function(newPage, pageSize) {
            return $rootScope.$broadcast('get-page', {
              page: newPage - 1,
              size: pageSize
            });
          });
        }
      };
      scope.$watch('query', function() {
        return $rootScope.$broadcast('data-search', {
          query: scope.query
        });
      });
      scope.$on('ngGridEventData', function(id) {
        var state;
        state = localStore.get('state');
        if (state) {
          scope.options.gridApi.saveState.restore(scope, state);
          return;
        }
      });
    };
    return {
      restrict: 'E',
      link: link,
      transclude: true,
      scope: {
        options: '=',
        disablePaging: '@',
        disableSearch: '@',
        enableEdit: '@'
      },
      template: function(elem, attr) {
        var editing, html, pagination;
        editing = attr.enableEdit ? "ui-grid-edit" : "";
        pagination = attr.disablePaging ? "" : "ui-grid-pagination";
        html = "<input ng-hide=\"disableSearch\" class=\"form-control\" ng-model=\"query\" ng-model-options=\"{debounce:200}\" placeholder=\"Поиск\" autofocus> <div ui-grid=\"options\" class=\"grid\" ui-grid-selection ui-grid-resize-columns ui-grid-save-state ui-grid-cellNav " + editing + " " + pagination + "></div> </div>";
        return html;
      }
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('stockSrc', function($rootScope, $compile) {
    return {
      restrict: 'A',
      scope: {
        stockSrc: '@'
      },
      link: function(scope, element, attr) {
        if (!attr.ngSrc) {
          attr.$set('ng-src', $rootScope.api + scope.stockSrc);
          $compile(element)(scope);
        }
      }
    };
  });

}).call(this);



(function() {
  angular.module('fsa').service('ProductService', function(db) {
    var service;
    service = this;
    return service;
  });

}).call(this);



(function() {
  angular.module('fsa').directive('productSelect', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        productId: '=',
        asText: '=?',
        productUnitId: '=?',
        ngDisabled: '=?'
      },
      controller: function($scope, RequestService, $uibModal) {
        'ngInject';
        var vm;
        vm = this;
        vm.openSelectProduct = function() {
          var editModal;
          editModal = $uibModal.open({
            templateUrl: 'app/product/select.html',
            controller: 'ProductSelectController',
            controllerAs: 'product',
            size: 'lg'
          });
          editModal.result.then(function(result) {
            vm.selected = result;
          });
        };
        vm.searchProduct = function(search_name) {
          return RequestService.post('product.listing', {
            limit: 10,
            filter: {
              name: search_name
            }
          }).then(function(result) {
            return result.docs;
          });
        };
        $scope.$watch('productId', function() {
          if ((angular.isDefined($scope.productId)) && vm.watch_prevent !== true) {
            RequestService.post('product.listing', {
              filter: {
                _id: $scope.productId
              }
            }).then(function(result) {
              if (result.docs.length === 1) {
                vm.watch_prevent = true;
                vm.selected = result.docs[0];
              }
            });
          }
          vm.watch_prevent = false;
        });
        $scope.$watch('product.selected', function() {
          if ((angular.isDefined(vm.selected)) && vm.watch_prevent !== true) {
            vm.watch_prevent = true;
            $scope.productId = vm.selected._id;
            $scope.productUnitId = (angular.isDefined(vm.selected)) && (angular.isObject(vm.selected)) && (angular.isDefined(vm.selected.data)) ? vm.selected.data.unit_id : void 0;
          }
          vm.watch_prevent = false;
        });
      },
      controllerAs: 'product',
      link: function(scope, element, attr) {},
      template: '<div><div ng-hide="asText===true" class="input-group"> <div class="input-group-addon" ng-show="loadingProducts"> <span class="glyphicon glyphicon-refresh"></span> </div> <div class="input-group-addon" ng-show="noProducts"> <span class="glyphicon glyphicon-remove text-danger"></span> </div> <input type="text" ng-model="product.selected" class="form-control" uib-typeahead="product as product.name for product in product.searchProduct($viewValue)" typeahead-loading="loadingProducts" typeahead-no-results="noProducts" ng-disabled="ngDisabled"> <div class="input-group-btn"> <button class="btn btn-primary" type="button" ng-click="product.openSelectProduct()" ng-disabled="ngDisabled"> <span class="glyphicon glyphicon-paperclip"></span> </button> </div> </div> <span ng-show="asText===true">{{ product.selected.name }}</span></div>'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('panel', function() {
    var link;
    link = function(scope, el) {
      el.find('.collapse-link').on('click', function() {
        var $BOX_CONTENT, $BOX_PANEL, $ICON;
        $BOX_PANEL = $(this).closest('.panel');
        $ICON = $(this).find('i');
        $BOX_CONTENT = $BOX_PANEL.find('.panel-body');
        if ($BOX_PANEL.attr('style')) {
          $BOX_CONTENT.slideToggle(200, function() {
            return $BOX_PANEL.removeAttr('style');
          });
        } else {
          $BOX_CONTENT.slideToggle(200);
          $BOX_PANEL.css('height', 'auto');
        }
        return $ICON.toggleClass('fa-chevron-up fa-chevron-down');
      });
    };
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        title: '@'
      },
      link: link,
      template: '<div class="wrapper lter b-b "> <div class="panel"> <div class="panel-heading font-bold"> <h2>{{title}}</h2> </div> <div class="panel-body" ng-transclude> </div> </div> </div>'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').service('OpService', function(db) {
    var service;
    service = this;
    service.sale = function(invoice) {
      var docs;
      docs = [
        {
          type: 'sale',
          data: invoice
        }
      ];
      angular.forEach(invoice.products, function(p) {
        return docs.push({
          type: 'stock_record',
          data: {
            product_id: p.id,
            count: -p.count
          }
        });
      });
      return db.insert(docs);
    };
    service.purchase = function() {
      var docs;
      docs = [
        {
          type: 'purchase',
          data: invoice
        }
      ];
      angular.forEach(invoice.products, function(p) {
        return docs.push({
          type: 'stock_record',
          data: {
            product_id: p.id,
            count: p.count
          }
        });
      });
      return db.insert(docs);
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('fsa').service('IntermediateDataService', function() {
    var clear, get, savedData, set;
    savedData = null;
    set = function(data) {
      return savedData = data;
    };
    get = function(_default) {
      return savedData || _default;
    };
    clear = function() {
      return savedData = null;
    };
    return {
      set: set,
      get: get,
      clear: clear
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('input', function() {
    var link;
    link = function(scope, element, attr, ngModel) {
      if (attr.type !== 'file' || !ngModel) {
        return;
      }
      element.on('change', function() {
        var file, reader;
        file = element[0].files[0];
        reader = new FileReader();
        reader.onload = function(e) {
          var data;
          data = e.target.result;
          return ngModel.$setViewValue(data);
        };
        reader.readAsBinaryString(file);
      });
    };
    return {
      restrict: 'E',
      link: link,
      require: '?ngModel'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').filter('fileSize', function() {
    var sizes;
    sizes = [[1, 'b'], [1024, 'Kb'], [1024 * 1024, 'Mb'], [1024 * 1024 * 1024, 'Gb']];
    return function(input) {
      var i, l_size, len, out, size;
      input = input || 0;
      out = '';
      for (i = 0, len = sizes.length; i < len; i++) {
        size = sizes[i];
        if (input < size[0] && l_size) {
          out = (input / l_size[0]).toFixed(2) + ' ' + l_size[1];
        } else {
          l_size = size;
        }
      }
      return out;
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('employeeSelect', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        employeeId: '=',
        asText: '=',
        ngDisabled: '=?'
      },
      controller: function($scope, RequestService, $uibModal) {
        'ngInject';
        var vm;
        vm = this;
        vm.openSelectEmployee = function() {
          var editModal;
          editModal = $uibModal.open({
            templateUrl: 'app/employee/select.html',
            controller: 'EmployeeSelectController',
            controllerAs: 'employee',
            size: 'lg'
          });
          editModal.result.then(function(result) {
            vm.selected = result;
          });
        };
        vm.searchEmployee = function(search_name) {
          return RequestService.post('employee.listing', {
            name: search_name,
            limit: 10,
            with_related: true
          }).then(function(result) {
            return result.docs;
          });
        };
        $scope.$watch('employeeId', function() {
          if ((angular.isDefined($scope.employeeId)) && vm.watch_prevent !== true) {
            RequestService.post('employee.listing', {
              with_related: true,
              filter: {
                _id: $scope.employeeId
              }
            }).then(function(result) {
              if (result.docs.length === 1) {
                vm.watch_prevent = true;
                vm.selected = result.docs[0];
              }
            });
          }
          vm.watch_prevent = false;
        });
        $scope.$watch('employee.selected', function() {
          if ((angular.isDefined(vm.selected)) && vm.watch_prevent !== true) {
            vm.watch_prevent = true;
            $scope.employeeId = vm.selected._id;
          }
          vm.watch_prevent = false;
        });
      },
      controllerAs: 'employee',
      link: function(scope, element, attr) {},
      template: '<div class="col-responsive"><div ng-hide="asText===true" class="form-group"> <div class="input-group-addon" ng-show="loadingEmployees"> <span class="glyphicon glyphicon-refresh"></span> </div> <div class="input-group-addon" ng-show="noEmployees"> <span class="glyphicon glyphicon-remove text-danger"></span> </div> <input type="text" ng-model="employee.selected" class="form-control" uib-typeahead="employee as employee.name for employee in employee.searchEmployee($viewValue)" typeahead-loading="loadingEmployees" typeahead-no-results="noEmployees" ng-disabled="ngDisabled"> </div> <span ng-show="asText===true">{{ employee.selected.name }}</span></div>'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('dynamic', function($compile) {
    var link;
    link = function(scope, ele, attrs) {
      scope.$watch(attrs.dynamic, function(html) {
        ele.html(html);
        return $compile(ele.contents())(scope);
      });
    };
    return {
      restrict: 'A',
      replace: true,
      link: link
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('stockDict', function(BObjectService) {
    return {
      restrict: 'A',
      scope: {
        stockDict: '=',
        dictTable: '@',
        dictFilter: '=',
        dictFirstItem: '=',
        dictOptions: '=',
        dictOnLoad: '&'
      },
      link: function(scope, element, attr) {
        var getDict, lastParams;
        lastParams = null;
        getDict = function() {
          var filter, params;
          params = {
            stockDict: scope.stockDict,
            dictTable: scope.dictTable,
            dictFilter: scope.dictFilter,
            dictFirstItem: scope.dictFirstItem,
            dictOptions: scope.dictOptions
          };
          if (angular.equals(lastParams, params)) {
            return;
          }
          lastParams = params;
          filter = {
            type: scope.dictTable,
            with_related: true,
            filter: scope.dictFilter
          };
          BObjectService.list(filter.type, filter).then(function(data) {
            var dict, dicts;
            if (angular.isDefined(scope.dictOptions)) {
              if (scope.dictOptions.onlyParents === true) {
                dicts = (function() {
                  var i, len, ref, results;
                  ref = data.docs;
                  results = [];
                  for (i = 0, len = ref.length; i < len; i++) {
                    dict = ref[i];
                    if (dict.parent_id === null || angular.isUndefined(dict.parent_id)) {
                      results.push(dict);
                    }
                  }
                  return results;
                })();
              } else if (scope.dictOptions.onlyChildren === true) {
                dicts = (function() {
                  var i, len, ref, results;
                  ref = data.docs;
                  results = [];
                  for (i = 0, len = ref.length; i < len; i++) {
                    dict = ref[i];
                    if (dict.parent_id !== null && angular.isDefined(dict.parent_id)) {
                      results.push(dict);
                    }
                  }
                  return results;
                })();
              }
              if (angular.isUndefined(dicts)) {
                dicts = angular.copy(data.docs);
              }
            } else {
              dicts = angular.copy(data.docs);
            }
            if (angular.isDefined(scope.dictFirstItem)) {
              dicts.unshift(scope.dictFirstItem);
            }
            scope.stockDict = dicts;
            setTimeout(function() {
              if (scope.dictOnLoad && scope.dictOnLoad instanceof Function) {
                return scope.dictOnLoad();
              }
            }, 0);
          });
        };
        scope.$watch('dictTable', function(oldVal, newVal) {
          if (angular.isDefined(newVal)) {
            getDict();
          }
        });
        scope.$watch('dictFilter', function(oldVal, newVal) {
          if (angular.isDefined(newVal)) {
            getDict();
          }
        });
        scope.$watch('dictFirstItem', function(oldVal, newVal) {
          if (angular.isDefined(newVal)) {
            getDict();
          }
        });
        scope.$watch('dictOptions', function(oldVal, newVal) {
          if (angular.isDefined(newVal)) {
            getDict();
          }
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('documentComment', function() {
    return {
      scope: {
        documentId: '='
      },
      templateUrl: 'app/docs/comments.html',
      controller: 'CommentsController',
      controllerAs: 'comments'
    };
  });

}).call(this);



(function() {
  angular.module('fsa').directive('colResponsive', function() {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      template: '<div class="col col-xs-12 col-sm-4 col-md-4" ng-transclude></div>'
    };
  });

}).call(this);



(function() {
  'use strict';
  angular.module('fsa').service('ClientService', function($http, $rootScope) {
    var clientService;
    clientService = {};
    clientService.find = function(search, limit, type) {
      return $http.post($rootScope.api + 'contractor.find', {
        search: search,
        limit: limit,
        type: type
      });
    };
    clientService.getAddress = function(client_id, type) {
      return $http.post($rootScope.api + 'contractor/get_address', {
        client_id: client_id,
        type: type
      });
    };
    clientService.get = function(client_id) {
      return $http.post($rootScope.api + 'contractor.find', {
        client_id: client_id
      });
    };
    return clientService;
  });

}).call(this);




/**
 * Created by Ilyas on 27.02.18.
 */

(function() {
  'use strict';
  angular.module('fsa').directive('cbsClient', function($compile, ClientService) {
    return {
      restrict: 'AEC',
      scope: {
        modeldisplay: '=?',
        modelret: '=?',
        clientType: '=?',
        modelobject: '=?',
        ngDisabled: '=?',
        ngRequired: '=?'
      },
      link: function(scope) {
        scope.current = 0;
        scope.selected = false;
        scope.da = function(txt) {
          scope.ajaxClass = 'loadImage';
          ClientService.find(txt, 10, scope.clientType).then(function(response) {
            scope.TypeAheadData = response.data.clients;
            scope.ajaxClass = '';
          });
        };
        scope.handleSelection = function(key, val, object) {
          scope.modelret = key;
          scope.modeldisplay = object.last_name + ' ' + object.first_name;
          scope.modelobject = object;
          scope.current = 0;
          scope.selected = true;
        };
        scope.isCurrent = function(index) {
          return scope.current === index;
        };
        scope.setCurrent = function(index) {
          scope.current = index;
        };
        scope.$watch('modelret', function(value) {
          if (value) {
            ClientService.get(value).then(function(response) {
              var client;
              if (response.data.clients.length === 0) {
                scope.modeldisplay = null;
                scope.modelobject = null;
                return;
              }
              client = response.data.clients[0];
              scope.modeldisplay = client.last_name + ' ' + client.first_name;
              scope.modelobject = client;
            });
          } else {
            scope.modeldisplay = null;
            scope.modelobject = null;
          }
        });
      },
      template: '<input type="text" ng-model="modeldisplay" ng-keyup="da(modeldisplay)" class="form-control"  ng-keydown="selected=false" ' + 'style="width:100%;" ng-class="ajaxClass" ng-disabled="ngDisabled" ng-required="ngRequired"> ' + '<div class="list-group table-condensed overlap" ng-hide="!modeldisplay.length || selected" style="width:100%"> ' + '<a href="javascript:;" class="list-group-item noTopBottomPad" ng-repeat="item in TypeAheadData|filter:model  track by $index" ' + 'ng-click="handleSelection(item.id,item.last_name,item)" style="cursor:pointer" ' + 'ng-class="{active:isCurrent($index)}" ' + 'ng-mouseenter="setCurrent($index)"> ' + ' {{item.id}} ' + '<i>{{item.last_name}} {{item.first_name}}</i> ' + '</a> ' + '</div> ' + '</input> '
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('CompanyController', function($scope, RequestService, Session, $rootScope, AppStorage, $uibModal) {
    'ngInject';
    var editCompany, getCompanies, newCompany, setActiveCompany, vm;
    vm = this;
    vm.companiesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'short_name',
          displayName: 'Короткое имя'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company_type',
          displayName: 'Тип Компании'
        }, {
          name: 'data.description',
          displayName: 'Описание'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.logo',
          displayName: 'Логотип',
          visible: false
        }, {
          name: 'data.industry',
          displayName: 'Отрасль',
          visible: false
        }, {
          name: 'data.status',
          displayName: 'Статус',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Изменивший',
          visible: false
        }
      ]
    };
    getCompanies = function() {
      var filter;
      filter = {
        with_related: true,
        filter: {
          company_type: 'insurance_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        delete vm.selected_company;
        vm.companiesGridOptions.data = data.docs;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_company = angular.copy(row.entity);
    });
    setActiveCompany = function(user_company) {
      RequestService.post('user.set_company', user_company).then(function(result) {
        Session.setCompany(angular.copy(user_company));
        return $rootScope.$broadcast('set-active-company');
      });
    };
    newCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/company/edit.html',
        controller: 'CompanyEditController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: void 0
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    editCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/company/edit.html',
        controller: 'CompanyEditController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: vm.selected_company
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    vm.getCompanies = getCompanies;
    vm.setActiveCompany = setActiveCompany;
    vm.newCompany = newCompany;
    vm.editCompany = editCompany;
    getCompanies();
  }).controller('CompanyEditController', function($scope, RequestService, Session, email_mask, $uibModalInstance, company, toastr, flowFactory) {
    'ngInject';
    var addAddress, addAssistance, addEmail, addPhone, addStaff, addWebsite, deleteAddress, deleteAssistance, deleteEmail, deletePhone, deleteStaff, deleteWebsite, getUsers, handleFileSelect, putCompany, upload, vm;
    vm = this;
    vm.ua = Session.getUser();
    vm.users = [];
    vm.branches = [];
    vm.companiesAsAgents = [];
    vm.agentList = [];
    vm.company = '';
    vm.image = '';
    vm.result_image = '';
    vm.currflow = '';
    if (company === null || company === void 0) {
      vm.company = {
        data: {
          assistants: []
        },
        agents_id: [],
        staff: [],
        company_type: "insurance_company"
      };
    } else {
      vm.company = company;
    }
    upload = function() {
      if (!vm.result_image) {
        console.log("vm.result_image == null");
        return;
      }
      RequestService.post('upload/company/' + vm.company._id, {
        file: vm.result_image
      }).then(function(result) {
        vm.company.data.image = 'image/' + result.file;
        vm.currflow.cancel();
        vm.currflow = '';
      });
    };
    handleFileSelect = function(event, $flow, flowFile) {
      var image, reader;
      vm.currflow = $flow;
      if (!flowFile.file.type.startsWith('image/')) {
        toastr.warning('Выберите изображение');
        event.preventDefault();
        return false;
      }
      image = flowFile.file;
      if (angular.isUndefined(image)) {
        return;
      }
      vm.imageLoading = true;
      reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function($scope) {
          vm.imageLoading = false;
          vm.image = event.target.result;
        });
      };
      reader.readAsDataURL(image);
    };
    putCompany = function() {
      console.log(vm.company);
      if (vm.company.name === void 0 || vm.company.name.trim().length === 0) {
        toastr.warning('Укажите имя компании');
        return false;
      }
      if (vm.company.email !== void 0 && !vm.company.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      vm.company.user_id = 1;
      vm.company.company_type = 'insurance_company';
      RequestService.post('company.put', vm.company).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    vm.putCompany = putCompany;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    getUsers = function() {
      RequestService.post('user.listing').then(function(result) {
        vm.users = result.users;
        console.log(vm.users);
      });
    };
    vm.currStaff = {
      user_id: '',
      branch_id: ''
    };
    addStaff = function() {
      var i, len, ref, x1;
      if (vm.currStaff.user_id !== null && vm.currStaff.user_id !== void 0) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1.user_id === vm.currStaff.user_id) {
            toastr.warning("Этот user уже в списке");
            return;
          }
        }
        vm.company.staff.push(vm.currStaff);
        vm.currStaff = {
          user_id: '',
          branch_id: ''
        };
        return;
      } else {
        alert("В начале выберите user или филиал !");
        return;
      }
    };
    deleteStaff = function(index) {
      vm.company.staff.splice(index, 1);
    };
    addAssistance = function() {
      var i, len, ref, x1;
      if (vm.assistance !== null && vm.assistance !== void 0) {
        ref = vm.company.data.assistants;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1._id === vm.assistance._id) {
            console.log("Этот ассистанс уже в списке");
            return;
          }
        }
        vm.company.data.assistants.push(vm.assistance);
        return;
      } else {
        alert("В начале выберите Ассистанс !");
        return;
      }
    };
    deleteAssistance = function(index) {
      vm.company.data.assistants.splice(index, 1);
    };
    vm.address = '';
    addAddress = function() {
      if (vm.company.data.addresses === null || vm.company.data.addresses === void 0) {
        vm.company.data.addresses = [];
      } else {
        if (vm.company.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.address !== null && vm.address !== void 0 && vm.address !== '') {
        vm.company.data.addresses.push(vm.address);
        vm.address = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteAddress = function(index) {
      vm.company.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.company.data.emails === null || vm.company.data.emails === void 0) {
        vm.company.data.emails = [];
      } else {
        if (vm.company.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.email !== null && vm.email !== void 0 && vm.email !== '') {
        vm.company.data.emails.push(vm.email);
        vm.email = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteEmail = function(index) {
      vm.company.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.company.data.websites === null || vm.company.data.websites === void 0) {
        vm.company.data.websites = [];
      } else {
        if (vm.company.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.website !== null && vm.website !== void 0 && vm.website !== '') {
        vm.company.data.websites.push(vm.website);
        vm.website = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteWebsite = function(index) {
      vm.company.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.company.data.phones === null || vm.company.data.phones === void 0) {
        vm.company.data.phones = [];
      } else {
        if (vm.company.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.phone !== null && vm.phone !== void 0 && vm.phone !== '') {
        vm.company.data.phones.push(vm.phone);
        vm.phone = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deletePhone = function(index) {
      vm.company.data.phones.splice(index, 1);
    };
    vm.upload = upload;
    vm.handleFileSelect = handleFileSelect;
    vm.deleteStaff = deleteStaff;
    vm.addStaff = addStaff;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.addAssistance = addAssistance;
    vm.deleteAssistance = deleteAssistance;
    getUsers();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('CollateralController', function($scope, RequestService, $state, email_mask, $uibModal, hotkeys) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('CollateralListController', function($scope, RequestService, $state, email_mask, $uibModal, hotkeys) {
    'ngInject';
    var getCollaterals, goToShow, onDblClick, vm;
    vm = this;
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
    };
    vm.collateralGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'policy_client_fullname',
          displayName: 'Заемщик'
        }, {
          name: 'policy_number',
          displayName: 'Номер полиса'
        }, {
          name: 'client_fullname',
          displayName: 'Залогодатель'
        }, {
          name: 'type',
          displayName: 'Тип залога'
        }, {
          name: 'market_price',
          displayName: 'Рын. стоимость'
        }, {
          name: 'coll_price',
          displayName: 'Зал. стоимость'
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    getCollaterals = function() {
      var filter;
      filter = {
        filter: {}
      };
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["_created DESC"];
      RequestService.post('collateral.search', filter).then(function(data) {
        delete vm.selected_collateral;
        vm.collateralGridOptions.data = angular.copy(data.list);
        vm.collateralGridOptions.totalItems = data.count;
      });
    };
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/collateral/view.html',
        controller: 'CollateralViewController',
        controllerAs: 'view',
        scope: $scope,
        size: 'lg',
        resolve: {
          collateral: vm.selected_collateral
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_collateral = angular.copy(row.entity);
    });
    vm.getCollaterals = getCollaterals;
    vm.goToShow = goToShow;
    getCollaterals();
  }).controller('CollateralCreateController', function($scope, RequestService, $state, email_mask, $uibModal, hotkeys, toastr) {
    'ngInject';
    var putCollateral, vm;
    vm = this;
    vm.collateral = {};
    putCollateral = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (angular.isUndefined(vm.collateral.data)) {
        vm.collateral.data = {};
      }
      vm.collateral.type = 'Collateral';
      RequestService.post('collateral.save', vm.collateral).then(function(result) {
        vm.saving = false;
        toastr.success('Сохранено!');
      }, function() {
        return vm.saving = false;
      });
    };
    vm.putCollateral = putCollateral;
  }).controller('CollateralViewController', function(collateral, $scope, RequestService, $state, email_mask, $uibModal, hotkeys, toastr) {
    'ngInject';
    var vm;
    vm = this;
    vm.collateral = collateral;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ClientsController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('ClientsListController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var editContractor, getContractors, newContractor, vm;
    vm = this;
    vm.offset = 0;
    vm.limit = 20;
    vm.contractorsGridOptions = {
      noUnselect: true,
      paginationPageSizes: [20, 100, 500],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Наименование'
        }, {
          name: 'data.email',
          displayName: 'E-mail'
        }, {
          name: 'industry.name',
          displayName: 'Индустрия'
        }, {
          name: 'contractor_type_value.data.name',
          displayName: 'Тип'
        }, {
          name: 'contractor_company.name',
          displayName: 'Компания агента',
          visible: false
        }, {
          name: 'company.name',
          displayName: 'Компания',
          visible: false
        }
      ],
      events: {
        onRowSelect: function(row) {
          vm.selected_contractor = angular.copy(row.entity);
        },
        onPageSelect: function(page, size) {
          vm.offset = page * size;
          vm.limit = size;
          getContractors();
        }
      }
    };
    newContractor = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/contractor/edit.html',
        controller: 'ContractorEditController',
        controllerAs: 'contractor',
        size: 'lg',
        scope: $scope,
        resolve: {
          contractor: void 0
        }
      });
      editModal.result.then(function() {
        return getContractors();
      });
    };
    editContractor = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/contractor/edit.html',
        controller: 'ContractorEditController',
        controllerAs: 'contractor',
        size: 'lg',
        scope: $scope,
        resolve: {
          contractor: angular.copy(vm.selected_contractor)
        }
      });
      editModal.result.then(function() {
        return getContractors();
      });
    };
    getContractors = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true
      };
      RequestService.post('contractor.list', filter).then(function(result) {
        vm.contractorsGridOptions.data = result.docs;
        vm.contractorsGridOptions.totalItems = result.count;
        delete vm.selected_contractor;
      });
    };
    vm.newContractor = newContractor;
    vm.editContractor = editContractor;
    vm.getContractors = getContractors;
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить контрагента',
      callback: newContractor
    }).add({
      combo: 'r',
      description: 'Обновить список контрагентов',
      callback: getContractors
    });
    getContractors();
  }).controller('ClientsCreateController', function($scope, $state, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var putContractor, vm;
    vm = this;
    putContractor = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (angular.isUndefined(vm.contractor.data)) {
        vm.contractor.data = {};
      }
      RequestService.post('contractor.save', vm.contractor).then(function(result) {
        vm.saving = false;
        toastr.success('Сохранено!');
      }, function() {
        return vm.saving = false;
      });
    };
    vm.putContractor = putContractor;
  }).controller('ClientsViewController', function($scope, $state, $stateParams, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var getContractor, vm;
    vm = this;
    vm.id = $stateParams.id;
    getContractor = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        filter: {
          _id: vm.id
        }
      };
      RequestService.post('contractor.get', filter).then(function(result) {
        vm.contractor = result.doc;
      });
    };
    vm.getContractor = getContractor;
    getContractor();
  }).controller('ClientsEditController', function($scope, $state, $stateParams, RequestService, toastr, hotkeys, $uibModal, $uibModalStack) {
    'ngInject';
    var cancel, editDiagnosis, editHistory, editIdentity, finishDiagnosis, finishHistory, finishIdentity, getContractor, getEmployee, getproduct, removeDiagnosis, removeHistory, removeIdentity, saveClient, vm;
    vm = this;
    vm.id = $stateParams.id;
    vm.identities = [];
    vm.diagnosises = [];
    vm.histories = [];
    getContractor = function() {
      var filter;
      filter = {
        with_related: true,
        filter: {
          _id: vm.id
        }
      };
      RequestService.post('contractor.get', filter).then(function(result) {
        vm.contractor = result.doc;
      });
    };
    editIdentity = function(identity) {
      vm.curIdentity = identity;
    };
    finishIdentity = function(push) {
      if (push && !vm.curIdentity.id) {
        if (vm.prod) {
          vm.curIdentity.product_name = vm.prod.name;
        }
        if (vm.prod.unit) {
          vm.curIdentity.product_unit = vm.prod.unit.name;
        }
        vm.contractor.data.identities.push(vm.curIdentity);
        vm.product_id = null;
      }
      vm.curIdentity = null;
    };
    removeIdentity = function(index) {
      vm.identities.splice(index, 1);
    };
    editDiagnosis = function(diagnosis) {
      vm.curDiagnosis = diagnosis;
    };
    finishDiagnosis = function(push) {
      if (push && !vm.curDiagnosis.id) {
        if (vm.current_employee) {
          vm.curDiagnosis.employee = vm.current_employee;
        }
        vm.contractor.data.diagnosises.push(vm.curDiagnosis);
      }
      vm.curDiagnosis = null;
    };
    removeDiagnosis = function(index) {
      vm.diagnosises.splice(index, 1);
    };
    editHistory = function(history) {
      vm.curHistories = history;
    };
    finishHistory = function(push) {
      if (push && !vm.curHistories.id) {
        vm.contractor.data.histories.push(vm.curHistories);
      }
      vm.curHistories = null;
    };
    removeHistory = function(index) {
      vm.histories.splice(index, 1);
    };
    $scope.$watch('edit.product_id', function() {
      return getproduct();
    });
    $scope.$watch('edit.current_employee', function() {
      return getEmployee();
    });
    getproduct = function() {
      var filter;
      if (vm.product_id) {
        filter = {
          with_related: true,
          filter: {
            _id: vm.product_id
          }
        };
        RequestService.post('product.get', filter).then(function(result) {
          vm.prod = result.doc;
        });
      }
    };
    getEmployee = function() {
      var filter;
      if (vm.current_employee) {
        filter = {
          with_related: true,
          filter: {
            id: vm.current_employee
          }
        };
        RequestService.post('user.get', filter).then(function(result) {
          vm.employee = result.doc;
        });
      }
    };
    saveClient = function() {
      if (!vm.contractor.data) {
        vm.contractor.data = {};
      }
      RequestService.post('contractor.save', vm.contractor).then(function(result) {
        toastr.success('Сохранено!');
      });
    };
    cancel = function() {
      $state.go('app.clients.list');
    };
    vm.getContractor = getContractor;
    vm.editIdentity = editIdentity;
    vm.finishIdentity = finishIdentity;
    vm.removeIdentity = removeIdentity;
    vm.editDiagnosis = editDiagnosis;
    vm.finishDiagnosis = finishDiagnosis;
    vm.getproduct = getproduct;
    vm.getEmployee = getEmployee;
    vm.removeDiagnosis = removeDiagnosis;
    vm.editHistory = editHistory;
    vm.finishHistory = finishHistory;
    vm.removeHistory = removeHistory;
    vm.saveClient = saveClient;
    vm.cancel = cancel;
    getContractor();
  }).controller('ClientsModalController', function($scope, RequestService, $uibModalInstance, contractor, toastr) {
    'ngInject';
    var industryParentGroup, putContractor, vm;
    vm = this;
    vm.contractor = angular.copy(contractor || {
      type: 'Contractor'
    });
    putContractor = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (angular.isUndefined(vm.contractor.data)) {
        vm.contractor.data = {};
      }
      RequestService.post('contractor.save', vm.contractor).then(function(result) {
        vm.saving = false;
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
    };
    industryParentGroup = function(item) {
      if (!item.parent) {
        return '';
      }
      return item.parent.name;
    };
    vm.putContractor = putContractor;
    vm.industryParentGroup = industryParentGroup;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('BranchController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, date, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, m, onDblClick, resetFilter, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.date_start.setHours(vm.date_start.getHours() + 6);
    vm.date_end.setHours(vm.date_end.getHours() + 6);
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/branch/show.html',
        controller: 'BranchShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product.name',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'ФИО клиента'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Страховщик'
        }, {
          name: 'agent',
          displayName: 'Агент'
        }, {
          name: 'branch',
          displayName: 'Филиал'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      if (!vm.company) {
        $state.go('app.apolicy.new');
      } else if (vm.company.company_type === "insurance_company") {
        $state.go('app.apolicy.select');
      } else if (vm.company.company_type === "agent") {
        $state.go('app.apolicy.select');
      } else {
        $state.go('app.apolicy.new');
      }
      return false;
    };
    goToIssue = function() {
      $state.go('app.apolicy.issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/edit.html',
        controller: 'ApolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!vm.company) {
        filter.with_related = true;
      } else if (vm.company.company_type === 'agent') {
        filter.with_related = true;
        filter.filter = {
          agent_id: vm.company._id
        };
      }
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.filter.insurance_data = {};
      filter.filter.client = {};
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "branch_id") {
          filter.filter.branch_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "name") {
          filter.filter.client.name = v;
        }
        if (k === "surname") {
          filter.filter.client.surname = v;
        }
      }
      if (Object.keys(filter.filter.insurance_data).length === 0) {
        delete filter.filter.insurance_data;
      }
      if (Object.keys(filter.filter.client).length === 0) {
        delete filter.filter.client;
      }
      filter.offset = vm.offset;
      filter.limit = vm.limit;
      filter.order_by = ["_created DESC"];
      filter.filter.date_end = vm.date_end;
      filter.filter.date_start = vm.date_start;
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      RequestService.post('branch.branchlisting', {
        company_id: vm.company._id
      }).then(function(data) {
        return vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        'policyNumber': vm.selected_policy.policy_no
      });
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    getAgents();
    getPolicies();
  }).controller('BranchShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var FormPolicy, cancel, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    findCurrencyName = function() {
      var country, currency, i, j, len, len1, ref, ref1;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        country = ref[i];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            currency = ref1[j];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var i, item, itemx, j, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        ref1 = vm.policy.insurance_data.country_id;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          itemx = ref1[j];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
      console.log(vm.policy);
    }
    sendMail = function() {
      var countries, country, country_id, i, j, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (i = 0, len = ref.length; i < len; i++) {
        country_id = ref[i];
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country = ref1[j];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, i, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code + "00000";
      } else {
        policy_no = policy_no + "00000";
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        policyNumber: vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AuthController', function(RequestService, $scope, toastr, EVENTS, Session, browser, email_mask, AppStorage, $state, $stateParams) {
    'ngInject';
    var login, ref, register, toast, vm;
    vm = this;
    vm.os = (ref = browser()) != null ? ref : 'unknown';
    register = function() {
      if (!vm.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      if (vm.auth_loading === true) {
        return;
      }
      vm.auth_loading = true;
      RequestService.post('user/register', vm).then(function(data) {
        Session.create(data.token, data.user);
        $scope.$emit(EVENTS.loginSuccess);
        vm.auth_loading = false;
      }, function(result) {
        vm.auth_loading = false;
        toast(result);
      });
      return false;
    };
    login = function() {
      if (vm.auth_loading === true) {
        return;
      }
      vm.auth_loading = true;
      RequestService.post('user/auth', vm).then(function(data) {
        Session.create(data.token, data.user, data.company);
        $scope.$emit(EVENTS.loginSuccess);
        vm.auth_loading = false;
      }, function(result) {
        vm.auth_loading = false;
        toast(result ? result : {
          result: -1,
          message: 'Ошибка сети'
        });
      });
      return false;
    };
    toast = function(result) {
      if (result.result > 0) {
        return toastr.warning(result.message);
      } else if (result.result < 0) {
        return toastr.error(result.message);
      }
    };
    $scope.$on(EVENTS.loginSuccess, function() {
      var ua, uc;
      AppStorage.clear();
      ua = Session.getUser();
      uc = Session.getCompany();
      if (uc && uc.company && uc.company.user_id === ua.id) {
        $state.go('app.dashboard');
        return;
      }
      if (angular.isDefined($stateParams.r) && $stateParams.r.startsWith('app.')) {
        $state.go($stateParams.r, $stateParams.params);
        return;
      }
      $state.go('app.dashboard');
    });
    vm.register = register;
    vm.login = login;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('ApolicyController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var vm;
    vm = this;
  }).controller('ApolicyListController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var confirmAction, deletePolicy, downloadPDF, editBranch, fiterPolicy, getAgents, getPolicies, goToIssue, goToNew, goToShow, onDblClick, resetFilter, vm;
    vm = this;
    vm.today = new Date();
    vm.filter = null;
    vm.company = Session.getCompany();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.offset = 0;
    vm.limit = 10;
    goToShow = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/show.html',
        controller: 'ApolicyShowController',
        controllerAs: 'show',
        scope: $scope,
        size: 'lg',
        resolve: {
          product: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    onDblClick = function(row) {
      vm.selected_policy = angular.copy(row.entity);
      goToShow();
    };
    vm.policiesGridOptions = {
      enableRowHeaderSelection: true,
      enableFiltering: true,
      enableRowSelection: true,
      enableSorting: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      enableScrollbars: true,
      noUnselect: true,
      paginationPageSizes: [10, 20, 50, 100],
      paginationPageSize: 10,
      useExternalPagination: true,
      rowTemplate: ['<div ng-dblclick="grid.appScope.dblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" class="ui-grid-cell ng-scope ui-grid-disable-selection" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" role="gridcell" ui-grid-cell=""></div>'].join(''),
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'data.currency.name',
          displayName: 'Валюта'
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ],
      onRegisterApi: function(gridApi) {
        return vm.gridApi = gridApi;
      },
      appScopeProvider: {
        dblClick: onDblClick
      }
    };
    goToNew = function() {
      $state.go('app.apolicy.select');
      return false;
    };
    goToIssue = function() {
      $state.go('app.apolicy.issue');
      return false;
    };
    editBranch = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/apolicy/edit.html',
        controller: 'ApolicyEditController',
        controllerAs: 'policy',
        scope: $scope,
        size: 'lg',
        resolve: {
          branch: vm.selected_policy
        }
      });
      editModal.result.then(function() {
        return getBranches();
      });
      return false;
    };
    getPolicies = function() {
      var filter, k, ref, v;
      filter = {
        filter: {}
      };
      if (!filter.filter) {
        filter.filter = {};
      }
      filter.filter.insurance_data = {};
      filter.filter.client = {};
      ref = vm.filter;
      for (k in ref) {
        v = ref[k];
        if (k === "policy_status") {
          if (v === "Все") {
            if (filter.filter.data) {
              delete filter.filter.data;
            }
            continue;
          } else {
            filter.filter.data = {
              status: v
            };
          }
        }
        if (k === "agent_id") {
          filter.filter.agent_id = v;
        }
        if (k === "policy_no") {
          filter.filter.policy_no = v;
        }
        if (k === "date_end") {
          filter.filter.insurance_data.date_end = v;
        }
        if (k === "date_start") {
          filter.filter.insurance_data.date_start = v;
        }
        if (k === "name") {
          filter.filter.client = v;
        }
      }
      if (Object.keys(filter.filter.insurance_data).length === 0) {
        delete filter.filter.insurance_data;
      }
      if (Object.keys(filter.filter.client).length === 0) {
        delete filter.filter.client;
      }
      filter.offset = vm.offset;
      filter.filter.edit_user_id = $scope.app.ua.id;
      filter.limit = vm.limit;
      filter.with_related = true;
      filter.order_by = ["issue_date DESC"];
      RequestService.post('policies.listing', filter).then(function(data) {
        delete vm.selected_policy;
        vm.policies = angular.copy(data.docs);
        toastr.info("Полисы загружены.");
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    getAgents = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        vm.agents = data.docs;
      });
    };
    downloadPDF = function() {
      if (vm.selected_policy.objects === 'TS') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'LN') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else if (vm.selected_policy.objects === 'NED') {
        if (vm.selected_policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.selected_policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.selected_policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    deletePolicy = function() {
      return RequestService.post('policies.delete', vm.selected_policy).then(function(data) {
        getPolicies();
      });
    };
    resetFilter = function() {
      vm.policy_filtered = [];
      vm.filter = {};
      vm.policiesGridOptions.data = angular.copy(vm.policies);
    };
    fiterPolicy = function() {
      var end, i, issue_d, len, policy, ref, start;
      vm.policy_filtered = [];
      if (vm.filter.policy_status === "Все") {
        delete vm.filter.policy_status;
      }
      if (vm.policies) {
        ref = vm.policies;
        for (i = 0, len = ref.length; i < len; i++) {
          policy = ref[i];
          if (vm.filter.date_start && vm.filter.date_end) {
            issue_d = new Date(policy.issue_date);
            start = new Date(vm.filter.date_start);
            end = new Date(vm.filter.date_end);
            if (issue_d < start || issue_d > end) {
              continue;
            }
          }
          if (vm.filter.policy_no) {
            if (policy.policy_no.indexOf(vm.filter.policy_no) === -1) {
              continue;
            }
          }
          if (vm.filter.name) {
            if (policy.client.name.indexOf(vm.filter.name) === -1) {
              continue;
            }
          }
          if (vm.filter.surname) {
            if (policy.client.surname.indexOf(vm.filter.surname) === -1) {
              continue;
            }
          }
          if (vm.filter.policy_status) {
            if (policy.data.status !== vm.filter.policy_status) {
              continue;
            }
          }
          if (vm.filter.agent_id) {
            if (policy.agent_id !== vm.filter.agent_id) {
              continue;
            }
          }
          vm.policy_filtered.push(policy);
        }
        vm.policiesGridOptions.data = angular.copy(vm.policy_filtered);
      } else {
        console.log("vm.policies is falsy");
      }
      if (!vm.filter.policy_status) {
        return vm.filter.policy_status = "Все";
      }
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    hotkeys.bindTo($scope).add({
      combo: 'n',
      description: 'Добавить филиал',
      callback: goToNew
    }).add({
      combo: 'r',
      description: 'Обновить список филиалов',
      callback: getPolicies
    });
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          deletePolicy();
        }
      });
    };
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.deletePolicy = deletePolicy;
    vm.resetFilter = resetFilter;
    vm.fiterPolicy = fiterPolicy;
    vm.goToShow = goToShow;
    vm.goToNew = goToNew;
    vm.goToIssue = goToIssue;
    vm.editBranch = editBranch;
    vm.getPolicies = getPolicies;
    getAgents();
    getPolicies();
  }).controller('ApolicyEditController', function($scope, hotkeys, $state, RequestService, Session, $uibModalInstance, branch, toastr) {
    'ngInject';
    var putBranch, vm;
    vm = this;
    vm.branch = branch || {
      type: 'Branches'
    };
    putBranch = function() {
      if (vm.saving === true) {
        return;
      }
      vm.saving = true;
      if (vm.branch.name === void 0 || vm.branch.name.trim().length === 0) {
        toastr.warning('Укажите имя филиала');
        vm.saving = false;
        return false;
      }
      if (angular.isUndefined(vm.branch.branch_type)) {
        toastr.warning('Выберите тип');
        vm.saving = false;
        return false;
      }
      RequestService.post('branch.save', vm.branch).then(function(result) {
        $uibModalInstance.close(result);
      }, function() {
        return vm.saving = false;
      });
      return false;
    };
    vm.putBranch = putBranch;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }).controller('ApolicyNewController', function($scope, hotkeys, $state, RequestService, Session, toastr) {
    'ngInject';
    var getDiffDays, goToSelect, vm;
    vm = this;
    vm.diffDays = 0;
    vm.today = new Date();
    goToSelect = function(item) {
      $state.go('app.apolicy.select', {
        product: item
      });
    };
    getDiffDays = function() {
      var end, start;
      if (vm.pruduct.date_end && vm.pruduct.date_start) {
        start = new Date(vm.pruduct.date_start);
        end = new Date(vm.pruduct.date_end);
        vm.diffDays = Math.round(Math.abs((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000))) + 1;
      }
    };
    vm.goToSelect = goToSelect;
    vm.getDiffDays = getDiffDays;
  }).controller('ApolicySelectController', function($scope, hotkeys, $state, $stateParams, RequestService, $filter, Session, toastr, AppStorage) {
    'ngInject';
    var addCollateralLn, addCollateralNed, addCollateralTs, calculatePremiumLn, calculatePremiumNed, calculatePremiumTs, confirmAction, deleteCollateralLn, deleteCollateralNed, deleteCollateralTs, getInsuranceForms, getInsuranceLnObjects, getInsuranceNedObjects, getInsuranceTsObjects, getInsuranceTypes, getPeriods, getTotalDays, getYearLabel, onFullYearsChange, onPeriodTypeChange, onVehicleTypeChange, pdrobneeIconCnange, recalculateOnEventAll, recalculateOnEventisAnnual, savePolicy, setDefaultCurrency, setDefaultProduct, showPanel, updateEndDateForOverYear, validateVehicleAge, vm;
    vm = this;
    vm.parseInt = parseInt;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(364, 'day').toDate();
    vm.diffDays = 0;
    vm.insurance_period_type = 'year';
    vm.full_years = 1.5;
    vm.period_disabled = false;
    vm.currentYear = new Date().getFullYear();
    vm.minYear = vm.currentYear - 15;
    vm.vehicleAgeError = false;
    vm.nedPanel = false;
    vm.tsPanel = false;
    vm.lnPanel = false;
    vm.product = $stateParams.product;
    if (vm.product === null || vm.product === void 0) {
      vm.product = {};
      vm.product.factors = {};
    }
    vm.annualPolicies = [45, 90];
    vm.annualDays = vm.annualPolicies[0];
    vm.productsList = [];
    vm.collateralsned = {
      ned: []
    };
    vm.collateralsts = {
      ts: []
    };
    vm.collateralsln = {
      ln: []
    };
    vm.selectedProduct = {};
    vm.selectedAge = {};
    vm.currentCountryId = '';
    vm.min_insurance_amount = 0;
    vm.insurance_amount = 0;
    vm.currency_name = "USD";
    vm.policy = {
      objects: [],
      insurance_amount: 0,
      insurance_amountts: 0,
      insurance_amountned: 0,
      insurance_amountln: 0,
      insurance_premiumts: 0,
      insurance_premiumned: 0,
      insurance_premiumln: 0,
      date_start: moment().toDate()
    };
    vm.insuranceform = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformned = {
      adres: 'Кыргызская Республика'
    };
    vm.insuranceformts = {
      adres: 'Кыргызская Республика',
      driver: 'Лица, имеющие право на управление застрахованным транспортным средством.',
      objectts: null
    };
    vm.insuranceformln = {
      adres: 'Кыргызская Республика'
    };
    vm.inputCheck = true;
    vm.period_rate = 0;
    vm.currenciesToday = AppStorage.getObject('currenciesToday') || [];
    vm.company = Session.getCompany();
    validateVehicleAge = function() {
      var age, currentYear, yearIssue;
      if (vm.insuranceformts.year_issue) {
        yearIssue = parseInt(vm.insuranceformts.year_issue);
        currentYear = new Date().getFullYear();
        age = currentYear - yearIssue;
        if (age > 15 || yearIssue < vm.minYear) {
          vm.vehicleAgeError = true;
          toastr.warning("Принимаются ТС не старше 15 лет (не младше " + vm.minYear + " года выпуска)");
        } else {
          vm.vehicleAgeError = false;
        }
      }
    };
    onVehicleTypeChange = function() {};
    showPanel = function(insurance_type, check) {
      if (insurance_type.code === 'NED') {
        if (check === true) {
          vm.nedPanel = true;
          getInsuranceNedObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsned.ned.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.nedPanel = true;
          vm.insuranceformned.objectned = null;
          vm.insuranceformned.insurance_summ = null;
          vm.insuranceformned.coll_price = null;
          vm.insuranceformned.description = null;
          vm.insuranceformned.insurance_premium = null;
        } else if (check !== true & vm.collateralsned.ned.length === 0) {
          vm.nedPanel = false;
          vm.insuranceformned.objectned = null;
          vm.insuranceformned.insurance_summ = null;
          vm.insuranceformned.coll_price = null;
          vm.insuranceformned.description = null;
          vm.insuranceformned.insurance_premium = null;
        }
      }
      if (insurance_type.code === 'TC') {
        if (check === true) {
          vm.tsPanel = true;
          getInsuranceTsObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsts.ts.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.tsPanel = true;
          vm.insuranceformts.objectts = null;
          vm.insuranceformts.model = null;
          vm.insuranceformts.gosnumber = null;
          vm.insuranceformts.number = null;
          vm.insuranceformts.year_issue = null;
          vm.insuranceformts.insurance_summ = null;
          vm.insuranceformts.coll_price = null;
          vm.insuranceformts.insurance_premium = null;
        } else if (check !== true & vm.collateralsts.ts.length === 0) {
          vm.tsPanel = false;
          vm.insuranceformts.objectts = null;
          vm.insuranceformts.model = null;
          vm.insuranceformts.gosnumber = null;
          vm.insuranceformts.number = null;
          vm.insuranceformts.year_issue = null;
          vm.insuranceformts.insurance_summ = null;
          vm.insuranceformts.coll_price = null;
          vm.insuranceformts.insurance_premium = null;
        }
      }
      if (insurance_type.code === 'LN') {
        if (check === true) {
          vm.lnPanel = true;
          getInsuranceLnObjects(insurance_type._id);
        } else if (check !== true & vm.collateralsln.ln.length > 0) {
          toastr.warning('Невозможно закрыть');
          vm.lnPanel = false;
          vm.insuranceformln.objectln = null;
          vm.insuranceformln.birthday = null;
          vm.insuranceformln.pasport = null;
          vm.insuranceformln.insurance_summ = null;
          vm.insuranceformln.coll_price = null;
          vm.insuranceformln.insurance_premium = null;
        } else if (check !== true & vm.collateralsln.ln.length === 0) {
          vm.lnPanel = false;
          vm.insuranceformln.objectln = null;
          vm.insuranceformln.birthday = null;
          vm.insuranceformln.pasport = null;
          vm.insuranceformln.insurance_summ = null;
          vm.insuranceformln.coll_price = null;
          vm.insuranceformln.insurance_premium = null;
        }
      }
    };
    getInsuranceTypes = function() {
      return RequestService.post('insurancetypes.listing').then(function(data) {
        vm.insurancetypes = angular.copy(data.docs);
      });
    };
    getInsuranceNedObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsned = angular.copy(data.docs);
      });
    };
    getInsuranceTsObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsts = angular.copy(data.docs);
      });
    };
    getInsuranceLnObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: insurance_type
      }).then(function(data) {
        vm.insuranceobjectsln = angular.copy(data.docs);
      });
    };
    getInsuranceForms = function() {
      return RequestService.post('insuranceforms.listing', {
        insurance_object_id: vm.insuranceform.object._id
      }).then(function(data) {
        vm.insuranceforms = angular.copy(data.docs);
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    addCollateralNed = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.nedvijimost = {
          owner: insuranceform.owner,
          object: insuranceform.objectned.name,
          objectned: insuranceform.objectned,
          adres: insuranceform.adres,
          coll_price: insuranceform.coll_price,
          description: insuranceform.description,
          insurance_summ: insuranceform.insurance_summ,
          insurance_premium: insuranceform.insurance_premium
        };
        vm.collateralsned.ned.push(vm.nedvijimost);
        vm.nedvijimost = {};
        vm.insuranceformned = {
          objectned: null,
          insurance_summ: null,
          insurance_premium: null,
          adres: 'Кыргызская Республика'
        };
        vm.policy.insurance_amountned = vm.policy.insurance_amountned + insuranceform.insurance_summ;
        vm.policy.insurance_premiumned = vm.policy.insurance_premiumned + insuranceform.insurance_premium;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralNed = function(collateral, index) {
      vm.collateralsned.ned.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumned = vm.policy.insurance_premiumned - collateral.insurance_premium;
      vm.policy.insurance_amountned = vm.policy.insurance_amountned - collateral.insurance_summ;
    };
    addCollateralTs = function(insuranceform) {
      if (vm.vehicleAgeError) {
        toastr.error('Невозможно добавить ТС старше 15 лет');
        return;
      }
      if (!insuranceform.objectts) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (insuranceform.insurance_premium) {
        vm.ts = {
          object: insuranceform.objectts.name,
          objectts: insuranceform.objectts,
          adres: insuranceform.adres,
          model: insuranceform.model,
          gosnumber: insuranceform.gosnumber,
          number: insuranceform.number,
          year_issue: insuranceform.year_issue,
          insurance_summ: insuranceform.insurance_summ,
          coll_price: insuranceform.coll_price,
          insurance_premium: insuranceform.insurance_premium,
          driver: insuranceform.driver
        };
        vm.collateralsts.ts.push(vm.ts);
        vm.ts = {};
        vm.insuranceformts = {
          objectts: null,
          adres: 'Кыргызская Республика',
          model: null,
          gosnumber: null,
          number: null,
          year_issue: null,
          insurance_summ: null,
          coll_price: null,
          insurance_premium: null
        };
        vm.policy.insurance_premiumts = vm.policy.insurance_premiumts + insuranceform.insurance_premium;
        vm.policy.insurance_amountts = vm.policy.insurance_amountts + insuranceform.insurance_summ;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralTs = function(collateral, index) {
      vm.collateralsts.ts.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumts = vm.policy.insurance_premiumts - collateral.insurance_premium;
      vm.policy.insurance_amountts = vm.policy.insurance_amountts - collateral.insurance_summ;
    };
    addCollateralLn = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.ln = {
          adres: insuranceform.adres,
          birthday: insuranceform.birthday,
          pasport: insuranceform.pasport,
          insurance_summ: insuranceform.insurance_summ,
          client: insuranceform.client,
          insurance_premium: insuranceform.insurance_premium
        };
        vm.collateralsln.ln.push(vm.ln);
        vm.ln = {};
        vm.insuranceformln = {
          adres: 'Кыргызская Республика',
          birthday: null,
          pasport: null,
          insurance_summ: null,
          client: null,
          insurance_premium: null
        };
        vm.policy.insurance_premiumln = vm.policy.insurance_premiumln + insuranceform.insurance_premium;
        vm.policy.insurance_amountln = vm.policy.insurance_amountln + insuranceform.insurance_summ;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    deleteCollateralLn = function(collateral, index) {
      vm.collateralsln.ln.splice(index, 1);
      vm.collateral = {};
      vm.policy.insurance_premiumln = vm.policy.insurance_premiumln - collateral.insurance_premium;
      vm.policy.insurance_amountln = vm.policy.insurance_amountln - collateral.insurance_summ;
    };
    onPeriodTypeChange = function() {
      if (vm.insurance_period_type === 'year') {
        vm.policy.date_end = moment(vm.policy.date_start).add(364, 'day').toDate();
        vm.diffDays = 365;
        vm.period_disabled = true;
      } else if (vm.insurance_period_type === 'over_year') {
        if (!vm.full_years || vm.full_years < 1) {
          vm.full_years = 1.5;
        }
        updateEndDateForOverYear();
        vm.period_disabled = false;
      } else {
        vm.period_disabled = false;
        vm.policy.date_end = null;
      }
      recalculateOnEventAll();
    };
    onFullYearsChange = function() {
      if (vm.insurance_period_type === 'over_year' && vm.full_years) {
        if (vm.full_years < 1) {
          vm.full_years = 1;
        }
        updateEndDateForOverYear();
        recalculateOnEventAll();
      }
    };
    updateEndDateForOverYear = function() {
      var fractionalYears, fullYears, monthsInFractional, totalDays;
      if (vm.policy.date_start && vm.full_years) {
        fullYears = Math.floor(vm.full_years);
        fractionalYears = vm.full_years - fullYears;
        monthsInFractional = Math.round(fractionalYears * 10);
        totalDays = (fullYears * 365) + (monthsInFractional * 30) - 1;
        vm.policy.date_end = moment(vm.policy.date_start).add(totalDays, 'day').toDate();
      }
    };
    getYearLabel = function() {
      var years;
      years = parseFloat(vm.full_years);
      if (years % 1 !== 0) {
        return "года";
      }
      if (years === 1) {
        return "год";
      } else if (years >= 2 && years <= 4) {
        return "года";
      } else {
        return "лет";
      }
    };
    getTotalDays = function() {
      var fractionalYears, fullYears, monthsInFractional;
      if (vm.full_years) {
        fullYears = Math.floor(vm.full_years);
        fractionalYears = vm.full_years - fullYears;
        monthsInFractional = Math.round(fractionalYears * 10);
        return (fullYears * 365) + (monthsInFractional * 30);
      }
      return 0;
    };
    recalculateOnEventisAnnual = function() {
      vm.policy.date_end = moment(vm.policy.date_start).add(364, 'day').toDate();
      recalculateOnEventAll();
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, fullYearsCount, monthsCount, remainingDays, timeDiff;
      if (vm.insurance_period_type === 'year') {
        vm.diffDays = 365;
      } else if (vm.insurance_period_type === 'over_year') {
        if (vm.policy.date_start && vm.policy.date_end) {
          date1 = vm.policy.date_start;
          date2 = vm.policy.date_end;
          timeDiff = Math.abs(date2.getTime() - date1.getTime());
          diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
          fullYearsCount = Math.floor(diffDays / 365);
          remainingDays = diffDays - (fullYearsCount * 365);
          monthsCount = Math.round(remainingDays / 30);
          vm.full_years = parseFloat((fullYearsCount + monthsCount / 10).toFixed(1));
          if (vm.full_years < 1) {
            vm.full_years = 1;
          }
          vm.diffDays = diffDays;
        } else {
          vm.diffDays = getTotalDays();
        }
      } else {
        date1 = vm.policy.date_start;
        date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
    };
    savePolicy = function() {
      var agent_id, branch_id, end_date, fractionalYears, fullYears, monthsInFractional, policy, policyList, policy_no, theUser, totalDays;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
        branch_id = vm.company.company_id;
      } else if (vm.company.company_type === "branch_company") {
        branch_id = vm.company._id;
      }
      theUser = Session.getUser();
      policyList = {
        items: []
      };
      if (vm.collateralsts.ts.length > 0) {
        policy_no = 'DVI';
        policy_no = policy_no.slice(0, 3);
        end_date = null;
        if (vm.insurance_period_type === 'year') {
          end_date = moment(vm.policy.date_start).add(364, 'day').toDate();
        } else if (vm.insurance_period_type === 'over_year') {
          fullYears = Math.floor(vm.full_years);
          fractionalYears = vm.full_years - fullYears;
          monthsInFractional = Math.round(fractionalYears * 10);
          totalDays = (fullYears * 365) + (monthsInFractional * 30) - 1;
          end_date = moment(vm.policy.date_start).add(totalDays, 'day').toDate();
        } else {
          end_date = vm.policy.date_end;
        }
        policy = {
          policy_no: policy_no,
          credit_no: vm.policy.credit_no,
          issue_date: new Date(),
          product_id: vm.policy.product_id,
          company_id: vm.company._id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: vm.policy.client,
          insurance_amount: vm.policy.insurance_amountts,
          insurance_premium: vm.policy.insurance_premiumts,
          insurance_data: {
            ts: vm.collateralsts.ts,
            date_start: vm.policy.date_start,
            date_end: end_date,
            diffDays: vm.diffDays,
            period_type: vm.insurance_period_type,
            full_years: vm.full_years
          },
          objects: 'TS',
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency.name,
            currency: vm.currency,
            insurance_premium_kgs: 0
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис"
          }
        }
      });
      editModal.result.then(function(result) {
        var i, item, len, ref, temp, to_save;
        if (result) {
          to_save = [];
          ref = vm.insurants;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    calculatePremiumNed = function() {
      var i, len, period, ref;
      if (!vm.insuranceformned.objectned) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformned.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformned.insurance_premium = Math.round(vm.insuranceformned.insurance_summ * (vm.insuranceformned.objectned.rate / 100) * vm.period_rate);
    };
    calculatePremiumTs = function() {
      var annualPremium, baseRate, coefficient, days, daysInFractional, fractionalYears, fullYears, monthsInFractional, premiumForFractional, premiumForFullYears, years;
      if (!vm.insuranceformts.objectts) {
        toastr.warning('Выберите объект страхования');
        return;
      }
      if (!vm.insuranceformts.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      if (!vm.insuranceformts.year_issue) {
        toastr.warning('Введите год выпуска');
        return;
      }
      if (vm.vehicleAgeError) {
        toastr.error('ТС старше 15 лет не принимается');
        return;
      }
      baseRate = vm.insuranceformts.objectts.rate / 100;
      annualPremium = vm.insuranceformts.insurance_summ * baseRate;
      if (vm.insurance_period_type === 'year') {
        vm.insuranceformts.insurance_premium = Math.round(annualPremium);
      } else if (vm.insurance_period_type === 'over_year') {
        years = parseFloat(vm.full_years) || 1.5;
        fullYears = Math.floor(years);
        fractionalYears = years - fullYears;
        premiumForFullYears = annualPremium * fullYears;
        premiumForFractional = 0;
        if (fractionalYears > 0) {
          monthsInFractional = Math.round(fractionalYears * 10);
          daysInFractional = monthsInFractional * 30;
          coefficient = 1.0;
          if (daysInFractional <= 60) {
            coefficient = 0.20;
          } else if (daysInFractional <= 90) {
            coefficient = 0.30;
          } else if (daysInFractional <= 120) {
            coefficient = 0.40;
          } else if (daysInFractional <= 150) {
            coefficient = 0.50;
          } else if (daysInFractional <= 180) {
            coefficient = 0.60;
          } else if (daysInFractional <= 210) {
            coefficient = 0.70;
          } else if (daysInFractional <= 240) {
            coefficient = 0.75;
          } else if (daysInFractional <= 270) {
            coefficient = 0.80;
          } else if (daysInFractional <= 300) {
            coefficient = 0.85;
          } else if (daysInFractional <= 330) {
            coefficient = 0.90;
          } else if (daysInFractional <= 360) {
            coefficient = 0.95;
          } else {
            coefficient = 1.00;
          }
          premiumForFractional = annualPremium * coefficient;
        }
        vm.insuranceformts.insurance_premium = Math.round(premiumForFullYears + premiumForFractional);
      } else if (vm.insurance_period_type === 'up_to_year') {
        days = vm.diffDays;
        coefficient = 1.0;
        if (days <= 30) {
          coefficient = 0.20;
        } else if (days <= 60) {
          coefficient = 0.30;
        } else if (days <= 90) {
          coefficient = 0.40;
        } else if (days <= 120) {
          coefficient = 0.50;
        } else if (days <= 150) {
          coefficient = 0.60;
        } else if (days <= 180) {
          coefficient = 0.70;
        } else if (days <= 210) {
          coefficient = 0.75;
        } else if (days <= 240) {
          coefficient = 0.80;
        } else if (days <= 270) {
          coefficient = 0.85;
        } else if (days <= 300) {
          coefficient = 0.90;
        } else if (days <= 330) {
          coefficient = 0.95;
        } else {
          coefficient = 1.00;
        }
        vm.insuranceformts.insurance_premium = Math.round(annualPremium * coefficient);
      }
      toastr.success("Премия рассчитана: " + vm.insuranceformts.insurance_premium);
    };
    calculatePremiumLn = function() {
      var i, len, period, ref;
      if (!vm.insuranceformln.insurance_summ) {
        toastr.warning('Введите страховую сумму');
        return;
      }
      ref = vm.periods;
      for (i = 0, len = ref.length; i < len; i++) {
        period = ref[i];
        if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
          vm.period_rate = period.rate;
        }
      }
      vm.insuranceformln.insurance_premium = Math.round(vm.insuranceformln.insurance_summ * 0.004 * vm.period_rate);
    };
    vm.addCollateralTs = addCollateralTs;
    vm.deleteCollateralTs = deleteCollateralTs;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.confirmAction = confirmAction;
    vm.savePolicy = savePolicy;
    vm.calculatePremiumTs = calculatePremiumTs;
    vm.onPeriodTypeChange = onPeriodTypeChange;
    vm.onFullYearsChange = onFullYearsChange;
    vm.getYearLabel = getYearLabel;
    vm.getTotalDays = getTotalDays;
    vm.validateVehicleAge = validateVehicleAge;
    vm.onVehicleTypeChange = onVehicleTypeChange;
    vm.getInsuranceTsObjects = getInsuranceTsObjects;
    setDefaultCurrency = function() {
      var somCurrency;
      if (vm.currencies && vm.currencies.length > 0) {
        somCurrency = vm.currencies.find(function(c) {
          var ref;
          return ((ref = c.data) != null ? ref.code : void 0) === '417';
        });
        if (somCurrency) {
          vm.currency = somCurrency;
          console.log('Установлена валюта по умолчанию:', vm.currency.name);
        }
      }
    };
    setDefaultProduct = function() {
      if (vm.products && vm.products.length > 0) {
        vm.policy.product_id = vm.products[0]._id;
        console.log('Установлена программа кредитования по умолчанию:', vm.products[0].name);
      }
    };
    $scope.$watch('select.currencies', function(newVal) {
      if (newVal && newVal.length > 0) {
        setDefaultCurrency();
      }
    }, true);
    $scope.$watch('select.products', function(newVal) {
      if (newVal && newVal.length > 0) {
        setDefaultProduct();
      }
    }, true);
    recalculateOnEventAll();
    onPeriodTypeChange();
    RequestService.post('insurancetypes.listing').then(function(data) {
      var i, len, ref, type;
      ref = data.docs;
      for (i = 0, len = ref.length; i < len; i++) {
        type = ref[i];
        if (type.code === 'TC') {
          getInsuranceTsObjects(type._id);
          break;
        }
      }
    });
  }).controller('ApolicyIssueController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var addInsurant, changeIcon, computePrice, confirmAction, deleteInsurant, getCountries, i, len, pdrobneeIconCnange, phone, reCompute, ref, savePolicy, vm;
    vm = this;
    vm.countries = null;
    vm.countriesView = [];
    vm.currentCountryId = '';
    vm.min_insurance = 0;
    vm.product = $stateParams.product;
    vm.currency_name = '';
    vm.currencyRate = 0;
    vm.iconsList = [];
    vm.pdrobneeIcon = 'fa fa-chevron-down';
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    vm.company = Session.getCompany();
    vm.buyer = {};
    if (vm.company.company_type = 'agent') {
      vm.buyer.surname = null;
      vm.buyer.name = null;
      if (vm.company.data.phones) {
        ref = vm.company.data.phones;
        for (i = 0, len = ref.length; i < len; i++) {
          phone = ref[i];
          vm.buyer.phone = phone;
          break;
        }
      } else {
        vm.buyer.phone = null;
      }
    }
    getCountries = function() {
      var filter;
      filter = {
        with_related: true
      };
      RequestService.post('select.issue_listing', filter).then(function(result) {
        var country, currency, item, itemx, j, l, len1, len2, len3, m, ref1, ref2, ref3, results;
        vm.countries = result.countries;
        vm.min_insurance = 0;
        ref1 = result.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          item = ref1[j];
          ref2 = vm.product.tmp_product.country_id;
          for (l = 0, len2 = ref2.length; l < len2; l++) {
            itemx = ref2[l];
            if (itemx === item._id) {
              vm.countriesView.push(item);
              if (item.min_insurance > vm.min_insurance) {
                vm.min_insurance = item.min_insurance;
                vm.currentCountryId = itemx;
              }
            }
          }
        }
        vm.currencies = result.currencies;
        ref3 = vm.countries;
        results = [];
        for (m = 0, len3 = ref3.length; m < len3; m++) {
          country = ref3[m];
          if (country._id === vm.currentCountryId) {
            results.push((function() {
              var len4, n, ref4, results1;
              ref4 = vm.currencies;
              results1 = [];
              for (n = 0, len4 = ref4.length; n < len4; n++) {
                currency = ref4[n];
                if (country.currency_id === currency._id) {
                  vm.currency_name = currency.data.name;
                  results1.push(RequestService.post('currencynbkr.get_nbkr_rate', {
                    iso: vm.currency_name
                  }).then(function(result) {
                    return vm.currencyRate = result.results;
                  }));
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          } else {
            results.push(void 0);
          }
        }
        return results;
      });
    };
    if (vm.product) {
      getCountries();
      vm.insurants = [
        {
          surname: '',
          name: '',
          passport_no: '',
          date_of_birth: '',
          factorListing: angular.copy(vm.product.factorListing),
          factors: angular.copy(vm.product.tmp_product.factors),
          theprice: angular.copy(vm.product.theprice)
        }
      ];
      vm.iconsList.push('fa fa-plus-square');
    } else {
      $state.go("app.apolicy.select");
    }
    addInsurant = function() {
      vm.insurants.push({
        surname: '',
        name: '',
        passport_no: '',
        date_of_birth: '',
        factorListing: angular.copy(vm.product.factorListing),
        factors: angular.copy(vm.product.tmp_product.factors),
        theprice: angular.copy(vm.product.theprice)
      });
      vm.iconsList.push('fa fa-plus-square');
    };
    deleteInsurant = function(index) {
      vm.insurants.splice(index, 1);
      vm.iconsList.splice(index, 1);
    };
    changeIcon = function(index) {
      if (vm.iconsList[index] === 'fa fa-plus-square') {
        return vm.iconsList[index] = 'fa fa-minus-square';
      } else {
        return vm.iconsList[index] = 'fa fa-plus-square';
      }
    };
    reCompute = function(insurant) {
      if (insurant.date_of_birth) {
        insurant.factors['Возраст'] = moment().diff(insurant.date_of_birth, 'years');
        insurant.theprice = $filter('number')(computePrice(insurant), 2);
        console.log(insurant);
        console.log(vm.insurants);
      }
    };
    computePrice = function(insurant) {
      var base_price, basefactor, country_id, country_x, date1, date2, diffDays, factor, fixedamounts, foundcountry, insurance_amount, item_fact, j, l, len1, len2, len3, len4, m, n, obj_x, prod, ref1, ref2, ref3, ref4, theprice, timeDiff;
      prod = angular.copy(vm.product);
      prod.tmp_product.factors = insurant.factors;
      if (vm.countries === null || vm.countries === void 0 || vm.countries.length === 0) {
        console.log("vm.countries is null || vm.countries is undefined || vm.countries.length is 0");
        return;
      }
      if (prod.tmp_product === null || prod.tmp_product === void 0) {
        console.log("vm.prod.tmp_product is null || prod.tmp_product is undefined");
        return;
      }
      theprice = 0;
      base_price = 0;
      insurance_amount = 0;
      foundcountry = false;
      date1 = "";
      date2 = "";
      country_id = [];
      if (prod.tmp_product.country_id === null || prod.tmp_product.country_id === void 0 || prod.tmp_product.country_id.length === 0) {
        prod.tmp_product.country_id = country_id;
      } else {
        country_id = prod.tmp_product.country_id;
      }
      if (prod.tmp_product.date_start === null || prod.tmp_product.date_start === void 0 || prod.tmp_product.date_start === "") {
        prod.tmp_product.date_start = "2016-11-03T18:00:00.000Z";
        date1 = new Date(prod.tmp_product.date_start);
      } else {
        date1 = new Date(prod.tmp_product.date_start);
      }
      if (prod.tmp_product.date_end === null || prod.tmp_product.date_end === void 0 || prod.tmp_product.date_end === "") {
        prod.tmp_product.date_end = "2016-11-04T18:00:00.000Z";
        date2 = new Date(prod.tmp_product.date_end);
      } else {
        date2 = new Date(prod.tmp_product.date_end);
      }
      timeDiff = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (country_id.length > 1) {
        obj_x = {
          min_insurance: 0,
          country_id: ""
        };
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country_x = ref1[j];
          if (country_id.indexOf(country_x._id) > -1) {
            if (parseFloat(country_x.min_insurance) > parseFloat(obj_x.min_insurance)) {
              obj_x.min_insurance = country_x.min_insurance;
              obj_x.country_id = country_x._id;
            }
          }
        }
        country_id = obj_x.country_id;
      } else {
        country_id = country_id[0];
      }
      ref2 = prod.basefactors;
      for (l = 0, len2 = ref2.length; l < len2; l++) {
        basefactor = ref2[l];
        if (basefactor.countries_id.indexOf(country_id) > -1 && basefactor.interval.from_day <= diffDays && basefactor.interval.to_day >= diffDays && parseInt(basefactor.insurance_amount) === parseInt(vm.product.insurance_amount)) {
          foundcountry = true;
          base_price = basefactor.base_price;
          if (basefactor.is_per_day) {
            base_price = base_price * diffDays;
          }
          insurance_amount = basefactor.insurance_amount;
        }
      }
      if (foundcountry === false) {
        console.log("the country OR the interval does't match to this product");
        return;
      }
      theprice = base_price;
      fixedamounts = 0;
      ref3 = prod.factors;
      for (m = 0, len3 = ref3.length; m < len3; m++) {
        factor = ref3[m];
        ref4 = factor.factor;
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          item_fact = ref4[n];
          if (prod.tmp_product.factors[item_fact.name] !== null && prod.tmp_product.factors[item_fact.name] !== void 0 && factor.values.indexOf(prod.tmp_product.factors[item_fact.name].toString()) > -1) {
            if (factor.coefficient_type === "Множитель") {
              theprice = theprice * factor.coefficient;
            }
            if (factor.coefficient_type === "Слагаемое") {
              fixedamounts = fixedamounts + factor.coefficient;
            }
          }
        }
      }
      theprice = theprice + fixedamounts;
      theprice = theprice + ((theprice / 100) * 2);
      return theprice;
    };
    savePolicy = function() {
      var agent_id, branch_id, insurance_data, item, j, key, l, len1, len2, policy, policyList, policy_no, ref1, ref2, ref3, theUser, user, value;
      agent_id = null;
      branch_id = null;
      if (vm.company && vm.company.company_type === 'agent') {
        agent_id = vm.company._id;
      }
      theUser = Session.getUser();
      if (vm.company) {
        ref1 = vm.company.staff;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          user = ref1[j];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      vm.product.data;
      insurance_data = angular.copy(vm.product.tmp_product);
      policyList = {
        items: []
      };
      ref2 = vm.insurants;
      for (l = 0, len2 = ref2.length; l < len2; l++) {
        item = ref2[l];
        insurance_data.factors = item.factors;
        insurance_data.factors_list = [];
        ref3 = item.factors;
        for (key in ref3) {
          value = ref3[key];
          value = value + "";
          insurance_data.factors_list.push({
            key: key,
            value: value
          });
        }
        policy_no = vm.product.code;
        if (vm.company.company_type === "agent") {
          agent_id = vm.company._id;
          policy_no = policy_no.slice(0, 3) + vm.company.code + "00000";
        } else {
          policy_no = policy_no + "00000";
        }
        policy = {
          policy_no: policy_no,
          issue_date: new Date(),
          product_id: vm.product._id,
          company_id: vm.product.company_id,
          user_id: theUser.id,
          agent_id: agent_id,
          branch_id: branch_id,
          client: {
            surname: item.surname.toUpperCase(),
            name: item.name.toUpperCase(),
            passport_no: item.passport_no,
            date_of_birth: item.date_of_birth
          },
          insurance_amount: vm.product.insurance_amount,
          insurance_premium: item.theprice,
          insurance_data: angular.copy(insurance_data),
          payment_data: {},
          index: {},
          accumulation: {},
          data: {
            buyer: vm.buyer,
            status: 'Оформлен',
            currency_name: vm.currency_name,
            insurance_premium_kgs: (item.theprice * vm.currencyRate).toFixed(2)
          }
        };
        policyList.items.push(policy);
      }
      RequestService.post('policies.save', policyList).then(function(result) {
        if (policyList.items.length === 1) {
          policy = angular.copy(policyList.items[0]);
          policy._id = result.resultList[0].id;
          policy._rev = result.resultList[0].rev;
          policy.policy_no = result.resultList[0].policy_no;
          return $state.go('app.apolicy.view', {
            product: policy
          });
        } else {
          return $state.go("app.apolicy.list");
        }
      });
      return false;
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить страховой полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        var item, j, len1, ref1, temp, to_save;
        if (result) {
          to_save = [];
          ref1 = vm.insurants;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            item = ref1[j];
            temp = {
              client_type: 'insured',
              name: item.name,
              surname: item.surname,
              passport: item.passport_no,
              date_of_birth: item.date_of_birth
            };
            to_save.push(temp);
          }
          temp = {
            client_type: 'buyer',
            name: vm.buyer.name,
            surname: vm.buyer.surname,
            email: vm.buyer.email,
            phone: vm.buyer.phone
          };
          to_save.push(temp);
          RequestService.post('clients.save', {
            items: to_save
          }).then(function(result) {
            savePolicy();
          });
        }
      });
    };
    pdrobneeIconCnange = function() {
      if (vm.pdrobneeIcon === 'fa fa-chevron-down') {
        vm.pdrobneeIcon = 'fa fa-chevron-up';
      } else {
        vm.pdrobneeIcon = 'fa fa-chevron-down';
      }
    };
    vm.pdrobneeIconCnange = pdrobneeIconCnange;
    vm.changeIcon = changeIcon;
    vm.confirmAction = confirmAction;
    vm.addInsurant = addInsurant;
    vm.deleteInsurant = deleteInsurant;
    vm.reCompute = reCompute;
    vm.savePolicy = savePolicy;
  }).controller('ApolicyViewController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal) {
    'ngInject';
    var FormPolicy, confirmAction, confirmActionForm, confirmActionTerm, downloadPDF, findCurrencyName, findMinInsurance, getProducts, goToForm, goToPolicy, issueAgent_policy, sendMail, spoilPolicy, termAgent_policy, vm;
    vm = this;
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    getProducts = function(product_id) {
      var filter;
      filter = {
        with_related: true,
        _id: product_id
      };
      RequestService.post('select.view_listing', filter).then(function(result) {
        vm.product = result.product;
        vm.countries = result.countries;
        vm.currencies = result.currencies;
        findMinInsurance();
        findCurrencyName();
        if (!vm.policy.product) {
          vm.policy.product = angular.copy(vm.product);
        }
      });
    };
    findCurrencyName = function() {
      var country, currency, i, j, len, len1, ref, ref1;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        country = ref[i];
        if (country._id === vm.currentCountryId) {
          ref1 = vm.currencies;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            currency = ref1[j];
            if (country.currency_id === currency._id) {
              vm.currency_name = currency.data.name;
              if (vm.policy.policy_no === '00000' && vm.currency_name) {
                RequestService.post('currencynbkr.get_nbkr_rate', {
                  iso: vm.currency_name
                }).then(function(result) {
                  var currencyRate;
                  currencyRate = result.results;
                  return vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * currencyRate).toFixed(2);
                });
              }
              return;
            }
          }
        }
      }
    };
    findMinInsurance = function() {
      var i, item, itemx, j, len, len1, ref, ref1;
      vm.min_insurance = 0;
      ref = vm.countries;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        ref1 = vm.policy.insurance_data.country_id;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          itemx = ref1[j];
          if (itemx === item._id) {
            if (item.min_insurance > vm.min_insurance) {
              vm.min_insurance = item.min_insurance;
              vm.currentCountryId = itemx;
            }
          }
        }
      }
      if (vm.currencies) {
        findCurrencyName();
      }
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = $stateParams.product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      getProducts(vm.policy.product_id);
    }
    sendMail = function() {
      var countries, country, country_id, i, j, len, len1, ref, ref1, send_policy;
      countries = '';
      ref = vm.policy.insurance_data.country_id;
      for (i = 0, len = ref.length; i < len; i++) {
        country_id = ref[i];
        ref1 = vm.countries;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          country = ref1[j];
          if (country._id === country_id) {
            countries += ", " + country.data.name_eng;
            break;
          }
        }
      }
      send_policy = {};
      send_policy.policy_no = vm.policy.policy_no;
      send_policy.date_start = moment(vm.policy.insurance_data.date_start).format("DD-MM-YYYY");
      send_policy.date_end = moment(vm.policy.insurance_data.date_end).format("DD-MM-YYYY");
      send_policy.insurance_amount = vm.policy.insurance_amount;
      send_policy.insurance_premium = vm.policy.insurance_premium;
      send_policy.currency_name = vm.currency_name;
      send_policy.surname = vm.policy.client.surname;
      send_policy.name = vm.policy.client.name;
      send_policy.date_of_birth = moment(vm.policy.client.date_of_birth).format("DD-MM-YYYY");
      send_policy.passport_no = vm.policy.client.passport_no;
      send_policy.status = vm.policy.data.status;
      send_policy.countries = countries;
      send_policy.email = vm.policy.data.buyer.email;
      return RequestService.post('mailjet_service.send', send_policy).then(function(result) {
        console.log(result);
        toastr.success('Письмо отправлено на электронный почтовый ящик клиента');
      });
    };
    FormPolicy = function() {
      var agent_id, branch_id, i, len, policyList, policy_no, policy_to_send, ref, theUser, user;
      agent_id = null;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      policy_no = vm.product.code;
      if (vm.product.data === null || vm.product.data === void 0) {
        vm.product.data = {
          policy_count: 1
        };
      } else {
        if (vm.product.data.policy_count === null || vm.product.data.policy_count === void 0) {
          vm.product.data.policy_count = 1;
        } else {
          vm.product.data.policy_count = parseInt(vm.product.data.policy_count, 10) + 1;
        }
      }
      if (vm.company.company_type === "agent") {
        agent_id = vm.company._id;
        policy_no = policy_no.slice(0, 3) + vm.company.code + "00000";
      } else {
        policy_no = policy_no + "00000";
      }
      vm.policy.policy_no = policy_no;
      vm.policy.issue_date = new Date();
      vm.policy.data.insurance_premium_kgs = (vm.policy.insurance_premium * vm.currencyRate).toFixed(2);
      delete vm.policy.product;
      policy_to_send = angular.copy(vm.policy);
      policy_to_send.data.status = 'Оформлен';
      policyList.items.push(policy_to_send);
      RequestService.post('policies.save', policyList).then(function(result) {
        delete vm.product.company;
        delete vm.product.factors;
        delete vm.product.services;
        delete vm.product.basefactors;
        vm.policy.policy_no = result.resultList[0].policy_no;
        vm.policy.data.status = 'Оформлен';
        sendMail();
        return toastr.success('Полис оформлен успешно');
      });
      return false;
    };
    issueAgent_policy = function() {
      RequestService.post('currencynbkr.get_nbkr_rate', {
        iso: vm.currency_name
      }).then(function(result) {
        vm.currencyRate = result.results;
        console.log("vm.currencyRate " + vm.currencyRate);
        FormPolicy();
      });
    };
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      ReportService.printReport('IIP', {
        'policyNumber': vm.policy.policy_no
      });
    };
    termAgent_policy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          spoilPolicy();
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ApolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issueAgent_policy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termAgent_policy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
  }).controller('ApolicyShowController', function($scope, ReportService, hotkeys, $state, $stateParams, RequestService, Session, toastr, $uibModal, product, $uibModalInstance) {
    'ngInject';
    var cancel, confirmAction, confirmActionForm, confirmActionTerm, date1, diffDays, downloadPDF, goToForm, goToPolicy, spoilPolicy, termPolicy, timeDiff, vm;
    vm = this;
    vm.today = new Date();
    vm.product = '';
    vm.currency_name = '';
    vm.min_insurance = '';
    vm.currentCountryId = '';
    vm.currencies = [];
    vm.currencyRate = 1;
    vm.flag_status_policy = true;
    cancel = function() {
      return $uibModalInstance.dismiss();
    };
    vm.countries = null;
    vm.currentCountryId = '';
    vm.company = Session.getCompany();
    vm.policy = product;
    if (vm.policy === null || vm.policy === void 0) {
      $state.go("app.apolicy.list");
    } else {
      date1 = new Date(vm.policy.issue_date);
      timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays >= 1) {
        vm.flag_status_policy = false;
      }
    }
    spoilPolicy = function() {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Испорчен";
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис испорчен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    downloadPDF = function() {
      if (vm.policy.objects === 'TS') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('TS2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('TS', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'LN') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('LN2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('LN', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else if (vm.policy.objects === 'NED') {
        if (vm.policy.issue_date > '2019-07-22 00:00:00') {
          ReportService.printReport('NED2', {
            'policyNumber': vm.policy.policy_no
          });
        } else {
          ReportService.printReport('NED', {
            'policyNumber': vm.policy.policy_no
          });
        }
      } else {
        toastr.warning('Не существует шаблона');
      }
    };
    termPolicy = function(moneyBack) {
      var branch_id, i, len, policyList, ref, theUser, user;
      branch_id = null;
      theUser = Session.getUser();
      if (vm.company) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (user.user_id === theUser.id) {
            branch_id = user.branch_id;
          }
        }
      }
      policyList = {
        items: []
      };
      vm.policy.user_id = theUser.id;
      vm.policy.branch_id = branch_id;
      vm.policy.data.status = "Расторгнут";
      vm.policy.data.moneyBack = moneyBack;
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис расторжен успешно');
        return $state.go("app.apolicy.list");
      });
      return false;
    };
    goToPolicy = function() {
      $state.go('app.apolicy.list');
    };
    goToForm = function() {
      $state.go('app.apolicy.form', {
        policy: vm.policy
      });
    };
    confirmAction = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите испортить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          date1 = new Date(vm.policy.issue_date);
          timeDiff = Math.abs(date1.getTime() - vm.today.getTime());
          diffDays = Math.ceil((timeDiff / (1000 * 3600 * 24)) - 1);
          if (diffDays < 1) {
            spoilPolicy();
          } else {
            toastr.warning('Данная операция невозможна!');
          }
        }
      });
    };
    confirmActionForm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите оформить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          issuePolicy();
        }
      });
    };
    confirmActionTerm = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/dialog_parameter.html',
        controller: 'TerminateDialogController',
        controllerAs: 'term_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите расторгнуть этот полис?"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result !== false) {
          termPolicy(result);
        }
      });
    };
    vm.confirmActionForm = confirmActionForm;
    vm.downloadPDF = downloadPDF;
    vm.confirmAction = confirmAction;
    vm.confirmActionTerm = confirmActionTerm;
    vm.spoilPolicy = spoilPolicy;
    vm.goToForm = goToForm;
    vm.goToPolicy = goToPolicy;
    vm.cancel = cancel;
  }).controller('ApolicyFormController', function($scope, hotkeys, $state, RequestService, Session, $filter, toastr, $stateParams, $uibModal) {
    'ngInject';
    var SavePolicy, addCollateralNed, cancelNed, confirmActionNed, confirmActionSave, editNed, getInsuranceNedObjects, getPeriods, recalculateOnEventAll, removeNed, vm;
    vm = this;
    vm.today = new Date();
    vm.finish_date = moment(vm.today).add(364, 'day').toDate();
    vm.diffDays = 0;
    vm.min_insurance = 0;
    vm.currency_name = '';
    vm.currencyRate = 1;
    vm.policy = $stateParams.policy;
    vm.policy.date_start = moment().toDate();
    vm.policy.date_end = null;
    vm.ned = null;
    vm.collateralsned = {
      ned: []
    };
    vm.collateralsts = {
      ts: []
    };
    vm.collateralsln = {
      ln: []
    };
    $("[name='datemask']").mask("00.00.0000", {
      placeholder: "ДД.ММ.ГГГГ"
    });
    getInsuranceNedObjects = function(insurance_type) {
      return RequestService.post('insuranceobject.listing', {
        insurance_type_id: vm.policy.objects
      }).then(function(data) {
        vm.insuranceobjectsned = angular.copy(data.docs);
      });
    };
    recalculateOnEventAll = function() {
      var date1, date2, diffDays, i, j, l, len, len1, len2, len3, len4, len5, ln, m, n, ned, o, period, ref, ref1, ref2, ref3, ref4, ref5, timeDiff, ts;
      date1 = "";
      date2 = "";
      date1 = vm.policy.date_start;
      date2 = vm.policy.date_end || moment(vm.policy.date_start).add(1, 'day').toDate();
      vm.policy.insurance_premium = 0;
      vm.policy.insurance_amount = 0;
      diffDays = 0;
      if (vm.isAnnual) {
        vm.diffDays = 365;
      } else {
        timeDiff = Math.abs(date2.getTime() - date1.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        vm.diffDays = diffDays + 1;
      }
      if (vm.policy.insurance_data.ned) {
        ref = vm.policy.insurance_data.ned;
        for (i = 0, len = ref.length; i < len; i++) {
          ned = ref[i];
          ref1 = vm.periods;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            period = ref1[j];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ned.insurance_premium = Math.round(ned.insurance_summ * (ned.objectned.rate / 100) * vm.period_rate);
          }
          vm.policy.insurance_premium += ned.insurance_premium;
          vm.policy.insurance_amount += ned.insurance_summ;
        }
      } else if (vm.policy.insurance_data.ts) {
        ref2 = vm.policy.insurance_data.ts;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          ts = ref2[l];
          ref3 = vm.periods;
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            period = ref3[m];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ts.insurance_premium = Math.round(ts.insurance_summ * (ts.objectts.rate / 100) * vm.period_rate);
          }
          vm.policy.insurance_premium += ts.insurance_premium;
          vm.policy.insurance_amount += ts.insurance_summ;
        }
      } else if (vm.policy.insurance_data.ln) {
        ref4 = vm.policy.insurance_data.ln;
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          ln = ref4[n];
          ref5 = vm.periods;
          for (o = 0, len5 = ref5.length; o < len5; o++) {
            period = ref5[o];
            if (period.start <= vm.diffDays && period.end >= vm.diffDays) {
              vm.period_rate = period.rate;
            }
            ln.insurance_premium = Math.round(ln.insurance_summ * 0.004 * vm.period_rate);
          }
          vm.policy.insurance_premium += ln.insurance_premium;
          vm.policy.insurance_amount += ln.insurance_summ;
        }
      }
    };
    SavePolicy = function() {
      var old_policy_no, policyList, policy_no;
      policyList = {
        items: []
      };
      old_policy_no = vm.policy.policy_no;
      delete vm.policy._id;
      delete vm.policy._created;
      delete vm.policy._deleted;
      delete vm.policy._rev;
      if (vm.policy.insurance_data.ned) {
        policy_no = 'HPI';
        policy_no = policy_no.slice(0, 3);
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      } else if (vm.policy.insurance_data.ts) {
        policy_no = 'DVI';
        policy_no = policy_no.slice(0, 3);
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      } else if (vm.policy.insurance_data.ln) {
        policy_no = 'HAI';
        policy_no = policy_no.slice(0, 3);
        vm.policy.policy_no = policy_no;
        vm.policy.data.status = 'Оформлен';
        vm.policy.data.old_policy_no = old_policy_no;
      }
      policyList.items.push(vm.policy);
      RequestService.post('policies.save', policyList).then(function(result) {
        toastr.success('Полис сохранен успешно');
        return $state.go('app.apolicy.list');
      });
      return false;
    };
    confirmActionSave = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'PolicyDialogController',
        controllerAs: 'policy_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите сохранить этот полис"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          SavePolicy();
        }
      });
    };
    getPeriods = function() {
      return RequestService.post('period.listing').then(function(data) {
        vm.periods = angular.copy(data.docs);
      });
    };
    addCollateralNed = function(insuranceform) {
      if (insuranceform.insurance_premium) {
        vm.nedvijimost = {
          owner: insuranceform.owner,
          object: insuranceform.objectned.name,
          adres: insuranceform.adres,
          insurance_summ: insuranceform.insurance_summ,
          insurance_premium: insuranceform.insurance_premium
        };
        vm.collateralsned.ned.push(vm.nedvijimost);
        vm.nedvijimost = {};
        vm.insuranceformned = {
          objectned: null,
          insurance_summ: null,
          insurance_premium: null,
          adres: 'Кыргызская Республика'
        };
        vm.policy.insurance_amountned = vm.policy.insurance_amountned + insuranceform.insurance_summ;
        vm.policy.insurance_premiumned = vm.policy.insurance_premiumned + insuranceform.insurance_premium;
      } else {
        toastr.warning('Пожалуйста рассчитайте страховую премию');
      }
    };
    editNed = function(identity) {
      vm.insuranceformned = identity;
    };
    cancelNed = function() {
      vm.insuranceformned = null;
    };
    removeNed = function(index) {
      vm.neds.splice(index, 1);
    };
    confirmActionNed = function(index) {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/modals/confirmation-dialog.html',
        controller: 'ProfileDialogController',
        controllerAs: 'profile_dialog',
        size: 'sm',
        resolve: {
          text: {
            text: ", что хотите удалить"
          }
        }
      });
      editModal.result.then(function(result) {
        if (result) {
          removeNed(index);
        }
      });
    };
    vm.getPeriods = getPeriods;
    vm.confirmActionSave = confirmActionSave;
    vm.SavePolicy = SavePolicy;
    vm.recalculateOnEventAll = recalculateOnEventAll;
    vm.getInsuranceNedObjects = getInsuranceNedObjects;
    vm.addCollateralNed = addCollateralNed;
    vm.editNed = editNed;
    vm.cancelNed = cancelNed;
    vm.removeNed = removeNed;
    vm.confirmActionNed = confirmActionNed;
    getInsuranceNedObjects();
    getPeriods();
  }).controller('ApolicyDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    ok = function() {
      $uibModalInstance.close(true);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).controller('TerminateDialogController', function($scope, hotkeys, $state, RequestService, text, Session, $filter, toastr, $stateParams, $uibModalInstance) {
    'ngInject';
    var cancel, ok, vm;
    vm = this;
    vm.text = text || '';
    vm.moneyBack = 0;
    ok = function() {
      $uibModalInstance.close(vm.moneyBack);
    };
    cancel = function() {
      $uibModalInstance.close(false);
    };
    vm.ok = ok;
    vm.cancel = cancel;
  }).filter('filterCountries', function() {
    return function(input, search) {
      var i, item, len, res;
      res = [];
      if (input) {
        for (i = 0, len = input.length; i < len; i++) {
          item = input[i];
          if (item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.data.name_eng.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
            res.push(item);
          }
        }
      } else {
        return [];
      }
      return res;
    };
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AgentreportController', function(RequestService, ReportService, email_mask, Session, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var date, downloadExcelRPA, downloadExcelRPAP, downloadPDFRPA, downloadPDFRPAP, getPolicies, m, vm, y;
    vm = this;
    vm.today = new Date();
    date = new Date();
    y = date.getFullYear();
    m = date.getMonth();
    vm.date_start = new Date(y, m, 1);
    vm.date_end = new Date();
    vm.offset = 0;
    vm.limit = 10;
    vm.user = Session.getUser();
    vm.policies = null;
    vm.policy_filtered = [];
    vm.agents = [];
    vm.policiesGridOptions = {
      noUnselect: true,
      paginationPageSizes: [10, 20, 50],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: [
        {
          name: 'policy_no',
          displayName: 'Номер полис'
        }, {
          name: 'data.status',
          displayName: 'Статус'
        }, {
          name: 'product',
          displayName: 'Продукт',
          visible: false
        }, {
          name: 'client',
          displayName: 'Страхователь'
        }, {
          name: 'insurance_data.date_start',
          displayName: 'Начало',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_data.date_end',
          displayName: 'Конец',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'insurance_premium',
          displayName: 'Страховая премия'
        }, {
          name: 'issue_date',
          displayName: 'Дата выдачи',
          type: 'date',
          cellFilter: 'date:\'dd-MM-yyyy\''
        }, {
          name: 'company',
          displayName: 'Филиал'
        }, {
          name: 'agent.surname',
          displayName: 'Сотрудник',
          cellTemplate: '<span>{{row.entity.agent.surname}} {{row.entity.agent.name}}</span>'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'payment_data',
          displayName: 'Дата платежа',
          visible: false
        }, {
          name: 'index',
          displayName: 'Индекс',
          visible: false
        }, {
          name: 'accumulation',
          displayName: 'Накопление',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата создания',
          visible: false
        }, {
          name: 'status',
          displayName: 'Статус',
          visible: false
        }
      ]
    };
    downloadPDFRPA = function() {
      ReportService.printReport('RPA', {
        'user_id': vm.user.id + '',
        'start_date': moment(vm.date_start).format('MM/DD/YYYY') + '',
        'end_date': moment(vm.date_end).format('MM/DD/YYYY') + ''
      });
    };
    downloadExcelRPA = function() {
      if (vm.company.company_type !== 'agent' && vm.company._id === vm.agent_id) {
        ReportService.saveReportExcel('RPC', {
          'company_id': vm.filter.filter.agent_id + '',
          'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
          end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
        });
        return;
      } else {
        ReportService.saveReportExcel('RPA', {
          'agent_id': vm.filter.filter.agent_id + '',
          'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
          end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
        });
      }
    };
    downloadPDFRPAP = function() {
      ReportService.printReport('RPAP', {
        'agent_id': vm.filter.filter.agent_id + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    downloadExcelRPAP = function() {
      ReportService.saveReportExcel('RPAP', {
        'agent_id': vm.filter.filter.agent_id + '',
        'start_date': moment(vm.date_start).format('DD.MM.YYYY') + '',
        end_date: moment(vm.date_end).format('DD.MM.YYYY') + ''
      });
    };
    getPolicies = function() {
      if (!vm.company) {
        vm.filter = {
          offset: vm.offset,
          limit: vm.limit,
          order_by: ["_created DESC"],
          with_related: true,
          filter: {
            edit_user_id: vm.user.id,
            date_start: vm.date_start,
            date_end: vm.date_end,
            report_period: ['Оформлен', 'Истек']
          }
        };
      }
      RequestService.post('policies.listing', vm.filter).then(function(data) {
        delete vm.selected_policy;
        vm.policiesGridOptions.data = angular.copy(data.docs);
        vm.policiesGridOptions.totalItems = data.count;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_policy = angular.copy(row.entity);
    });
    $scope.$on('get-page', function(event, options) {
      vm.offset = options.page * options.size;
      vm.limit = options.size;
      getPolicies();
    });
    vm.downloadExcelRPA = downloadExcelRPA;
    vm.downloadExcelRPAP = downloadExcelRPAP;
    vm.downloadPDFRPA = downloadPDFRPA;
    vm.downloadPDFRPAP = downloadPDFRPAP;
    vm.getPolicies = getPolicies;
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AgentemployeeController', function(RequestService, Session, email_mask, $state, $scope, hotkeys, toastr, $uibModal) {
    'ngInject';
    var editUser, getUsers, newUser, removeUser, vm;
    vm = this;
    vm.company = Session.getCompany();
    vm.users = {};
    vm.agentemployeeGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'User.username',
          displayName: 'Имя'
        }, {
          name: 'branch',
          displayName: 'Филиал'
        }, {
          name: 'User.email',
          displayName: 'Емайл'
        }, {
          name: 'User.rec_date',
          displayName: 'Дата регистрации'
        }
      ]
    };
    getUsers = function() {
      var filter;
      filter = {
        offset: vm.offset,
        limit: vm.limit,
        with_related: true,
        id: vm.company._id
      };
      RequestService.post('agentemployee.listing', filter).then(function(result) {
        delete vm.selected_agent;
        vm.agentemployeeGridOptions.data = result.users;
        return vm.agentemployeeGridOptions.totalItems = result.count;
      });
    };
    newUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/agentemployee/create.html',
        controller: 'AgentemployeeCreateController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: void 0
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    editUser = function() {
      var employeeDialog;
      employeeDialog = $uibModal.open({
        templateUrl: 'app/agentemployee/edit.html',
        controller: 'AgentemployeeCreateController',
        controllerAs: 'user',
        size: 'lg',
        resolve: {
          user: angular.copy(vm.selected_user)
        }
      });
      employeeDialog.result.then(function() {
        return getUsers();
      });
    };
    removeUser = function(row) {
      var removeModal;
      removeModal = $uibModal.open({
        controller: function($scope, $uibModalInstance) {
          var vmm;
          vmm = this;
          vmm.ok = function() {
            return $uibModalInstance.close(vmm.report);
          };
          vmm.cancel = function() {
            return $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'removeModal',
        template: '<div class="modal-header"><h3>Удаление пользователя</h3></div><div class="modal-body"><h5 class="text-danger">Вы уверены что хотите удалить?</h5></div><div class="modal-footer"><button class="btn btn-primary btn-sm pull-right" ng-click="removeModal.ok()">ок</button><button class="btn btn-default btn-sm pull-right" ng-click="removeModal.cancel()">Отмена</button></div>'
      });
      removeModal.result.then(function(report) {
        RequestService.post('agentemployee.remove', {
          id: vm.selected_user.User.id
        }).then(function(result) {
          getUsers();
        });
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_user = row.entity;
    });
    vm.getUsers = getUsers;
    vm.newUser = newUser;
    vm.editUser = editUser;
    vm.removeUser = removeUser;
    getUsers();
  }).controller('AgentemployeeCreateController', function(RequestService, product_types, user, $scope, $uibModalInstance, Session) {
    'ngInject';
    var cancel, createUser, getBranches, updateUser, vm;
    vm = this;
    if (user === null || user === void 0) {
      vm.user = {};
    } else {
      vm.user = user.User;
    }
    getBranches = function() {
      var company, filter;
      company = Session.getCompany();
      if (company) {
        filter = {
          with_related: true,
          filter: {
            company_id: company._id
          }
        };
      } else {
        filter = {
          with_related: true
        };
      }
      RequestService.post('branch.listing', filter).then(function(data) {
        delete vm.selected_branch;
        vm.branches = data.docs;
      });
    };
    createUser = function() {
      RequestService.post('agentemployee.register', vm.user).then(function(result) {
        $uibModalInstance.close(result);
      });
    };
    updateUser = function() {
      RequestService.post('user.put', vm.user).then(function(result) {
        console.log("updateUser ->result.user = ");
        console.log(result.user);
        $uibModalInstance.close(result);
      });
    };
    cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    vm.updateUser = updateUser;
    vm.createUser = createUser;
    vm.cancel = cancel;
    vm.getBranches = getBranches;
    getBranches();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AgentbranchController', function($scope, RequestService, Session, $rootScope, AppStorage, $uibModal) {
    'ngInject';
    var editCompany, getCompanies, newCompany, setActiveCompany, vm;
    vm = this;
    vm.uc = Session.getCompany();
    vm.companiesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'short_name',
          displayName: 'Короткое имя'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company_type',
          displayName: 'Тип Компании'
        }, {
          name: 'data.description',
          displayName: 'Описание'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.logo',
          displayName: 'Логотип',
          visible: false
        }, {
          name: 'data.industry',
          displayName: 'Отрасль',
          visible: false
        }, {
          name: 'data.status',
          displayName: 'Статус',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Изменивший',
          visible: false
        }
      ]
    };
    getCompanies = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'branch_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        delete vm.selected_company;
        vm.companiesGridOptions.data = data.docs;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_company = angular.copy(row.entity);
    });
    setActiveCompany = function(user_company) {
      RequestService.post('user.set_company', user_company).then(function(result) {
        Session.setCompany(angular.copy(user_company));
        return $rootScope.$broadcast('set-active-company');
      });
    };
    newCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agentbranch/edit.html',
        controller: 'AgentbranchEditController',
        controllerAs: 'agentbranch',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: void 0
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    editCompany = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agentbranch/edit.html',
        controller: 'AgentbranchEditController',
        controllerAs: 'agentbranch',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: vm.selected_company
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    vm.getCompanies = getCompanies;
    vm.setActiveCompany = setActiveCompany;
    vm.newCompany = newCompany;
    vm.editCompany = editCompany;
    getCompanies();
  }).controller('AgentbranchEditController', function($scope, RequestService, Session, email_mask, $uibModalInstance, company, toastr, flowFactory) {
    'ngInject';
    var addAddress, addAssistance, addEmail, addPhone, addStaff, addWebsite, deleteAddress, deleteAssistance, deleteEmail, deletePhone, deleteStaff, deleteWebsite, getCompanies, getUsers, handleFileSelect, putCompany, upload, vm;
    vm = this;
    vm.ua = Session.getUser();
    vm.users = [];
    vm.branches = [];
    vm.companiesAsAgents = [];
    vm.agentList = [];
    vm.company = '';
    vm.image = '';
    vm.result_image = '';
    vm.currflow = '';
    vm.uc = Session.getCompany();
    getCompanies = function() {
      var filter;
      filter = {
        filter: {
          company_type: 'branch_company'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        return vm.branches = data.docs;
      });
    };
    if (company === null || company === void 0) {
      vm.company = {
        data: {
          assistants: []
        },
        agents_id: [],
        staff: [],
        company_type: "branch_company"
      };
    } else {
      vm.company = company;
    }
    upload = function() {
      if (!vm.result_image) {
        console.log("vm.result_image == null");
        return;
      }
      RequestService.post('upload/company/' + vm.company._id, {
        file: vm.result_image
      }).then(function(result) {
        vm.company.data.image = 'image/' + result.file;
        vm.currflow.cancel();
        vm.currflow = '';
      });
    };
    handleFileSelect = function(event, $flow, flowFile) {
      var image, reader;
      vm.currflow = $flow;
      if (!flowFile.file.type.startsWith('image/')) {
        toastr.warning('Выберите изображение');
        event.preventDefault();
        return false;
      }
      image = flowFile.file;
      if (angular.isUndefined(image)) {
        return;
      }
      vm.imageLoading = true;
      reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function($scope) {
          vm.imageLoading = false;
          vm.image = event.target.result;
        });
      };
      reader.readAsDataURL(image);
    };
    putCompany = function() {
      console.log(vm.company);
      if (vm.company.name === void 0 || vm.company.name.trim().length === 0) {
        toastr.warning('Укажите имя компании');
        return false;
      }
      if (vm.company.email !== void 0 && !vm.company.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      vm.company.user_id = 1;
      vm.company.company_type = 'branch_company';
      vm.company.company_id = vm.uc._id;
      RequestService.post('company.put', vm.company).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    vm.putCompany = putCompany;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    getUsers = function() {
      RequestService.post('user.listing').then(function(result) {
        vm.users = result.users;
      });
    };
    vm.currStaff = {
      user_id: '',
      branch_id: ''
    };
    addStaff = function() {
      var i, len, ref, x1;
      if (vm.currStaff.user_id !== null && vm.currStaff.user_id !== void 0) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1.user_id === vm.currStaff.user_id) {
            toastr.warning('Этот user уже в списке');
            return;
          }
        }
        vm.currStaff.branch_id = vm.company._id;
        vm.company.staff.push(vm.currStaff);
        vm.currStaff = {
          user_id: '',
          branch_id: ''
        };
        return;
      } else {
        alert("В начале выберите user или филиал !");
        return;
      }
    };
    deleteStaff = function(index) {
      vm.company.staff.splice(index, 1);
    };
    addAssistance = function() {
      var i, len, ref, x1;
      if (vm.assistance !== null && vm.assistance !== void 0) {
        ref = vm.company.data.assistants;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1._id === vm.assistance._id) {
            console.log("Этот ассистанс уже в списке");
            return;
          }
        }
        vm.company.data.assistants.push(vm.assistance);
        return;
      } else {
        alert("В начале выберите Ассистанс !");
        return;
      }
    };
    deleteAssistance = function(index) {
      vm.company.data.assistants.splice(index, 1);
    };
    vm.address = '';
    addAddress = function() {
      if (vm.company.data.addresses === null || vm.company.data.addresses === void 0) {
        vm.company.data.addresses = [];
      } else {
        if (vm.company.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.address !== null && vm.address !== void 0 && vm.address !== '') {
        vm.company.data.addresses.push(vm.address);
        vm.address = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteAddress = function(index) {
      vm.company.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.company.data.emails === null || vm.company.data.emails === void 0) {
        vm.company.data.emails = [];
      } else {
        if (vm.company.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.email !== null && vm.email !== void 0 && vm.email !== '') {
        vm.company.data.emails.push(vm.email);
        vm.email = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteEmail = function(index) {
      vm.company.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.company.data.websites === null || vm.company.data.websites === void 0) {
        vm.company.data.websites = [];
      } else {
        if (vm.company.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.website !== null && vm.website !== void 0 && vm.website !== '') {
        vm.company.data.websites.push(vm.website);
        vm.website = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteWebsite = function(index) {
      vm.company.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.company.data.phones === null || vm.company.data.phones === void 0) {
        vm.company.data.phones = [];
      } else {
        if (vm.company.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.phone !== null && vm.phone !== void 0 && vm.phone !== '') {
        vm.company.data.phones.push(vm.phone);
        vm.phone = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deletePhone = function(index) {
      vm.company.data.phones.splice(index, 1);
    };
    vm.upload = upload;
    vm.handleFileSelect = handleFileSelect;
    vm.deleteStaff = deleteStaff;
    vm.addStaff = addStaff;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.addAssistance = addAssistance;
    vm.deleteAssistance = deleteAssistance;
    vm.getCompanies = getCompanies;
    getUsers();
    getCompanies();
  });

}).call(this);



(function() {
  angular.module('fsa').controller('AgentController', function($scope, RequestService, Session, $rootScope, AppStorage, $uibModal) {
    'ngInject';
    var editAgent, getCompanies, newAgent, setActiveCompany, vm;
    vm = this;
    vm.uc = Session.getCompany();
    vm.companiesGridOptions = {
      noUnselect: true,
      columnDefs: [
        {
          name: 'name',
          displayName: 'Название'
        }, {
          name: 'short_name',
          displayName: 'Короткое имя'
        }, {
          name: 'code',
          displayName: 'Код'
        }, {
          name: 'data.addresses[0]',
          displayName: 'Адреса'
        }, {
          name: 'data.phones[0]',
          displayName: 'Телефон'
        }, {
          name: 'data.emails[0]',
          displayName: 'E-mail'
        }, {
          name: 'data.manager',
          displayName: 'Менеджер'
        }, {
          name: 'company_type',
          displayName: 'Тип Компании'
        }, {
          name: 'data.description',
          displayName: 'Описание'
        }, {
          name: '_id',
          displayName: 'ID',
          visible: false
        }, {
          name: 'data.logo',
          displayName: 'Логотип',
          visible: false
        }, {
          name: 'data.industry',
          displayName: 'Отрасль',
          visible: false
        }, {
          name: 'data.status',
          displayName: 'Статус',
          visible: false
        }, {
          name: '_created',
          displayName: 'Дата добавления',
          visible: false
        }, {
          name: 'edit_user_id',
          displayName: 'Изменивший',
          visible: false
        }
      ]
    };
    getCompanies = function() {
      var filter;
      filter = {
        with_related: true,
        filter: {
          company_type: 'agent'
        }
      };
      RequestService.post('company.listing', filter).then(function(data) {
        delete vm.selected_company;
        vm.companiesGridOptions.data = data.docs;
      });
    };
    $scope.$on('data-selected', function(event, row) {
      vm.selected_company = angular.copy(row.entity);
    });
    setActiveCompany = function(user_company) {
      RequestService.post('user.set_company', user_company).then(function(result) {
        Session.setCompany(angular.copy(user_company));
        return $rootScope.$broadcast('set-active-company');
      });
    };
    newAgent = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agent/create.html',
        controller: 'AgentCreateController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: void 0
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    editAgent = function() {
      var editModal;
      editModal = $uibModal.open({
        templateUrl: 'app/agent/create.html',
        controller: 'AgentCreateController',
        controllerAs: 'company',
        size: 'lg',
        scope: $scope,
        resolve: {
          company: vm.selected_company
        }
      });
      editModal.result.then(function() {
        return getCompanies();
      });
    };
    vm.getCompanies = getCompanies;
    vm.setActiveCompany = setActiveCompany;
    vm.newAgent = newAgent;
    vm.editAgent = editAgent;
    getCompanies();
  }).controller('AgentCreateController', function($scope, RequestService, Session, email_mask, $uibModalInstance, company, toastr, flowFactory) {
    'ngInject';
    var addAddress, addAssistance, addEmail, addPhone, addStaff, addWebsite, deleteAddress, deleteAssistance, deleteEmail, deletePhone, deleteStaff, deleteWebsite, getUsers, handleFileSelect, putCompany, upload, vm;
    vm = this;
    vm.ua = Session.getUser();
    vm.users = [];
    vm.branches = [];
    vm.companiesAsAgents = [];
    vm.agentList = [];
    vm.company = '';
    vm.image = '';
    vm.result_image = '';
    vm.currflow = '';
    if (company === null || company === void 0) {
      vm.company = {
        data: {
          assistants: []
        },
        agents_id: [],
        staff: [],
        company_type: "agent"
      };
    } else {
      vm.company = company;
    }
    upload = function() {
      if (!vm.result_image) {
        console.log("vm.result_image == null");
        return;
      }
      RequestService.post('upload/company/' + vm.company._id, {
        file: vm.result_image
      }).then(function(result) {
        vm.company.data.image = 'image/' + result.file;
        vm.currflow.cancel();
        vm.currflow = '';
      });
    };
    handleFileSelect = function(event, $flow, flowFile) {
      var image, reader;
      vm.currflow = $flow;
      if (!flowFile.file.type.startsWith('image/')) {
        toastr.warning('Выберите изображение');
        event.preventDefault();
        return false;
      }
      image = flowFile.file;
      if (angular.isUndefined(image)) {
        return;
      }
      vm.imageLoading = true;
      reader = new FileReader();
      reader.onload = function(event) {
        $scope.$apply(function($scope) {
          vm.imageLoading = false;
          vm.image = event.target.result;
        });
      };
      reader.readAsDataURL(image);
    };
    putCompany = function() {
      console.log(vm.company);
      if (vm.company.name === void 0 || vm.company.name.trim().length === 0) {
        toastr.warning('Укажите имя компании');
        return false;
      }
      if (vm.company.email !== void 0 && !vm.company.email.match(email_mask)) {
        toastr.warning('Укажите валидный email');
        return false;
      }
      vm.company.user_id = 1;
      RequestService.post('company.put', vm.company).then(function(result) {
        $uibModalInstance.close(result);
      });
      return false;
    };
    vm.putCompany = putCompany;
    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
    getUsers = function() {
      RequestService.post('user.listing').then(function(result) {
        vm.users = result.users;
        console.log(vm.users);
      });
    };
    vm.currStaff = {
      user_id: '',
      branch_id: ''
    };
    addStaff = function() {
      var i, len, ref, x1;
      if (vm.currStaff.user_id !== null && vm.currStaff.user_id !== void 0) {
        ref = vm.company.staff;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1.user_id === vm.currStaff.user_id) {
            console.log("Этот user уже в списке");
            return;
          }
        }
        vm.company.staff.push(vm.currStaff);
        vm.currStaff = {
          user_id: '',
          branch_id: ''
        };
        return;
      } else {
        alert("В начале выберите user или филиал !");
        return;
      }
    };
    deleteStaff = function(index) {
      vm.company.staff.splice(index, 1);
    };
    addAssistance = function() {
      var i, len, ref, x1;
      if (vm.assistance !== null && vm.assistance !== void 0) {
        ref = vm.company.data.assistants;
        for (i = 0, len = ref.length; i < len; i++) {
          x1 = ref[i];
          if (x1._id === vm.assistance._id) {
            console.log("Этот ассистанс уже в списке");
            return;
          }
        }
        vm.company.data.assistants.push(vm.assistance);
        return;
      } else {
        alert("В начале выберите Ассистанс !");
        return;
      }
    };
    deleteAssistance = function(index) {
      vm.company.data.assistants.splice(index, 1);
    };
    vm.address = '';
    addAddress = function() {
      if (vm.company.data.addresses === null || vm.company.data.addresses === void 0) {
        vm.company.data.addresses = [];
      } else {
        if (vm.company.data.addresses.includes(vm.address)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.address !== null && vm.address !== void 0 && vm.address !== '') {
        vm.company.data.addresses.push(vm.address);
        vm.address = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteAddress = function(index) {
      vm.company.data.addresses.splice(index, 1);
    };
    vm.email = '';
    addEmail = function() {
      if (vm.company.data.emails === null || vm.company.data.emails === void 0) {
        vm.company.data.emails = [];
      } else {
        if (vm.company.data.emails.includes(vm.email)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.email !== null && vm.email !== void 0 && vm.email !== '') {
        vm.company.data.emails.push(vm.email);
        vm.email = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteEmail = function(index) {
      vm.company.data.emails.splice(index, 1);
    };
    vm.website = '';
    addWebsite = function() {
      if (vm.company.data.websites === null || vm.company.data.websites === void 0) {
        vm.company.data.websites = [];
      } else {
        if (vm.company.data.websites.includes(vm.website)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.website !== null && vm.website !== void 0 && vm.website !== '') {
        vm.company.data.websites.push(vm.website);
        vm.website = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deleteWebsite = function(index) {
      vm.company.data.websites.splice(index, 1);
    };
    vm.phone = '';
    addPhone = function() {
      if (vm.company.data.phones === null || vm.company.data.phones === void 0) {
        vm.company.data.phones = [];
      } else {
        if (vm.company.data.phones.includes(vm.phone)) {
          console.log("This element is already in list ! ! !");
          return;
        }
      }
      if (vm.phone !== null && vm.phone !== void 0 && vm.phone !== '') {
        vm.company.data.phones.push(vm.phone);
        vm.phone = '';
      } else {
        console.log("Нельзя добавлять пустое");
      }
    };
    deletePhone = function(index) {
      vm.company.data.phones.splice(index, 1);
    };
    getUsers();
    vm.upload = upload;
    vm.handleFileSelect = handleFileSelect;
    vm.deleteStaff = deleteStaff;
    vm.addStaff = addStaff;
    vm.addPhone = addPhone;
    vm.deletePhone = deletePhone;
    vm.addWebsite = addWebsite;
    vm.deleteWebsite = deleteWebsite;
    vm.addEmail = addEmail;
    vm.deleteEmail = deleteEmail;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.addAssistance = addAssistance;
    vm.deleteAssistance = deleteAssistance;
  });

}).call(this);



(function() {
  angular.module('fsa').service('BObjectService', function($rootScope, RequestService, $cacheFactory, $q) {
    var bObject, dictionaryCache;
    bObject = {};
    dictionaryCache = $cacheFactory('dictionaries');
    bObject.list = function(type, filter, nocache) {
      var data, defer;
      if (angular.isUndefined(filter)) {
        filter = {};
      }
      filter.type = type;
      defer = $q.defer();
      data = null;
      if (angular.isUndefined(nocache) || nocache === false) {
        data = dictionaryCache.get(type + JSON.stringify(filter));
      }
      if (data) {
        defer.resolve(data);
      } else {
        RequestService.post('dictionary/listing', filter).then(function(data) {
          dictionaryCache.put(type + JSON.stringify(filter), data);
          return defer.resolve(data);
        }, function(data) {
          return defer.reject(data);
        });
      }
      return defer.promise;
    };
    bObject.clear = function() {
      return dictionaryCache.removeAll();
    };
    return bObject;
  }).service('RequestService', function($http, $rootScope, $q) {
    return {
      post: function(methodName, data, silent, timeOutSec) {
        var result, timedOut, timedOutFunc, timeout;
        timeOutSec = timeOutSec || 60;
        timeout = $q.defer();
        result = $q.defer();
        timedOut = false;
        timedOutFunc = function() {
          timedOut = true;
          timeout.resolve();
        };
        setTimeout(timedOutFunc, 100000 * timeOutSec);
        if (silent) {
          silent;
        }
        data = data || {};
        $rootScope.httPromise = $http({
          method: 'post',
          url: $rootScope.api + methodName,
          data: data,
          cache: false,
          timeout: timeout.promise
        }).success(function(data, status, headers, config) {
          if (!silent) {
            !silent;
          }
          if (data.result === 0) {
            return result.resolve(data);
          } else {
            return result.reject(data);
          }
        }).error(function(data, status, headers, config) {
          if (timedOut) {
            if (!silent) {
              !silent;
            }
            result.reject({
              error: 'timeout',
              message: 'Request took longer than ' + timeOutSec + ' seconds.'
            });
          } else {

          }
          if (!silent) {
            !silent;
          }
          return result.reject(data);
        });
        return result.promise;
      }
    };
  }).service('browser', function($window) {
    var userAgent;
    userAgent = $window.navigator.userAgent;
    return function() {
      return userAgent;
    };
  }).service('Session', function($localStorage) {
    return {
      create: function(token, user, user_company) {
        $localStorage.token = token;
        $localStorage.user = user;
        $localStorage.user_company = user_company;
      },
      setUser: function(user) {
        $localStorage.user = user;
      },
      destroy: function() {
        delete $localStorage.token;
        delete $localStorage.user;
        delete $localStorage.user_company;
      },
      getToken: function() {
        return $localStorage.token;
      },
      getUser: function() {
        return $localStorage.user;
      },
      getCompany: function() {
        return $localStorage.user_company;
      }
    };
  }).service('AppToast', function(toastr) {
    return {
      pop: function(type, message) {
        toastr.clear();
        if (toastr.hasOwnProperty(type)) {
          toastr[type](message);
        }
      }
    };
  }).service('AppStorage', function($window) {
    return {
      set: function(key, value) {
        $window.localStorage[key] = value;
      },
      get: function(key) {
        return $window.localStorage[key] || null;
      },
      setObject: function(key, value) {
        $window.localStorage[key] = JSON.stringify(value);
      },
      getObject: function(key) {
        return JSON.parse($window.localStorage[key] || null);
      },
      remove: function(key) {
        var err;
        try {
          $window.localStorage.removeItem(key);
        } catch (error) {
          err = error;
        }
      },
      clear: function() {
        var err;
        try {
          $window.localStorage.clear();
        } catch (error) {
          err = error;
        }
      }
    };
  }).service('passData', function() {
    var getData, passData, setData;
    passData = {};
    setData = function(key, data) {
      return passData[key] = data;
    };
    getData = function(key) {
      return passData[key];
    };
    return {
      setData: setData,
      getData: getData
    };
  }).service('ReportService', function($http, RequestService) {
    var service;
    service = {};
    service.printReport = function(code, params) {
      RequestService.post('reporta.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            report.print();
          });
        }
      });
    };
    service.saveReportPdf = function(code, params) {
      RequestService.post('reporta.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            var fileName, settings, stream;
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            settings = new Stimulsoft.Report.Export.StiPdfExportSettings;
            service = new Stimulsoft.Report.Export.StiPdfExportService;
            stream = new Stimulsoft.System.IO.MemoryStream();
            service.exportTo(report, stream, settings);
            data = stream.toArray();
            fileName = String.isNullOrEmpty(report.reportAlias) ? report.reportName : report.reportAlias;
            Object.saveAs(data, fileName + '.pdf', 'application/pdf');
          });
        }
      });
    };
    service.saveReportExcel = function(code, params) {
      RequestService.post('report.listing', {
        filter: {
          code: code
        }
      }).then(function(data) {
        var report, report_template;
        if (data.report_list && data.report_list.length === 1) {
          report = new Stimulsoft.Report.StiReport();
          report_template = data.report_list[0].template;
          report.load(report_template);
          RequestService.post('reporta.get_query_result', {
            code: code,
            parameters: params
          }).then(function(response) {
            var fileName, settings, stream;
            report.dictionary.databases.clear();
            report.regData(code, code, response.data);
            report.render();
            settings = new Stimulsoft.Report.Export.StiExcelExportSettings();
            service = new Stimulsoft.Report.Export.StiExcel2007ExportService();
            stream = new Stimulsoft.System.IO.MemoryStream();
            service.exportTo(report, stream, settings);
            data = stream.toArray();
            fileName = String.isNullOrEmpty(report.reportAlias) ? report.reportName : report.reportAlias;
            Object.saveAs(data, fileName + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          });
        }
      });
    };
    return service;
  }).factory('authInterceptor', function($rootScope, $q, $location, $log, Session, EVENTS, $base64) {
    return {
      request: function(config) {
        config.headers = config.headers || {};
        if (Session.getToken()) {
          config.headers.Authorization = 'Basic ' + $base64.encode('web' + ':' + Session.getToken());
        }
        $rootScope.$broadcast(EVENTS.requestStart);
        return config;
      },
      requestError: function(rejection) {
        $rootScope.$broadcast(EVENTS.connectionError);
        return $q.reject(rejection);
      },
      responseError: function(rejection) {
        $rootScope.$broadcast(EVENTS.connectionError);
        return $q.reject(rejection);
      },
      response: function(response) {
        $rootScope.$broadcast(EVENTS.requestEnd);
        if (response.data.result === 107) {
          $rootScope.$broadcast(EVENTS.notAuthenticated);
        }
        if (response.data.result > 0) {
          $rootScope.$broadcast(EVENTS.businessError, response.data.message);
        }
        if (response.data.result < 0) {
          $rootScope.$broadcast(EVENTS.applicationError, response.data.message);
        }
        return response || $q.when(response);
      }
    };
  });

}).call(this);



(function() {
  angular.module('fsa').run(function($log, $rootScope, amMoment) {
    'ngInject';
    $log.debug('runBlock end');
    $rootScope.api = 'https://bank.agi.kg/';
    amMoment.changeLocale('ru');
  });

}).call(this);



(function() {
  angular.module('fsa').config(function($stateProvider, $urlRouterProvider) {
    'ngInject';
    var args, c, i, j, len, path, r, template, url;
    $stateProvider.state('app', {
      abstract: true,
      url: '/app',
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'app'
    }).state('login', {
      url: '/login',
      templateUrl: 'app/auth/login.html',
      controller: 'AuthController',
      controllerAs: 'auth'
    }).state('register', {
      url: '/register',
      templateUrl: 'app/auth/register.html',
      controller: 'AuthController',
      controllerAs: 'auth'
    }).state('app.policy_new', {
      url: '/policy/new',
      templateUrl: 'app/policy/new.html',
      controller: 'PolicyNewController',
      controllerAs: 'policies'
    }).state('app.policy_show', {
      url: '/policy/show',
      templateUrl: 'app/policy/show.html',
      controller: 'PolicyShowController',
      controllerAs: 'show',
      params: {
        product: null
      }
    }).state('app.policy_form', {
      url: '/policy/form',
      templateUrl: 'app/policy/form.html',
      controller: 'PolicyFormController',
      controllerAs: 'forming',
      params: {
        policy: null
      }
    }).state('app.policy_select', {
      url: '/policy/select',
      templateUrl: 'app/policy/select.html',
      controller: 'PolicySelectController',
      controllerAs: 'select',
      params: {
        product: null
      }
    }).state('app.policy_issue', {
      url: '/policy/issue',
      templateUrl: 'app/policy/issue.html',
      controller: 'PolicyIssueController',
      controllerAs: 'issue',
      params: {
        product: null,
        policy: null
      }
    }).state('app.policy_view', {
      url: '/policy/view',
      templateUrl: 'app/policy/view.html',
      controller: 'PolicyViewController',
      controllerAs: 'view',
      params: {
        product: null,
        policy: null
      }
    }).state('app.product', {
      abstract: false,
      url: '/product',
      templateUrl: 'app/product/product.html',
      controller: 'ProductController',
      controllerAs: 'product'
    }).state('app.product_new', {
      url: '/product/new',
      templateUrl: 'app/product/new.html',
      controller: 'ProductNewController',
      controllerAs: 'new_product',
      params: {
        product: null
      }
    }).state('app.product_view', {
      url: '/product/view',
      templateUrl: 'app/product/view.html',
      controller: 'ProductViewController',
      controllerAs: 'view_product',
      params: {
        product: null
      }
    }).state('app.report_viewer', {
      url: '/report_viewer',
      templateUrl: 'app/report/reporta.html',
      controller: 'ReportaController',
      controllerAs: 'reporta',
      params: {
        reportMode: 'viewer'
      }
    }).state('app.report_designer', {
      url: '/report_designer',
      templateUrl: 'app/report/reporta.html',
      controller: 'ReportaController',
      controllerAs: 'reporta',
      params: {
        reportMode: 'designer'
      }
    }).state('app.policya.main-limited', {
      url: '/policya-main-limited',
      templateUrl: 'app/policya/main-limited.html',
      controller: 'PolicyaMainController',
      controllerAs: 'main'
    });
    i = [
      {
        'n': 'app.dashboard'
      }, {
        'n': 'app.company'
      }, {
        'n': 'app.agentbranch'
      }, {
        'n': 'app.policy'
      }, {
        'n': 'app.clients',
        'a': true,
        e: true
      }, {
        'n': 'app.clients.list'
      }, {
        'n': 'app.clients.edit',
        'u': '.edit/{id}'
      }, {
        'n': 'app.clients.view',
        'u': '.view/{id}'
      }, {
        'n': 'app.clients.create'
      }, {
        'n': 'app.collateral',
        'a': true,
        e: true
      }, {
        'n': 'app.collateral.list'
      }, {
        'n': 'app.collateral.edit',
        'u': '.edit/{id}'
      }, {
        'n': 'app.collateral.create'
      }, {
        'n': 'app.agent'
      }, {
        'n': 'app.agent.accesses',
        'u': '.accesses/{id}'
      }, {
        'n': 'app.menu'
      }, {
        'n': 'app.menu.item',
        'u': '.item/{id}'
      }, {
        'n': 'app.udf',
        'u': '.udf/{is_admin:bool}'
      }, {
        'n': 'app.role'
      }, {
        'n': 'app.currency'
      }, {
        'n': 'app.category'
      }, {
        'n': 'app.industry'
      }, {
        'n': 'app.unit'
      }, {
        'n': 'app.purpose'
      }, {
        'n': 'app.rule'
      }, {
        'n': 'app.docs',
        'a': true,
        e: true
      }, {
        'n': 'app.docs.list'
      }, {
        'n': 'app.docs.entry',
        u: '.entry/{id}'
      }, {
        'n': 'app.docs.view',
        u: '.view/{id}'
      }, {
        'n': 'app.defaults'
      }, {
        'n': 'app.dictionary'
      }, {
        'n': 'app.profile',
        'a': true
      }, {
        'n': 'app.profile.view'
      }, {
        'n': 'app.profile.edit'
      }, {
        'n': 'app.approval.view',
        u: '.view/{id}'
      }, {
        'n': 'app.payment'
      }, {
        'n': 'app.operation'
      }, {
        'n': 'app.users'
      }, {
        'n': 'app.report'
      }, {
        'n': 'app.reportperiod'
      }, {
        'n': 'app.agentreport'
      }, {
        'n': 'app.report_template'
      }, {
        'n': 'app.doctemplates',
        'a': true,
        'e': true
      }, {
        'n': 'app.doctemplates.list'
      }, {
        'n': 'app.doctemplates.add'
      }, {
        'n': 'app.equipment',
        'a': true,
        e: true
      }, {
        'n': 'app.equipment.list'
      }, {
        'n': 'app.equipment.create'
      }, {
        'n': 'app.equipment.show',
        u: '.show/{id}'
      }, {
        'n': 'app.employee'
      }, {
        'n': 'app.insurancesumm'
      }, {
        'n': 'app.branch'
      }, {
        'n': 'app.agentemployee'
      }, {
        'n': 'app.news',
        'a': true,
        'e': true
      }, {
        'n': 'app.news.list'
      }, {
        'n': 'app.news.form',
        p: {
          'news': null
        }
      }, {
        'n': 'app.news.view',
        p: {
          news: null
        }
      }, {
        'n': 'app.news.uploadimage'
      }, {
        'n': 'app.apolicy',
        'a': true,
        'e': true
      }, {
        'n': 'app.apolicy.list'
      }, {
        'n': 'app.apolicy.new'
      }, {
        'n': 'app.apolicy.select'
      }, {
        'n': 'app.apolicy.form',
        p: {
          policy: null
        }
      }, {
        'n': 'app.apolicy.issue',
        p: {
          product: null
        }
      }, {
        'n': 'app.apolicy.show'
      }, {
        'n': 'app.apolicy.view',
        p: {
          product: null
        }
      }, {
        'n': 'app.hpolicy',
        'a': true,
        'e': true
      }, {
        'n': 'app.hpolicy.list'
      }, {
        'n': 'app.fpolicy',
        'a': true,
        'e': true
      }, {
        'n': 'app.fpolicy.list'
      }, {
        'n': 'app.regulations',
        'a': true,
        'e': true
      }, {
        'n': 'app.regulations.list'
      }, {
        'n': 'app.regulations.form',
        p: {
          'regulations': null
        }
      }
    ];
    for (j = 0, len = i.length; j < len; j++) {
      r = i[j];
      url = r.n.substring(r.n.lastIndexOf('.') + 1);
      path = r.n.split('.');
      template = [path[0], path[1], (path.length > 2 ? path[2] : path[1]) + '.html'].join('/');
      path[1] = path[1].toUpperCase().charAt(0) + path[1].substring(1);
      if (path.length > 2) {
        path[2] = path[2].toUpperCase().charAt(0) + path[2].substring(1);
      }
      c = path.length > 2 ? path[1] + path[2] : path[1];
      args = {
        url: '.' + url,
        controller: c + 'Controller',
        controllerAs: url,
        abstract: angular.isDefined(r.a && r.a)
      };
      if (angular.isDefined(r.u)) {
        args.url = r.u;
      }
      if (angular.isDefined(r.p)) {
        args.params = r.p;
      }
      if (angular.isDefined(r.t)) {
        args.template = r.t;
      } else if (r.e) {
        args.template = '<ui-view></ui-view>';
      } else {
        args.templateUrl = template;
      }
      console.log('Generated ' + r.n + ' as ' + angular.toJson(args));
      $stateProvider.state(r.n, args);
    }
    return $urlRouterProvider.otherwise('/login');
  });

}).call(this);



(function() {
  angular.module('fsa').constant('malarkey', malarkey).constant('moment', moment).constant('EVENTS', {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
    connectionError: 'http-connection-error',
    businessError: 'business-error',
    applicationError: 'application-error',
    requestStart: 'http-request-start',
    requestEnd: 'http-request-end',
    successMessage: 'business-success',
    errorMessage: 'business-error'
  }).constant('email_mask', /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i).constant('user_company_accesses', [
    {
      key: 'company',
      value: 'Компания'
    }, {
      key: 'branch',
      value: 'Филиал'
    }
  ]).constant('branch_types', [
    {
      key: 'store',
      value: 'Магазин'
    }, {
      key: 'cost_center',
      value: 'Центр затрат'
    }, {
      key: 'fsa',
      value: 'Склад'
    }
  ]).constant('product_types', [
    {
      key: 'raw',
      value: 'Сырье'
    }, {
      key: 'goods',
      value: 'Товар'
    }, {
      key: 'inventory',
      value: 'Инвентарий'
    }, {
      key: 'work',
      value: 'Работа'
    }, {
      key: 'service',
      value: 'Услуга'
    }
  ]).constant('contractor_types', [
    {
      key: 'supplier',
      value: 'Поставщик'
    }, {
      key: 'buyer',
      value: 'Покупатель'
    }, {
      key: 'employee',
      value: 'Сотрудник'
    }
  ]).constant('operation_types', [
    {
      key: 'purchase',
      value: 'Покупка'
    }, {
      key: 'sales',
      value: 'Продажа'
    }, {
      key: 'movement',
      value: 'Перевод'
    }, {
      key: 'consumption',
      value: 'Потребление'
    }, {
      key: 'return',
      value: 'Возврат'
    }
  ]).constant('operation_statuses', [
    {
      key: 'new',
      value: 'Новый'
    }, {
      key: 'active',
      value: 'Активый'
    }, {
      key: 'closed',
      value: 'Закрыт'
    }, {
      key: 'canceled',
      value: 'Отменен'
    }
  ]).constant('booking_statuses', [
    {
      key: 'new',
      value: 'Новый'
    }, {
      key: 'active',
      value: 'Активый'
    }, {
      key: 'closed',
      value: 'Закрыт'
    }, {
      key: 'canceled',
      value: 'Отменен'
    }
  ]).constant('booking_types', [
    {
      key: 'order',
      value: 'Заказ на покупку'
    }, {
      key: 'quote',
      value: 'Заказ на продажу'
    }
  ]).constant('document_statuses', [
    {
      key: 'draft',
      value: 'Черновик'
    }, {
      key: 'approval',
      value: 'На одобрении'
    }, {
      key: 'approved',
      value: 'Одобрен'
    }, {
      key: 'committed',
      value: 'Принят'
    }
  ]).constant('approve_types', [
    {
      key: 'all',
      value: 'Все'
    }, {
      key: 'one',
      value: 'Один'
    }
  ]).constant('udf_purposes', [
    {
      key: 'company',
      value: 'Компания'
    }, {
      key: 'operation',
      value: 'Операция'
    }, {
      key: 'contractor',
      value: 'Контрагент'
    }, {
      key: 'user',
      value: 'Пользователь'
    }, {
      key: 'branch',
      value: 'Филиал'
    }, {
      key: 'approval',
      value: 'Одобрение'
    }, {
      key: 'booking',
      value: 'Заказ'
    }
  ]).constant('udf_fields', [
    {
      key: 'text',
      value: 'Текст'
    }, {
      key: 'textarea',
      value: 'Текстовое поле'
    }, {
      key: 'number',
      value: 'Число'
    }, {
      key: 'date',
      value: 'Дата'
    }, {
      key: 'time',
      value: 'Время'
    }, {
      key: 'checkbox',
      value: 'Флажок'
    }, {
      key: 'radio',
      value: 'Радио кнопка'
    }, {
      key: 'select',
      value: 'Раскрывающийся список'
    }, {
      key: 'multiSelect',
      value: 'Список со мн. выбором'
    }
  ]);

}).call(this);



(function() {
  angular.module('fsa').config(function($logProvider, toastrConfig, hotkeysProvider, $httpProvider) {
    'ngInject';
    $logProvider.debugEnabled(true);
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    hotkeysProvider.cheatSheetHotkey = ["h", "р"];
    hotkeysProvider.cheatSheetDescription = "Информация о быстрых кнопках открыть/закрыть";
    return $httpProvider.interceptors.push('authInterceptor');
  });

}).call(this);



(function () {
    'use strict';

    angular.module('fsa')
        .directive('sideNav', function () {
            return {
                restrict: 'AC',
                link: function (scope, el) {
                    var $BODY = $('body'),
                        $MENU_TOGGLE = $('#menu_toggle'),
                        $SIDEBAR_MENU = $('#sidebar-menu'),
                        $SIDEBAR_FOOTER = $('.sidebar-footer'),
                        $LEFT_COL = $('.left_col'),
                        $RIGHT_COL = $('.right_col'),
                        $NAV_MENU = $('.nav_menu'),
                        $FOOTER = $('footer');

                    var setContentHeight = function () {
                        // reset height
                        $RIGHT_COL.css('min-height', $(window).height());

                        var bodyHeight = $BODY.outerHeight(),
                            footerHeight = $BODY.hasClass('footer_fixed') ? 0 : $FOOTER.height(),
                            leftColHeight = $LEFT_COL.eq(1).height() + $SIDEBAR_FOOTER.height(),
                            contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

                        // normalize content
                        contentHeight -= $NAV_MENU.height() + footerHeight;

                        $RIGHT_COL.css('min-height', contentHeight);
                    };

                    var setCurrentPage = function (url) {
                        var CURRENT_URL = url || window.location.href.split('?')[0];

                        $SIDEBAR_MENU.find('li.current-page').removeClass('current-page');

                        $SIDEBAR_MENU.find('a').filter(function () {
                            return this.href == CURRENT_URL;
                        }).parent('li').addClass('current-page').parents('ul').slideDown(function () {
                            setContentHeight();
                        }).parent().addClass('active');
                    };

                    function initSideMenu (class_name) {
                        $SIDEBAR_MENU.find('a' + class_name).on('click', function (ev) {
                            if (ev.target.href) {
                                setCurrentPage(ev.target.href);
                            } else {
                                var $li = $(this).parent();

                                if ($li.is('.active')) {
                                    $li.removeClass('active active-sm');
                                    $('ul:first', $li).slideUp(function () {
                                        setContentHeight();
                                    });
                                } else {
                                    // prevent closing menu if we are on child menu
                                    if (!$li.parent().is('.child_menu')) {
                                        $SIDEBAR_MENU.find('li').removeClass('active active-sm');
                                        $SIDEBAR_MENU.find('li ul').slideUp();
                                    }

                                    $li.addClass('active');

                                    $('ul:first', $li).slideDown(function () {
                                        setContentHeight();
                                    });
                                }
                            }
                        });
                    }

                    initSideMenu();

                    scope.$watch('app.navigation', function () {
                        initSideMenu('.dynamic_menu');
                    });

                    scope.$watch('app.admin_menu', function () {
                        initSideMenu('.admin_menu');
                    });

                    // toggle small or large menu
                    $MENU_TOGGLE.on('click', function () {
                        if ($BODY.hasClass('nav-md')) {
                            $SIDEBAR_MENU.find('li.active ul').hide();
                            $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
                        } else {
                            $SIDEBAR_MENU.find('li.active-sm ul').show();
                            $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
                        }

                        $BODY.toggleClass('nav-md nav-sm');

                        setContentHeight();
                    });

                    setCurrentPage();

                    // recompute content when resizing
                    $(window).smartresize(function () {
                        setContentHeight();
                    });

                    setContentHeight();

                    // fixed sidebar
                    if ($.fn.mCustomScrollbar) {
                        $('.menu_fixed').mCustomScrollbar({
                            autoHideScrollbar: true,
                            theme: 'minimal',
                            mouseWheel: {preventDefault: true}
                        });
                    }
                }
            };
        });
})();

/**
 * Created by jaynakus on 2/11/16.
 */
angular.module('fsa')
    .directive('autofocus', function () {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                $element[0].focus();
            }
        }
    });

angular.module("fsa").run(["$templateCache", function($templateCache) {$templateCache.put("app/agent/agent.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Агенты</div><div class=panel-body><button ng-click=agent.newAgent() class=\"btn btn-primary btn-sm\">Добавить агента</button> <button ng-click=agent.editAgent() ng-disabled=\"agent.selected_company==null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Редактировать</span></button><paged-table options=agent.companiesGridOptions disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/agent/create.html","<!--\nCreated by Aibek on 26/08/16.\n\n--><form ng-submit=company.putCompany() class=from-horizontal><div class=modal-header></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основная информация</a></li><li><a data-toggle=tab data-target=#contact>Контакты</a></li><li><a data-toggle=tab data-target=#user>Пользователи</a></li><li><a data-toggle=tab data-target=#logo>Логотип</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><col-responsive><div class=form-group><label>Официальное имя</label><input type=text ng-model=company.company.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Краткое имя</label><input type=text ng-model=company.company.short_name ng-required=false ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код компании</label><input type=text ng-model=company.company.code ng-required=false ng-trim=true maxlength=2 class=form-control></div></col-responsive><col-responsive stock-dict=company.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=company.company.data.status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата регистрации</label><div class=\"input-group no-margin\"><input type=text ng-required=true uib-datepicker-popup=dd-MM-yyyy ng-model=company.company.data.reg_date ng-click=\"company.registrationDP.popup_to_date.opened=true\" is-open=company.registrationDP.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"company.registrationDP.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Номер регистрации</label><input type=text ng-model=company.company.data.register_number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=company.company.data.inn ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код ОКПО</label><input type=text ng-model=company.company.data.code_okpo ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=company.company_types dict-table=Enums dict-filter={name:&quot;company_type&quot;}><div class=form-group><label>Тип</label><ui-select ng-model=company.company.company_type ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.company_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><div stock-dict=agent.companies dict-table=Companies dict-filter={company_type:&quot;branch_company&quot;} class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Филиал</label><ui-select ng-model=company.company.company_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in agent.companies\">{{type.name}}</ui-select-choices></ui-select></div></div><col-responsive><div class=form-group><label>Менеджер</label><input type=text ng-model=company.company.data.manager ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Капитал</label><input type=text ng-model=company.company.data.capital ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Правила страхования</label><div class=input-group><input type=text ng-model=company.company.data.insurance_rules ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Образец полиса</label><div class=input-group><input type=text ng-model=company.company.data.policy_sample ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание</label><textarea ng-model=company.company.data.description rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Рекомендация</label><textarea ng-model=company.company.data.recommendation rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Франшиза</label><textarea ng-model=company.company.data.franchise rows=4 class=form-control></textarea></div></col-responsive></div></div><div id=contact class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Телефон</label><div class=input-group><input type=number ng-model=company.phone ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addPhone() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.phones\" class=list-group-item><label>{{x}}</label><a ng-click=company.deletePhone($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Адрес</label><div class=input-group><input type=text ng-model=company.address ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addAddress() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.addresses\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteAddress($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>E-mail</label><div class=input-group><input type=email ng-model=company.email ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addEmail() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.emails\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteEmail($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Вебсайт</label><div class=input-group><input type=text ng-model=company.website ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addWebsite() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.websites\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteWebsite($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div></div><div id=user class=\"tab-pane fade\"><div class=row><div class=row><!--.col.col-xs-12.col-sm-6.col-md-6(stock-dict=\'company.users\' dict-table=\'User\')--><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Ползователи</label><ui-select ng-model=company.currStaff.user_id ng-required=true class=form-control><ui-select-match>{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"type.id as type in company.users\">{{type.username}}</ui-select-choices></ui-select></div></div><div stock-dict=company.branches dict-table=Companies dict-filter={company_id:company.company._id} class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=company.currStaff.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in company.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col col-xs-12\"><button type=button ng-click=company.addStaff() class=\"btn btn-primary btn-sm pull-right\">Добавить</button></div></div><div class=row><div class=\"col col-xs-12\"><h2>Список пользователей</h2><table class=\"table table-bordered\"><thead><tr><th>Пользователь</th><th>Филиал</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in company.company.staff\"><td><span ng-repeat=\"user in company.users\" ng-if=\"user.id == item.user_id\">{{user.username}}</span></td><td><span ng-repeat=\"branch in company.branches | filter:{_id:item.branch_id}\">{{branch.name}}</span></td><td><a ng-click=company.deleteStaff($index) class=\"btn btn-danger glyphicon glyphicon-remove-sign\"></a></td></tr></tbody></table></div></div></div></div><div id=logo class=\"tab-pane fade\"><div class=row><div flow-init={singleFile:true} class=\"col col-xs-12 col-md-8 col-lg-8\"><span flow-btn flow-file-added=\"company.handleFileSelect($event, $flow, $file)\" class=\"btn btn-default margin-right-8\">Выбрать файл...</span><span>{{$flow.files[0].name}}</span></div></div><div class=row><div class=\"col col-xs-12 col-md-8 col-lg-8\"><div class=cropArea><img-crop image=company.image result-image=company.result_image area-type=square result-image-size=100></img-crop></div><div>Итоговое изибражение:<div><img ng-src={{company.result_image}}></div><a data-target=# ng-click=company.upload() class=\"btn btn-primary\">Заменить существующий</a></div></div><div class=\"col col-xs-12 col-md-4 col-lg-4\"><div class=\"clearfix pull-left\"><h3>Логотип компании</h3><img ng-src={{app.api}}{{company.company.data.image}} class=profile-image-lg></div></div></div></div></div></div><div class=modal-body><!--button.btn.btn-primary.btn-sm.pull-right(type=\'submit\', ng-if=\'company.company.user_id==company.ua.id\') Сохранить--> <button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=company.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentbranch/agentbranch.html","<!--\nCreated by Aibek on 15/06/16.\n\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Филиалы</div><div class=panel-body><button type=button ng-click=agentbranch.newCompany() class=\"btn btn-primary btn-xs\">Создать</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!branch.selected_branch\' ng-click=\'branch.editBranch()\')--> <button ng-click=agentbranch.editCompany() ng-disabled=!agentbranch.selected_company class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=agentbranch.confirmAction() ng-disabled=!agentbranch.selected_company class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=agentbranch.getCompanies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=agentbranch.companiesGridOptions disable-search=true disable-paging=true></paged-table></div></div></div>");
$templateCache.put("app/agentbranch/edit.html","<form ng-submit=agentbranch.putCompany() class=from-horizontal><div class=modal-header></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основная информация</a></li><!--li--><!--  a(data-toggle=\'tab\', data-target=\'#contact\') Контакты--><li><a data-toggle=tab data-target=#user>Пользователи</a></li><!--li--><!--  a(data-toggle=\'tab\', data-target=\'#menu5\') Логотип--></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><col-responsive><div class=form-group><label>Официальное имя</label><input type=text ng-model=agentbranch.company.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Краткое имя</label><input type=text ng-model=agentbranch.company.short_name ng-required=false ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код компании</label><input type=text ng-model=agentbranch.company.code ng-required=false ng-trim=true maxlength=2 class=form-control></div></col-responsive><col-responsive stock-dict=agentbranch.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=agentbranch.company.data.status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in agentbranch.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата регистрации</label><div class=\"input-group no-margin\"><input type=text ng-required=true uib-datepicker-popup=dd-MM-yyyy ng-model=agentbranch.company.data.reg_date ng-click=\"company.registrationDP.popup_to_date.opened=true\" is-open=company.registrationDP.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"agentbranch.registrationDP.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Номер регистрации</label><input type=text ng-model=agentbranch.company.data.register_number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=agentbranch.company.data.inn ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код ОКПО</label><input type=text ng-model=agentbranch.company.data.code_okpo ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Менеджер</label><input type=text ng-model=agentbranch.company.data.manager ng-required=true ng-trim=true class=form-control></div></col-responsive><!--col-responsive(stock-dict=\'company.insurer_types\' dict-table=\'Enums\' dict-filter=\'{name:\"insurer_type\"}\')--><!--  .form-group--><!--    label Тип--><!--    ui-select.form-control(ng-model=\'agentbranch.company.data.insurer_type\' ng-required=\'true\')--><!--      ui-select-match {{$select.selected.data.name}}--><!--      ui-select-choices(repeat=\'type.data.key as type in company.insurer_types track by type.data.key\') {{type.data.name}}--><col-responsive><div class=form-group><label>Капитал</label><input type=text ng-model=agentbranch.company.data.capital ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Правила страхования</label><div class=input-group><input type=text ng-model=agentbranch.company.data.insurance_rules ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Образец полиса</label><div class=input-group><input type=text ng-model=agentbranch.company.data.policy_sample ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание</label><textarea ng-model=agentbranch.company.data.description rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Рекомендация</label><textarea ng-model=agentbranch.company.data.recommendation rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Франшиза</label><textarea ng-model=agentbranch.company.data.franchise rows=4 class=form-control></textarea></div></col-responsive></div></div><div id=user class=\"tab-pane fade\"><div class=row><col-responsive><div class=form-group><label>Ползователи</label><ui-select ng-model=agentbranch.currStaff.user_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"type.id as type in agentbranch.users |filter:{username:$select.search}\">{{type.username}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><button type=button ng-click=agentbranch.addStaff() class=\"btn btn-primary btn-sm pull-right\">Добавить</button></col-responsive><div class=row><div class=\"col col-xs-12\"><h2>Список пользователей</h2><table class=\"table table-bordered\"><thead><tr><th>Пользователь</th><th>Филиал</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in agentbranch.company.staff\"><td><span ng-repeat=\"user in agentbranch.users\" ng-if=\"user.id == item.user_id\">{{user.username}}</span></td><td><span ng-repeat=\"branch in agentbranch.branches | filter:{_id:item.branch_id}\">{{branch.name}}</span></td><td><a ng-click=agentbranch.deleteStaff($index) class=\"btn btn-danger glyphicon glyphicon-remove-sign\"></a></td></tr></tbody></table></div></div></div></div></div></div><div class=modal-body><div class=row><div class=\"col-lg-12 col-md-12 col-xs-12\"><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=agentbranch.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></div></div></form>");
$templateCache.put("app/agentemployee/agentemployee.html","<div class=container><panel title=Сотрудники><button type=button ng-click=agentemployee.newUser() class=\"btn btn-primary btn-xs\">Создать</button> <button ng-click=agentemployee.editUser() ng-disabled=!agentemployee.selected_user class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=agentemployee.removeUser() ng-disabled=!agentemployee.selected_user class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=agentemployee.getUsers() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=agentemployee.agentemployeeGridOptions disable-search=true disable-paging=true></paged-table></panel></div>");
$templateCache.put("app/agentemployee/create.html","<form ng-submit=user.createUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=user.user.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentemployee/edit.html","<form ng-submit=user.updateUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Информация для авторизации</a></li><li><a data-toggle=tab data-target=#menu1>Информация о пользователе</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Филиалы</label><ui-select ng-model=user.user.branch_id ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.branches\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=menu1 class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/agentreport/agentreport.html","<!--\nCreated by ilias on 17.05.2018.\n\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Отчет</div><div class=panel-body><form><div class=row><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=agentreport.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=agentreport.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=agentreport.date_start ng-model=agentreport.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><button type=button ng-click=agentreport.getPolicies() class=\"btn btn-primary btn-sm\"><i aria-hidden=true class=\"fa fa-search\"></i> Применить фильтр</button> <button type=button ng-click=agentreport.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button type=button ng-click=agentreport.downloadPDFRPA() class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет</button> <button type=button ng-click=agentreport.downloadExcelRPA() ng-if=false class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Excel</button> <button type=button ng-click=agentreport.downloadPDFRPAP() ng-if=false ng-disabled=\"agentreport.company.company_type!=\'agent\' &amp;&amp; agentreport.company._id == agentreport.filter.agent_id\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения</button> <button type=button ng-if=false ng-click=agentreport.downloadExcelRPAP() ng-disabled=\"agentreport.company.company_type!=\'agent\' &amp;&amp; agentreport.company._id == agentreport.filter.agent_id\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения Excel</button></form><paged-table options=agentreport.policiesGridOptions disable-search=true height=700></paged-table></div></div></div>");
$templateCache.put("app/apolicy/form.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Возобновление</div><div class=panel-body><div class=row><div class=col-md-12><button type=button ui-sref=app.apolicy.list class=\"btn btn-warning\">Выход</button> <button type=button ng-click=form.confirmActionSave() ng-disabled=\"!form.policy.insurance_premium || form.policy.insurance_premium &lt;= 0\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Возобновить</button></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{form.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{form.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{form.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=form.today max-date=form.policy.date_end ng-change=form.recalculateOnEventAll() ng-click=\"form.search.popup_to_date.opened1=true\" ng-model=form.policy.date_start is-open=form.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"form.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=form.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=form.policy.date_start max-date=form.finish_date ng-change=form.recalculateOnEventAll() ng-click=\"form.search.popup_from_date.opened=true\" ng-model=form.policy.date_end is-open=form.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=form.isAnnual ng-click=\"form.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{form.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{form.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{form.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=form.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in form.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=form.editWork(work) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=form.confirmActionWork(work) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></tbody></table></div></div></div><div ng-show=form.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in form.policy.insurance_data.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=form.editWork(work) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=form.confirmActionWork(work) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></tbody></table></div></div></div><div ng-show=form.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in form.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=form.editWork(work) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=form.confirmActionWork(work) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></tbody></table></div></div></div><div ng-show=form.policy.insurance_data.ned class=row><div class=wrapper><table class=\"table table-user-information\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in form.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=form.editNed(c) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=form.confirmActionNed(c) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></tbody></table><button ng-click=form.editNed({}) class=\"btn btn-default\">Добавить</button></div><div class=wrapper><div ng-show=\"form.insuranceformned != null\" class=row><col-responsive><div class=form-group><label>Собственник</label><input type=text ng-model=form.insuranceformned.owner required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Объект страхования</label><ui-select ng-model=form.insuranceformned.objectned class=form-control><ui-select-match>{{form.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in form.insuranceobjectsned track by object._id\">{{object.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=form.insuranceformned.adres required class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=form.insuranceformned.insurance_summ required min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=form.insuranceformned.insurance_premium required disabled class=form-control></div></col-responsive><div class=row><col-responsive><div class=form-group><button type=button ng-click=form.calculatePremiumNed() class=\"btn btn-default\">Раcсчитать</button> <button ng-click=form.addCollateralNed(form.insuranceformned) class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button> <button ng-click=form.cancelWork() class=\"btn btn-default m-b-lg\">Отмена</button></div></col-responsive></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/apolicy/issue.html","<!--\nCreated by ilias on 07.10.2016.\n\n--><div class=container><form ng-submit=issue.confirmAction() class=from-horizontal><div class=row><div class=col-md-10><button type=button ui-sref=app.apolicy.select class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Изменить полис</button><div class=\"panel panel-default\"><div class=panel-heading><h2 style=display:inline>Ваш страховой полис</h2></div><!--.panel-body(stock-dict=\'issue.currencies\' dict-table=\'Currencies\')--><div class=panel-body><table class=\"table table-striped\"><thead></thead><tbody><tr><td>Страховщик</td><td>{{issue.product.company[0].name}}</td></tr><tr ng-if=\"issue.company.company_type == \'agent\'\"><td>Агент страховой компании</td><td>{{issue.company.name}} Телефон {{issue.company.data.phones[0]}}</td></tr><tr><td>Период действия страхового полиса</td><td>с {{issue.product.tmp_product.date_start | date:\'dd-MM-yyyy\'}} по {{issue.product.tmp_product.date_end | date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Продукт</td><td>{{issue.product.name}}</td></tr><tr><td>Страна поездки</td><td><span ng-repeat=\"x in issue.countriesView\">{{x.name}} <mark>({{x.data.name_eng}})</mark></span></td></tr><tr><td>Страховая сумма</td><td><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><label ng-if=\"issue.min_insurance!=null\">{{issue.product.insurance_amount}}<span> {{issue.currency_name}}</span></label><label ng-if=\"issue.min_insurance==null\">0</label><a data-toggle=collapse data-target=#collapse1 ng-click=issue.pdrobneeIconCnange() style=cursor:pointer class=pull-right><i ng-class=issue.pdrobneeIcon aria-hidden=true></i> Сервисы</a></h4></div><div id=collapse1 class=\"panel-collapse collapse\"><div class=panel-body><ul><li ng-repeat=\"x in issue.product.services\"><span>{{x.name}}</span></li></ul></div></div></div></td></tr><tr ng-repeat=\"x in issue.insurants\"><td>Стоимость страхового полиса ({{$index+1}}-го)</td><td><h4 ng-if=\"x.theprice!=null\">{{x.theprice}} {{issue.currency_name}} / {{(x.theprice * issue.currencyRate).toFixed(2)}} KGS</h4><span class=small>(курс валют: 1 {{issue.currency_name}}: {{issue.currencyRate}} KGS)</span><h4 ng-if=\"x.theprice==null\">0</h4></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-md-10><div class=\"panel panel-default\"><div class=panel-heading><h2>Путешественники (застрахованные)</h2></div><div class=panel-body><div ng-repeat=\"x in issue.insurants\" class=row><div class=col-md-5><div class=row><div class=col-md-6><div class=form-group><label>Фамилия<br><em>Латиницей</em></label><input type=text ng-model=x.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-6><div class=form-group><label>Имя<br><em>Латиницей</em></label><input type=text ng-model=x.name ng-required=true ng-trim=true class=form-control></div></div></div></div><div class=col-md-2><div class=form-group><label><br>Паспорт №</label><input type=text ng-model=x.passport_no ng-trim=true class=form-control></div></div><div class=col-md-5><div class=form-group><label><br>Дата рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=issue.reCompute(x) uib-datepicker-popup=dd.MM.yyyy ng-model=x.date_of_birth is-open=x.isOpen close-text=Закрыть current-text=Сегодня clear-text=Очистить ng-required=true class=form-control><span class=input-group-btn><button type=button ng-click=\"x.isOpen = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span><span class=input-group-btn> <button style=\"margin-left: 20px\" ng-click=issue.deleteInsurant($index) type=button class=\"btn btn-danger\"><i aria-hidden=true class=\"fa fa-times\"></i></button></span><span class=input-group-btn> <button style=\"margin-left: 20px\" ng-click=issue.changeIcon($index) popover-trigger=click popover-placement=bottom uib-popover-template=&quot;myPopoverTemplate.html&quot; popover-title=\"Условия страховки\" type=button class=\"btn btn-info\"><i style=\"font-size: 130%\" aria-hidden=true class={{issue.iconsList[$index]}}></i> Условия</button></span></div></div></div></div><div class=row><div class=col-md-2><button type=button ng-click=issue.addInsurant() class=\"btn btn-default\"><i aria-hidden=true class=\"fa fa-plus\"></i> Добавить путешественника</button></div></div></div></div></div></div><div class=row><div class=col-md-10><div class=\"panel panel-default\"><div class=panel-heading><h2>Покупатель (страхователь)</h2></div><div class=panel-body><div class=row><div class=col-md-2><div class=form-group><label>Фамилия<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-2><div class=form-group><label>Имя<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.name ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-3><div class=form-group><label><br>Телефон</label><input type=text ui-mask=0(999)999-999 ng-model=issue.buyer.phone ng-trim=true class=form-control></div></div></div></div></div><div class=row><button type=submit class=\"btn btn-primary btn-sm pull-right\">Оформить полис</button></div></div></div></form></div><script type=text/ng-template id=myPopoverTemplate.html><div style=\"width: 350px;\">\n    <ul class=\"list-group\">\n      <li ng-repeat=\"factor in x.factorListing\" ng-if=\"factor.name != \'Возраст\'\" class=\"list-group-item\"><a ng-if=\"factor.description != null &amp;&amp; service.data.description != \'\'\"><i uib-tooltip=\"{{factor.description}}\" class=\"fa fa-info-circle\"></i></a><a id=\"headingOne{{$index}}\" role=\"tab\" data-toggle=\"collapse\" data-parent=\"#accordion1\" data-target=\"#collapseOnefer{{$index}}\" aria-expanded=\"false\" aria-controls=\"collapseOne\" style=\"cursor:pointer;\" class=\"panel-heading collapsed\"><i aria-hidden=\"true\" style=\"color: #2f3233; font-size: 130%;\" class=\"fa fa-chevron-down\"></i> {{factor.name}}\n          <mark><span style=\"text-decoration-color: red; text-decoration-line: underline; text-decoration-style: dotted;\">: {{x.factors[factor.name]}}</span></mark></a>\n        <div id=\"collapseOnefer{{$index}}\" role=\"tabpanel\" aria-labelledby=\"headingOne\" aria-expanded=\"false\" style=\"height: 0px;\" class=\"panel-collapse collapse\">\n          <div class=\"panel-body\">\n            <div class=\"container\">\n              <div class=\"form-group\">\n                <ui-select ng-model=\"x.factors[factor.name]\" on-select=\"issue.reCompute(x)\" ng-required=\"true\" class=\"form-control\">\n                  <ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match>\n                  <ui-select-choices repeat=\"type in factor.values | orderBy\">{{type}}</ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n          </div>\n        </div>\n      </li>\n    </ul>\n  </div></script>");
$templateCache.put("app/apolicy/list.html","<!--\nCreated by Aibek on 15/06/16.\n\n--><!--ui-sref=\'app.policy_new\',--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Полисы</div><div class=panel-body><form ng-submit=list.getPolicies()><div class=row><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive ng-if=\"list.company.company_type !=\'agent\'\"><div class=form-group><label>Сотрудники:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agent._id as agent in list.agents \">{{agent.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.name placeholder=\" Введите имя\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=\"wrapper ln_solid\"></div><button type=button ng-click=list.goToNew() class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!list.selected_policy\' ng-click=\'list.editBranch()\')--> <button ng-click=list.goToShow() ng-disabled=!list.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button><!--button.btn.btn-default.btn-sm(ng-click=\'list.delete()\' ng-disabled=\"!list.selected_policy\")--> <button ng-click=list.confirmAction() ng-disabled=\"!list.selected_policy || list.selected_list.data.status != \'Сохранен\'\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=\"wrapper ln_solid\"></div><paged-table options=list.policiesGridOptions disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/apolicy/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"panel panel-default\"><div class=panel-heading><h2>Туристическая страховка</h2></div><div class=panel-body></div><div class=row><div stock-dict=policies.countries dict-table=Countries class=col-md-10><div class=form-group><label>Территория</label><ui-select ng-model=policies.pruduct.country_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in policies.countries| filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-5><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.today max-date=policies.pruduct.date_end ng-model=policies.pruduct.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-5><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.pruduct.date_start ng-model=policies.pruduct.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Количество дней</label><input type=text ng-model=policies.diffDays readonly class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label style=\"visibility: hidden\">asdfsdf</label><div class=input-group><button ng-click=policies.goToSelect(policies.pruduct) type=button class=\"btn btn-primary\">Найти страховку</button></div></div></div></div></div>");
$templateCache.put("app/apolicy/select.html","<!--Created by Ilyas on 1.03.2018.\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Создание полиса</div><div class=panel-body><div class=row><col-responsive><div class=form-group><label>Страхователь</label><input type=text ng-model=select.policy.client required class=form-control></div></col-responsive></div><div class=row><col-responsive stock-dict=select.products dict-table=Product><div class=form-group><label>Наименование программы кредитования</label><ui-select ng-model=select.policy.product_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in select.products track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер кредитного договора</label><input type=text ng-model=select.policy.credit_no class=form-control></div></col-responsive><col-responsive stock-dict=select.currencies dict-table=Currencies><div class=form-group><label>Валюта</label><ui-select ng-model=select.currency class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"currency as currency in select.currencies\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Тип периода страхования</label><select ng-model=select.insurance_period_type ng-change=select.onPeriodTypeChange() class=form-control><option value=up_to_year>До года</option><option value=year>Год</option><option value=over_year>Свыше года</option></select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today max-date=select.policy.date_end ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.policy.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=select.period_disabled uib-datepicker-popup=dd.MM.yyyy min-date=select.policy.date_start ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.policy.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=select.period_disabled ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div ng-show=\"select.insurance_period_type == &quot;over_year&quot;\" class=row><col-responsive><div class=form-group><label>Количество лет (можно дробное, например 1.5)</label><input type=number ng-model=select.full_years min=1 step=0.1 ng-change=select.onFullYearsChange() class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label ng-show=\"select.insurance_period_type == &quot;up_to_year&quot;\">Количество дней: {{select.diffDays}}</label><label ng-show=\"select.insurance_period_type == &quot;year&quot;\">Период: 1 год (365 дней)</label><label ng-show=\"select.insurance_period_type == &quot;over_year&quot;\">Период: {{select.full_years}} {{select.getYearLabel()}} ({{select.getTotalDays()}} дней)</label></div></col-responsive></div><div class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-info\"><div class=panel-heading><strong><big>СТРАХОВАНИЕ ТРАНСПОРТНЫХ СРЕДСТВ</big></strong></div><div class=panel-body><form ng-submit=select.addCollateralTs(select.insuranceformts)><div class=row><col-responsive><div class=form-group><label>Объект страхования (Тип ТС)</label><ui-select ng-model=select.insuranceformts.objectts ng-required=true ng-change=select.onVehicleTypeChange() class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsts track by object._id\">{{object.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Марка, модель ТС</label><input type=text ng-model=select.insuranceformts.model ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Гос. регистрационный №</label><input type=text ng-model=select.insuranceformts.gosnumber ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Номер кузова/ шасси</label><input type=text ng-model=select.insuranceformts.number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=select.car_year_issue dict-table=Enums dict-filter={name:&quot;year_issue&quot;}><div class=form-group><label>Год выпуска</label><ui-select ng-model=select.insuranceformts.year_issue ng-required=true ng-trim=true ng-change=select.validateVehicleAge() class=form-control><ui-select-match>{{$select.selected.data.key}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in select.car_year_issue\">{{type.data.key}}</ui-select-choices></ui-select><small ng-show=select.vehicleAgeError class=text-danger>Принимаются ТС не старше 15 лет (не младше {{select.minYear}} года выпуска)</small></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformts.adres ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformts.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Действительная стоимость</label><input type=number ng-model=select.insuranceformts.coll_price ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformts.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><div class=\"col col-xs-12 col-sm-8 col-md-8\"><div class=form-group><label>Уполномоченные водители</label><input type=text ng-model=select.insuranceformts.driver disabled class=form-control></div></div></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumTs() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsts.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.coll_price | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralTs(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Общая страховая сумма: {{select.policy.insurance_amountts | number:2}}</label><br><label>Общая страховая премия: {{select.policy.insurance_premiumts | number:2}}</label></div></col-responsive></div><br></div></div></div></div><div class=row><div class=form-group><button ng-disabled=select.saving type=button ui-sref=app.policy class=\"btn btn-default m-t\">Отмена</button> <button ng-disabled=\"select.collateralsts.ts.length == 0\" type=button ng-click=select.savePolicy() class=\"btn btn-success m-t\">Сохранить</button></div></div></div></div></div>");
$templateCache.put("app/apolicy/show.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"wrapper lter b-b\"><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span> <input id=foo value={{show.policy.policy_no}} ng-disabled=true> <button ngclipboard=\"\" data-clipboard-target=#foo class=btn><i alt=\"Copy to clipboard\" class=\"fa fa-copy\"></i></button></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-8><h5>Наименование программы кредитования:<span class=text-info>{{show.policy.product}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-default.pull-right(type=\'button\'  ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\")--><!--  i.fa.fa-refresh(aria-hidden=\'true\')--><!--  |   Возобновить--> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/apolicy/view.html","<div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{view.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{view.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{view.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{view.policy.insurance_amount}} {{view.currency_name}}</span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{view.policy.insurance_premium}} {{view.currency_name}} / {{view.policy.data.insurance_premium_kgs}} KGS</span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in view.policy.insurance_data.country_id\"><span ng-repeat=\"country in view.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{view.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{view.product.name}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{view.policy.client.surname}} {{view.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{view.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{view.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=view.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in view.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in view.product.services_id\" class=list-group-item><span ng-repeat=\"service in view.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ui-sref=app.apolicy.list class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=view.downloadPDF() ng-if=\"view.policy.policy_no != \'00000\'\" ng-disabled=\"view.policy.policy_no == \'00000\' || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=view.confirmAction() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=view.confirmActionTerm() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=view.goToForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=view.confirmActionForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/auth/login.html","<div class=container><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6 col-md-offset-4 login_class\"><div id=iosBlurBg><div id=whiteBg></div></div><div id=bottomEnter></div><div id=bottomBlurBg></div><!-- Login Form--><div class=loginForm><div class=title><p>INSURANCE<br><span>SYSTEM</span></p><hr><hr class=short></div><form layout=column ng-submit=auth.login() class=\"login-right flex\"><div class=form-group><input placeholder=Пользователь ng-required=true ng-model=auth.username class=form-control></div><div class=form-group><input type=password placeholder=Пароль ng-required=true ng-model=auth.password class=form-control></div><div><button type=submit ng-disabled=auth.auth_loading class=\"btn btn-login\">Войти</button></div></form></div><a href=#><div class=enterButton><img ng-src=/assets/images/small_logo.png></div></a></div></div></div>");
$templateCache.put("app/auth/register.html","<!--Created by jaynakus on 5/26/16.\n--><div class=\"container body footer-fixed\"><div class=main_container><!-- page content--><div role=main class=right_col><div class=login><div class=login_wrapper><div class=\"form login_form\"><div class=login_content><form ng-submit=auth.register()><h1>Зарегистрироваться</h1><div><input placeholder=Пользователь required ng-model=auth.username class=form-control></div><div><input type=email placeholder=Email required ng-model=auth.email class=form-control></div><div><input type=password placeholder=Пароль required ng-model=auth.password class=form-control></div><div><button type=submit class=\"btn btn-default submit\">Зарегистрироваться</button></div><div class=clearfix></div><div class=separator><p class=change_link>Уже регистрировались?<a ui-sref=login class=to_register>Войти</a></p><div class=clearfix></div><br><div><h1><img src=assets/images/stok.png style=\"border: none; background-color: transparent\" width=150 height=150 class=img-thumbnail><!--span   kamkor IPS--></h1><p>© 2016-2017 Miller & Weismann</p></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/branch/branch.html","<div class=container><panel title=\"По филиалам\"><form ng-submit=branch.getPolicies()><div class=row><col-responsive stock-dict=branch.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=branch.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in branch.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Филиалы:</label><ui-select ng-model=branch.filter.branch_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agent._id as agent in branch.agents \">{{agent.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=branch.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=branch.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=branch.date_start ng-click=\"branch.search.popup_to_date.opened=true\" is-open=branch.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"branch.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=branch.date_start ng-model=branch.date_end ng-click=\"branch.search.popup_from_date.opened=true\" is-open=branch.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"branch.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"branch.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=ln_solid></div><button ng-click=branch.goToShow() ng-disabled=!branch.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=branch.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=branch.policiesGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/branch/show.html","<!--Created by ilias on 15.09.2017.\n--><div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><!--.col-md-4(stock-dict=\'show.currencies\' dict-table=\'Currencies\')--><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount}} {{show.currency_name}}<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium}} {{show.currency_name}} / {{show.policy.data.insurance_premium_kgs}} KGS<!--span( ng-repeat=\"country in show.countries| filter: {_id: show.currentCountryId}\" ng-if=\"show.currentCountryId\")--><!--  span.text-info(ng-repeat=\"currency in show.currencies | filter: {_id: country.currency_id}\")--> <!--    |   {{currency.data.name}}--></span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in show.policy.insurance_data.country_id\"><span ng-repeat=\"country in show.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{show.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{show.product.name}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{show.policy.client.surname}} {{show.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{show.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{show.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=show.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in show.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in show.product.services_id\" class=list-group-item><span ng-repeat=\"service in show.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button></div></div></div>");
$templateCache.put("app/clients/create.html","<!--Created by ilias on 18.02.17.\n--><div class=container><panel title=\"Создание клиента\"><div class=row><col-responsive><div class=form-group><label>ФИО клиента</label><input type=text ng-model=create.contractor.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=create.contractor.data.birthday is-open=create.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"create.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Телефон</label><input type=number ng-model=create.contractor.data.phone ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>E-mail</label><input type=email ng-model=create.contractor.data.email ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Адрес</label><input type=text ng-model=create.contractor.data.address ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Место работы</label><input type=text ng-model=create.contractor.data.work ng-trim=true class=form-control></div><div stock-dict=create.contractor_types dict-table=Enums dict-filter={name:&quot;contractor_type&quot;} class=form-group><label>Тип</label><ui-select ng-model=create.contractor.contractor_type ng-init=\"create.contractor.contractor_type=&quot;client&quot;\" ng-disabled=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in create.contractor_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><udf-view udf-table=contractor udf-data=create.contractor class=\"col col-xs-12\"></udf-view></div><div class=row><button ng-disabled=contractor.saving type=button ng-click=create.putContractor() class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=contractor.saving type=button ui-sref=app.clients.list class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></panel></div>");
$templateCache.put("app/clients/edit.html","<!--\neditd by ilias on 18.02.17.\n\n--><!-- header--><div class=\"wrapper bg-light lter b\"><a ui-sref=app.clients.list tooltip=Отмена class=\"btn btn-sm btn-default w-xxs m-r-sm\"><i class=\"fa fa-long-arrow-left\"></i></a><a ng-click=refresh() tooltip=Обновить class=\"btn btn-sm btn-default w-xxs m-r-sm\"><i class=\"fa fa-refresh\"></i></a></div><!-- / header--><div class=wrapper><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Изменения данных клиента</div><div class=panel-body><form name=clientForm class=\"bs-example form-validation\"><div class=row><col-responsive><div class=form-group><label>ФИО клиента</label><input type=text ng-model=edit.contractor.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=edit.contractor.data.birthday is-open=edit.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Телефон</label><input type=number ng-model=edit.contractor.data.phone ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>E-mail</label><input type=email ng-model=edit.contractor.data.email ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Адрес</label><input type=text ng-model=edit.contractor.data.address ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Место работы</label><input type=text ng-model=edit.contractor.data.work ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.contractor_types dict-table=Enums dict-filter=\"{name: &quot;contractor_type&quot;}\"><div class=form-group><label>Тип</label><ui-select ng-model=edit.contractor.contractor_type ng-init=\"create.contractor.contractor_type=&quot;client&quot;\" ng-disabled=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in edit.contractor_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><udf-view udf-table=contractor udf-data=edit.contractor class=\"col col-xs-12\"></udf-view></div></form><hr><uib-tabset class=tab-container><uib-tab heading=Анализы><div ng-show=\"edit.curIdentity==null\" class=wrapper><table class=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight: bold\"><td style=width:15%>Вид анализа</td><td style=width:10%>Результат</td><td style=width:15%>Ед измерения</td><td style=width:15%>Дата сдачи</td><td style=width:25%></td></tr><tr ng-repeat=\"id in edit.contractor.data.identities\"><td>{{ id.product_name }}</td><td>{{ id.result }}</td><td>{{ id.product_unit }}</td><td>{{ id.date_receipt | date: \'dd.MM.yyyy\' }}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=edit.editIdentity(id) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=edit.removeIdentity($index) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></table><button ng-click=edit.editIdentity({}) class=\"btn btn-default\">Добавить</button></div><div class=wrapper><form ng-show=\"edit.curIdentity!=null\" class=\"bs-example form-validation\"><div class=row><col-responsive><div class=form-group><label>Продукт</label><product-select product-id=edit.product_id></product-select></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Результат</label><input type=text placeholder=Результат ng-model=edit.curIdentity.result class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата сдачи</label><div class=\"input-group no-margin\"><input type=text uib-dtpicker-popup ng-model=edit.curIdentity.date_receipt is-open=edit.date_receipt.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.date_receipt.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><br><button ng-click=edit.finishIdentity(true) class=\"btn btn-primary m-b-lg\">Сохранить</button> <button ng-click=edit.finishIdentity(false) class=\"btn btn-default m-b-lg\">Отмена</button></form></div></uib-tab><uib-tab heading=Диагнозы><div ng-show=\"edit.curDiagnosis==null\" class=wrapper><table class=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight: bold\"><td>Название</td><td>Врач</td><td>Дата приема</td><td>Описание</td><td></td></tr><tr ng-repeat=\"diagnosis in edit.contractor.data.diagnosises\"><td>{{ diagnosis.name }}</td><td>{{ diagnosis.employee }}</td><td>{{ diagnosis.date }}</td><td>{{ diagnosis.comment }}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=edit.editDiagnosis(diagnosis) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=edit.removeDiagnosis($index) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></table><button ng-click=edit.editDiagnosis({}) class=\"btn btn-default m-b-lg\">Добавить</button></div><div class=wrapper><form ng-show=\"edit.curDiagnosis!=null\" class=\"bs-example form-validation\"><div class=row><col-responsive><div class=form-group><label class=control-label>Название</label><input type=text ng-model=edit.curDiagnosis.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Врач</label><employee-select employee-id=edit.current_employee></employee-select></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Дата приема</label><div class=\"input-group no-margin\"><input type=text uib-dtpicker-popup ng-model=edit.curDiagnosis.date is-open=edit.date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Описание</label><textarea rows=7 style=max-width:100% ng-model=edit.curDiagnosis.comment class=form-control></textarea></div></col-responsive></div><br><button ng-click=edit.finishDiagnosis(true) class=\"btn btn-primary m-b-lg\">Сохранить</button> <button ng-click=edit.finishDiagnosis(false) class=\"btn btn-default m-b-lg\">Отмена</button></form></div></uib-tab><uib-tab heading=\"История лечения\"><div ng-show=\"edit.curHistories==null\" class=wrapper><table class=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight: bold\"><td style=width:25%>Наименование</td><td style=width:25%>Кол-во</td><td style=width:25%>Дата назначения</td><td style=width:25%>Продолжительность</td><td style=width:25%>Врач</td><td style=width:25%>Комментарии</td><td style=width:25%></td></tr><tr ng-repeat=\"history in edit.contractor.data.histories\"><td>{{ history.name }}</td><td>{{ history.summ }}</td><td>{{ history.date }}</td><td>{{ history.duration }}</td><td>{{ history.current_employee }}</td><td>{{ history.comment }}</td><td style=\"white-space: nowrap\"><div class=buttons><button tooltip=Изменить ng-click=edit.editHistory(history) class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <button tooltip=Удалить ng-click=edit.removeHistory($index) class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-minus\"></i></button></div></td></tr></table><button ng-click=edit.editHistory({}) class=\"btn btn-default m-b-lg\">Добавить</button></div><div class=wrapper><form ng-show=\"edit.curHistories!=null\" class=\"bs-example form-validation\"><div class=row><col-responsive><div class=form-group><label class=control-label>Название</label><input type=text ng-model=edit.curHistories.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Кол-во</label><input type=number ng-model=edit.curHistories.summ class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Дата приема</label><div class=\"input-group no-margin\"><input type=text uib-dtpicker-popup ng-model=edit.curHistories.date is-open=edit.date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"edit.date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Продолжительность</label><input type=number ng-model=edit.curHistories.duration class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Врач</label><employee-select employee-id=edit.current_employee></employee-select></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Описание</label><textarea rows=7 style=max-width:100% ng-model=edit.curHistories.comment class=form-control></textarea></div></col-responsive></div><br><button ng-click=edit.finishHistory(true) class=\"btn btn-primary m-b-lg\">Сохранить</button> <button ng-click=edit.finishHistory(false) class=\"btn btn-default m-b-lg\">Отмена</button></form></div></uib-tab></uib-tabset><div class=\"form-group pull-right m-r-md\"><button type=submit ng-disabled=clientForm.$invalid ng-click=edit.saveClient() class=\"btn btn-primary btn-md m-r-xs\">Сохранить</button><!-- <button ng-click=\"validateClientForm()\" class=\"btn btn-primary btn-md m-r-xs\">Сохранить</button>--> <button ng-click=edit.cancel() class=\"btn btn-default btn-md\">Назад</button></div></div></div></div>");
$templateCache.put("app/clients/list.html","<!--\nCreated by ilias on 18.02.17.\n\n--><div class=container><panel title=Клиенты><button ui-sref=app.clients.create class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!list.selected_contractor ui-sref=\"app.clients.view({id: list.selected_contractor._id})\" class=\"btn btn-default btn-sm\">Посмотреть</button> <button ng-disabled=!list.selected_contractor ui-sref=\"app.clients.edit({id: list.selected_contractor._id})\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=list.getContractors() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=list.contractorsGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/clients/modal.html","<!--\ncontractord by ilias on 23.03.17.\n\n--><form ng-submit=contractor.putContractor()><div class=modal-header><h3>Клиент</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>ФИО клиента</label><input type=text ng-model=contractor.contractor.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-model=contractor.contractor.data.birthday is-open=contractor.popup_delivery_date.opened class=form-control><span class=input-group-btn><button type=button ng-click=\"contractor.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Телефон</label><input type=number ng-model=contractor.contractor.data.phone ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>E-mail</label><input type=email ng-model=contractor.contractor.data.email ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Адрес</label><input type=text ng-model=contractor.contractor.data.address ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Место работы</label><input type=text ng-model=contractor.contractor.data.work ng-trim=true class=form-control></div><div stock-dict=contractor.contractor_types dict-table=Enums dict-filter={name:&quot;contractor_type&quot;} class=form-group><label>Тип</label><ui-select ng-model=contractor.contractor.contractor_type ng-init=\"contractor.contractor.contractor_type=&quot;client&quot;\" ng-disabled=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in contractor.contractor_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive></div></div><div class=modal-footer><button ng-disabled=contractor.saving type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=contractor.saving type=button ng-click=contractor.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/clients/view.html","<!--Created by ilias on 18.02.17.\n--><div class=container></div><div class=wrapper><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Данные о клиенте</div><div class=panel-body><div class=row><div class=col-sm-3><button ui-sref=app.clients.list class=\"btn btn-primary m-b\">Назад</button></div></div><div class=wrapper-md><div class=row><div class=col-sm-9><div class=\"panel panel-default\"><div class=col-sm-12><h3 style=\"text-align: center\">{{ view.contractor.name }}</h3><hr><div class=\"col-lg-6 col-sm-6\"><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Дата Рождения:</strong></label><div class=col-xs-4><p class=form-control-static>{{ view.contractor.data.birthday | date: \'dd.MM.yyyy\' }}</p></div></div></div><!--.col.col-xs-12--><!--  .form-group--><!--    label.col-xs-4--><!--      strong Пол:--><!--    .col-xs-4--><!--      p.form-control-static(cbs-dict=\'Gender\') {{getGenderText(Gender, view.gender)}}--><!--.col.col-xs-12--><!--  .form-group--><!--    label.col-xs-4--><!--      strong Национальность:--><!--    .col-xs-4--><!--      p.form-control-static {{ view.nation }}--><!--.col.col-xs-12--><!--  .form-group--><!--    label.col-xs-4--><!--      strong Семейное положение:--><!--    .col-xs-4--><!--      p.form-control-static(cbs-dict=\'MaritalStatus\')  {{getMaritalStatusText(MaritalStatus, view.marital_status)}}--><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>E-mail :</strong></label><div class=col-xs-4><p class=form-control-static>{{view.contractor.data.email}}</p></div></div></div><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Телефон:</strong></label><div class=col-xs-4><p class=form-control-static>{{view.contractor.data.phone}}</p></div></div></div></div><div class=\"col-lg-6 col-sm-6\"><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Адрес:</strong></label><div class=col-xs-4><p class=form-control-static>{{view.contractor.data.address}}</p></div></div></div><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Компания в система:</strong></label><div class=col-xs-4><p class=form-control-static>{{ view.contractor.contractor_company.name }}</p></div></div></div><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Место работы:</strong></label><div class=col-xs-4><p class=form-control-static>{{ view.contractor.data.work }}</p></div></div></div><div class=\"col col-xs-12\"><div class=form-group><label class=col-xs-4><strong>Тип клиента:</strong></label><div class=col-xs-4><p class=form-control-static>{{ view.contractor.contractor_type_value.data.name }}</p></div></div></div></div></div></div></div></div></div><uib-tabset><uib-tab heading=Анализы><div class=col-sm-12><div class=row><div class=col-sm-12><div class=\"panel panel-default m-t\"><div class=panel-heading><strong>Результаты анализов</strong></div><div><table data-page-size=5 class=\"table table-striped table-hover bg-white b-a\"><thead><tr><th data-toggle=true>Вид анализа</th><th data-hide=phone>Результат</th><th data-hide=phone,tablet>Ед измерения</th><th data-hide=phone,tablet>Дата сдачи</th></tr></thead><tbody><tr ng-repeat=\"loan in view.contractor.data.identities\"><td>{{ loan.product_name }}</td><td>{{ loan.result }}</td><td>{{ loan.product_unit }}</td><td>{{ loan.date_receipt | date: \'dd.MM.yyyy\' }}</td></tr></tbody><!-- <tfoot class=\"hide-if-no-paging\">--><!-- <tr>--><!-- <td colspan=\"5\" class=\"text-center\">--><!-- <ul class=\"pagination\"></ul>--><!-- </td>--><!-- </tr>--><!-- </tfoot>--></table></div></div></div></div></div></uib-tab><uib-tab heading=Диагнозы><div class=col-sm-12><div class=row><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-heading><strong>Диагноз</strong></div><div><table data-page-size=5 class=\"table table-striped table-hover bg-white b-a\"><thead><tr><th data-toggle=true>Название</th><th data-hide=true>Врач</th><th data-hide=true>Дата приема</th><th data-hide=true>Описание</th></tr></thead><tbody><tr ng-repeat=\"diagnosis in view.contractor.data.diagnosises\"><td>{{ diagnosis.name }}</td><td>{{ diagnosis.employee }}</td><td>{{ diagnosis.date | date: \'dd.MM.yyyy\'}}</td><td>{{ diagnosis.comment }}</td></tr></tbody><!-- <tfoot class=\"hide-if-no-paging\">--><!-- <tr>--><!-- <td colspan=\"5\" class=\"text-center\">--><!-- <ul class=\"pagination\"></ul>--><!-- </td>--><!-- </tr>--><!-- </tfoot>--></table></div></div></div></div></div></uib-tab><uib-tab heading=\"История лечения\"><div class=col-sm-12><div class=row><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-heading><strong>История лечения</strong></div><div><table data-page-size=5 class=\"table table-striped table-hover bg-white b-a\"><thead><tr><td data-hide=true>Наименование</td><td data-hide=true>Кол-во</td><td data-hide=true>Дата назначения</td><td data-hide=true>Продолжительность</td><td data-hide=true>Врач</td><td data-hide=true>Комментарии</td></tr></thead><tbody><tr ng-repeat=\"history in view.contractor.data.histories\"><td>{{ history.name }}</td><td>{{ history.summ }}</td><td>{{ history.date | date: \'dd.MM.yyyy\'}}</td><td>{{ history.duration }}</td><td>{{ history.current_employee }}</td><td>{{ history.comment }}</td></tr></tbody><!-- <tfoot class=\"hide-if-no-paging\">--><!-- <tr>--><!-- <td colspan=\"5\" class=\"text-center\">--><!-- <ul class=\"pagination\"></ul>--><!-- </td>--><!-- </tr>--><!-- </tfoot>--></table></div></div></div></div></div></uib-tab></uib-tabset><div class=row><div class=col-sm-3><button ui-sref=app.clients.list class=\"btn btn-primary\">Назад</button></div></div></div></div></div>");
$templateCache.put("app/collateral/collateral.html","<div class=container><panel title=Залоги><form ng-submit=collateral.getPolicies()><div class=row><col-responsive><div class=form-group><label>Клиент</label><contractor-select contractor-id=collateral.filter.client_id placeholder=\"Введите имя клиента\"></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса</label><input type=text ng-model=collateral.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"collateral.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=ln_solid></div><button type=button ng-click=collateral.goToNew() class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!collateral.selected_policy\' ng-click=\'collateral.editBranch()\')--> <button ng-click=collateral.goToShow() ng-disabled=!collateral.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button><!--button.btn.btn-default.btn-sm(ng-click=\'collateral.delete()\' ng-disabled=\"!collateral.selected_policy\")--> <button ng-click=collateral.confirmAction() ng-disabled=\"!collateral.selected_policy || collateral.selected_collateral.data.status != \'Сохранен\'\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=collateral.downloadPDF() ng-disabled=\"!collateral.selected_policy || collateral.selected_collateral.policy_no == \'00000\' || (collateral.selected_collateral.data.status != \'Оформлен\' &amp;&amp; collateral.selected_collateral.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=collateral.savePDF() ng-disabled=\"!collateral.selected_policy || collateral.selected_collateral.policy_no == \'00000\' || (collateral.selected_collateral.data.status != \'Оформлен\' &amp;&amp; collateral.selected_collateral.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Скачать pdf</button> <button type=button ng-click=collateral.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=collateral.collateralGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/collateral/create.html","<div class=container><panel title=\"Создание залога\"><form name=collateralForm><div class=row><label class=\"col-md-2 control-label\">Владелец:</label><div class=col-md-3><div class=form-group><contractor-select contractor-id=create.collateral.contractor_id placeholder=\"Введите имя клиента\"></contractor-select></div></div></div><div class=row><label class=\"col-md-2 control-label\">Название:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.name required class=form-control></div></div></div><div stock-dict=create.statuses dict-table=Enums dict-filter={name:&quot;collateral_type&quot;} class=row><label class=\"col-md-2 control-label\">Тип залога:</label><div class=col-md-3><div class=form-group><ui-select ng-model=create.collateral.enums_id ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in create.statuses\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><label class=\"col-md-2 control-label\">ИДН:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.idn required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Рын. стоимость:</label><div class=col-md-2><div class=form-group><input type=number min=0 ng-model=create.collateral.market_price required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Залог. стоимость:</label><div class=col-md-2><div class=form-group><input type=number min=0 ng-model=create.collateral.coll_price required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Ликвидность:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.liquidity required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Правоустанавливающие документы:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.documents required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Местонахождение:</label><div class=col-md-3><div class=form-group><input type=text ng-model=create.collateral.address required class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Описание:</label><div class=col-md-3><div class=form-group><textarea rows=5 ng-model=create.collateral.description class=form-control></textarea></div></div></div><div class=row><div class=\"col-md-3 col-md-offset-2\"><!--button.btn.btn-primary.m-t(ng-click=\'switchCollateralView(true, false, false)\') Назад--> <button ng-disabled=create.saving type=button ui-sref=app.collateral.list class=\"btn btn-primary m-t\">Отмена</button> <button ng-disabled=collateralForm.$invalid type=button ng-click=create.putCollateral() class=\"btn btn-primary m-t\">Сохранить</button></div></div></form></panel></div>");
$templateCache.put("app/collateral/list.html","<div class=container><panel title=Залоги><form ng-submit=list.getPolicies()><div class=row><col-responsive><div class=form-group><label>Клиент</label><contractor-select contractor-id=list.filter.client_id placeholder=\"Введите имя клиента\"></contractor-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=ln_solid></div><button ui-sref=app.collateral.create class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-click=list.goToShow() ng-disabled=!list.selected_collateral class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button ng-click=list.confirmAction() ng-disabled=!list.selected_collateral class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=list.getCollaterals() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=list.collateralGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/collateral/view.html","<div class=container><panel title=\"Просмотр залога\"><div class=row><label class=\"col-md-2 control-label\">Владелец:</label><div class=col-md-3><div class=form-group><contractor-select contractor-id=view.collateral.contractor_id placeholder=\"Введите имя клиента\" disabled></contractor-select></div></div></div><div class=row><label class=\"col-md-2 control-label\">Название:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.name ng-disabled class=form-control></div></div></div><div stock-dict=view.statuses dict-table=Enums dict-filter={name:&quot;collateral_type&quot;} class=row><label class=\"col-md-2 control-label\">Тип залога:</label><div class=col-md-3><div class=form-group><ui-select ng-model=view.collateral.type_id ng-disabled class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in view.statuses\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><label class=\"col-md-2 control-label\">ИДН:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.idn ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Рын. стоимость:</label><div class=col-md-2><div class=form-group><input type=number min=0 ng-model=view.collateral.market_price ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Залог. стоимость:</label><div class=col-md-2><div class=form-group><input type=number min=0 ng-model=view.collateral.coll_price ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Ликвидность:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.liquidity ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Правоустанавливающие документы:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.documents ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Местонахождение:</label><div class=col-md-3><div class=form-group><input type=text ng-model=view.collateral.address ng-disabled class=form-control></div></div></div><div class=row><label class=\"col-md-2 control-label\">Описание:</label><div class=col-md-3><div class=form-group><textarea rows=5 ng-model=view.collateral.description ng-disabled class=form-control></textarea></div></div></div><div class=row><div class=\"col-md-3 col-md-offset-2\"><button ng-disabled=view.saving type=button ui-sref=app.collateral.list class=\"btn btn-primary m-t\">Yfpfl</button></div></div></panel></div>");
$templateCache.put("app/company/company.html","<!--Created by Aibek on 06/06/16.\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Компании</div><div class=panel-body><button type=button ng-click=company.newCompany() class=\"btn btn-primary btn-sm\">Создать</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!branch.selected_branch\' ng-click=\'branch.editBranch()\')--> <button ng-click=company.editCompany() ng-disabled=\"company.selected_company==null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button><paged-table options=company.companiesGridOptions disable-search=true disable-paging=true></paged-table></div></div></div><!--.container--><!--  panel(title=\'Компании\')--><!--    .row--><!--      .col.col-xs-12--><!--        button.btn.btn-primary.btn-sm(ng-click=\'company.newCompany()\') Создать компанию--><!--    .row(ng-if=\'company.user_companies.length == 0\')--><!--      .col.col-xs-12--><!--        h4 У вас нет компании.--><!--    .row--><!--      .col.col-xs-6.col-sm-4.col-md-3.col-lg-2(ng-repeat=\'uc in company.user_companies\')--><!--        panel(title=\'{{uc.company.name}}\')--><!--          image(style=\'width:100%;\', src=\'assets/images/img.jpg\')--><!--          label.no-margin.small(ng-if=\'uc.user_id!=app.ua.id\') Доступ: {{uc.access}}--><!--          label.no-margin.small(ng-if=\'uc.user_id==app.ua.id\') Вы владелец--><!--          .ln_solid--> <!--          button.btn.btn-default.btn-sm(ng-click=\'company.editCompany(uc.company)\', ng-if=\'uc.user_id==app.ua.id\') Редактировать-->");
$templateCache.put("app/company/edit.html","<!--\nCreated by Aibek on 26/08/16.\n\n--><form ng-submit=company.putCompany() class=from-horizontal><div class=modal-header></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab data-target=#home>Основная информация</a></li><li><a data-toggle=tab data-target=#contact>Контакты</a></li><li><a data-toggle=tab data-target=#user>Пользователи</a></li><li><a data-toggle=tab data-target=#logo>Логотип</a></li></ul><div class=tab-content><div id=home class=\"tab-pane fade in active\"><div class=row><col-responsive><div class=form-group><label>Официальное имя</label><input type=text ng-model=company.company.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Краткое имя</label><input type=text ng-model=company.company.short_name ng-required=false ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код компании</label><input type=text ng-model=company.company.code ng-required=false ng-trim=true maxlength=2 class=form-control></div></col-responsive><col-responsive stock-dict=company.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=company.company.data.status ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Дата регистрации</label><div class=\"input-group no-margin\"><input type=text ng-required=true uib-datepicker-popup=dd-MM-yyyy ng-model=company.company.data.reg_date ng-click=\"company.registrationDP.popup_to_date.opened=true\" is-open=company.registrationDP.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"company.registrationDP.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Номер регистрации</label><input type=text ng-model=company.company.data.register_number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ИНН</label><input type=text ng-model=company.company.data.inn ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код ОКПО</label><input type=text ng-model=company.company.data.code_okpo ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=company.company_types dict-table=Enums dict-filter={name:&quot;company_type&quot;}><div class=form-group><label>Тип</label><ui-select ng-model=company.company.company_type ng-required=true class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in company.company_types track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Менеджер</label><input type=text ng-model=company.company.data.manager ng-required=true ng-trim=true class=form-control></div></col-responsive><!--col-responsive(stock-dict=\'company.insurer_types\' dict-table=\'Enums\' dict-filter=\'{name:\"insurer_type\"}\')--><!--  .form-group--><!--    label Тип--><!--    ui-select.form-control(ng-model=\'company.company.data.insurer_type\' ng-required=\'true\')--><!--      ui-select-match {{$select.selected.data.name}}--><!--      ui-select-choices(repeat=\'type.data.key as type in company.insurer_types track by type.data.key\') {{type.data.name}}--><col-responsive><div class=form-group><label>Капитал</label><input type=text ng-model=company.company.data.capital ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Правила страхования</label><div class=input-group><input type=text ng-model=company.company.data.insurance_rules ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Образец полиса</label><div class=input-group><input type=text ng-model=company.company.data.policy_sample ng-trim=true ng-disabled=true class=form-control><span class=input-group-btn><button type=button class=\"btn btn-secondary\">Загрузить</button></span></div></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Описание</label><textarea ng-model=company.company.data.description rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Рекомендация</label><textarea ng-model=company.company.data.recommendation rows=4 class=form-control></textarea></div></col-responsive><col-responsive><div class=form-group><label>Франшиза</label><textarea ng-model=company.company.data.franchise rows=4 class=form-control></textarea></div></col-responsive></div></div><div id=contact class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Телефон</label><div class=input-group><input type=number ng-model=company.phone ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addPhone() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.phones\" class=list-group-item><label>{{x}}</label><a ng-click=company.deletePhone($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Адрес</label><div class=input-group><input type=text ng-model=company.address ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addAddress() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.addresses\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteAddress($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>E-mail</label><div class=input-group><input type=email ng-model=company.email ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addEmail() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.emails\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteEmail($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Вебсайт</label><div class=input-group><input type=text ng-model=company.website ng-trim=true class=form-control><span class=input-group-btn><button type=button ng-click=company.addWebsite() class=\"btn btn-secondary\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-plus\"></i></button></span></div><ul style=\"max-height:200px; overflow-y: auto\" class=list-group><li ng-repeat=\"x in company.company.data.websites\" class=list-group-item><label>{{x}}</label><a ng-click=company.deleteWebsite($index) class=\"btn btn-sm btn-primary pull-right\"><i aria-hidden=true style=\"font-size: 130%\" class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div></div><div id=user class=\"tab-pane fade\"><div class=row><div class=row><!--.col.col-xs-12.col-sm-6.col-md-6(stock-dict=\'company.users\' dict-table=\'User\')--><div class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Ползователи</label><ui-select ng-model=company.currStaff.user_id ng-required=true class=form-control><ui-select-match>{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"type.id as type in company.users\">{{type.username}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col col-xs-12\"><button type=button ng-click=company.addStaff() class=\"btn btn-primary btn-sm pull-right\">Добавить</button></div></div><div class=row><div class=\"col col-xs-12\"><h2>Список пользователей</h2><table class=\"table table-bordered\"><thead><tr><th>Пользователь</th><th>Филиал</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in company.company.staff\"><td><span ng-repeat=\"user in company.users\" ng-if=\"user.id == item.user_id\">{{user.username}}</span></td><td><span ng-repeat=\"branch in company.branches | filter:{_id:item.branch_id}\">{{branch.name}}</span></td><td><a ng-click=company.deleteStaff($index) class=\"btn btn-danger glyphicon glyphicon-remove-sign\"></a></td></tr></tbody></table></div></div></div></div><div id=logo class=\"tab-pane fade\"><div class=row><div flow-init={singleFile:true} class=\"col col-xs-12 col-md-8 col-lg-8\"><span flow-btn flow-file-added=\"company.handleFileSelect($event, $flow, $file)\" class=\"btn btn-default margin-right-8\">Выбрать файл...</span><span>{{$flow.files[0].name}}</span></div></div><div class=row><div class=\"col col-xs-12 col-md-8 col-lg-8\"><div class=cropArea><img-crop image=company.image result-image=company.result_image area-type=square result-image-size=100></img-crop></div><div>Итоговое изибражение:<div><img ng-src={{company.result_image}}></div><a data-target=# ng-click=company.upload() class=\"btn btn-primary\">Заменить существующий</a></div></div><div class=\"col col-xs-12 col-md-4 col-lg-4\"><div class=\"clearfix pull-left\"><h3>Логотип компании</h3><img ng-src={{app.api}}{{company.company.data.image}} class=profile-image-lg></div></div></div></div></div></div><div class=modal-body><!--button.btn.btn-primary.btn-sm.pull-right(type=\'submit\', ng-if=\'company.company.user_id==company.ua.id\') Сохранить--> <button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=company.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/currency/currency.html","<!--\nCreated by Ilias on 13/06/16.\n\n--><div class=container><panel title=\"Курс валют\"><button ng-click=currency.confirmAction() ng-disabled=\"currency.selected_currency == null\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button ng-click=currency.getCurrency() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=currency.currencyGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=row><div class=\"col col-md-7\"><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Нормативные документы</div><div class=panel-body><table id=dev-table class=\"table table-hover table-bordered\"><thead><tr><th>#</th><th>Наименование</th><th>Файл</th></tr></thead><tbody><tr ng-repeat=\"regulation in dashboard.regulations | orderBy:&quot;-created_from&quot;\"><td>{{$index+1}}</td><td>{{regulation.name}}</td><td><a href=\"{{dashboard.api + regulation.file}}\" target=_blank>Скачать</a></td></tr></tbody></table></div></div></div><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Полисы которые заканчиваются в течении 30 дней</div><div class=panel-body><paged-table options=dashboard.policiesGridOptions disable-search=true></paged-table></div></div></div></div><div class=\"col col-md-5\"><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Официальные курсы валют НБ КР на {{dashboard.today | amDateFormat:\'DD.MM.YYYY\'}} г.</div><div class=panel-body><table class=table><thead><tr><th>Валюта</th><th>Курс</th></tr></thead><tbody ng-repeat=\"currency in dashboard.currencies\"><tr><td>{{currency.currency}}</td><td>{{currency.value}}</td></tr></tbody></table></div></div></div><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Новости</div><div class=panel-body><div class=holder><div ng-repeat=\"item in dashboard.news\" class=border-wrapper><a ng-click=dashboard.goToNewsPage(item) class=\"h5 text-primary m-b-sm text-center\">{{item.name | limitTo: 75 }}{{item.name.length > 75 ? \'...\' : \'\'}}<span class=\"small pull-right\"></span></a><div class=row><div class=\"col-md-3 col-sm-3 col-xs-12\"><time class=\"comment-date small\">{{item.create_date | amDateFormat:\'DD MMM YYYY\'}}</time><div ng-switch=item.section class=normal><button ng-switch-when=Новости class=tagmain>Новости</button> <button ng-switch-when=Объявления class=tagmain>Объявления</button> <button ng-switch-when=\"Бюллетень ВАК\" class=tagmain>Бюллетень ВАК</button> <button ng-switch-when=Пресс-Релиз class=tagmain>Пресс-Релиз</button> <button ng-switch-when=\"Планы ВАК\" class=tagmain>Планы ВАК</button> <button ng-switch-when=\"Отчеты ВАК\" class=tagmain>Отчеты ВАК</button></div></div><div class=\"col-md-8 col-sm-8 col-xs-12\"><p ng-bind-html=\"item.description | limitTo: 500\"></p></div></div><hr></div></div></div></div></div></div></div>");
$templateCache.put("app/defaults/defaults.html","<!--\nCreated by Aibek on 17/08/16.\n\n--><panel title=Документы><button ng-disabled=!defaults.selected_default ng-click=defaults.editDefault() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=defaults.getDefaults() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=defaults.gridOptions disable-paging=true disable-search=true></paged-table></panel>");
$templateCache.put("app/defaults/edit.html","<!--\nCreated by Aibek on 29/08/16.\n\n--><form ng-submit=defaults.putDefault() class=modal-content><div class=modal-header><h3>Параметры документа</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Тип</label><input ng-disabled=true ng-repeat=\"doc_type in defaults.doc_types | filter: {id:defaults.doc_default.document_type} | limitTo: 1 track by doc_type.id\" ng-model=doc_type.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Одобрение</label><label class=form-control><input type=checkbox ng-model=defaults.doc_default.data.approval.required><span ng-hide=defaults.doc_default.data.approval.required>&nbsp;Не обьязательно</span><span ng-show=defaults.doc_default.data.approval.required>&nbsp;Обьязательное одобрение</span></label></div></col-responsive><col-responsive ng-if=\"defaults.doc_default.data.approval.required===true\"><div stock-dict=defaults.approval_types dict-table=Enums dict-filter={name:&quot;approval_type&quot;} class=form-group><label>Должны одобрить</label><div class=form-control><label ng-repeat=\"type in defaults.approval_types track by type.data.key\" ng-class={&quot;margin-right-8&quot;:!$last}><input type=radio ng-model=defaults.doc_default.data.approval.approval_type ng-value=type.data.key name=approve_type><span>&nbsp;{{type.data.name}}</span></label></div></div></col-responsive><col-responsive ng-if=\"defaults.doc_default.data.approval.required===true\"><div class=form-group><label uib-tooltip=\"Одобрение будет проходить по порядку добавления ролей\">Добавить роль для одобрения</label><div stock-dict=defaults.roles dict-table=Roles class=input-group><ui-select ng-model=defaults.approval_role_id class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (defaults.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-disabled=!defaults.approval_role_id ng-click=defaults.addApprovalRole() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus text-primary\"></span></button></span></div></div></col-responsive><div ng-show=\"defaults.doc_default.data.approval.roles_id.length &gt; 0 &amp;&amp; defaults.doc_default.data.approval.required===true\" class=\"col col-xs-12\"><label>Роли для одобрения</label></div><div ng-show=\"defaults.doc_default.data.approval.roles_id.length &gt; 0 &amp;&amp; defaults.doc_default.data.approval.required===true\" class=\"col col-xs-12\"><col-responsive ng-repeat=\"role_id in defaults.doc_default.data.approval.roles_id\"><div class=input-group><div class=input-group-addon><span>{{$index+1}}</span></div><ui-select ng-model=role_id ng-disabled=true class=form-control><ui-select-match>{{$select.selected.data.approval_name}}</ui-select-match><ui-select-choices repeat=\"role._id as role in (defaults.roles | filter:{data:{approval_name:$select.search}}) track by role._id\">{{role.data.approval_name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=defaults.delApprovalRole(role_id) class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove text-danger\"></span></button></span></div></col-responsive></div><col-responsive><div class=form-group><label>Исполнитель</label><employee-select employee-id=defaults.doc_default.data.data.executor_id></employee-select></div></col-responsive></div></div><div class=modal-footer><button ng-disabled=\"defaults.saving==true\" type=button ng-click=defaults.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=\"defaults.saving==true\" class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/dictionary/dictionary.html","<!--Created by Aibek on 24/08/16.\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Справочники</div><div class=panel-body><div class=row><div class=\"col col-xs-12 col-md-3\"><div class=list-group><a ng-class=\"{active:dictionary.active_table.table==table.table}\" ng-click=\"dictionary.active_table=table\" ng-repeat=\"table in dictionary.tables | filter: dictionary.roleFilter track by table.table\" class=list-group-item>{{table.name}}</a></div></div><div class=\"col col-xs-12 col-md-9\"><button ng-click=dictionary.newDictionary() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!dictionary.selected_dictionary ng-click=dictionary.editDictionary() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-disabled=!dictionary.selected_dictionary ng-click=dictionary.removeConfirmAction() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-trash margin-right-8\"></span><span>Удалить</span></button><div dynamic=dictionary.grid></div></div></div></div></div></div>");
$templateCache.put("app/dictionary/modal.html","<!--Created by Aibek on 24/08/16.\n--><form ng-submit=edit.saveDictionary()><div class=modal-header><h3>{{edit.table.name}}</h3></div><div class=modal-body><ng-include src=edit.template></ng-include></div><div class=modal-footer><button type=button ng-click=edit.cancel() class=\"btn btn-default\">Отмена</button> <button type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/doctemplates/add.html","<div flow-init=add.flowConfig class=container><div class=row><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=x_panel><div class=x_title><h2>Добавить документ</h2><div class=clearfix></div></div><div class=x_content><form id=doctemp-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text id=title name=title required ng-model=add.docTemp.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Выберите файл<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><!--input(type=\"file\", flow-btn)--><file-load file-src=add.docTemp.url type=exp_fk allow=ods,odt,xls,xlsx></file-load><!--label.btn.btn-default.btn-file--><!--  input(type=\"file\", id=\"file\", name=\"file\", ng-model=\"add.docTemp.file\", hidden)--></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=add.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=add.saveDocTemp() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/doctemplates/list.html","<div class=container><div class=row><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=x_panel><div class=x_title><h2>Шаблоны документов</h2><div class=clearfix></div></div><div class=x_content><table class=table><thead><tr><th>#</th><th>Название</th><th><button type=button ng-click=list.openAddForm() class=\"btn btn-default btn-xs\">Добавить</button> <button type=button ng-click=list.getDocTeplates() class=\"btn btn-default btn-xs\">Обновить</button></th></tr></thead><tbody><tr ng-repeat=\"doc in list.docTemps\" ng-if=\"list.docTemps.length &gt; 0\"><td>{{ ($index + 1) }}</td><td padding-top>{{ doc.name }}</td><td><a target=_blank href=\"{{ list.api + \'download/\' + doc.url }}\" class=\"btn btn-primary btn-xs\">Скачать</a> <button type=button ng-click=list.deleteDoc(doc) class=\"btn btn-danger btn-xs\">Удалить</button></td></tr><tr ng-if=\"list.docTemps.length == 0\"><td></td><td>Нет шаблонов</td><td></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/employee/create.html","<!--\nCreated by ilias on 20.08.2017.\n\n--><form ng-submit=employee.createEmployee()><div class=modal-header><h3>Новый сотрудник</h3></div><div class=modal-body><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>ФИО</label><input type=text ng-model=employee.employee.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"employee.popup_delivery_date.opened=true\" ng-model=employee.employee.birthday is-open=employee.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"employee.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=employee.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/employee/edit.html","<!--\nCreated by ilias on 20.08.2017.\n\n--><form ng-submit=employee.updateEmployee()><div class=modal-header><h3>Сотрудник<div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>ФИО</label><input type=text ng-model=employee.employee.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"employee.popup_delivery_date.opened=true\" ng-model=employee.employee.birthday is-open=employee.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"employee.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></h3></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=employee.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/employee/employee.html","<!--Created by ilias on 20.08.2017.\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Сотрудники</div><div class=panel-body><button ng-click=employee.newEmployee() class=\"btn btn-primary btn-sm\">Добавить<!--button.btn.btn-default.btn-sm(ng-click=\"employee.editEmployee()\" ng-disabled=\"users.selected_user == null\")--> <button ng-click=employee.editEmployee() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=employee.deleteEmployee(employee.selected_user) class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button ng-click=employee.getEmployees() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button></button><paged-table options=employee.employeeGridOptions disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/fpolicy/list.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Полисы</div><div class=panel-body><form ng-submit=list.getPolicies()><div class=row><col-responsive><div class=form-group><label>Сотрудники:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.surname}} {{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"agent.id as agent in list.agents \">{{agent.data.surname}} {{agent.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.client placeholder=\" Введите Фио клиента\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=\"wrapper ln_solid\"></div><button ng-click=list.goToShow() ng-disabled=!list.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=\"wrapper ln_solid\"></div><paged-table options=list.policiesGridOptions disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/fpolicy/show.html","<!--Created by troy on 07.10.2016.\n--><div class=container><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=panel><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-refresh\"></i> Возобновить</button> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/hpolicy/list.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Полисы</div><div class=panel-body><form ng-submit=list.getPolicies()><div class=row><col-responsive><div class=form-group><label>Филиалы</label><ui-select ng-model=list.filter.branch_id ng-required=true on-select=list.getAgents(list.filter.branch_id) class=form-control><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"company._id as company in list.branches \">{{company.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сотрудники:</label><ui-select ng-model=list.filter.agent_id ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.surname}} {{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"agent.id as agent in list.agents \">{{agent.data.surname}} {{agent.data.name}}</ui-select-choices></ui-select><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}></col-responsive></div></col-responsive><col-responsive stock-dict=list.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=list.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in list.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=list.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>ФИО клиента:</label><input type=text ng-model=list.filter.client placeholder=\" Введите Фио клиента\" class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=list.filter.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=list.filter.date_start ng-click=\"list.search.popup_to_date.opened=true\" is-open=list.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=list.filter.date_start ng-model=list.filter.date_end ng-click=\"list.search.popup_from_date.opened=true\" is-open=list.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"list.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=\"wrapper ln_solid\"></div><button ng-click=list.goToShow() ng-disabled=!list.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button type=button ng-click=list.downloadPDF() ng-disabled=\"!list.selected_policy || list.selected_list.policy_no == \'00000\' || (list.selected_policy.data.status != \'Оформлен\' &amp;&amp; list.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=list.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=\"wrapper ln_solid\"></div><paged-table options=list.policiesGridOptions disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/hpolicy/show.html","<!--Created by troy on 07.10.2016.\n--><div class=container><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{show.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-refresh\"></i> Возобновить</button> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/main/main.html","<!--Created by iliyas on 5/26/16.\n--><div class=body><!-- header--><header id=header role=menu class=\"app-header navbar\"><!-- navbar header--><div class=navbar-header><button data-toggle=collapse data-target=#collapseExample aria-expanded=false aria-controls=collapseExample class=\"pull-right visible-xs dk\"><i class=\"glyphicon glyphicon-align-justify\"></i></button></div><div id=collapseExample class=\"collapse pos-rlt navbar-collapse box-shadow bg-white-only\"><div class=navbar-header><a ui-sref=app.dashboard class=\"navbar-brand text-lt\"><img src=/assets/images/logo.png alt=. class=ayu_logo></a><a ui-sref=app.dashboard class=\"navbar-brand text-lt\"><img src=/assets/images/dcb_logo.png alt=.></a></div><ul class=\"nav navbar-nav\"><li ng-repeat=\"menu in app.navigation | orderBy : &quot;data.position&quot;\" class=dropdown><a data-toggle=dropdown class=dropdown-toggle><span>{{menu.name}}</span><span class=caret></span></a><ul role=menu id=menu{{$index+1}} class=dropdown-menu><li ng-repeat=\"child in menu.children | orderBy : &quot;data.position&quot;\"><a ui-sref={{child.data.route}}>{{child.name}}</a></li></ul></li><li ui-sref-active=active ng-repeat=\"menu in app.admin_menu | orderBy : &quot;data.position&quot;\" class=dropdown><a data-toggle=dropdown class=dropdown-toggle><span>{{menu.name}}</span><span class=caret></span></a><ul role=menu class=dropdown-menu><li ng-repeat=\"child in menu.children | orderBy : &quot;data.position&quot;\"><a ui-sref={{child.data.route}}>{{child.name}}</a></li></ul></li></ul><!-- nabar right--><ul class=\"nav navbar-nav navbar-right\"><li><a class=\"navbar-brand text-lt\"><span class=\"hidden-folded m-l-xs\">Тариф 2,8%</span></a></li><li><a class=\"navbar-brand text-lt\"><span class=\"hidden-folded m-l-xs\">{{app.uc.name}}</span></a></li><li><a data-toggle=dropdown aria-expanded=false ui-sref=app.profile.view class=\"user-profile dropdown-toggle\">{{app.ua.username}}</a></li><li><a ng-click=app.logOut()><i class=\"fa fa-sign-out pull-right\"></i> exit</a></li></ul></div></header><!-- content--><div id=content role=main class=app-content><div class=app-content-body><ui-view></ui-view></div></div><!-- footer--><footer id=footer role=footer class=app-footer><div class=\"wrapper b-t bg-light\"><span class=pull-right>1.3.6<a href=\"\" ui-scroll=app class=\"m-l-sm text-muted\"><i class=\"fa fa-long-arrow-up\"></i></a></span> © 2018 Copyright.</div></footer><!-- / footer--></div>");
$templateCache.put("app/menu/item.html","<!--\nCreated by Aibek on 13/06/16.\n\n--><div class=container><panel title=\"{{item.menu._id ? &quot;Изменть&quot;:&quot;Добавить&quot;}}\"><form ng-submit=item.putMenu() class=form-horizontal><div class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Родитель</label></div><div class=\"col col-md-10\"><ui-select ng-model=item.menu.parent_id ng-disabled=item.children.length&gt;0 theme=bootstrap remove-selected=false><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"menu._id as menu in (menu.menus | filter:{name:$select.search} | filter: menu.filterOnlyParents | orderBy:&quot;data.position&quot;) track by menu._id\" ui-disable-choice=\"menu._id==item.menu._id\">{{menu.name}}</ui-select-choices></ui-select></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Наименование</label></div><div class=\"col col-md-10\"><input type=text ng-model=item.menu.name ng-required=true ng-trim=true class=form-control></div></div></div><div ng-hide=item.disabled class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Путь</label></div><div class=\"col col-md-10\"><input type=text ng-model=item.menu.data.route class=form-control></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Позиция</label></div><div class=\"col col-md-10\"><input type=number ng-model=item.menu.data.position ng-required=true class=form-control></div></div></div><div class=form-group><div class=row><div class=\"col-md-2 text-right\"><label>Иконка</label></div><div class=\"col col-md-10\"><div ng-class=\"{&quot;input-group&quot;: item.menu.data.icon}\"><div class=input-group-btn><button ng-if=item.menu.data.icon class=\"btn btn-default\"><i ng-class=item.menu.data.icon></i></button></div><input type=text ng-model=item.menu.data.icon class=form-control></div></div></div></div><button ng-if=item.menu._id class=\"btn btn-primary btm-sm\">Сохранить</button> <button ng-if=!item.menu._id class=\"btn btn-primary btm-sm\">Добавить</button> <button ng-if=\"item.menu._id &amp;&amp; item.menu.children.length==0\" ng-click=item.deleteMenu(item.menu) class=\"btn btn-danger btm-sm\">Удалить</button></form></panel></div>");
$templateCache.put("app/menu/menu.html","<!--\nCreated by Aibek on 13/06/16.\n\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Меню</div><div class=panel-body><div class=row><div class=\"col col-md-2 col-sm-3\"><div class=row><div class=\"col col-md-12\"><button ui-sref=app.menu.item({id:&quot;new&quot;}) class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-click=menu.getMenus() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></div><div ng-repeat=\"menu_item in menu.menus | filter: menu.filterOnlyParents | orderBy : &quot;data.position&quot;\" class=list-group><a ui-sref=app.menu.item({id:menu_item._id}) class=list-group-item>{{menu_item.data.position}}) {{menu_item.name}}</a><a ui-sref=app.menu.item({id:child._id}) ng-repeat=\"child in menu.menus | filter:{parent_id:menu_item._id} | orderBy : &quot;data.position&quot;\" class=list-group-item>&#9;{{child.data.position}}. {{child.name}}</a></div></div><div class=\"col col-md-10 col-sm-9\"><ui-view></ui-view></div></div></div></div></div>");
$templateCache.put("app/modals/confirmation-dialog.html","<!--Created by troy on 30.11.2016.\n--><div class=container><div class=\"panel panel-default\"><div class=panel-heading>Окно подтверждения!</div><div class=panel-body>Вы уверены {{policy_dialog.text.text}}</div><div class=panel-footer><button id=delete type=button ng-click=policy_dialog.ok() class=\"btn btn-success\">ДА</button> <button type=button ng-click=policy_dialog.cancel() class=\"btn btn-primary\">НЕТ</button></div></div></div>");
$templateCache.put("app/modals/dialog_parameter.html","<!--Created by troy on 15.12.2016.\n--><div class=container><form ng-submit=term_dialog.ok() class=from-horizontal><div class=\"panel panel-default\"><div class=panel-heading>Окно подтверждения!</div><div class=panel-body><h5>Вы уверены {{term_dialog.text.text}}</h5><div class=form-group><label for=money>Возвращаемая сумма:</label><input id=money type=number ng-model=term_dialog.moneyBack min=0 step=0.01 ng-required=true class=form-control></div></div><div class=panel-footer><button id=delete type=submit class=\"btn btn-success\">Расторгнуть</button> <button type=button ng-click=term_dialog.cancel() class=\"btn btn-primary\">Нет</button></div></div></form></div>");
$templateCache.put("app/modals/search-product.html","<!--Created by jaynakus on 7/18/16.\n--><div class=modal-header><h3>Поиск</h3></div><div class=modal-body><input ng-keyup=pressed($event) ng-model=query ng-model-options={debounce:200} placeholder=Поиск autofocus class=form-control><paged-table id=search options=gridOptions disable-search=true></paged-table><div class=clearfix></div></div><div class=modal-footer><button ng-click=cancel() class=\"btn btn-primary\">Отмена</button> <button ng-click=ok() class=\"btn btn-success\">OK</button></div>");
$templateCache.put("app/news/form.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Создание новости</div><div class=panel-body><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_content><form id=news-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Дата</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup ng-click=\"form.search.popup_to_date.opened=true\" ng-model=form.newsItem.create_date is-open=form.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"form.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div stock-dict=form.sectionsofpublication dict-table=Sectionsofpublication class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Раздел публикации</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><ui-select ng-model=form.newsItem.sectionsofpublication_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in form.sectionsofpublication\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text id=name_ru name=name_ru required ng-model=form.newsItem.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Описание<span class=required>*</span></label><div class=\"col-md-8 col-sm-8 col-xs-12\"><wysiwyg-edit content=form.newsItem.description ng-model=form.newsItem.description required></wysiwyg-edit></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Ссылка</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><textarea id=link name=link width=100 height=80 ng-model=form.newsItem.link class=\"form-control col-md-7 col-xs-12\"></textarea></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Актив<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=checkbox><label><input type=checkbox checked ng-model=form.newsItem.is_active class=flat></label></div></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=form.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=form.saveNews() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div></div>");
$templateCache.put("app/news/list.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Новости и публикации</div><div class=panel-body><form id=news-form><div class=row><col-responsive><div class=form-group><label class=control-label>Наименование</label><input type=text ng-model=list.searchValues.name class=form-control></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Актив</label><select ng-model=list.searchValues.is_active class=form-control><option value=all>Все</option><option value=yes>Активные</option><option value=no>Неактивные</option></select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label class=control-label>Дата создания от</label><div class=\"input-group no-margin\"><input type=text name=valid_from ng-model=list.searchValues.created_from uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened1 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label class=control-label>Дата создания до</label><div class=\"input-group no-margin\"><input type=text name=valid_to ng-model=list.searchValues.created_to uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened2 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened2 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=\"wrapper ln_solid\"></div><button type=button ng-click=list.getNews() class=\"btn btn-primary btn-xs\">Найти</button> <button type=button ng-click=list.openCreateForm() class=\"btn btn-primary btn-xs\">Добавить</button> <button type=button ng-click=list.openEditForm() ng-disabled=\"list.selected_news == null\" class=\"btn btn-primary btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button type=button ng-click=list.removeNews() ng-disabled=\"list.selected_news == null\" class=\"btn btn-primary btn-xs\"><span>Удалить</span></button><div class=\"wrapper ln_solid\"></div><paged-table options=list.gridOptions disable-search=false></paged-table></form></div></div></div>");
$templateCache.put("app/news/uploadimage.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Загрузить картинку</h2><div class=clearfix></div></div><div class=x_content><form id=image-upload-form class=\"form-horizontal form-label-left\"><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Выберите картинку<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><label class=\"btn btn-default btn-file\"><input type=file id=file name=file ng-model=uploadimage.newsItem.image hidden></label></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=uploadimage.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=uploadimage.saveImage() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/news/view.html","<!--Created by admin on 30.08.2016.\n--><div class=\"form-group form-group-sm\"><button ui-sref=app.dashboard title=Назад class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-chevron-left margin-right-8\"><span>Назад</span></span></button></div><panel title={{view.document.name}}><div class=container><div class=\"col-sm-10 col-md-10\"><div class=row><div class=form-group><div class=\"col-sm-8 col-md-8\"><p>Создано: <time class=comment-date>{{view.document.created_date | amDateFormat:\'DD MMM YYYY HH:mm\'}}</time></p><h4>Тема: {{view.document.name}}</h4><div dynamic=view.document.description></div></div></div></div></div></div><div class=row><a ng-click=view.toTheTop() title=Наверх class=\"pull-right toTheTop\"><h1><span class=\"glyphicon glyphicon-hand-up\"></span></h1></a></div></panel>");
$templateCache.put("app/operation/operation.html","<!--\nCreated by Aibek on 26/07/16.\n\n--><panel title=Операции><button ng-click=operation.getOperations() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=operation.gridOptions disable-search=true></paged-table></panel>");
$templateCache.put("app/operation/view.html","<!--Created by Aibek on 25/08/16.\n--><div class=modal-header><h3>Операция</h3></div><div class=modal-body><div class=row-striped><div class=row><div class=\"col col-xs-12 col-md-4\">Филал</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.branch.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доукмент</div><div class=\"col col-xs-12 col-md-8\"><a ui-sref=app.docs.view({id:view.operation.document_id})>{{view.operation.document.title}}</a><p class=small>{{view.operation.document.short_desc}}</p></div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Продукт</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.product.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Единица измерения</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.unit.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Количество</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.quantity | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Валюта</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.currency.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Стоимость</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.quote_unit_price | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Сумма</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.total_cost | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доп. стоимотсь</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.additional_cost | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Статус операции</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.operation_status_value.data.name}}</div></div><div ng-if=view.operation.branch2 class=row><div class=\"col col-xs-12 col-md-4\">Филал назначения</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.branch2.name}}</div></div><div ng-if=view.operation.contractor class=row><div class=\"col col-xs-12 col-md-4\">Контрагент</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.contractor.name}}</div></div><div ng-if=view.operation.is_due class=row><div class=\"col col-xs-12 col-md-4\">В долг</div><div class=\"col col-xs-12 col-md-8\"><input type=checkbox ng-model=view.operation.is_due></div></div><div ng-if=view.operation.is_due class=row><div class=\"col col-xs-12 col-md-4\">Дата выплаты</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.due_date | amDateFormat:\"Do MMMM YYYY\"}}</div></div><div ng-if=view.operation.is_advance class=row><div class=\"col col-xs-12 col-md-4\">Аванс</div><div class=\"col col-xs-12 col-md-8\"><input type=checkbox ng-model=view.operation.is_advance></div></div><div ng-if=view.operation.employee class=row><div class=\"col col-xs-12 col-md-4\">Сотрудник</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.employee.user.username}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Комметарий</div><div class=\"col col-xs-12 col-md-8\">{{view.operation.comment}}</div></div></div></div><div class=modal-footer><button ng-click=view.cancel() class=\"btn btn-default btn-sm\">Закрыть</button></div>");
$templateCache.put("app/payment/edit.html","<!--Created by Aibek on 25/08/16.\n--><form ng-submit=edit.savePayment()><div class=modal-header><h3>Платеж</h3></div><div class=modal-body><div class=form-horizontal><div class=row><col-responsive><div stock-dict=edit.branches dict-table=Branches class=form-group><label>Филиал</label><ui-select ng-model=edit.payment.branch_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"branch._id as branch in edit.branches track by branch._id\">{{branch.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.currencies dict-table=Currencies class=form-group><label>Валюта</label><ui-select ng-model=edit.payment.currency_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"currency._id as currency in edit.currencies track by currency._id\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.payment_directions dict-table=Enums dict-filter={name:&quot;payment_direction&quot;} class=form-group><label>Направление платежа</label><ui-select ng-model=edit.payment.payment_direction ng-required=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"payment_direction.data.key as payment_direction in edit.payment_directions track by payment_direction.data.key\">{{payment_direction.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div stock-dict=edit.payment_types dict-table=Enums dict-filter={name:&quot;payment_type&quot;} class=form-group><label>Тип платежа</label><ui-select ng-model=edit.payment.payment_type ng-required=true><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"payment_type.data.key as payment_type in edit.payment_types track by payment_type.data.key\">{{payment_type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Сумма</label><input type=number step=0.01 min=0 ng-model=edit.payment.amount ng-required=true class=form-control></div></col-responsive><col-responsive><div ng-class={&quot;has-error&quot;:payment.contractor_error} class=form-group><label>Контрагент</label><contractor-select contractor-id=edit.payment.data.contractor_id></contractor-select></div></col-responsive><col-responsive><div ng-class={&quot;has-error&quot;:payment.employee_error} class=form-group><label>Сотрудник</label><employee-select employee-id=edit.payment.data.employee_id></employee-select></div></col-responsive><col-responsive><div stock-dict=edit.branches dict-table=Branches ng-class={&quot;has-error&quot;:payment.branch_error} class=form-group><label>Филиал назначения</label><ui-select ng-model=edit.payment.data.branch_id ng-required=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"branch._id as branch in edit.branches track by branch._id\">{{branch.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Комментарий</label><textarea ng-model=edit.payment.data.comment ng-trim=true class=form-control></textarea></div></col-responsive></div></div></div><div class=modal-footer><button ng-disabled=\"edit.saving===true\" type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=\"edit.saving===true\" type=button ng-click=edit.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/payment/payment.html","<!--\nCreated by Aibek on 26/07/16.\n\n--><panel title=Платежи><button ng-click=payment.newPayment() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!payment.selected_payment ng-click=payment.editPayment() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=payment.getPayments() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=payment.gridOptions disable-search=true></paged-table></panel>");
$templateCache.put("app/payment/view.html","<!--Created by Aibek on 25/08/16.\n--><div class=modal-header><h3>Платеж</h3></div><div class=modal-body><div class=row-striped><div class=row><div class=\"col col-xs-12 col-md-4\">Филал</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.branch.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Доукмент</div><div class=\"col col-xs-12 col-md-8\"><a ui-sref=app.docs.view({id:view.payment.document_id})>{{view.payment.document.title}}</a><p class=small>{{view.payment.document.short_desc}}</p></div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Валюта</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.currency.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Сумма</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.amount | number:2}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Дата платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_date | amDateFormat: \'Do MMMM YYYY\'}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Направление платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_direction_value.data.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Тип платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_type_value.data.name}}</div></div><div class=row><div class=\"col col-xs-12 col-md-4\">Статус платежа</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.payment_status_value.data.name}}</div></div><div ng-if=view.payment.branch2 class=row><div class=\"col col-xs-12 col-md-4\">Филал назначения</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.branch2.name}}</div></div><div ng-if=view.payment.contractor class=row><div class=\"col col-xs-12 col-md-4\">Контрагент</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.contractor.name}}</div></div><div ng-if=view.payment.employee class=row><div class=\"col col-xs-12 col-md-4\">Сотрудник</div><div class=\"col col-xs-12 col-md-8\">{{view.payment.employee.user.username}}</div></div></div></div><div class=modal-footer><button ng-click=view.cancel() class=\"btn btn-default btn-sm\">Закрыть</button></div>");
$templateCache.put("app/policy/form.html","<!--\nCreated by troy on 24.11.2016.\n\n--><div class=container><!--pre {{forming.policy.insurance_data|json}}--><div class=row><div class=col-md-12><button type=button ui-sref=app.policy class=\"btn btn-warning\">Выход</button> <button type=button ng-click=forming.confirmActionSave() ng-disabled=\"!forming.policy.insurance_premium || forming.policy.insurance_premium &lt;= 0\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Возобновить</button></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{forming.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{forming.policy.client}}</span></h5></div></div><div class=row><div class=col-md-10><h5>Номер кредита:<span class=text-info> {{forming.policy.credit_no}}</span></h5></div><div class=col-md-2></div></div><div class=row><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=forming.today max-date=forming.policy.date_end ng-change=forming.recalculateOnEventAll() ng-click=\"forming.search.popup_to_date.opened1=true\" ng-model=forming.policy.date_start is-open=forming.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"forming.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=forming.isAnnual uib-datepicker-popup=dd.MM.yyyy min-date=forming.policy.date_start max-date=forming.finish_date ng-change=forming.recalculateOnEventAll() ng-click=\"forming.search.popup_from_date.opened=true\" ng-model=forming.policy.date_end is-open=forming.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=forming.isAnnual ng-click=\"forming.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{forming.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{forming.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{forming.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=forming.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in forming.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=forming.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in forming.policy.insurance_data.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=forming.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in forming.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/policy/issue.html","<!--\nCreated by ilias on 07.10.2016.\n\n--><div class=container><form ng-submit=issue.confirmAction() class=from-horizontal><div class=row><div class=col-md-10><button type=button ui-sref=app.apolicy.select class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Изменить полис</button><div class=\"panel panel-default\"><div class=panel-heading><h2 style=display:inline>Ваш страховой полис</h2></div><!--.panel-body(stock-dict=\'issue.currencies\' dict-table=\'Currencies\')--><div class=panel-body><table class=\"table table-striped\"><thead></thead><tbody><tr><td>Страховщик</td><td>{{issue.product.company[0].name}}</td></tr><tr ng-if=\"issue.company.company_type == \'agent\'\"><td>Агент страховой компании</td><td>{{issue.company.name}} Телефон {{issue.company.data.phones[0]}}</td></tr><tr><td>Период действия страхового полиса</td><td>с {{issue.product.tmp_product.date_start | date:\'dd-MM-yyyy\'}} по {{issue.product.tmp_product.date_end | date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Продукт</td><td>{{issue.product.name}}</td></tr><tr><td>Страна поездки</td><td><span ng-repeat=\"x in issue.countriesView\">{{x.name}} <mark>({{x.data.name_eng}})</mark></span></td></tr><tr><td>Страховая сумма</td><td><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><label ng-if=\"issue.min_insurance!=null\">{{issue.product.insurance_amount}}<span> {{issue.currency_name}}</span></label><label ng-if=\"issue.min_insurance==null\">0</label><a data-toggle=collapse data-target=#collapse1 ng-click=issue.pdrobneeIconCnange() style=cursor:pointer class=pull-right><i ng-class=issue.pdrobneeIcon aria-hidden=true></i> Сервисы</a></h4></div><div id=collapse1 class=\"panel-collapse collapse\"><div class=panel-body><ul><li ng-repeat=\"x in issue.product.services\"><span>{{x.name}}</span></li></ul></div></div></div></td></tr><tr ng-repeat=\"x in issue.insurants\"><td>Стоимость страхового полиса ({{$index+1}}-го)</td><td><h4 ng-if=\"x.theprice!=null\">{{x.theprice}} {{issue.currency_name}} / {{(x.theprice * issue.currencyRate).toFixed(2)}} KGS</h4><span class=small>(курс валют: 1 {{issue.currency_name}}: {{issue.currencyRate}} KGS)</span><h4 ng-if=\"x.theprice==null\">0</h4></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-md-10><div class=\"panel panel-default\"><div class=panel-heading><h2>Путешественники (застрахованные)</h2></div><div class=panel-body><div ng-repeat=\"x in issue.insurants\" class=row><div class=col-md-5><div class=row><div class=col-md-6><div class=form-group><label>Фамилия<br><em>Латиницей</em></label><input type=text ng-model=x.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-6><div class=form-group><label>Имя<br><em>Латиницей</em></label><input type=text ng-model=x.name ng-required=true ng-trim=true class=form-control></div></div></div></div><div class=col-md-2><div class=form-group><label><br>Паспорт №</label><input type=text ng-model=x.passport_no ng-trim=true class=form-control></div></div><div class=col-md-5><div class=form-group><label><br>Дата рождения</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=issue.reCompute(x) max-date=issue.today uib-datepicker-popup=dd.MM.yyyy ng-model=x.date_of_birth is-open=x.isOpen close-text=Закрыть current-text=Сегодня clear-text=Очистить ng-required=true class=form-control><span class=input-group-btn><button type=button ng-click=\"x.isOpen = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span><span class=input-group-btn> <button style=\"margin-left: 20px\" ng-click=issue.deleteInsurant($index) type=button class=\"btn btn-danger\"><i aria-hidden=true class=\"fa fa-times\"></i></button></span><span class=input-group-btn> <button style=\"margin-left: 20px\" ng-click=issue.changeIcon($index) popover-trigger=click popover-placement=bottom uib-popover-template=&quot;myPopoverTemplate.html&quot; popover-title=\"Условия страховки\" type=button class=\"btn btn-info\"><i style=\"font-size: 130%\" aria-hidden=true class={{issue.iconsList[$index]}}></i> Условия</button></span></div></div></div></div><div class=row><div class=col-md-2><button type=button ng-click=issue.addInsurant() class=\"btn btn-default\"><i aria-hidden=true class=\"fa fa-plus\"></i> Добавить путешественника</button></div></div></div></div></div></div><div class=row><div class=col-md-10><div class=\"panel panel-default\"><div class=panel-heading><h2>Покупатель (страхователь)</h2></div><div class=panel-body><div class=row><div class=col-md-2><div class=form-group><label>Фамилия<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.surname ng-required=true ng-trim=true class=form-control></div></div><div class=col-md-2><div class=form-group><label>Имя<br><em>Кирилицей</em></label><input type=text ng-model=issue.buyer.name ng-required=true ng-trim=true class=form-control></div></div><!--.col-md-3--><!--  .form-group--><!--    label--><!--      br--><!--      | Электронная почта--><!--    input.form-control(type=\'email\' ng-model=\"issue.buyer.email\" ng-required=\'true\' ng-trim=\'true\')--><!----><!--.col-md-3--><!--  .form-group--><!--    label--><!--      br--><!--      | Телефон--><!--    input.form-control(type=\'text\' ui-mask=\"0(999)999-999\" ng-model=\"issue.buyer.phone\" ng-required=\'true\' ng-trim=\'true\')\n              //.input-group.no-margin\n              //  span.input-group-btn\n              //    button.btn.btn-default(type=\"button\", ng-click=\"select.popup_delivery_date.opened=true\")\n              //      i.glyphicon.glyphicon-calendar\n              //  input.form-control(type=\"text\", ng-model=\'select.a\', uib-datepicker-popup=\"dd-MM-yyyy\", is-open=\"profile.popup_delivery_date.opened\", close-text=\"Закрыть\", current-text=\'Сегодня\', clear-text=\'Очистить\')\n              //  span.input-group-btn\n              //    button.btn.btn-default(type=\"button\" style=\"margin-left: 20px; width: 50px;\")\n              //      i.fa.fa-plus(aria-hidden=\'true\')\n              \n              --></div></div></div><div class=row><button type=submit class=\"btn btn-primary btn-sm pull-right\">Оформить полис</button></div></div></div></form></div><script type=text/ng-template id=myPopoverTemplate.html><div style=\"width: 350px;\">\n    <ul class=\"list-group\">\n      <li ng-repeat=\"factor in x.factorListing\" ng-if=\"factor.name != \'Возраст\'\" class=\"list-group-item\"><a ng-if=\"factor.description != null &amp;&amp; service.data.description != \'\'\"><i uib-tooltip=\"{{factor.description}}\" class=\"fa fa-info-circle\"></i></a><a id=\"headingOne{{$index}}\" role=\"tab\" data-toggle=\"collapse\" data-parent=\"#accordion1\" data-target=\"#collapseOnefer{{$index}}\" aria-expanded=\"false\" aria-controls=\"collapseOne\" style=\"cursor:pointer;\" class=\"panel-heading collapsed\"><i aria-hidden=\"true\" style=\"color: #2f3233; font-size: 130%;\" class=\"fa fa-chevron-down\"></i> {{factor.name}}\n          <mark><span style=\"text-decoration-color: red; text-decoration-line: underline; text-decoration-style: dotted;\">: {{x.factors[factor.name]}}</span></mark></a>\n        <div id=\"collapseOnefer{{$index}}\" role=\"tabpanel\" aria-labelledby=\"headingOne\" aria-expanded=\"false\" style=\"height: 0px;\" class=\"panel-collapse collapse\">\n          <div class=\"panel-body\">\n            <div class=\"container\">\n              <div class=\"form-group\">\n                <ui-select ng-model=\"x.factors[factor.name]\" on-select=\"issue.reCompute(x)\" ng-required=\"true\" class=\"form-control\">\n                  <ui-select-match placeholder=\"Выберите из списка\">{{$select.selected}}</ui-select-match>\n                  <ui-select-choices repeat=\"type in factor.values | orderBy\">{{type}}</ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n          </div>\n        </div>\n      </li>\n    </ul>\n  </div></script>");
$templateCache.put("app/policy/new.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"panel panel-default\"><div class=panel-heading><h2>Туристическая страховка</h2></div><div class=panel-body></div><div class=row><div stock-dict=policies.countries dict-table=Countries class=col-md-10><div class=form-group><label>Территория</label><ui-select ng-model=policies.pruduct.country_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}} <mark>({{$item.data.name_eng}})</mark></ui-select-match><ui-select-choices repeat=\"type._id as type in policies.countries| filterCountries:$select.search | orderBy:&quot;name&quot;\">{{type.name}} <mark>({{type.data.name_eng}})</mark></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-5><div class=form-group><label>Туда</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.today max-date=policies.pruduct.date_end ng-model=policies.pruduct.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-md-5><div class=form-group><label>Обратно</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-change=policies.getDiffDays() uib-datepicker-popup=dd.MM.yyyy min-date=policies.pruduct.date_start ng-model=policies.pruduct.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-md-4><div class=form-group><label>Количество дней</label><input type=text ng-model=policies.diffDays readonly class=form-control></div></div></div><div class=row><div class=col-md-10><div class=form-group><label style=\"visibility: hidden\">asdfsdf</label><div class=input-group><button ng-click=policies.goToSelect(policies.pruduct) type=button class=\"btn btn-primary\">Найти страховку</button></div></div></div></div></div>");
$templateCache.put("app/policy/policy.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Полисы</div><div class=panel-body><form ng-submit=policy.getPolicies()><div class=row><col-responsive stock-dict=policy.policy_statuses dict-table=Enums dict-filter={name:&quot;policy_status&quot;}><div class=form-group><label>Статус:</label><ui-select ng-model=policy.filter.policy_status ng-required=true class=form-control><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"status.data.key as status in policy.policy_statuses track by status.data.key\">{{status.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер полиса:</label><input type=text ng-model=policy.filter.policy_no placeholder=\"Введите номер полиса\" class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=policy.filter.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=policy.filter.date_start ng-click=\"policy.search.popup_to_date.opened=true\" is-open=policy.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policy.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=policy.filter.date_start ng-model=policy.filter.date_end ng-click=\"policy.search.popup_from_date.opened=true\" is-open=policy.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policy.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"policy.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=\"wrapper ln_solid\"></div><button type=button ng-click=policy.goToNew() class=\"btn btn-primary btn-xs\">Добавить</button> <button ng-click=policy.goToShow() ng-disabled=!policy.selected_policy class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button><!--//button.btn.btn-default.btn-sm(ng-click=\'policy.delete()\' ng-disabled=\"!policy.selected_policy\")--> <button ng-click=policy.confirmAction() ng-show=\"app.ua.role == 10\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-remove margin-right-8\"></span><span>Удалить</span></button> <button type=button ng-click=policy.downloadPDF() ng-disabled=\"!policy.selected_policy || policy.selected_policy.policy_no == \'00000\' || (policy.selected_policy.data.status != \'Оформлен\' &amp;&amp; policy.selected_policy.data.status != \'Истек\')\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-default.btn-xs(type=\'button\' ng-click=\"policy.savePDF()\" ng-disabled=\"!policy.selected_policy || policy.selected_policy.policy_no == \'00000\' || (policy.selected_policy.data.status != \'Оформлен\' && policy.selected_policy.data.status != \'Истек\')\")--><!--  i.fa.fa-print(aria-hidden=\'true\')--><!--  |   Скачать pdf--> <button type=button ng-click=policy.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><div class=\"wrapper ln_solid\"></div><paged-table options=policy.policiesGridOptions disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/policy/select.html","<!--Created by Ilyas on 1.03.2018.\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Создание полиса</div><div class=panel-body><div class=row><col-responsive><div class=form-group><label>Страхователь</label><input type=text ng-model=select.policy.client required class=form-control></div></col-responsive></div><div class=row><col-responsive stock-dict=select.products dict-table=Product><div class=form-group><label>Наименование программы кредитования</label><ui-select ng-model=select.policy.product_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in select.products track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Номер кредитного договора</label><input type=text ng-model=select.policy.credit_no class=form-control></div></col-responsive><col-responsive stock-dict=select.currencies dict-table=Currencies><div class=form-group><label>Валюта</label><ui-select ng-model=select.currency class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"currency as currency in select.currencies\">{{currency.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Тип периода страхования</label><select ng-model=select.insurance_period_type ng-change=select.onPeriodTypeChange() class=form-control><option value=up_to_year>До года</option><option value=year>Год</option><option value=over_year>Свыше года</option></select></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Период страхования от</label><div class=\"input-group no-margin\"><input type=text name=datemask uib-datepicker-popup=dd.MM.yyyy min-date=select.today max-date=select.policy.date_end ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_to_date.opened1=true\" ng-model=select.policy.date_start is-open=select.search.popup_to_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"select.search.popup_to_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Период страхования до</label><div class=\"input-group no-margin\"><input type=text name=datemask ng-disabled=select.period_disabled uib-datepicker-popup=dd.MM.yyyy min-date=select.policy.date_start ng-change=select.recalculateOnEventAll() ng-click=\"select.search.popup_from_date.opened=true\" ng-model=select.policy.date_end is-open=select.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-disabled=select.period_disabled ng-click=\"select.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div ng-show=\"select.insurance_period_type == &quot;over_year&quot;\" class=row><col-responsive><div class=form-group><label>Количество лет (можно дробное, например 1.5)</label><input type=number ng-model=select.full_years min=1 step=0.1 ng-change=select.onFullYearsChange() class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label ng-show=\"select.insurance_period_type == &quot;up_to_year&quot;\">Количество дней: {{select.diffDays}}</label><label ng-show=\"select.insurance_period_type == &quot;year&quot;\">Период: 1 год (365 дней)</label><label ng-show=\"select.insurance_period_type == &quot;over_year&quot;\">Период: {{select.full_years}} {{select.getYearLabel()}} ({{select.getTotalDays()}} дней)</label></div></col-responsive></div><div class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-info\"><div class=panel-heading><strong><big>СТРАХОВАНИЕ ТРАНСПОРТНЫХ СРЕДСТВ</big></strong></div><div class=panel-body><form ng-submit=select.addCollateralTs(select.insuranceformts)><div class=row><col-responsive><div class=form-group><label>Объект страхования (Тип ТС)</label><ui-select ng-model=select.insuranceformts.objectts ng-required=true ng-change=select.onVehicleTypeChange() class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"object as object in select.insuranceobjectsts track by object._id\">{{object.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Марка, модель ТС</label><input type=text ng-model=select.insuranceformts.model ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Гос. регистрационный №</label><input type=text ng-model=select.insuranceformts.gosnumber ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Номер кузова/ шасси</label><input type=text ng-model=select.insuranceformts.number ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=select.car_year_issue dict-table=Enums dict-filter={name:&quot;year_issue&quot;}><div class=form-group><label>Год выпуска</label><ui-select ng-model=select.insuranceformts.year_issue ng-required=true ng-trim=true ng-change=select.validateVehicleAge() class=form-control><ui-select-match>{{$select.selected.data.key}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in select.car_year_issue\">{{type.data.key}}</ui-select-choices></ui-select><small ng-show=select.vehicleAgeError class=text-danger>Принимаются ТС не старше 15 лет (не младше {{select.minYear}} года выпуска)</small></div></col-responsive><col-responsive><div class=form-group><label>Территория страхования</label><input type=text ng-model=select.insuranceformts.adres ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая сумма</label><input type=number ng-model=select.insuranceformts.insurance_summ ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Действительная стоимость</label><input type=number ng-model=select.insuranceformts.coll_price ng-required=true ng-trim=true min=0 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Страховая премия</label><input type=number ng-model=select.insuranceformts.insurance_premium ng-required=true ng-trim=true disabled class=form-control></div></col-responsive><div class=\"col col-xs-12 col-sm-8 col-md-8\"><div class=form-group><label>Уполномоченные водители</label><input type=text ng-model=select.insuranceformts.driver disabled class=form-control></div></div></div><div class=row><col-responsive><div class=form-group><button type=button ng-click=select.calculatePremiumTs() class=\"btn btn-default\">Раcсчитать</button> <button type=submit class=\"btn btn-info btn-addon\"><i class=\"fa fa-plus\"></i> Добавить</button></div></col-responsive></div></form><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in select.collateralsts.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.coll_price | number:2}}</td><td>{{c.insurance_premium | number:2}}</td><td><button uib-tooltip=Удалить ng-click=\"select.deleteCollateralTs(c, $index)\" class=\"btn btn-sm btn-icon btn-danger\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></div></div><div class=row><col-responsive><div class=form-group><label>Общая страховая сумма: {{select.policy.insurance_amountts | number:2}}</label><br><label>Общая страховая премия: {{select.policy.insurance_premiumts | number:2}}</label></div></col-responsive></div><br></div></div></div></div><div class=row><div class=\"col-md-12 col-sm-12\"><div class=\"panel panel-info\"><div class=panel-heading><strong><h4>Счет на оплату</h4></strong></div><div class=panel-body><div class=row><col-responsive><div class=form-group><label>Кому (получатель платежа)</label><input type=text ng-model=select.policy.client placeholder=Страхователь disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>ИНН получателя</label><input type=text ng-model=select.payment_data.inn placeholder=\"Индивидуальный номер налогоплательщика\" class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Номер счета</label><input type=text ng-value=select.getInvoiceNumber() placeholder=\"Номер счета\" disabled class=form-control></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Сумма к оплате</label><input type=number ng-model=select.payment_data.amount disabled class=form-control></div></col-responsive></div></div></div></div></div><div class=row><div class=form-group><button ng-disabled=select.saving type=button ui-sref=app.policy class=\"btn btn-default m-t\">Отмена</button> <button ng-disabled=\"select.collateralsts.ts.length == 0\" type=button ng-click=select.savePolicy() class=\"btn btn-success m-t\">Сохранить</button></div></div></div></div></div>");
$templateCache.put("app/policy/show.html","<!--\nCreated by troy on 07.10.2016.\n\n--><div class=\"wrapper lter b-b\"><div class=panel><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"show.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span> <input id=foo value={{show.policy.policy_no}} ng-disabled=true> <button ngclipboard=\"\" data-clipboard-target=#foo class=btn><i alt=\"Copy to clipboard\" class=\"fa fa-copy\"></i></button></h4></div><div class=panel-body><div class=row><div class=col-md-10><h5>ФИО страхователя:<span class=text-info> {{show.policy.client}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Номер кредита:<span class=text-info> {{show.policy.credit_no}}</span></h5></div><div class=col-md-8><h5>Наименование программы кредитования:<span class=text-info>{{show.policy.product}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{show.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{show.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{show.policy.insurance_amount | number:2}}</span></h5></div><div class=col-md-4><h5>Страховая премия :<span class=text-info> {{show.policy.insurance_premium | number:2}}</span></h5></div><div class=col-md-4><h5>Валюта :<span class=text-info> {{show.policy.data.currency.name}}</span></h5></div></div><div class=ln_solid></div><div ng-show=show.policy.insurance_data.ned class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Собственник</th><th>Объект страхования</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ned\"><td>{{c.owner}}</td><td>{{c.object}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ts class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Объект страхования</th><th>Марка, модель ТС</th><th>Гос. регистрационный №;</th><th>Номер кузова/ шасси</th><th>Год выпуска</th><th>Территория страхования</th><th>Страховая сумма</th><th>Действительная стоимость</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ts\"><td>{{c.object}}</td><td>{{c.model}}</td><td>{{c.gosnumber}}</td><td>{{c.number}}</td><td>{{c.year_issue |date:\'dd-MM-yyyy\'}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ}}</td><td>{{c.coll_price}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div><div ng-show=show.policy.insurance_data.ln class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped b-t b-light table-hover table-bordered data-he\"><thead><tr><th>Застрахованное лицо</th><th>Дата рождения</th><th>Документ удостоверяющий личность</th><th>Территория страхования</th><th>Страховая сумма</th><th>Страховая премия</th></tr></thead><tbody><tr ng-repeat=\"c in show.policy.insurance_data.ln\"><td>{{c.client}}</td><td>{{c.birthday |date:\'dd-MM-yyyy\' }}</td><td>{{c.pasport}}</td><td>{{c.adres}}</td><td>{{c.insurance_summ | number:2}}</td><td>{{c.insurance_premium | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=panel-footer><button type=button ng-click=show.cancel() class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=show.downloadPDF() ng-if=\"show.policy.policy_no != \'00000\' &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"show.policy.policy_no == \'00000\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button><!--button.btn.btn-default.pull-right(type=\'button\'  ng-click=\"show.goToForm()\" ng-if=\"show.policy.data.status && show.policy.data.status == \'Истек\'\" ng-disabled=\"show.policy.data.status != \'Истек\'\")--><!--  i.fa.fa-refresh(aria-hidden=\'true\')--><!--  |   Возобновить--> <button type=button ng-click=show.confirmAction() ng-if=\"show.policy.data.status &amp;&amp; show.policy.data.status == \'Оформлен\'\" ng-disabled=\"!show.policy.data.status || show.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=show.goToForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=show.confirmActionForm() ng-if=\"show.policy.data.status != \'Истек\' &amp;&amp; show.policy.data.status != \'Оформлен\' &amp;&amp; show.policy.data.status != \'Испорчен\' &amp;&amp; show.policy.data.status != \'Расторгнут\'\" ng-disabled=\"show.policy.data.status == \'Оформлен\' || show.policy.data.status == \'Испорчен\'|| show.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/policy/view.html","<div class=container><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-md-12><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Сохранен\'\" class=\"alert alert-info\"><strong>Полис сохранен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Испорчен\'\" class=\"alert alert-danger\"><strong>Полис испорчен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Расторгнут\'\" class=\"alert alert-danger\"><strong>Полис расторгнут</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Оформлен\'\" class=\"alert alert-success\"><strong>Полис оформлен</strong></div><div style=\"color: black\" ng-if=\"view.policy.data.status == \'Истек\'\" class=\"alert alert-warning\"><strong>Полис истек</strong></div></div></div></div><div class=panel-body><div class=col-md-12><div class=\"panel panel-default\"><div class=panel-heading><h4 style=display:inline-block><span>Номер полиса:</span><span class=\"label label-default\">{{view.policy.policy_no}}</span></h4></div><div class=panel-body><div class=row><div class=col-md-4><h5>Начало :<span class=text-info> {{view.policy.insurance_data.date_start|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-5><h5>Конец :<span class=text-info> {{view.policy.insurance_data.date_end|date:\'dd-MM-yyyy\'}}</span></h5></div></div><div class=row><div class=col-md-4><h5>Страховая сумма :<span class=text-info> {{view.policy.insurance_amount}} {{view.currency_name}}</span></h5></div><div class=col-md-5><h5>Страховая премия :<span class=text-info> {{view.policy.insurance_premium}} {{view.currency_name}} / {{view.policy.data.insurance_premium_kgs}} KGS</span></h5></div></div><div class=row><div class=col-md-10><h5>Страны пребывания:<span ng-repeat=\"country_id in view.policy.insurance_data.country_id\"><span ng-repeat=\"country in view.countries| filter:{_id:country_id}\" class=text-info> {{country.name}} <mark>({{country.data.name_eng}})</mark></span></span></h5></div><div class=col-md-2><h5></h5></div></div><div class=row><div class=col-md-10><h5>Страховая компания:<span class=text-info> {{view.product.company[0].name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Продукт:<span class=text-info> {{view.product.name}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div class=row><div class=col-md-10><h5>ФИО Клиента:<span class=text-info> {{view.policy.client.surname}} {{view.policy.client.name}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Дата рождения:<span class=text-info> {{view.policy.client.date_of_birth|date:\'dd-MM-yyyy\'}}</span></h5></div><div class=col-md-2></div></div><div class=row><div class=col-md-10><h5>Номер паспорта:<span class=text-info> {{view.policy.client.passport_no}}</span></h5></div><div class=col-md-2></div></div><div class=ln_solid></div><div stock-dict=view.services dict-table=Services class=row><ul style=\"background-color: gray\" class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer><h2><b>Факторы</b></h2></a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer><h2><b>Сервисы</b></h2></a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"(key, value) in view.policy.insurance_data.factors\"><td>{{key}}</td><td>{{value}}</td></tr></tbody></table></div><div id=service class=\"tab-pane fade\"><ul class=list-group><li ng-repeat=\"service_id in view.product.services_id\" class=list-group-item><span ng-repeat=\"service in view.services | filter:{_id:service_id}\">- {{service.name}}</span></li></ul></div></div></div></div></div></div></div><div class=panel-footer><button type=button ui-sref=app.apolicy.list class=\"btn btn-primary\">Закрыть</button> <button type=button ng-click=view.downloadPDF() ng-if=\"view.policy.policy_no != \'00000\'\" ng-disabled=\"view.policy.policy_no == \'00000\' || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-default pull-right\"><i aria-hidden=true class=\"fa fa-print\"></i> Распечатать</button> <button type=button ng-click=view.confirmAction() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-scissors\"></i> Испортить</button> <button type=button ng-click=view.confirmActionTerm() ng-if=\"view.policy.data.status &amp;&amp; view.policy.data.status == \'Оформлен\'\" ng-disabled=\"!view.policy.data.status || view.policy.data.status != \'Оформлен\'\" class=\"btn btn-danger pull-right\"><i aria-hidden=true class=\"fa fa-thumbs-o-down\"></i> Расторгнуть</button> <button type=button ng-click=view.goToForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil\"></i> Изменить</button> <button type=button ng-click=view.confirmActionForm() ng-if=\"view.policy.data.status != \'Истек\' &amp;&amp; view.policy.data.status != \'Оформлен\' &amp;&amp; view.policy.data.status != \'Испорчен\' &amp;&amp; view.policy.data.status != \'Расторгнут\'\" ng-disabled=\"view.policy.data.status == \'Оформлен\' || view.policy.data.status == \'Испорчен\'|| view.policy.data.status == \'Расторгнут\'\" class=\"btn btn-success pull-right\"><i aria-hidden=true class=\"fa fa-pencil-square-o\"></i> Выдать</button></div></div></div>");
$templateCache.put("app/product/new.html","<!--\nCreated by troy on 13.10.2016.\n\n--><panel title=Продукт><wizard hide-indicators=false indicators-position=top><wz-step wz-title=\"Основные данные\"><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Основные данные</h2><!--pre.text-left {{new_product.new_product|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next=\"import.read()\" ng-disabled=\"!import.fileData\") Дальше--><a wz-next=new_product.saveProduct() class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=form-group><label for=first-name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Название<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input id=first-name type=text ng-model=new_product.new_product.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label stock-dict=new_product.insurancetypes dict-table=InsuranceTypes class=\"control-label col-md-3 col-sm-3 col-xs-12\">Вид страхования<span class=required>*</span></label><div class=\"col-md-3 col-sm-3 col-xs-12\"><ui-select ng-model=new_product.new_product.insurance_type ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type.code as type in new_product.insurancetypes track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=form-group><label for=middle-name class=\"control-label col-md-3 col-sm-3 col-xs-12\">Начало</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input id=middle-name type=text min-date=new_product.today max-date=new_product.new_product.date_end uib-datepicker-popup=dd-MM-yyyy ng-click=\"profile.popup_delivery_date.opened=true\" ng-model=new_product.new_product.date_start is-open=profile.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label for=middle-name2 class=\"control-label col-md-3 col-sm-3 col-xs-12\">Конец</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"input-group no-margin\"><input id=middle-name2 type=text uib-datepicker-popup=dd-MM-yyyy min-date=new_product.new_product.date_start ng-click=\"profile.popup_delivery_date.opened1=true\" ng-model=new_product.new_product.date_end is-open=profile.popup_delivery_date.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><label for=middle-name22 class=\"control-label col-md-3 col-sm-3 col-xs-12\">Описание</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><textarea id=middle-name22 rows=4 ng-model=new_product.new_product.description class=form-control></textarea></div></div></div></form></wz-step><wz-step wz-title=Сервисы><div dynamic=html></div><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Сервисы</h2><!--pre.text-left {{new_product.new_product|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous=\"import.clear()\") Назад--><a wz-previous=import.clear() class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a wz-next=new_product.saveProduct() class=\"btn btn-success\"><i aria-hidden=true class=\"fa fa-long-arrow-right\"></i></a></div></div></div><br><div class=row><div stock-dict=new_product.tmp_services dict-table=Services class=\"col col-xs-12 col-sm-6 col-md-6\"><div class=form-group><label>Сервисы</label><div class=input-group><ui-select ng-model=new_product.new_product.services_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in new_product.tmp_services | filter:{name:$select.search} | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened1=true\" style=visibility:hidden ng-disabled=true class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></form></wz-step><wz-step wz-title=Факторы><form class=\"form-horizontal form-label-left\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-4\"><a ui-sref=app.product class=\"btn btn-default\">Отмена</a></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"well well-sm text-center\"><h2>Дополнительные факторы</h2><!--pre.text-left {{new_product.current_F|json}}--></div></div><div class=\"col-md-4 col-sm-4 col-xs-4\"><div class=\"btn-group pull-right\"><!--a.btn.btn-success(wz-next ng-disabled=\"import.alerts.length>0\") Дальше--> <!--a.btn.btn-primary(wz-previous) Назад--><a wz-previous class=\"btn btn-primary\"><i aria-hidden=true class=\"fa fa-long-arrow-left\"></i></a><a ng-click=new_product.confirmActionFinish() class=\"btn btn-success\">Готово</a></div></div></div><br><div class=row><div class=col-md-8><div class=row><div stock-dict=new_product.tmp_factors dict-table=Factors class=col-md-10><div class=form-group><label>Выбрать фактор</label><ui-select ng-model=new_product.current_F.factor on-select=new_product.clearFactorValues() ng-required=true class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in new_product.tmp_factors track by type._id | orderBy:&quot;name&quot;\">{{type.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-10><div class=form-group><label>Коэффициент</label><input type=number ng-model=new_product.current_F.coefficient class=form-control><!--coefficient_type--></div></div></div><div class=row><div stock-dict=new_product.tmp_coefficients dict-table=Enums dict-filter={name:&quot;coefficient_type&quot;} class=col-md-10><div class=form-group><label>Вид коэффициента</label><ui-select ng-model=new_product.current_F.coefficient_type class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in new_product.tmp_coefficients track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-md-10 pull-left\"><div class=radio><label><input type=radio name=optradio ng-model=new_product.current_F.is_default ng-value=false> Опциональный</label></div><div class=radio><label><input type=radio name=optradio ng-model=new_product.current_F.is_default ng-value=true checked> Включен по умолчанию</label></div></div></div></div><div class=\"col-md-4 pull-left\"><div class=form-group><label>Значения фактора</label><ui-select ng-model=new_product.current_F.values ng-required=true multiple class=form-control><ui-select-match>{{$item}}</ui-select-match><ui-select-choices repeat=\"type in new_product.current_F.factor.values| filter:$select.search| filter:new_product.factorValueFilter | orderBy:new_product.sortFactorValues\">{{type}}</ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><button type=button ng-click=new_product.confirmActionF() class=\"btn btn-success btn-sm pull-right\">Сохранить фактор</button></div></div><span ng-init=new_product.initMS2() style=display:none></span></form><h2>Список факторов</h2><div style=\"height:200px; overflow-y:auto\" class=panel-group><div ng-repeat=\"x in new_product.factorListTS track by x.factor_name\" class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a data-toggle=collapse data-target=#collapse22{{$index}} class=\"btn btn-info\"><i aria-hidden=true class=\"fa fa-chevron-down\"></i><!--span(ng-repeat=\"y in x.countries.items\")  {{$index+1}}.{{y.name}}--> {{x.factor_name}}</a> <button type=button ng-click=new_product.confirmActionFDeleteAll(x) class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-remove\"></span> Remove</button></h4></div><panel-collapse id=collapse22{{$index}} class=collapse><div class=panel-body><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><table class=\"table table-striped\"><thead><tr><th>Значения</th><th>Коэффициент</th><th>Тип коэффициента</th><th>По умолчанию</th><th></th></tr></thead><tbody><tr ng-repeat=\"y in x.data\"><td><span ng-repeat=\"z in y.values\">{{$index + 1}}: \"{{z}}\",<br></span></td><td>{{y.coefficient}}</td><td>{{y.coefficient_type}}</td><td>{{y.is_default}}</td><td><button type=button ng-click=new_product.confirmActionFdelete($index,y,x) class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div></div></div></panel-collapse></div></div></wz-step></wizard></panel><script type=text/ng-template id=myPopoverTemplate.html><div style=\"max-width: 200px; max-height: 500px; overflow-y: auto;\">\n    <ul class=\"list-group\">\n      <li ng-repeat=\"y in x.countries\" class=\"list-group-item\">\n        {{$index+1}}: \"{{y.name}}\"\n      </li>\n    </ul>\n  </div></script>");
$templateCache.put("app/product/product.html","<!--Created by Aibek on 09/06/16.\n--><div class=container><panel title=Продукты><!--button.btn.btn-primary.btn-sm(ng-click=\'product.newProduct()\') Добавить--> <button ui-sref=app.product_new class=\"btn btn-primary btn-xs\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!product.selected_product\' ng-click=\'product.editProduct()\')--> <button ng-click=product.gotoedit(product.selected_product) ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=product.gotoview(product.selected_product) ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-eye\"></i><span> Просмотр</span></button> <button ng-click=product.confirmAction() ng-disabled=\"product.selected_product == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-trash\"></i><span> Удалить</span></button> <button ng-click=product.getProducts() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=product.productsGridOptions disable-search=true></paged-table></panel></div>");
$templateCache.put("app/product/view.html","<!--\nCreated by troy on 28.11.2016.\n\n--><div class=container><button type=button ui-sref=app.product class=\"btn btn-warning\"><i aria-hidden=true class=\"fa fa-hand-o-left\"></i> Назад</button><ul class=\"nav nav-pills nav-justified\"><li class=active><a data-toggle=tab data-target=#basic style=cursor:pointer>Основные Данные</a></li><li><a data-toggle=tab data-target=#service style=cursor:pointer>Сервисы</a></li><li><a data-toggle=tab data-target=#factor style=cursor:pointer>Факторы</a></li></ul><div class=tab-content><div id=basic class=\"tab-pane fade in active\"><hr><div class=row><div class=col-md-7><table class=\"table table-striped\"><tbody><tr><td>Название продукта</td><td>{{view_product.product.name}}</td></tr><tr><td>Компания продукта</td><td>{{view_product.product.company.name}}</td></tr><tr><td>Код продукта</td><td>{{view_product.product.code}}</td></tr><tr><td>Тип страхования</td><td>{{view_product.product.insurance_type}}</td></tr><tr><td>Начало</td><td>{{view_product.toDate(view_product.product.date_start)|date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Конец</td><td>{{view_product.toDate(view_product.product.date_end)|date:\'dd-MM-yyyy\'}}</td></tr><tr><td>Описание</td><td>{{view_product.product.description}}</td></tr></tbody></table></div></div></div><div id=service class=\"tab-pane fade\"><hr><ul class=list-group><li ng-repeat=\"service in view_product.product.services\" class=list-group-item>{{$index + 1}}. {{service.name}}</li></ul></div><div id=factor class=\"tab-pane fade\"><hr><table class=\"table table-striped\"><thead><tr class=row><th class=col-md-3>Фактор</th><th class=col-md-1>Коэффицент</th><th class=col-md-2>Тип коэффицента</th><th class=col-md-6>Значения</th></tr></thead><tbody><tr ng-repeat=\"factor in view_product.product.factors\" class=row><td class=col-md-3>{{factor.factor.name}}</td><td class=col-md-1>{{factor.coefficient}}</td><td class=col-md-2>{{factor.coefficient_type}}</td><td class=col-md-6><span ng-repeat=\"value in factor.values\"><span ng-if=\"factor.factor.usage != \'age\'\">{{$index + 1}}).</span><span> {{value}}</span><br ng-if=\"($index + 1)%4 == 0\"></span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/profile/edit.html","<!--Created by troy on 09.09.2016.--><div ng-controller=\"ProfileEditController as profile\" class=container><div class=ln_solid></div><div class=\"row-striped row-v-padding\"><div class=col-md-4><div class=row><h4><b>Основная информация</b></h4></div><div class=row><label>Эта информация будет видна в вашем профиле</label></div></div><div class=col-md-8><div class=row><div class=form-group><label>Фамилия</label><input ng-model=profile.profile.data.surname type=text placeholder=\"Введите Фамилию\" class=form-control></div></div><div class=row><div class=form-group><label>Имя</label><input ng-model=profile.profile.data.name type=text placeholder=\"Введите Имя\" class=form-control></div></div><div class=row><div class=form-group><label>Отчество</label><input ng-model=profile.profile.data.middleName type=text placeholder=\"Введите Отчество\" class=form-control></div></div><div class=row><div class=form-group><label>Адрес</label><input ng-model=profile.profile.data.address type=text placeholder=\"Введите Адрес\" class=form-control></div></div><div class=row><div class=form-group><label>Дата рждения</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy ng-model=profile.profile.data.birthDate is-open=profile.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"profile.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=row><div class=form-group><label>Телефон</label><div class=input-group><input ng-model=profile.tempPhone type=text placeholder=\"Введите Телефон и нажмите знак плюса справа\" class=form-control><span class=input-group-btn><button type=button ng-click=profile.addPhone() class=\"btn btn-success\"><span class=\"glyphicon glyphicon-plus\"></span></button></span></div><div ng-repeat=\"x in profile.profile.data.phones\" class=input-group><span class=input-group-addon>{{($index+1) + \' \'}}</span> <input type=text value={{x}} readonly class=form-control><span class=input-group-btn><button type=button ng-click=profile.deletePhone($index) class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove\"></span></button></span></div></div></div><div class=\"row pull-right\"><button ng-click=profile.putData() type=button class=\"btn btn-primary btn-sm\">Сохранить</button></div></div></div></div>");
$templateCache.put("app/profile/profile.html","<!--\nCreated by troy on 13.09.2016.\n\n--><ui-view></ui-view>");
$templateCache.put("app/profile/view.html","<!--Created by troy on 09.09.2016.\n--><div ng-controller=\"ProfileViewController as profile\" class=container><div class=ln_solid></div><div class=\"row-striped row-v-padding\"><div class=col-md-5><h3>Авторизация</h3><div class=\"well well-sm\"><div class=row><!--.col-md-4--><!--  h1 Picture--><div class=col-md-12><div class=form-group><div class=input-group><input ng-model=profile.profile.username type=text placeholder=\"Имя пользователя\" disabled class=form-control><span class=input-group-btn><button type=button ng-click=profile.changeUsername() class=\"btn btn-secondary\"><span class=\"glyphicon glyphicon-pencil\"></span></button></span></div></div><div class=form-group><div class=input-group><input ng-model=profile.profile.email type=text placeholder=Email disabled class=form-control><span class=input-group-btn><button type=button ng-click=profile.changeEmail() class=\"btn btn-secondary\"><span class=\"glyphicon glyphicon-pencil\"></span></button></span></div></div><button type=button ng-click=profile.changePassword() class=\"btn btn-primary btn-sm\">Изменить Пароль</button></div><div class=col-md-6></div></div></div></div><div class=col-md-7><h3>Личные данные</h3><div class=\"well well-sm\"><div class=row><div class=col-md-12><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Фамилия</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.surname></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Имя</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.name></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Отчество</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.middleName></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Адрес</b></h5><div class=col-md-8><h5 ng-bind=profile.profile.data.address></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Дата рждения</b></h5><div class=col-md-8><h5 ng-bind=\"profile.profile.data.birthDate | date:\'dd-MM-yyyy\'\"></h5></div></div></div><div class=ln_solid></div><div class=row><div class=form-group><h5 class=\"control-label col-md-4\"><b>Телефон</b></h5><div class=col-md-8><h5><span ng-repeat=\"x in profile.profile.data.phones\"><span ng-if=$index&gt;0>{{\" \"+\"; \"}}</span><span>{{x}}</span></span></h5></div></div></div><div class=ln_solid></div><div class=row><button type=button ui-sref=app.profile.edit class=\"btn btn-primary btn-sm pull-right\">Изменить</button></div></div></div></div></div></div><div class=ln_solid><script type=text/ng-template id=changePassword.html><form ng-submit=\"$ctrl.passwordSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение пароля</h3>\n          <pre>{{$ctrl.password|json}}</pre>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Текущий пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" minlength=\"3\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Новый пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.newPswd\" type=\"password\" minlength=\"6\" id=\"inputPassword\" placeholder=\"Минимум 6 символов\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Подтверждение</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.confirmPswd\" type=\"password\" id=\"inputPasswordConfirm\" data-match=\"#inputPassword\" data-match-error=\"Пароль не подтвержден\" required class=\"form-control\">\n                <h5 style=\"color:red;\" ng-if=\"($ctrl.password.confirmPswd.length &gt;5)&amp;&amp;($ctrl.password.confirmPswd!=$ctrl.password.newPswd)\">Пароль не прдтвержден</h5>\n              </div>\n            </div>\n          </div>\n          <div class=\"ln_solid\"></div>\n          <div class=\"row pull-right\"></div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script><script type=text/ng-template id=changeUsername.html><form ng-submit=\"$ctrl.usernameSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение имени пользователя</h3>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-4\"><b>Пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-4\"><b>Имя пользователя</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.username\" type=\"text\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script><script type=text/ng-template id=changeEmail.html><form ng-submit=\"$ctrl.emailSave()\">\n        <div class=\"modal-header\">\n          <h3>Изменение E-mail\'a</h3>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Пароль</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.password.currentPswd\" type=\"password\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <h5 class=\"control-label col-md-3\"><b>Email</b></h5>\n              <div class=\"col-md-6\">\n                <input ng-model=\"$ctrl.email\" type=\"email\" required class=\"form-control\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Сохранить</button>\n          <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-warning btn-sm\">Отмена</button>\n        </div>\n      </form></script></div></div>");
$templateCache.put("app/property/form.html","");
$templateCache.put("app/property/list.html","");
$templateCache.put("app/property/property.html","");
$templateCache.put("app/regulations/form.html","<div class=container><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Нормативные документы</h2><div class=clearfix></div></div><div class=x_content><form id=regulations-form class=\"form-horizontal form-label-left\"><div stock-dict=form.departmentdocuments dict-table=Departmentdocument class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Раздел публикации</label><div class=\"col-md-6 col-sm-6 col-xs-12\"><ui-select ng-model=form.regulationsItem.departmentdocument_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in form.departmentdocuments\">{{type.name}}</ui-select-choices></ui-select></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">Наименование<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><input type=text id=name_ru name=name_ru required ng-model=form.regulationsItem.name class=\"form-control col-md-7 col-xs-12\"></div></div><div class=form-group><label class=\"control-label col-md-3 col-sm-3 col-xs-12\">файлы<span class=required>*</span></label><div class=\"col-md-6 col-sm-6 col-xs-12\"><div><file-load file-src=form.regulationsItem.file type=regulations allow=pdf,word,zip></file-load></div><!--.form-group--><!--  div(flow-init=\'form.uploader.flow.opts\' flow-name=\"form.uploader.flow\" flow-file-success=\"form.uploader.controllerFn($flow, $file, $message)\" flow-file-added=\"!!{jpg:1,gif:1,png:1,doc:1,xls:1,xlsx:1,pnt:1,htm:1,pdf:1,txt:1,docx:1}[$file.getExtension()]\")--><!--    button.btn.btn-default.btn-sm(flow-btn)--><!--      span.glyphicon.glyphicon-plus Файл--><!--    button.btn.btn-default.btn-sm(ng-click=\"form.upload()\" type=\"button\") Загрузить--><!--    div(ng-repeat=\"file in form.uploader.flow.files\")--><!--      span {{file.name}} ---><!--      a(ng-click=\"removeFile(file.name); file.cancel();\") X--><!--      div.progress.progress-striped(ng-class=\"{active: file.isUploading()}\")--><!--        div.progress-bar(role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: (file.progress() * 100) + \'%\'}\" style=\"width: 100%;\")--><!--          span.sr-only.ng-binding 1% Complete--><!--  span файлы: {{form.uploader.flow.files.length}}--></div></div><div class=form-group><div class=\"col-md-6 col-sm-6 col-xs-12 col-md-offset-3\"><button type=button ng-click=form.goBack() class=\"btn btn-default\">Отмена</button> <button type=button ng-click=form.saveRegulations() class=\"btn btn-primary\">Сохранить</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/regulations/list.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Нормативные документы</div><div class=panel-body><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_content><div class=row><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Наименование</label><input type=text ng-model=list.searchValues.name class=form-control></div><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Дата создания от</label><div class=\"input-group no-margin\"><input type=text name=valid_from ng-model=list.searchValues.created_from uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened1 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened1 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 col-sm-12 col-xs-12 form-group\"><label class=control-label>Дата создания до</label><div class=\"input-group no-margin\"><input type=text name=valid_to ng-model=list.searchValues.created_to uib-datepicker-popup=dd.MM.yyyy datepicker-options=list.dateOptions is-open=list.dateOptions.opened2 close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"list.dateOptions.opened2 = true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=row><div class=\"col-md-4 col-sm-12 col-xs-12\"><button type=button ng-click=list.getRegulations() class=\"btn btn-default\">Найти</button> <button type=button ng-click=list.openCreateForm() class=\"btn btn-primary\">Созданить</button> <button type=button ng-click=list.openEditForm() ng-disabled=!list.selected_regulations class=\"btn btn-default\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button type=button ng-click=list.confirmAction() ng-disabled=!list.selected_regulations class=\"btn btn-danger\"><span>Удалить</span></button></div></div></div></div></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=row><div class=col-md-12><paged-table options=list.gridOptions disable-search=false></paged-table></div></div></div></div></div></div></div>");
$templateCache.put("app/regulations/regulations.html","<vak-header></vak-header><div id=body class=container><div class=row><div class=\"sidenav col-md-3 col-sm-3 col-xs-12\"><div class=panel><div class=panel-heading><div class=panel-title>{{\'REGULATIONS_LABEL\' | translate}}</div></div><div class=\"panel-body side\"><ul class=list-group><li ng-repeat=\"department in regulations.departments\" ng-click=regulations.getRegulations(department._id) class=list-group-item>{{department.name_ru}}</li><li ng-click=regulations.goToAnti() class=list-group-item>{{\'ANTI_PLAGIARISM_LABEL\' | translate}}</li></ul></div></div></div><div class=\"col-md-9 col-sm-9 col-xs-12\"><div class=panel><div class=panel-heading><div class=panel-title>{{\'REGULATIONS_LABEL\' | translate}}</div></div><div class=panel-body></div><table id=dev-table class=\"table table-hover table-bordered\"><thead><tr><th>#</th><th>{{\'NAME_RU_LABEL\' | translate}}</th><th>{{\'NAME_KG_LABEL\' | translate}}</th><th>{{\'FILE_LABEL\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"regulation in regulations.regulations.list | orderBy:&quot;-created_from&quot;\"><td>{{$index+1}}</td><td>{{regulation.name_ru}}</td><td>{{regulation.name_kg}}</td><td><a href=\"{{regulations.link + regulation.file}}\" target=_blank>{{\'DOWNLOAD_FILE\' | translate}}</a></td></tr></tbody></table></div></div></div></div><vak-footer></vak-footer>");
$templateCache.put("app/report/report.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Просмотр отчета</div><div class=panel-body><div class=row><col-responsive stock-dict=report.report_categories dict-table=ReportCategories><div class=form-group><label>Категория</label><ui-select ng-model=report.report_category_id><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in report.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Отчет</label><ui-select ng-model=report.selected_report><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"report in report.reports|filter:{name:$select.search}\">{{report.name}}</ui-select-choices></ui-select></div></col-responsive></div><div id=reportViewer></div></div></div></div>");
$templateCache.put("app/report/reporta.html","<div class=row><col-responsive><div class=form-group><label>Категория</label><ui-select ng-model=reporta.search.report_category_id on-select=reporta.getReportList()><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in reporta.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label>Отчет</label><ui-select ng-model=reporta.selected_report on-select=reporta.setSelected($select.selected)><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"reporta in reporta.reports|filter:{name:$select.search}\">{{reporta.name}}</ui-select-choices></ui-select></div></col-responsive></div><div id=viewerContent></div><div id=designerContent></div>");
$templateCache.put("app/report_template/query_edit.html","<form ng-submit=edit.save()><div class=modal-header><h3>Запрос</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.query.code ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.query.name ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Ключ возврата</label><input type=text ng-model=edit.query.result_key ng-required=true class=form-control></div></col-responsive></div><div class=form-group><label>Запрос</label><textarea rows=10 ng-required=true ng-model=edit.query.query class=form-control></textarea></div></div><div class=modal-footer><button ng-disabled=edit.saving type=button ng-click=edit.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=edit.saving type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/report_template/report_template.html","<div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Шаблоны отчетов</div><div class=panel-body><div class=form-group><button ng-click=report_template.newTemplate() class=\"btn btn-primary\">Новый шаблон</button> <button ng-click=report_template.editTemplate() ng-disabled=!report_template.selected_template class=\"btn btn-default\">Редактировать</button> <button ng-click=report_template.getTemplates() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><paged-table options=report_template.gridOptions disable-paging=true disable-search=true></paged-table></div></div></div><div class=ln_solid></div><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Запросы отчетов</div><div class=panel-body><div class=form-group><button ng-click=report_template.newQuery() class=\"btn btn-primary\">Новый запрос</button> <button ng-click=report_template.editQuery() ng-disabled=!report_template.selected_query class=\"btn btn-default\">Редактировать</button> <button ng-click=report_template.getQueries() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><paged-table options=report_template.queriesGridOptions disable-paging=true disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/report_template/template_edit.html","<form ng-submit=edit.save()><div class=modal-header><h3>Шаблон отчета</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.template.code ng-required=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.template.name ng-required=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.report_categories dict-table=DirReportCategories><div class=form-group><label>Категория</label><ui-select ng-model=edit.template.report_category_id><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"category._id as category in edit.report_categories|filter:{name:$select.search}\" group-by=app.parentGroup>{{category.name}}</ui-select-choices></ui-select></div></col-responsive></div><div class=form-group><label>Шаблон</label><textarea rows=10 ng-required=true ng-model=edit.template.template class=form-control></textarea></div></div><div class=modal-footer><button ng-disabled=edit.saving type=button ng-click=edit.cancel() class=\"btn btn-warning\">Отмена</button> <button ng-disabled=edit.saving type=submit class=\"btn btn-primary\">Сохранить</button></div></form>");
$templateCache.put("app/reportperiod/reportperiod.html","<!--\nCreated by ilias on 17.05.2018.\n\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Составить отчет</div><div class=panel-body><form><div class=row><col-responsive><div class=form-group><label>Филиалы</label><ui-select ng-model=reportperiod.branch_id onselect=reportperiod.getAgents() theme=bootstrap on-remove=reportperiod.removeBranches()><ui-select-match allow-clear=true placeholder=\"Выберите филиал\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"company._id as company in reportperiod.branches\"><div ng-bind=company.name></div></ui-select-choices></ui-select></div></col-responsive><col-responsive ng-if=\"reportperiod.company.company_type != \'agent\' &amp;&amp; reportperiod.company.company_type != \'branch_company\'\"><div class=form-group><label>Агенты:</label><select ng-model=reportperiod.user_id ng-options=\"item.id as item.data.surname + \' \' + item.data.name for item in reportperiod.agents | filter:{surname:search}\" class=form-control></select><!--ui-select.form-control(ng-model=\'reportperiod.user_id\' ng-required=\'true\' on-remove=\"reportperiod.removeAgents()\")--><!--  ui-select-match(allow-clear=\'true\') {{$select.selected.data.surname}} {{$select.selected.data.name}}--><!--  ui-select-choices(repeat=\'agent.id as agent in reportperiod.agents \') {{agent.data.surname}} {{agent.data.name}}--></div></col-responsive></div><div class=row><col-responsive><div class=form-group><label>Начало:</label><div class=\"input-group no-margin\"><input type=text max-date=reportperiod.date_end uib-datepicker-popup=dd-MM-yyyy ng-model=reportperiod.date_start ng-click=\"policies.search.popup_to_date.opened=true\" is-open=policies.search.popup_to_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_to_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive><col-responsive><div class=form-group><label>Конец:</label><div class=\"input-group no-margin\"><input type=text uib-datepicker-popup=dd-MM-yyyy min-date=reportperiod.date_start ng-model=reportperiod.date_end ng-click=\"policies.search.popup_from_date.opened=true\" is-open=policies.search.popup_from_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"policies.search.popup_from_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></col-responsive></div><div class=\"wrapper ln_solid\"></div><button type=button ng-click=reportperiod.getPolicies() class=\"btn btn-primary btn-xs\"><i aria-hidden=true class=\"fa fa-search\"></i> Применить фильтр</button> <button type=button ng-click=reportperiod.getPolicies() class=\"btn btn-default btn-xs\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button type=button ng-click=reportperiod.downloadPDFRPCR() ng-disabled=\"reportperiod.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет</button> <button type=button ng-click=reportperiod.downloadExcelRPCR() ng-disabled=\"reportperiod.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет xlx</button> <button type=button ng-click=reportperiod.downloadPDFRPC() ng-disabled=\"reportperiod.branch_id != null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по Вознаграждению</button> <button type=button ng-click=reportperiod.downloadPDFRPFR() ng-disabled=\"(reportperiod.branch_id == null) || (reportperiod.user_id != null)\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по филиалу</button> <button type=button ng-click=reportperiod.downloadPDFRPF() ng-disabled=\"(reportperiod.branch_id == null) || (reportperiod.user_id != null)\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Вознаграждения по филиалу</button> <button type=button ng-click=reportperiod.downloadPDFRPAR() ng-disabled=\"reportperiod.user_id == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет по агенту</button> <button type=button ng-click=reportperiod.downloadPDFRPA() ng-disabled=\"reportperiod.user_id == null\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет Вознаграждения по агенту</button> <button type=button ng-click=reportperiod.downloadPDFRPAP() ng-if=false ng-disabled=\"reportperiod.company.company_type!=\'agent\' &amp;&amp; reportperiod.company._id == reportperiod.filter.agent_id\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения</button> <button type=button ng-if=false ng-click=reportperiod.downloadExcelRPAP() ng-disabled=\"reportperiod.company.company_type!=\'agent\' &amp;&amp; reportperiod.company._id == reportperiod.filter.agent_id\" class=\"btn btn-default btn-xs\"><i aria-hidden=true class=\"fa fa-print\"></i> Отчет вознаграждения Excel</button><div class=\"wrapper ln_solid\"></div><paged-table options=reportperiod.policiesGridOptions disable-search=true height=700></paged-table></form></div></div></div>");
$templateCache.put("app/role/edit.html","<!--\nCreated by Aibek on 25/08/16.\n\n--><form ng-submit=role.saveRole()><div class=modal-header><h3>Роль</h3></div><div class=modal-body><div class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=role.role.name ng-required=true ng-trim=true class=form-control></div><div class=form-group><label>Имя роли для одобрения</label><input type=text ng-model=role.role.data.approval_name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><label>Права</label><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.read disabled><span>&nbsp;Чтение</span></label></div><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.write><span>&nbsp;Редактирование</span></label></div><div class=form-group><label class=form-control><input type=checkbox ng-model=role.role.data.delete><span>&nbsp;Удаление</span></label></div></col-responsive><col-responsive><div class=form-group><label>Меню</label><ui-select ng-model=role.role.menus_id multiple><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"menu._id as menu in role.menus | filter: $select.search\" group-by=role.menuParentGroup>{{menu.name}}</ui-select-choices></ui-select></div></col-responsive></div></div><div class=modal-footer><button ng-disabled=\"role.saving===true\" type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button ng-disabled=\"role.saving===true\" type=button ng-click=role.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/role/role.html","<!--\nCreated by Aibek on 10/06/16.\n\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Роли</div><div class=panel-body><button ng-click=role.newRole() class=\"btn btn-primary btn-sm\">Добавить</button> <button ng-disabled=!role.selected_role ng-click=role.editRole() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=role.getRoles() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=role.rolesGridOptions disable-search=true disable-paging=true></paged-table></div></div></div>");
$templateCache.put("app/users/create.html","<!--\nCreated by troy on 15.11.2016.\n\n--><form ng-submit=user.createUser()><div class=modal-header><h3>Новый пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab href=#users-create-auth>Информация для авторизации</a></li><li><a data-toggle=tab href=#users-create-profile>Информация о пользователе</a></li></ul><div class=tab-content><div id=users-create-auth class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div></div></div><div id=users-create-profile class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/users/edit.html","<!--\nCreated by Aibek on 25/08/16.\n\n--><form ng-submit=user.updateUser()><div class=modal-header><h3>Пользователь</h3></div><div class=modal-body><ul class=\"nav nav-tabs\"><li class=active><a data-toggle=tab href=#users-edit-auth>Информация для авторизации</a></li><li><a data-toggle=tab href=#users-edit-profile>Информация о пользователе</a></li></ul><div class=tab-content><div id=users-edit-auth class=\"tab-pane fade in active\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя пользователя</label><input type=text ng-model=user.user.username ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Емайл</label><input type=email ng-model=user.user.email ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Пароль</label><input type=password ng-model=user.user.password ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Важность</label><input type=number ng-model=user.user.role ng-trim=true class=form-control></div></div><div stock-dict=user.roles dict-table=Roles class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Роли</label><ui-select ng-model=user.user.roles_id ng-required=true multiple class=form-control><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type._id as type in user.roles\">{{type.name}}</ui-select-choices></ui-select></div></div></div></div><div id=users-edit-profile class=\"tab-pane fade\"><div class=row><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Фамилия</label><input type=text ng-model=user.user.data.surname ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Имя</label><input type=text ng-model=user.user.data.name ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Отчество</label><input type=text ng-model=user.user.data.patronymic ng-trim=true class=form-control></div></div><div class=\"col col-xs-12 col-sm-6\"><div class=form-group><label>Дата рождения</label><div class=\"input-group no-margin\"><input id=middle-name type=text uib-datepicker-popup=dd-MM-yyyy ng-click=\"user.popup_delivery_date.opened=true\" ng-model=user.user.data.date_of_birth is-open=user.popup_delivery_date.opened close-text=Закрыть current-text=Сегодня clear-text=Очистить class=form-control><span class=input-group-btn><button type=button ng-click=\"user.popup_delivery_date.opened=true\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=modal-footer><button type=submit class=\"btn btn-primary btn-sm pull-right\">Сохранить</button> <button type=button ng-click=user.cancel() class=\"btn btn-warning btn-sm pull-right\">Отмена</button></div></form>");
$templateCache.put("app/users/users.html","<!--\nCreated by Aibek on 13/06/16.\n\n--><div class=\"wrapper lter b-b\"><div class=\"panel panel-info\"><div class=\"panel-heading font-bold\">Пользователи</div><div class=panel-body><form ng-submit=users.getUsers()><div class=row><col-responsive><div class=form-group><label>Email:</label><input type=text ng-model=users.filter.email placeholder=\"Введите email\" class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Логин:</label><input type=text ng-model=users.filter.login placeholder=\"Введите логин\" class=form-control></div></col-responsive></div><div class=btn-group-sm><button type=submit class=\"btn btn-success\"><span class=\"glyphicon glyphicon-search margin-right-8\"></span><span>Найти</span></button> <button type=button ng-click=\"users.filter={}\" class=\"btn btn-default\">Сбросить фильтры</button><div class=clearfix></div></div></form><div class=wrapper></div><button ng-click=users.newUser() class=\"btn btn-primary btn-sm\">Добавить</button><!--button.btn.btn-default.btn-sm(ng-disabled=\'!product.selected_product\' ng-click=\'product.editProduct()\')--> <button ng-click=users.editUser() ng-disabled=\"users.selected_user == null\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil margin-right-8\"></span><span>Изменить</span></button> <button ng-click=product.getProducts() class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span></button><paged-table options=users.usersGridOptions disable-search=true></paged-table></div></div></div>");
$templateCache.put("app/components/contractorSelect/contractor-select.html","<div><div ng-hide=\"asText===true\" class=input-group><div ng-show=loadingContractors class=input-group-addon><span class=\"glyphicon glyphicon-refresh\"></span></div><div ng-show=noContractors class=input-group-addon><span class=\"glyphicon glyphicon-remove text-danger\"></span></div><input type=text ng-model=contractor.selected uib-typeahead=\"contractor as contractor.name for contractor in contractor.searchContractor($viewValue)\" typeahead-loading=loadingContractors typeahead-no-results=noContractors ng-disabled=ngDisabled ng-required=ngRequired class=form-control><div class=input-group-btn><button type=button ng-click=contractor.openSelectContractor() ng-disabled=ngDisabled class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-paperclip\"></span></button></div></div><span ng-show=\"asText===true\">{{ contractor.selected.name }}</span></div>");
$templateCache.put("app/components/contractorSelect/select.html","<!--\nCreated by Aibek on 26/08/16.\n\n--><div class=modal-header><h3>{{contractor.modalOptions.title}}</h3></div><div class=modal-body><div class=row><div class=\"col col-xs-12 col-sm-12 col-md-4\"><form ng-submit=contractor.searchContractors() class=form-horizontal><div class=form-group><label>Наименование</label><input type=search ng-model=contractor.search_name class=form-control></div><div stock-dict=contractor.contractor_types dict-table=Enums dict-filter={name:&quot;contractor_type&quot;} ng-hide=contractor.modalOptions.filter.contractor_type class=from-group><label>Тип контрагента</label><ui-select ng-model=contractor.contractor_type><ui-select-match allow-clear=true>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"contractor_type.data.key as contractor_type in contractor.contractor_types | filter:$select.search track by contractor_type.data.key\">{{contractor_type.data.name}}</ui-select-choices></ui-select></div><div stock-dict=contractor.industries dict-table=Industries class=from-group><label>Индустрия</label><ui-select ng-model=contractor.industry_id><ui-select-match allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"industry._id as industry in contractor.industries | filter:{name:$select.search} track by industry._id\" group-by=contractor.industryParentGroup>{{industry.name}}</ui-select-choices></ui-select></div><button type=submit class=\"btn btn-success\">Показать</button> <button type=button ng-click=contractor.createContractor() class=\"btn btn-success\">Создать новый</button></form></div><div class=\"col col-xs-12 col-sm-12 col-md-8\"><paged-table options=contractor.gridOptions disable-search=true></paged-table></div></div></div><div class=modal-footer><button type=button ng-click=contractor.cancel() class=\"btn btn-default\">Отмена</button> <button ng-disabled=!contractor.selected_contractor ng-click=contractor.selectContractor() class=\"btn btn-primary\">Принять</button></div>");
$templateCache.put("app/components/fileLoad/file-link.html","<a ng-href={{file_link}} target=_blank>{{file_name}}</a>");
$templateCache.put("app/components/fileLoad/file-load.html","<div class=file-load><div class=\"bdr bdr-v\"><div class=bdr-h></div></div><div tabindex=0 flow-init flow-object=file.flow class=file-content><div class=file-thumbnail><img ng-src=assets/pdf/default/pdf_icon.svg></div><div class=file-opt><div class=file-icon><span class=\"glyphicon glyphicon-file\"></span></div><div class=file-info><div ng-repeat=\"file_item in $flow.files | limitTo: 1\"><uib-progressbar max=file_item.size value=file_item.sizeUploaded() ng-class=\"{active: file_item.isUploading(), success: file_item.isComplete()}\" class=progress-xs></uib-progressbar><div><div class=file-name><span>{{file_item.name}}</span></div><div class=file-size><span>{{file_item.size|fileSize}}</span></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn ng-hide=file.isUploading() class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span></button> <button type=button uib-tooltip=Отмена tooltip-append-to-body=true ng-click=file_item.cancel() class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove\"></span></button> <button type=button uib-tooltip=Повторить tooltip-append-to-body=true ng-click=file_item.retry() ng-show=file_item.error class=\"btn btn-warning\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div></div></div><div ng-if=\"$flow.files.length==0 &amp;&amp; file.file\"><div><div class=file-name><span>{{file.file.name}}</span></div><div class=file-size><span>{{file.file.size|fileSize}}</span></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span></button><a href=\"{{file.api + fileSrc}}\" target=_blank uib-tooltip=Скачать tooltip-append-to-body=true class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-download-alt\"></span></a><!--button.btn.btn-danger(type=\'button\' uib-tooltip=\'Удалить\' tooltip-append-to-body=\'true\' flow-btn)--><!--  span.glyphicon.glyphicon-remove--></div></div></div><div ng-if=\"$flow.files.length==0 &amp;&amp; !file.file\"><div><div class=file-name><span>Выберите файл</span></div><div class=file-size></div></div><div class=file-btns><div class=btn-group-sm><button type=button uib-tooltip=\"Загрузить новый\" tooltip-append-to-body=true flow-btn class=\"btn btn-default\"><span class=\"glyphicon glyphicon-cloud-upload\"></span> Выбрать</button></div></div></div></div></div></div></div>");
$templateCache.put("app/dictionary/currencies/edit.html","<div ng-controller=\"CurrencyController as currency\" class=row><div class=\"col col-md-4\"><div class=form-group><label>Государство</label><input type=text ng-model=edit.dictionary.data.country class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Намименование</label><input type=text ng-model=edit.dictionary.name ng-required=true class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Знак</label><input type=text ng-model=edit.dictionary.data.symbol class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label for=code>Код</label><input id=code type=text ng-model=edit.dictionary.data.code class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label for=short_name>Короткое название</label><input id=short_name type=text ng-model=edit.dictionary.data.short_name class=form-control></div></div><div class=\"col col-md-4\"><div class=form-group><label>Намименование (ISO 4217)</label><input type=text ng-model=edit.dictionary.data.name class=form-control></div></div></div>");
$templateCache.put("app/dictionary/currencies/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/departmentdocument/edit.html","<!--\nCreated by ilias on 19.06.2018.\n\n--><div ng-controller=\"DepartmentdocumentController as departmentdocument\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/departmentdocument/view.html","<!--\nCreated by ilias on 19.06.2018.\n\n--><pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/dirreportcategories/edit.html","<div ng-controller=\"DirReportCategoriesController as category\" class=row><div class=\"col-md-6 col-xs-12\"><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></div><div class=\"col-md-6 col-xs-12\"><div class=form-group><label>Родительская категория</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in category.dirReportCategories | filter: {name:$select.search} track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></div></div>");
$templateCache.put("app/dictionary/enums/edit.html","<div ng-controller=\"EnumController as enum\" class=row><col-responsive><div class=form-group><label>Тип</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.data.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Коэффициент</label><input type=text ng-model=edit.dictionary.data.key ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/enums/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/industries/edit.html","<div ng-controller=\"IndustryController as industry\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.industries dict-table=Industries dict-options={onlyParents:true} dict-first-item=\"{_id:null,name:&quot;Нет родителя&quot;}\"><div class=form-group><label>Родетельская индустрия</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (edit.industries | filter: {name:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></col-responsive><col-responsive ng-show=\"app.ua.role&gt;=10\"><div class=form-group><label>Основная индустрия</label><input type=number ng-model=edit.dictionary.data.base_industry class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/industries/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/insuranceforms/edit.html","<div ng-controller=\"InsuranceformsController as insuranceforms\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Тип</label><input type=text ng-model=edit.dictionary.typeinput ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Ключ</label><input type=text ng-model=edit.dictionary.data.key ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=insurancetypes.parents dict-table=InsuranceObjects><div class=form-group><label>Объект страхования</label><ui-select ng-model=edit.dictionary.insurance_object_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in insurancetypes.parents track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive></div>");
$templateCache.put("app/dictionary/insuranceforms/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/insuranceobjects/edit.html","<div ng-controller=\"InsuranceobjectsController as insuranceobjects\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Коэффициент</label><input type=number ng-model=edit.dictionary.rate ng-trim=true step=0.001 class=form-control></div></col-responsive><col-responsive stock-dict=insurancetypes.parents dict-table=InsuranceTypes><div class=form-group><label>Тип страхования</label><ui-select ng-model=edit.dictionary.insurance_type_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in insurancetypes.parents track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive></div>");
$templateCache.put("app/dictionary/insuranceobjects/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/insurancetypes/edit.html","<div ng-controller=\"InsurancetypesController as insurancetypes\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Коэффициент</label><input type=number ng-model=edit.dictionary.rate ng-trim=true ng-pattern=/^[0-9]+(.[0-9]{1,2})?$/ step=0.001 class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Описание</label><input type=text ng-model=edit.dictionary.description ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Код</label><input type=text ng-model=edit.dictionary.code ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=insurancetypes.parents dict-table=InsuranceTypes><div class=form-group><label>Родитель</label><ui-select ng-model=edit.dictionary.parent_id class=form-control><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-null-choice>Нет родителя</ui-select-null-choice><ui-select-choices repeat=\"type._id as type in insurancetypes.parents track by type._id\">{{type.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive stock-dict=insurancetypes.statuses dict-table=Enums dict-filter={name:&quot;statuses&quot;}><div class=form-group><label>Статус</label><ui-select ng-model=edit.dictionary.status class=form-control><ui-select-match>{{$select.selected.data.name}}</ui-select-match><ui-select-choices repeat=\"type.data.key as type in insurancetypes.statuses track by type.data.key\">{{type.data.name}}</ui-select-choices></ui-select></div></col-responsive><col-responsive><div class=form-group><label><br><input type=checkbox ng-model=edit.dictionary.mandatory> Обязательное</label><label style=margin-left:10px><br><input type=checkbox ng-model=edit.dictionary.is_used> Используется</label></div></col-responsive></div>");
$templateCache.put("app/dictionary/insurancetypes/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/period/edit.html","<div ng-controller=\"PeriodController as period\" class=row><col-responsive><div class=form-group><label>Начало</label><input type=number ng-model=edit.dictionary.start ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Конец</label><input type=number ng-model=edit.dictionary.end ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Коэффициент</label><input type=number ng-model=edit.dictionary.rate ng-required=true ng-trim=true ng-pattern=/^[0-9]+(.[0-9]{1,2})?$/ step=0.001 class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/period/view.html","");
$templateCache.put("app/dictionary/product/edit.html","<div ng-controller=\"ProductController as product\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=edit.industries dict-table=Industries dict-options={onlyParents:true} dict-first-item=\"{_id:null,name:&quot;Нет родителя&quot;}\"><div class=form-group><label>Родетельская индустрия</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (edit.industries | filter: {name:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></col-responsive></div>");
$templateCache.put("app/dictionary/product/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/relativedegree/edit.html","<div class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/relativedegree/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/reportcategories/edit.html","<div ng-controller=\"ReportCategoryController as category\" class=row><col-responsive><div class=form-group><label>Название</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive stock-dict=category.categories dict-table=ReportCategories dict-options={onlyParents:true} dict-first-item=\"{_id:null,name:&quot;Нет родителя&quot;}\"><div class=form-group><label>Родительская категория</label><ui-select ng-model=edit.dictionary.parent_id ng-disabled=edit.dictionary.children.length&gt;0><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"parent._id as parent in (category.categories | filter: {name:$select.search}) track by parent._id\" ui-disable-choice=\"parent._id!=null&amp;&amp;parent._id==edit.dictionary._id\"><span ng-bind=parent.name></span></ui-select-choices></ui-select></div></col-responsive></div>");
$templateCache.put("app/dictionary/reportcategories/view.html","<pre>{{edit.dictionary|json:true}}</pre>");
$templateCache.put("app/dictionary/sectionsofpublication/edit.html","<!--\nCreated by admin on 03.07.2018.\n\n--><div ng-controller=\"SectionsofpublicationController as sectionsofpublication\" class=row><col-responsive><div class=form-group><label>Наименование</label><input type=text ng-model=edit.dictionary.name ng-required=true ng-trim=true class=form-control></div></col-responsive><col-responsive><div class=form-group><label>Порядок</label><input type=number ng-model=edit.dictionary.order ng-required=true ng-trim=true class=form-control></div></col-responsive></div>");
$templateCache.put("app/dictionary/sectionsofpublication/view.html","<!--Created by admin on 03.07.2018.\n--><pre>{{edit.dictionary|json:true}}</pre>");}]);